var Tm = Object.defineProperty;
var Im = (t, e, n) => e in t ? Tm(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var fe = (t, e, n) => (Im(t, typeof e != "symbol" ? e + "" : e, n), n);
import * as S from "react";
import P, { useCallback as pe, forwardRef as de, Children as Or, isValidElement as Ci, createElement as A, cloneElement as Ki, Fragment as of, createContext as At, useMemo as rr, useContext as Gt, useEffect as ue, useRef as le, useState as ke, useLayoutEffect as qi, useReducer as sf, Component as $m } from "react";
import * as Nm from "react-dom";
import af, { flushSync as lf } from "react-dom";
function Rm(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var na = { exports: {} }, yr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ws, fc;
function Wa() {
  if (fc)
    return ws;
  fc = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ws = o() ? Object.assign : function(i, s) {
    for (var a, l = r(i), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        e.call(a, d) && (l[d] = a[d]);
      if (t) {
        c = t(a);
        for (var f = 0; f < c.length; f++)
          n.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, ws;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hc;
function Am() {
  if (hc)
    return yr;
  hc = 1, Wa();
  var t = P, e = 60103;
  if (yr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    e = n("react.element"), yr.Fragment = n("react.fragment");
  }
  var r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      o.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (a && a.defaultProps)
      for (u in l = a.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: e, type: a, key: f, ref: h, props: d, _owner: r.current };
  }
  return yr.jsx = s, yr.jsxs = s, yr;
}
var _s = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pc;
function Lm() {
  return pc || (pc = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = P, n = Wa(), r = 60103, o = 60106;
      t.Fragment = 60107;
      var i = 60108, s = 60114, a = 60109, l = 60110, c = 60112, u = 60113, d = 60120, f = 60115, h = 60116, p = 60121, g = 60122, m = 60117, v = 60129, b = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var y = Symbol.for;
        r = y("react.element"), o = y("react.portal"), t.Fragment = y("react.fragment"), i = y("react.strict_mode"), s = y("react.profiler"), a = y("react.provider"), l = y("react.context"), c = y("react.forward_ref"), u = y("react.suspense"), d = y("react.suspense_list"), f = y("react.memo"), h = y("react.lazy"), p = y("react.block"), g = y("react.server.block"), m = y("react.fundamental"), y("react.scope"), y("react.opaque.id"), v = y("react.debug_trace_mode"), y("react.offscreen"), b = y("react.legacy_hidden");
      }
      var w = typeof Symbol == "function" && Symbol.iterator, x = "@@iterator";
      function M(k) {
        if (k === null || typeof k != "object")
          return null;
        var q = w && k[w] || k[x];
        return typeof q == "function" ? q : null;
      }
      var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function C(k) {
        {
          for (var q = arguments.length, se = new Array(q > 1 ? q - 1 : 0), ge = 1; ge < q; ge++)
            se[ge - 1] = arguments[ge];
          O("error", k, se);
        }
      }
      function O(k, q, se) {
        {
          var ge = E.ReactDebugCurrentFrame, Ve = ge.getStackAddendum();
          Ve !== "" && (q += "%s", se = se.concat([Ve]));
          var Be = se.map(function(Me) {
            return "" + Me;
          });
          Be.unshift("Warning: " + q), Function.prototype.apply.call(console[k], console, Be);
        }
      }
      var R = !1;
      function D(k) {
        return !!(typeof k == "string" || typeof k == "function" || k === t.Fragment || k === s || k === v || k === i || k === u || k === d || k === b || R || typeof k == "object" && k !== null && (k.$$typeof === h || k.$$typeof === f || k.$$typeof === a || k.$$typeof === l || k.$$typeof === c || k.$$typeof === m || k.$$typeof === p || k[0] === g));
      }
      function $(k, q, se) {
        var ge = q.displayName || q.name || "";
        return k.displayName || (ge !== "" ? se + "(" + ge + ")" : se);
      }
      function T(k) {
        return k.displayName || "Context";
      }
      function j(k) {
        if (k == null)
          return null;
        if (typeof k.tag == "number" && C("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof k == "function")
          return k.displayName || k.name || null;
        if (typeof k == "string")
          return k;
        switch (k) {
          case t.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case s:
            return "Profiler";
          case i:
            return "StrictMode";
          case u:
            return "Suspense";
          case d:
            return "SuspenseList";
        }
        if (typeof k == "object")
          switch (k.$$typeof) {
            case l:
              var q = k;
              return T(q) + ".Consumer";
            case a:
              var se = k;
              return T(se._context) + ".Provider";
            case c:
              return $(k, k.render, "ForwardRef");
            case f:
              return j(k.type);
            case p:
              return j(k._render);
            case h: {
              var ge = k, Ve = ge._payload, Be = ge._init;
              try {
                return j(Be(Ve));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var L = 0, Y, H, z, ee, I, F, te;
      function J() {
      }
      J.__reactDisabledLog = !0;
      function re() {
        {
          if (L === 0) {
            Y = console.log, H = console.info, z = console.warn, ee = console.error, I = console.group, F = console.groupCollapsed, te = console.groupEnd;
            var k = {
              configurable: !0,
              enumerable: !0,
              value: J,
              writable: !0
            };
            Object.defineProperties(console, {
              info: k,
              log: k,
              warn: k,
              error: k,
              group: k,
              groupCollapsed: k,
              groupEnd: k
            });
          }
          L++;
        }
      }
      function B() {
        {
          if (L--, L === 0) {
            var k = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, k, {
                value: Y
              }),
              info: n({}, k, {
                value: H
              }),
              warn: n({}, k, {
                value: z
              }),
              error: n({}, k, {
                value: ee
              }),
              group: n({}, k, {
                value: I
              }),
              groupCollapsed: n({}, k, {
                value: F
              }),
              groupEnd: n({}, k, {
                value: te
              })
            });
          }
          L < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var N = E.ReactCurrentDispatcher, W;
      function V(k, q, se) {
        {
          if (W === void 0)
            try {
              throw Error();
            } catch (Ve) {
              var ge = Ve.stack.trim().match(/\n( *(at )?)/);
              W = ge && ge[1] || "";
            }
          return `
` + W + k;
        }
      }
      var G = !1, oe;
      {
        var X = typeof WeakMap == "function" ? WeakMap : Map;
        oe = new X();
      }
      function U(k, q) {
        if (!k || G)
          return "";
        {
          var se = oe.get(k);
          if (se !== void 0)
            return se;
        }
        var ge;
        G = !0;
        var Ve = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Be;
        Be = N.current, N.current = null, re();
        try {
          if (q) {
            var Me = function() {
              throw Error();
            };
            if (Object.defineProperty(Me.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Me, []);
              } catch (dn) {
                ge = dn;
              }
              Reflect.construct(k, [], Me);
            } else {
              try {
                Me.call();
              } catch (dn) {
                ge = dn;
              }
              k.call(Me.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (dn) {
              ge = dn;
            }
            k();
          }
        } catch (dn) {
          if (dn && ge && typeof dn.stack == "string") {
            for (var _e = dn.stack.split(`
`), ut = ge.stack.split(`
`), Ze = _e.length - 1, tt = ut.length - 1; Ze >= 1 && tt >= 0 && _e[Ze] !== ut[tt]; )
              tt--;
            for (; Ze >= 1 && tt >= 0; Ze--, tt--)
              if (_e[Ze] !== ut[tt]) {
                if (Ze !== 1 || tt !== 1)
                  do
                    if (Ze--, tt--, tt < 0 || _e[Ze] !== ut[tt]) {
                      var un = `
` + _e[Ze].replace(" at new ", " at ");
                      return typeof k == "function" && oe.set(k, un), un;
                    }
                  while (Ze >= 1 && tt >= 0);
                break;
              }
          }
        } finally {
          G = !1, N.current = Be, B(), Error.prepareStackTrace = Ve;
        }
        var br = k ? k.displayName || k.name : "", dc = br ? V(br) : "";
        return typeof k == "function" && oe.set(k, dc), dc;
      }
      function be(k, q, se) {
        return U(k, !1);
      }
      function De(k) {
        var q = k.prototype;
        return !!(q && q.isReactComponent);
      }
      function Re(k, q, se) {
        if (k == null)
          return "";
        if (typeof k == "function")
          return U(k, De(k));
        if (typeof k == "string")
          return V(k);
        switch (k) {
          case u:
            return V("Suspense");
          case d:
            return V("SuspenseList");
        }
        if (typeof k == "object")
          switch (k.$$typeof) {
            case c:
              return be(k.render);
            case f:
              return Re(k.type, q, se);
            case p:
              return be(k._render);
            case h: {
              var ge = k, Ve = ge._payload, Be = ge._init;
              try {
                return Re(Be(Ve), q, se);
              } catch {
              }
            }
          }
        return "";
      }
      var wt = {}, ct = E.ReactDebugCurrentFrame;
      function St(k) {
        if (k) {
          var q = k._owner, se = Re(k.type, k._source, q ? q.type : null);
          ct.setExtraStackFrame(se);
        } else
          ct.setExtraStackFrame(null);
      }
      function Wt(k, q, se, ge, Ve) {
        {
          var Be = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Me in k)
            if (Be(k, Me)) {
              var _e = void 0;
              try {
                if (typeof k[Me] != "function") {
                  var ut = Error((ge || "React class") + ": " + se + " type `" + Me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof k[Me] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ut.name = "Invariant Violation", ut;
                }
                _e = k[Me](q, Me, ge, se, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Ze) {
                _e = Ze;
              }
              _e && !(_e instanceof Error) && (St(Ve), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ge || "React class", se, Me, typeof _e), St(null)), _e instanceof Error && !(_e.message in wt) && (wt[_e.message] = !0, St(Ve), C("Failed %s type: %s", se, _e.message), St(null));
            }
        }
      }
      var it = E.ReactCurrentOwner, rt = Object.prototype.hasOwnProperty, pr = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, gr, Dt, ln;
      ln = {};
      function jr(k) {
        if (rt.call(k, "ref")) {
          var q = Object.getOwnPropertyDescriptor(k, "ref").get;
          if (q && q.isReactWarning)
            return !1;
        }
        return k.ref !== void 0;
      }
      function mr(k) {
        if (rt.call(k, "key")) {
          var q = Object.getOwnPropertyDescriptor(k, "key").get;
          if (q && q.isReactWarning)
            return !1;
        }
        return k.key !== void 0;
      }
      function qt(k, q) {
        if (typeof k.ref == "string" && it.current && q && it.current.stateNode !== q) {
          var se = j(it.current.type);
          ln[se] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(it.current.type), k.ref), ln[se] = !0);
        }
      }
      function cn(k, q) {
        {
          var se = function() {
            gr || (gr = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", q));
          };
          se.isReactWarning = !0, Object.defineProperty(k, "key", {
            get: se,
            configurable: !0
          });
        }
      }
      function Xt(k, q) {
        {
          var se = function() {
            Dt || (Dt = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", q));
          };
          se.isReactWarning = !0, Object.defineProperty(k, "ref", {
            get: se,
            configurable: !0
          });
        }
      }
      var _t = function(k, q, se, ge, Ve, Be, Me) {
        var _e = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: k,
          key: q,
          ref: se,
          props: Me,
          // Record the component responsible for creating this element.
          _owner: Be
        };
        return _e._store = {}, Object.defineProperty(_e._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(_e, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ge
        }), Object.defineProperty(_e, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ve
        }), Object.freeze && (Object.freeze(_e.props), Object.freeze(_e)), _e;
      };
      function vs(k, q, se, ge, Ve) {
        {
          var Be, Me = {}, _e = null, ut = null;
          se !== void 0 && (_e = "" + se), mr(q) && (_e = "" + q.key), jr(q) && (ut = q.ref, qt(q, Ve));
          for (Be in q)
            rt.call(q, Be) && !pr.hasOwnProperty(Be) && (Me[Be] = q[Be]);
          if (k && k.defaultProps) {
            var Ze = k.defaultProps;
            for (Be in Ze)
              Me[Be] === void 0 && (Me[Be] = Ze[Be]);
          }
          if (_e || ut) {
            var tt = typeof k == "function" ? k.displayName || k.name || "Unknown" : k;
            _e && cn(Me, tt), ut && Xt(Me, tt);
          }
          return _t(k, _e, ut, Ve, ge, it.current, Me);
        }
      }
      var bs = E.ReactCurrentOwner, ic = E.ReactDebugCurrentFrame;
      function vr(k) {
        if (k) {
          var q = k._owner, se = Re(k.type, k._source, q ? q.type : null);
          ic.setExtraStackFrame(se);
        } else
          ic.setExtraStackFrame(null);
      }
      var ys;
      ys = !1;
      function xs(k) {
        return typeof k == "object" && k !== null && k.$$typeof === r;
      }
      function sc() {
        {
          if (bs.current) {
            var k = j(bs.current.type);
            if (k)
              return `

Check the render method of \`` + k + "`.";
          }
          return "";
        }
      }
      function Cm(k) {
        {
          if (k !== void 0) {
            var q = k.fileName.replace(/^.*[\\\/]/, ""), se = k.lineNumber;
            return `

Check your code at ` + q + ":" + se + ".";
          }
          return "";
        }
      }
      var ac = {};
      function Em(k) {
        {
          var q = sc();
          if (!q) {
            var se = typeof k == "string" ? k : k.displayName || k.name;
            se && (q = `

Check the top-level render call using <` + se + ">.");
          }
          return q;
        }
      }
      function lc(k, q) {
        {
          if (!k._store || k._store.validated || k.key != null)
            return;
          k._store.validated = !0;
          var se = Em(q);
          if (ac[se])
            return;
          ac[se] = !0;
          var ge = "";
          k && k._owner && k._owner !== bs.current && (ge = " It was passed a child from " + j(k._owner.type) + "."), vr(k), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', se, ge), vr(null);
        }
      }
      function cc(k, q) {
        {
          if (typeof k != "object")
            return;
          if (Array.isArray(k))
            for (var se = 0; se < k.length; se++) {
              var ge = k[se];
              xs(ge) && lc(ge, q);
            }
          else if (xs(k))
            k._store && (k._store.validated = !0);
          else if (k) {
            var Ve = M(k);
            if (typeof Ve == "function" && Ve !== k.entries)
              for (var Be = Ve.call(k), Me; !(Me = Be.next()).done; )
                xs(Me.value) && lc(Me.value, q);
          }
        }
      }
      function km(k) {
        {
          var q = k.type;
          if (q == null || typeof q == "string")
            return;
          var se;
          if (typeof q == "function")
            se = q.propTypes;
          else if (typeof q == "object" && (q.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          q.$$typeof === f))
            se = q.propTypes;
          else
            return;
          if (se) {
            var ge = j(q);
            Wt(se, k.props, "prop", ge, k);
          } else if (q.PropTypes !== void 0 && !ys) {
            ys = !0;
            var Ve = j(q);
            C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ve || "Unknown");
          }
          typeof q.getDefaultProps == "function" && !q.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Mm(k) {
        {
          for (var q = Object.keys(k.props), se = 0; se < q.length; se++) {
            var ge = q[se];
            if (ge !== "children" && ge !== "key") {
              vr(k), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ge), vr(null);
              break;
            }
          }
          k.ref !== null && (vr(k), C("Invalid attribute `ref` supplied to `React.Fragment`."), vr(null));
        }
      }
      function uc(k, q, se, ge, Ve, Be) {
        {
          var Me = D(k);
          if (!Me) {
            var _e = "";
            (k === void 0 || typeof k == "object" && k !== null && Object.keys(k).length === 0) && (_e += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var ut = Cm(Ve);
            ut ? _e += ut : _e += sc();
            var Ze;
            k === null ? Ze = "null" : Array.isArray(k) ? Ze = "array" : k !== void 0 && k.$$typeof === r ? (Ze = "<" + (j(k.type) || "Unknown") + " />", _e = " Did you accidentally export a JSX literal instead of a component?") : Ze = typeof k, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ze, _e);
          }
          var tt = vs(k, q, se, Ve, Be);
          if (tt == null)
            return tt;
          if (Me) {
            var un = q.children;
            if (un !== void 0)
              if (ge)
                if (Array.isArray(un)) {
                  for (var br = 0; br < un.length; br++)
                    cc(un[br], k);
                  Object.freeze && Object.freeze(un);
                } else
                  C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                cc(un, k);
          }
          return k === t.Fragment ? Mm(tt) : km(tt), tt;
        }
      }
      function Om(k, q, se) {
        return uc(k, q, se, !0);
      }
      function Pm(k, q, se) {
        return uc(k, q, se, !1);
      }
      var Sm = Pm, Dm = Om;
      t.jsx = Sm, t.jsxs = Dm;
    }();
  }(_s)), _s;
}
process.env.NODE_ENV === "production" ? na.exports = Am() : na.exports = Lm();
var Va = na.exports;
const dt = Va.Fragment, _ = Va.jsx, Z = Va.jsxs;
function ne() {
  return ne = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, ne.apply(this, arguments);
}
function Fm(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function Ba(...t) {
  return (e) => t.forEach(
    (n) => Fm(n, e)
  );
}
function et(...t) {
  return pe(Ba(...t), t);
}
const zt = /* @__PURE__ */ de((t, e) => {
  const { children: n, ...r } = t, o = Or.toArray(n), i = o.find(Hm);
  if (i) {
    const s = i.props.children, a = o.map((l) => l === i ? Or.count(s) > 1 ? Or.only(null) : /* @__PURE__ */ Ci(s) ? s.props.children : null : l);
    return /* @__PURE__ */ A(ra, ne({}, r, {
      ref: e
    }), /* @__PURE__ */ Ci(s) ? /* @__PURE__ */ Ki(s, void 0, a) : null);
  }
  return /* @__PURE__ */ A(ra, ne({}, r, {
    ref: e
  }), n);
});
zt.displayName = "Slot";
const ra = /* @__PURE__ */ de((t, e) => {
  const { children: n, ...r } = t;
  return /* @__PURE__ */ Ci(n) ? /* @__PURE__ */ Ki(n, {
    ...Wm(r, n.props),
    ref: e ? Ba(e, n.ref) : n.ref
  }) : Or.count(n) > 1 ? Or.only(null) : null;
});
ra.displayName = "SlotClone";
const cf = ({ children: t }) => /* @__PURE__ */ A(of, null, t);
function Hm(t) {
  return /* @__PURE__ */ Ci(t) && t.type === cf;
}
function Wm(t, e) {
  const n = {
    ...e
  };
  for (const r in e) {
    const o = t[r], i = e[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...t,
    ...n
  };
}
function uf(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (n = uf(t[e])) && (r && (r += " "), r += n);
    else
      for (e in t)
        t[e] && (r && (r += " "), r += e);
  return r;
}
function df() {
  for (var t, e, n = 0, r = ""; n < arguments.length; )
    (t = arguments[n++]) && (e = uf(t)) && (r && (r += " "), r += e);
  return r;
}
const gc = (t) => typeof t == "boolean" ? "".concat(t) : t === 0 ? "0" : t, mc = df, Kt = (t, e) => (n) => {
  var r;
  if ((e == null ? void 0 : e.variants) == null)
    return mc(t, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = e, s = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = i == null ? void 0 : i[c];
    if (u === null)
      return null;
    const f = gc(u) || gc(d);
    return o[c][f];
  }), a = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((p) => {
      let [g, m] = p;
      return Array.isArray(m) ? m.includes({
        ...i,
        ...a
      }[g]) : {
        ...i,
        ...a
      }[g] === m;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return mc(t, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function Vm() {
  for (var t = 0, e, n, r = ""; t < arguments.length; )
    (e = arguments[t++]) && (n = ff(e)) && (r && (r += " "), r += n);
  return r;
}
function ff(t) {
  if (typeof t == "string")
    return t;
  for (var e, n = "", r = 0; r < t.length; r++)
    t[r] && (e = ff(t[r])) && (n && (n += " "), n += e);
  return n;
}
var ja = "-";
function Bm(t) {
  var e = zm(t), n = t.conflictingClassGroups, r = t.conflictingClassGroupModifiers, o = r === void 0 ? {} : r;
  function i(a) {
    var l = a.split(ja);
    return l[0] === "" && l.length !== 1 && l.shift(), hf(l, e) || jm(a);
  }
  function s(a, l) {
    var c = n[a] || [];
    return l && o[a] ? [].concat(c, o[a]) : c;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: s
  };
}
function hf(t, e) {
  var s;
  if (t.length === 0)
    return e.classGroupId;
  var n = t[0], r = e.nextPart.get(n), o = r ? hf(t.slice(1), r) : void 0;
  if (o)
    return o;
  if (e.validators.length !== 0) {
    var i = t.join(ja);
    return (s = e.validators.find(function(a) {
      var l = a.validator;
      return l(i);
    })) == null ? void 0 : s.classGroupId;
  }
}
var vc = /^\[(.+)\]$/;
function jm(t) {
  if (vc.test(t)) {
    var e = vc.exec(t)[1], n = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function zm(t) {
  var e = t.theme, n = t.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = Um(Object.entries(t.classGroups), n);
  return o.forEach(function(i) {
    var s = i[0], a = i[1];
    oa(a, r, s, e);
  }), r;
}
function oa(t, e, n, r) {
  t.forEach(function(o) {
    if (typeof o == "string") {
      var i = o === "" ? e : bc(e, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (Ym(o)) {
        oa(o(r), e, n, r);
        return;
      }
      e.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(function(s) {
      var a = s[0], l = s[1];
      oa(l, bc(e, a), n, r);
    });
  });
}
function bc(t, e) {
  var n = t;
  return e.split(ja).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function Ym(t) {
  return t.isThemeGetter;
}
function Um(t, e) {
  return e ? t.map(function(n) {
    var r = n[0], o = n[1], i = o.map(function(s) {
      return typeof s == "string" ? e + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(function(a) {
        var l = a[0], c = a[1];
        return [e + l, c];
      })) : s;
    });
    return [r, i];
  }) : t;
}
function Gm(t) {
  if (t < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(i, s) {
    n.set(i, s), e++, e > t && (e = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(s) {
      var a = n.get(s);
      if (a !== void 0)
        return a;
      if ((a = r.get(s)) !== void 0)
        return o(s, a), a;
    },
    set: function(s, a) {
      n.has(s) ? n.set(s, a) : o(s, a);
    }
  };
}
var pf = "!";
function Km(t) {
  var e = t.separator || ":", n = e.length === 1, r = e[0], o = e.length;
  return function(s) {
    for (var a = [], l = 0, c = 0, u, d = 0; d < s.length; d++) {
      var f = s[d];
      if (l === 0) {
        if (f === r && (n || s.slice(d, d + o) === e)) {
          a.push(s.slice(c, d)), c = d + o;
          continue;
        }
        if (f === "/") {
          u = d;
          continue;
        }
      }
      f === "[" ? l++ : f === "]" && l--;
    }
    var h = a.length === 0 ? s : s.substring(c), p = h.startsWith(pf), g = p ? h.substring(1) : h, m = u && u > c ? u - c : void 0;
    return {
      modifiers: a,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
}
function qm(t) {
  if (t.length <= 1)
    return t;
  var e = [], n = [];
  return t.forEach(function(r) {
    var o = r[0] === "[";
    o ? (e.push.apply(e, n.sort().concat([r])), n = []) : n.push(r);
  }), e.push.apply(e, n.sort()), e;
}
function Xm(t) {
  return {
    cache: Gm(t.cacheSize),
    splitModifiers: Km(t),
    ...Bm(t)
  };
}
var Zm = /\s+/;
function Qm(t, e) {
  var n = e.splitModifiers, r = e.getClassGroupId, o = e.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return t.trim().split(Zm).map(function(s) {
    var a = n(s), l = a.modifiers, c = a.hasImportantModifier, u = a.baseClassName, d = a.maybePostfixModifierPosition, f = r(d ? u.substring(0, d) : u), h = !!d;
    if (!f) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      if (f = r(u), !f)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      h = !1;
    }
    var p = qm(l).join(":"), g = c ? p + pf : p;
    return {
      isTailwindClass: !0,
      modifierId: g,
      classGroupId: f,
      originalClassName: s,
      hasPostfixModifier: h
    };
  }).reverse().filter(function(s) {
    if (!s.isTailwindClass)
      return !0;
    var a = s.modifierId, l = s.classGroupId, c = s.hasPostfixModifier, u = a + l;
    return i.has(u) ? !1 : (i.add(u), o(l, c).forEach(function(d) {
      return i.add(a + d);
    }), !0);
  }).reverse().map(function(s) {
    return s.originalClassName;
  }).join(" ");
}
function Jm() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r, o, i, s = a;
  function a(c) {
    var u = e[0], d = e.slice(1), f = d.reduce(function(h, p) {
      return p(h);
    }, u());
    return r = Xm(f), o = r.cache.get, i = r.cache.set, s = l, l(c);
  }
  function l(c) {
    var u = o(c);
    if (u)
      return u;
    var d = Qm(c, r);
    return i(c, d), d;
  }
  return function() {
    return s(Vm.apply(null, arguments));
  };
}
function Ye(t) {
  var e = function(r) {
    return r[t] || [];
  };
  return e.isThemeGetter = !0, e;
}
var gf = /^\[(?:([a-z-]+):)?(.+)\]$/i, ev = /^\d+\/\d+$/, tv = /* @__PURE__ */ new Set(["px", "full", "screen"]), nv = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, rv = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ov = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Vt(t) {
  return Zn(t) || tv.has(t) || ev.test(t) || ia(t);
}
function ia(t) {
  return cr(t, "length", uv);
}
function iv(t) {
  return cr(t, "size", mf);
}
function sv(t) {
  return cr(t, "position", mf);
}
function av(t) {
  return cr(t, "url", dv);
}
function Lo(t) {
  return cr(t, "number", Zn);
}
function Zn(t) {
  return !Number.isNaN(Number(t));
}
function lv(t) {
  return t.endsWith("%") && Zn(t.slice(0, -1));
}
function zr(t) {
  return yc(t) || cr(t, "number", yc);
}
function xe(t) {
  return gf.test(t);
}
function Yr() {
  return !0;
}
function Cn(t) {
  return nv.test(t);
}
function cv(t) {
  return cr(t, "", fv);
}
function cr(t, e, n) {
  var r = gf.exec(t);
  return r ? r[1] ? r[1] === e : n(r[2]) : !1;
}
function uv(t) {
  return rv.test(t);
}
function mf() {
  return !1;
}
function dv(t) {
  return t.startsWith("url(");
}
function yc(t) {
  return Number.isInteger(Number(t));
}
function fv(t) {
  return ov.test(t);
}
function hv() {
  var t = Ye("colors"), e = Ye("spacing"), n = Ye("blur"), r = Ye("brightness"), o = Ye("borderColor"), i = Ye("borderRadius"), s = Ye("borderSpacing"), a = Ye("borderWidth"), l = Ye("contrast"), c = Ye("grayscale"), u = Ye("hueRotate"), d = Ye("invert"), f = Ye("gap"), h = Ye("gradientColorStops"), p = Ye("gradientColorStopPositions"), g = Ye("inset"), m = Ye("margin"), v = Ye("opacity"), b = Ye("padding"), y = Ye("saturate"), w = Ye("scale"), x = Ye("sepia"), M = Ye("skew"), E = Ye("space"), C = Ye("translate"), O = function() {
    return ["auto", "contain", "none"];
  }, R = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, D = function() {
    return ["auto", xe, e];
  }, $ = function() {
    return [xe, e];
  }, T = function() {
    return ["", Vt];
  }, j = function() {
    return ["auto", Zn, xe];
  }, L = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, Y = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, H = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, z = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, ee = function() {
    return ["", "0", xe];
  }, I = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, F = function() {
    return [Zn, Lo];
  }, te = function() {
    return [Zn, xe];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Yr],
      spacing: [Vt],
      blur: ["none", "", Cn, xe],
      brightness: F(),
      borderColor: [t],
      borderRadius: ["none", "", "full", Cn, xe],
      borderSpacing: $(),
      borderWidth: T(),
      contrast: F(),
      grayscale: ee(),
      hueRotate: te(),
      invert: ee(),
      gap: $(),
      gradientColorStops: [t],
      gradientColorStopPositions: [lv, ia],
      inset: D(),
      margin: D(),
      opacity: F(),
      padding: $(),
      saturate: F(),
      scale: F(),
      sepia: ee(),
      skew: te(),
      space: $(),
      translate: $()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", xe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Cn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": I()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": I()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(L(), [xe])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: R()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": R()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": R()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", zr]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: D()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", xe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ee()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ee()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", zr]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Yr]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", zr]
        }, xe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": j()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": j()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Yr]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [zr]
        }, xe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": j()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": j()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", xe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", xe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(z())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(z(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(z(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", xe, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", xe, Vt]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [Cn]
        }, Cn, xe]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [xe, e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", xe, Vt]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [xe, e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Cn, ia]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Lo]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Yr]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", xe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Zn, Lo]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", xe, Vt]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", xe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", xe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(Y(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Vt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", xe, Vt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: $()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", xe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", xe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(L(), [sv])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", iv]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, av]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(Y(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Y()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(Y())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [xe, Vt]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Vt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: T()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Vt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Cn, cv]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Yr]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": H()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": H()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Cn, xe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [y]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [y]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", xe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: te()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", xe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: te()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", xe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [zr, xe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [C]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [C]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [M]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [M]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", xe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", xe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": $()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": $()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": $()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": $()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": $()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": $()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": $()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": $()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": $()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": $()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": $()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": $()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": $()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": $()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": $()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": $()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": $()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": $()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", xe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Vt, Lo]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var pv = /* @__PURE__ */ Jm(hv);
function ye(...t) {
  return pv(df(t));
}
const Ei = Kt(
  "relative select-none overflow-hidden inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors duration-75 focus-visible:outline-none focus-visible:ring-1 border border-transparent disabled:cursor-not-allowed disabled:pointer-events-none",
  {
    variants: {
      variant: {
        primary: "bg-info-bold text-foundations-inverse border-info-bolder hover:bg-info-bolder hover:border-info-boldest hover:shadow-sm focus-visible:border-info-boldest focus-visible:ring-info-boldest focus-visible::shadow-sm active:bg-info-boldest [&_.spinner-container]:bg-foundations-subtlest [&_.spinner-icon]:border-info-boldest [&_.spinner-icon]:border-r-info-subtle",
        secondary: "bg-foundations-default text-foundations-subtle border-foundations-bold hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:ring-info-bold focus-visible:shadow-sm active:bg-foundations-subtler active:text-foundations-bold [&_.spinner-container]:bg-foundations-default [&_.spinner-icon]:border-info-boldest [&_.spinner-icon]:border-r-info-subtle",
        tertiary: "text-foundations-subtle hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:ring-info-bold focus-visible:shadow-sm active:bg-foundations-subtler active:text-foundations-bold  [&_.spinner-container]:bg-foundations-default [&_.spinner-icon]:border-info-boldest [&_.spinner-icon]:border-r-info-subtle"
      },
      size: {
        xs: "text-xs px-4 py-1.5 [&_svg]:h-5 [&_svg]:w-5 [&_.spinner-icon]:h-5 [&_.spinner-icon]:w-5",
        sm: "text-sm px-6 py-2.5 [&_svg]:h-5 [&_svg]:w-5 [&_.spinner-icon]:h-5 [&_.spinner-icon]:w-5",
        md: "text-base px-6 py-3 [&_svg]:h-6 [&_svg]:w-6 [&_.spinner-icon]:h-6 [&_.spinner-icon]:w-6",
        lg: "text-base px-8 py-4 [&_svg]:h-6 [&_svg]:w-6 [&_.spinner-icon]:h-6 [&_.spinner-icon]:w-6"
      },
      disabled: {
        true: ""
      },
      colorScheme: {
        danger: "",
        success: "",
        inverse: ""
      }
    },
    compoundVariants: [
      {
        variant: "primary",
        colorScheme: "danger",
        className: "bg-danger-bold border-danger-bolder hover:bg-danger-bolder hover:border-danger-boldest focus-visible:border-danger-boldest focus-visible:ring-danger-boldest active:bg-danger-boldest [&_.spinner-icon]:border-red-700 [&_.spinner-icon]:border-r-red-300"
      },
      {
        variant: "primary",
        colorScheme: "success",
        className: "bg-success-bold border-success-bolder hover:bg-success-bolder hover:border-success-boldest focus-visible:border-success-boldest focus-visible:ring-success-boldest active:bg-success-boldest [&_.spinner-icon]:border-green-700 [&_.spinner-icon]:border-r-green-300"
      },
      {
        variant: "primary",
        colorScheme: "inverse",
        className: "bg-foundations-default text-info border-info-bold hover:bg-info-subtler hover:border-info-bold focus-visible:border-info-bold focus-visible:ring-info-bold active:bg-info-subtler active:text-info disabled:text-foundations-subtler "
      },
      {
        variant: "secondary",
        colorScheme: "danger",
        className: "text-danger border border-danger-subtle hover:text-danger active:border-danger-subtler active:text-danger hover:bg-danger-subtler focus-visible:border-danger-subtle focus-visible:ring-danger-subtle active:bg-danger-subtler"
      },
      {
        variant: "secondary",
        colorScheme: "success",
        className: "text-success border border-success-subtle hover:text-success active:border-success-subtler active:text-success hover:bg-success-subtler focus-visible:border-success-subtle focus-visible:ring-success-subtle active:bg-success-subtler"
      },
      {
        variant: "primary",
        disabled: !0,
        className: "disabled:bg-foundations-subtler disabled:text-foundations-subtler disabled:border-foundations-subtle"
      },
      {
        variant: "secondary",
        disabled: !0,
        className: "disabled:bg-foundations-subtlest disabled:border-foundations-subtle disabled:text-foundations-subtler"
      },
      {
        variant: "tertiary",
        disabled: !0,
        className: "disabled:text-foundations-subtler"
      },
      {
        colorScheme: "inverse",
        disabled: !0,
        className: "disabled:border-foundations-bold disabled:bg-foundations-subtler disabled:!text-foundations-subtler"
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "sm"
    }
  }
), sa = S.forwardRef(
  ({
    className: t,
    variant: e,
    size: n,
    isLoading: r,
    colorScheme: o,
    asChild: i = !1,
    children: s,
    ...a
  }, l) => i ? /* @__PURE__ */ _(
    zt,
    {
      className: ye(
        Ei({
          variant: e,
          size: n,
          colorScheme: o,
          disabled: a.disabled || r,
          className: t
        })
      ),
      ref: l,
      ...a,
      children: s
    }
  ) : /* @__PURE__ */ Z(
    "button",
    {
      type: "button",
      className: ye(
        Ei({
          variant: e,
          size: n,
          colorScheme: o,
          disabled: a.disabled || r,
          className: t
        })
      ),
      ref: l,
      disabled: a.disabled || r,
      ...a,
      children: [
        s,
        r && /* @__PURE__ */ _("div", { className: "spinner-container absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ _("div", { className: "spinner-icon animate-spin rounded-full border-4" }) })
      ]
    }
  )
);
sa.displayName = "Button";
const gv = P.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ _(
  "div",
  {
    role: "group",
    ref: n,
    className: ye(
      "flex [&>button:focus]:z-10 [&>button:not(:first-child)]:rounded-l-none [&>button:not(:focus-visible):not(:last-child)]:border-r-transparent [&>button:not(:last-child)]:rounded-r-none",
      t
    ),
    ...e
  }
));
gv.displayName = "ButtonGroup";
const xc = Kt("", {
  variants: {
    size: {
      xs: "[&_svg]:h-5 [&_svg]:w-5 p-1.5",
      sm: "[&_svg]:h-5 [&_svg]:w-5 p-2.5",
      md: "[&_svg]:h-6 [&_svg]:w-6 p-3",
      lg: "[&_svg]:h-6 [&_svg]:w-6 p-4"
    },
    shape: {
      circle: "rounded-full"
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), aa = S.forwardRef(
  ({
    className: t,
    variant: e,
    size: n,
    isLoading: r,
    colorScheme: o,
    shape: i,
    asChild: s = !1,
    children: a,
    ...l
  }, c) => s ? /* @__PURE__ */ _(
    zt,
    {
      className: ye(
        Ei({
          variant: e,
          size: n,
          colorScheme: o,
          disabled: l.disabled || r
        }),
        xc({
          size: n,
          shape: i,
          className: t
        })
      ),
      ref: c,
      ...l,
      children: a
    }
  ) : /* @__PURE__ */ Z(
    "button",
    {
      type: "button",
      className: ye(
        Ei({
          variant: e,
          size: n,
          colorScheme: o,
          disabled: l.disabled || r
        }),
        xc({
          size: n,
          shape: i,
          className: t
        })
      ),
      ref: c,
      disabled: l.disabled || r,
      ...l,
      children: [
        a,
        r && /* @__PURE__ */ _("div", { className: "spinner-container absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ _("div", { className: "spinner-icon animate-spin rounded-full border-4" }) })
      ]
    }
  )
);
aa.displayName = "IconButton";
function ve(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (t == null || t(o), n === !1 || !o.defaultPrevented)
      return e == null ? void 0 : e(o);
  };
}
function sn(t, e = []) {
  let n = [];
  function r(i, s) {
    const a = /* @__PURE__ */ At(s), l = n.length;
    n = [
      ...n,
      s
    ];
    function c(d) {
      const { scope: f, children: h, ...p } = d, g = (f == null ? void 0 : f[t][l]) || a, m = rr(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ A(g.Provider, {
        value: m
      }, h);
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[t][l]) || a, p = Gt(h);
      if (p)
        return p;
      if (s !== void 0)
        return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [
      c,
      u
    ];
  }
  const o = () => {
    const i = n.map((s) => /* @__PURE__ */ At(s));
    return function(a) {
      const l = (a == null ? void 0 : a[t]) || i;
      return rr(
        () => ({
          [`__scope${t}`]: {
            ...a,
            [t]: l
          }
        }),
        [
          a,
          l
        ]
      );
    };
  };
  return o.scopeName = t, [
    r,
    mv(o, ...e)
  ];
}
function mv(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return rr(
        () => ({
          [`__scope${e.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = e.scopeName, n;
}
const vv = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], je = vv.reduce((t, e) => {
  const n = /* @__PURE__ */ de((r, o) => {
    const { asChild: i, ...s } = r, a = i ? zt : e;
    return ue(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ A(a, ne({}, s, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${e}`, {
    ...t,
    [e]: n
  };
}, {});
function za(t, e) {
  t && lf(
    () => t.dispatchEvent(e)
  );
}
function ht(t) {
  const e = le(t);
  return ue(() => {
    e.current = t;
  }), rr(
    () => (...n) => {
      var r;
      return (r = e.current) === null || r === void 0 ? void 0 : r.call(e, ...n);
    },
    []
  );
}
function vf(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = ht(t);
  ue(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return e.addEventListener("keydown", r), () => e.removeEventListener("keydown", r);
  }, [
    n,
    e
  ]);
}
const la = "dismissableLayer.update", bv = "dismissableLayer.pointerDownOutside", yv = "dismissableLayer.focusOutside";
let wc;
const xv = /* @__PURE__ */ At({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), bf = /* @__PURE__ */ de((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: s, onInteractOutside: a, onDismiss: l, ...c } = t, u = Gt(xv), [d, f] = ke(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = ke({}), g = et(
    e,
    (C) => f(C)
  ), m = Array.from(u.layers), [v] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), b = m.indexOf(v), y = d ? m.indexOf(d) : -1, w = u.layersWithOutsidePointerEventsDisabled.size > 0, x = y >= b, M = wv((C) => {
    const O = C.target, R = [
      ...u.branches
    ].some(
      (D) => D.contains(O)
    );
    !x || R || (i == null || i(C), a == null || a(C), C.defaultPrevented || l == null || l());
  }, h), E = _v((C) => {
    const O = C.target;
    [
      ...u.branches
    ].some(
      (D) => D.contains(O)
    ) || (s == null || s(C), a == null || a(C), C.defaultPrevented || l == null || l());
  }, h);
  return vf((C) => {
    y === u.layers.size - 1 && (o == null || o(C), !C.defaultPrevented && l && (C.preventDefault(), l()));
  }, h), ue(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (wc = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), _c(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = wc);
      };
  }, [
    d,
    h,
    r,
    u
  ]), ue(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), _c());
  }, [
    d,
    u
  ]), ue(() => {
    const C = () => p({});
    return document.addEventListener(la, C), () => document.removeEventListener(la, C);
  }, []), /* @__PURE__ */ A(je.div, ne({}, c, {
    ref: g,
    style: {
      pointerEvents: w ? x ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: ve(t.onFocusCapture, E.onFocusCapture),
    onBlurCapture: ve(t.onBlurCapture, E.onBlurCapture),
    onPointerDownCapture: ve(t.onPointerDownCapture, M.onPointerDownCapture)
  }));
});
function wv(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = ht(t), r = le(!1), o = le(() => {
  });
  return ue(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          yf(bv, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (e.removeEventListener("click", o.current), o.current = c, e.addEventListener("click", o.current, {
          once: !0
        })) : c();
      }
      r.current = !1;
    }, s = window.setTimeout(() => {
      e.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), e.removeEventListener("pointerdown", i), e.removeEventListener("click", o.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function _v(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = ht(t), r = le(!1);
  return ue(() => {
    const o = (i) => {
      i.target && !r.current && yf(yv, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", o), () => e.removeEventListener("focusin", o);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function _c() {
  const t = new CustomEvent(la);
  document.dispatchEvent(t);
}
function yf(t, e, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && o.addEventListener(t, e, {
    once: !0
  }), r ? za(o, i) : o.dispatchEvent(i);
}
const Rn = globalThis != null && globalThis.document ? qi : () => {
}, Cv = S["useId".toString()] || (() => {
});
let Ev = 0;
function po(t) {
  const [e, n] = S.useState(Cv());
  return Rn(() => {
    t || n(
      (r) => r ?? String(Ev++)
    );
  }, [
    t
  ]), t || (e ? `radix-${e}` : "");
}
const kv = ["top", "right", "bottom", "left"], An = Math.min, kt = Math.max, ki = Math.round, Fo = Math.floor, Ln = (t) => ({
  x: t,
  y: t
}), Mv = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ov = {
  start: "end",
  end: "start"
};
function ca(t, e, n) {
  return kt(t, An(e, n));
}
function bn(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function yn(t) {
  return t.split("-")[0];
}
function Wr(t) {
  return t.split("-")[1];
}
function Ya(t) {
  return t === "x" ? "y" : "x";
}
function Ua(t) {
  return t === "y" ? "height" : "width";
}
function Vr(t) {
  return ["top", "bottom"].includes(yn(t)) ? "y" : "x";
}
function Ga(t) {
  return Ya(Vr(t));
}
function Pv(t, e, n) {
  n === void 0 && (n = !1);
  const r = Wr(t), o = Ga(t), i = Ua(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = Mi(s)), [s, Mi(s)];
}
function Sv(t) {
  const e = Mi(t);
  return [ua(t), e, ua(e)];
}
function ua(t) {
  return t.replace(/start|end/g, (e) => Ov[e]);
}
function Dv(t, e, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? o : r : e ? r : o;
    case "left":
    case "right":
      return e ? i : s;
    default:
      return [];
  }
}
function Tv(t, e, n, r) {
  const o = Wr(t);
  let i = Dv(yn(t), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), e && (i = i.concat(i.map(ua)))), i;
}
function Mi(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Mv[e]);
}
function Iv(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function xf(t) {
  return typeof t != "number" ? Iv(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Oi(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function Cc(t, e, n) {
  let {
    reference: r,
    floating: o
  } = t;
  const i = Vr(e), s = Ga(e), a = Ua(s), l = yn(e), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Wr(e)) {
    case "start":
      h[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[s] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const $v = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: o
  }), {
    x: u,
    y: d
  } = Cc(c, r, l), f = r, h = {}, p = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: m,
      fn: v
    } = a[g], {
      x: b,
      y,
      data: w,
      reset: x
    } = await v({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (u = b ?? u, d = y ?? d, h = {
      ...h,
      [m]: {
        ...h[m],
        ...w
      }
    }, x && p <= 50) {
      p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (c = x.rects === !0 ? await s.getElementRects({
        reference: t,
        floating: e,
        strategy: o
      }) : x.rects), {
        x: u,
        y: d
      } = Cc(c, f, l)), g = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function go(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = bn(e, t), p = xf(h), m = a[f ? d === "floating" ? "reference" : "floating" : d], v = Oi(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(m))) == null || n ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), b = d === "floating" ? {
    ...s.floating,
    x: r,
    y: o
  } : s.reference, y = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), w = await (i.isElement == null ? void 0 : i.isElement(y)) ? await (i.getScale == null ? void 0 : i.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Oi(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: b,
    offsetParent: y,
    strategy: l
  }) : b);
  return {
    top: (v.top - x.top + p.top) / w.y,
    bottom: (x.bottom - v.bottom + p.bottom) / w.y,
    left: (v.left - x.left + p.left) / w.x,
    right: (x.right - v.right + p.right) / w.x
  };
}
const Ec = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a
    } = e, {
      element: l,
      padding: c = 0
    } = bn(t, e) || {};
    if (l == null)
      return {};
    const u = xf(c), d = {
      x: n,
      y: r
    }, f = Ga(o), h = Ua(f), p = await s.getDimensions(l), g = f === "y", m = g ? "top" : "left", v = g ? "bottom" : "right", b = g ? "clientHeight" : "clientWidth", y = i.reference[h] + i.reference[f] - d[f] - i.floating[h], w = d[f] - i.reference[f], x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let M = x ? x[b] : 0;
    (!M || !await (s.isElement == null ? void 0 : s.isElement(x))) && (M = a.floating[b] || i.floating[h]);
    const E = y / 2 - w / 2, C = M / 2 - p[h] / 2 - 1, O = An(u[m], C), R = An(u[v], C), D = O, $ = M - p[h] - R, T = M / 2 - p[h] / 2 + E, j = ca(D, T, $), Y = Wr(o) != null && T != j && i.reference[h] / 2 - (T < D ? O : R) - p[h] / 2 < 0 ? T < D ? D - T : $ - T : 0;
    return {
      [f]: d[f] - Y,
      data: {
        [f]: j,
        centerOffset: T - j + Y
      }
    };
  }
}), Ka = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n;
      const {
        placement: r,
        middlewareData: o,
        rects: i,
        initialPlacement: s,
        platform: a,
        elements: l
      } = e, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: d,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: p = !0,
        ...g
      } = bn(t, e), m = yn(r), v = yn(s) === s, b = await (a.isRTL == null ? void 0 : a.isRTL(l.floating)), y = d || (v || !p ? [Mi(s)] : Sv(s));
      !d && h !== "none" && y.push(...Tv(s, p, h, b));
      const w = [s, ...y], x = await go(e, g), M = [];
      let E = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (c && M.push(x[m]), u) {
        const D = Pv(r, i, b);
        M.push(x[D[0]], x[D[1]]);
      }
      if (E = [...E, {
        placement: r,
        overflows: M
      }], !M.every((D) => D <= 0)) {
        var C, O;
        const D = (((C = o.flip) == null ? void 0 : C.index) || 0) + 1, $ = w[D];
        if ($)
          return {
            data: {
              index: D,
              overflows: E
            },
            reset: {
              placement: $
            }
          };
        let T = (O = E.filter((j) => j.overflows[0] <= 0).sort((j, L) => j.overflows[1] - L.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!T)
          switch (f) {
            case "bestFit": {
              var R;
              const j = (R = E.map((L) => [L.placement, L.overflows.filter((Y) => Y > 0).reduce((Y, H) => Y + H, 0)]).sort((L, Y) => L[1] - Y[1])[0]) == null ? void 0 : R[0];
              j && (T = j);
              break;
            }
            case "initialPlacement":
              T = s;
              break;
          }
        if (r !== T)
          return {
            reset: {
              placement: T
            }
          };
      }
      return {};
    }
  };
};
function kc(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Mc(t) {
  return kv.some((e) => t[e] >= 0);
}
const wf = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...o
      } = bn(t, e);
      switch (r) {
        case "referenceHidden": {
          const i = await go(e, {
            ...o,
            elementContext: "reference"
          }), s = kc(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Mc(s)
            }
          };
        }
        case "escaped": {
          const i = await go(e, {
            ...o,
            altBoundary: !0
          }), s = kc(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Mc(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Nv(t, e) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = t, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = yn(n), a = Wr(n), l = Vr(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = i && l ? -1 : 1, d = bn(e, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const qa = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r
      } = e, o = await Nv(e, t);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, Xa = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: o
      } = e, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (m) => {
            let {
              x: v,
              y: b
            } = m;
            return {
              x: v,
              y: b
            };
          }
        },
        ...l
      } = bn(t, e), c = {
        x: n,
        y: r
      }, u = await go(e, l), d = Vr(yn(o)), f = Ya(d);
      let h = c[f], p = c[d];
      if (i) {
        const m = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", b = h + u[m], y = h - u[v];
        h = ca(b, h, y);
      }
      if (s) {
        const m = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", b = p + u[m], y = p - u[v];
        p = ca(b, p, y);
      }
      const g = a.fn({
        ...e,
        [f]: h,
        [d]: p
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, _f = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = e, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = bn(t, e), u = {
        x: n,
        y: r
      }, d = Vr(o), f = Ya(d);
      let h = u[f], p = u[d];
      const g = bn(a, e), m = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const y = f === "y" ? "height" : "width", w = i.reference[f] - i.floating[y] + m.mainAxis, x = i.reference[f] + i.reference[y] - m.mainAxis;
        h < w ? h = w : h > x && (h = x);
      }
      if (c) {
        var v, b;
        const y = f === "y" ? "width" : "height", w = ["top", "left"].includes(yn(o)), x = i.reference[d] - i.floating[y] + (w && ((v = s.offset) == null ? void 0 : v[d]) || 0) + (w ? 0 : m.crossAxis), M = i.reference[d] + i.reference[y] + (w ? 0 : ((b = s.offset) == null ? void 0 : b[d]) || 0) - (w ? m.crossAxis : 0);
        p < x ? p = x : p > M && (p = M);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, Za = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = e, {
        apply: s = () => {
        },
        ...a
      } = bn(t, e), l = await go(e, a), c = yn(n), u = Wr(n), d = Vr(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let p, g;
      c === "top" || c === "bottom" ? (p = c, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = c, p = u === "end" ? "top" : "bottom");
      const m = h - l[p], v = f - l[g], b = !e.middlewareData.shift;
      let y = m, w = v;
      if (d) {
        const M = f - l.left - l.right;
        w = u || b ? An(v, M) : M;
      } else {
        const M = h - l.top - l.bottom;
        y = u || b ? An(m, M) : M;
      }
      if (b && !u) {
        const M = kt(l.left, 0), E = kt(l.right, 0), C = kt(l.top, 0), O = kt(l.bottom, 0);
        d ? w = f - 2 * (M !== 0 || E !== 0 ? M + E : kt(l.left, l.right)) : y = h - 2 * (C !== 0 || O !== 0 ? C + O : kt(l.top, l.bottom));
      }
      await s({
        ...e,
        availableWidth: w,
        availableHeight: y
      });
      const x = await o.getDimensions(i.floating);
      return f !== x.width || h !== x.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Fn(t) {
  return Cf(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Pt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function wn(t) {
  var e;
  return (e = (Cf(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Cf(t) {
  return t instanceof Node || t instanceof Pt(t).Node;
}
function xn(t) {
  return t instanceof Element || t instanceof Pt(t).Element;
}
function on(t) {
  return t instanceof HTMLElement || t instanceof Pt(t).HTMLElement;
}
function Oc(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Pt(t).ShadowRoot;
}
function Mo(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: o
  } = Lt(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(o);
}
function Rv(t) {
  return ["table", "td", "th"].includes(Fn(t));
}
function Qa(t) {
  const e = Ja(), n = Lt(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Av(t) {
  let e = Tr(t);
  for (; on(e) && !Xi(e); ) {
    if (Qa(e))
      return e;
    e = Tr(e);
  }
  return null;
}
function Ja() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Xi(t) {
  return ["html", "body", "#document"].includes(Fn(t));
}
function Lt(t) {
  return Pt(t).getComputedStyle(t);
}
function Zi(t) {
  return xn(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function Tr(t) {
  if (Fn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Oc(t) && t.host || // Fallback.
    wn(t)
  );
  return Oc(e) ? e.host : e;
}
function Ef(t) {
  const e = Tr(t);
  return Xi(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : on(e) && Mo(e) ? e : Ef(e);
}
function Pi(t, e) {
  var n;
  e === void 0 && (e = []);
  const r = Ef(t), o = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = Pt(r);
  return o ? e.concat(i, i.visualViewport || [], Mo(r) ? r : []) : e.concat(r, Pi(r));
}
function kf(t) {
  const e = Lt(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const o = on(t), i = o ? t.offsetWidth : n, s = o ? t.offsetHeight : r, a = ki(n) !== i || ki(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function el(t) {
  return xn(t) ? t : t.contextElement;
}
function Pr(t) {
  const e = el(t);
  if (!on(e))
    return Ln(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = kf(e);
  let s = (i ? ki(n.width) : n.width) / r, a = (i ? ki(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Lv = /* @__PURE__ */ Ln(0);
function Mf(t) {
  const e = Pt(t);
  return !Ja() || !e.visualViewport ? Lv : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Fv(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Pt(t) ? !1 : e;
}
function or(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), i = el(t);
  let s = Ln(1);
  e && (r ? xn(r) && (s = Pr(r)) : s = Pr(t));
  const a = Fv(i, n, r) ? Mf(i) : Ln(0);
  let l = (o.left + a.x) / s.x, c = (o.top + a.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (i) {
    const f = Pt(i), h = r && xn(r) ? Pt(r) : r;
    let p = f.frameElement;
    for (; p && r && h !== f; ) {
      const g = Pr(p), m = p.getBoundingClientRect(), v = Lt(p), b = m.left + (p.clientLeft + parseFloat(v.paddingLeft)) * g.x, y = m.top + (p.clientTop + parseFloat(v.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += b, c += y, p = Pt(p).frameElement;
    }
  }
  return Oi({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Hv(t) {
  let {
    rect: e,
    offsetParent: n,
    strategy: r
  } = t;
  const o = on(n), i = wn(n);
  if (n === i)
    return e;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = Ln(1);
  const l = Ln(0);
  if ((o || !o && r !== "fixed") && ((Fn(n) !== "body" || Mo(i)) && (s = Zi(n)), on(n))) {
    const c = or(n);
    a = Pr(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: e.width * a.x,
    height: e.height * a.y,
    x: e.x * a.x - s.scrollLeft * a.x + l.x,
    y: e.y * a.y - s.scrollTop * a.y + l.y
  };
}
function Wv(t) {
  return Array.from(t.getClientRects());
}
function Of(t) {
  return or(wn(t)).left + Zi(t).scrollLeft;
}
function Vv(t) {
  const e = wn(t), n = Zi(t), r = t.ownerDocument.body, o = kt(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), i = kt(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Of(t);
  const a = -n.scrollTop;
  return Lt(r).direction === "rtl" && (s += kt(e.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function Bv(t, e) {
  const n = Pt(t), r = wn(t), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const c = Ja();
    (!c || c && e === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function jv(t, e) {
  const n = or(t, !0, e === "fixed"), r = n.top + t.clientTop, o = n.left + t.clientLeft, i = on(t) ? Pr(t) : Ln(1), s = t.clientWidth * i.x, a = t.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function Pc(t, e, n) {
  let r;
  if (e === "viewport")
    r = Bv(t, n);
  else if (e === "document")
    r = Vv(wn(t));
  else if (xn(e))
    r = jv(e, n);
  else {
    const o = Mf(t);
    r = {
      ...e,
      x: e.x - o.x,
      y: e.y - o.y
    };
  }
  return Oi(r);
}
function Pf(t, e) {
  const n = Tr(t);
  return n === e || !xn(n) || Xi(n) ? !1 : Lt(n).position === "fixed" || Pf(n, e);
}
function zv(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = Pi(t).filter((a) => xn(a) && Fn(a) !== "body"), o = null;
  const i = Lt(t).position === "fixed";
  let s = i ? Tr(t) : t;
  for (; xn(s) && !Xi(s); ) {
    const a = Lt(s), l = Qa(s);
    !l && a.position === "fixed" && (o = null), (i ? !l && !o : !l && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Mo(s) && !l && Pf(t, s)) ? r = r.filter((u) => u !== s) : o = a, s = Tr(s);
  }
  return e.set(t, r), r;
}
function Yv(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = t;
  const s = [...n === "clippingAncestors" ? zv(e, this._c) : [].concat(n), r], a = s[0], l = s.reduce((c, u) => {
    const d = Pc(e, u, o);
    return c.top = kt(d.top, c.top), c.right = An(d.right, c.right), c.bottom = An(d.bottom, c.bottom), c.left = kt(d.left, c.left), c;
  }, Pc(e, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Uv(t) {
  return kf(t);
}
function Gv(t, e, n) {
  const r = on(e), o = wn(e), i = n === "fixed", s = or(t, !0, i, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ln(0);
  if (r || !r && !i)
    if ((Fn(e) !== "body" || Mo(o)) && (a = Zi(e)), r) {
      const c = or(e, !0, i, e);
      l.x = c.x + e.clientLeft, l.y = c.y + e.clientTop;
    } else
      o && (l.x = Of(o));
  return {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function Sc(t, e) {
  return !on(t) || Lt(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function Sf(t, e) {
  const n = Pt(t);
  if (!on(t))
    return n;
  let r = Sc(t, e);
  for (; r && Rv(r) && Lt(r).position === "static"; )
    r = Sc(r, e);
  return r && (Fn(r) === "html" || Fn(r) === "body" && Lt(r).position === "static" && !Qa(r)) ? n : r || Av(t) || n;
}
const Kv = async function(t) {
  let {
    reference: e,
    floating: n,
    strategy: r
  } = t;
  const o = this.getOffsetParent || Sf, i = this.getDimensions;
  return {
    reference: Gv(e, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await i(n)
    }
  };
};
function qv(t) {
  return Lt(t).direction === "rtl";
}
const Xv = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Hv,
  getDocumentElement: wn,
  getClippingRect: Yv,
  getOffsetParent: Sf,
  getElementRects: Kv,
  getClientRects: Wv,
  getDimensions: Uv,
  getScale: Pr,
  isElement: xn,
  isRTL: qv
};
function Zv(t, e) {
  let n = null, r;
  const o = wn(t);
  function i() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = t.getBoundingClientRect();
    if (a || e(), !d || !f)
      return;
    const h = Fo(u), p = Fo(o.clientWidth - (c + d)), g = Fo(o.clientHeight - (u + f)), m = Fo(c), b = {
      rootMargin: -h + "px " + -p + "px " + -g + "px " + -m + "px",
      threshold: kt(0, An(1, l)) || 1
    };
    let y = !0;
    function w(x) {
      const M = x[0].intersectionRatio;
      if (M !== l) {
        if (!y)
          return s();
        M ? s(!1, M) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      y = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...b,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, b);
    }
    n.observe(t);
  }
  return s(!0), i;
}
function tl(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = el(t), u = o || i ? [...c ? Pi(c) : [], ...Pi(e)] : [];
  u.forEach((v) => {
    o && v.addEventListener("scroll", n, {
      passive: !0
    }), i && v.addEventListener("resize", n);
  });
  const d = c && a ? Zv(c, n) : null;
  let f = -1, h = null;
  s && (h = new ResizeObserver((v) => {
    let [b] = v;
    b && b.target === c && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      h && h.observe(e);
    })), n();
  }), c && !l && h.observe(c), h.observe(e));
  let p, g = l ? or(t) : null;
  l && m();
  function m() {
    const v = or(t);
    g && (v.x !== g.x || v.y !== g.y || v.width !== g.width || v.height !== g.height) && n(), g = v, p = requestAnimationFrame(m);
  }
  return n(), () => {
    u.forEach((v) => {
      o && v.removeEventListener("scroll", n), i && v.removeEventListener("resize", n);
    }), d && d(), h && h.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const Qv = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Xv,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return $v(t, e, {
    ...o,
    platform: i
  });
}, Df = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof t == "function" ? t(n) : t;
      return r && e(r) ? r.current != null ? Ec({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Ec({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var di = typeof document < "u" ? qi : ue;
function Si(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, o;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Si(t[r], e[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(t), n = o.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && t.$$typeof) && !Si(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Tf(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Dc(t, e) {
  const n = Tf(t);
  return Math.round(e * n) / n;
}
function Tc(t) {
  const e = S.useRef(t);
  return di(() => {
    e.current = t;
  }), e;
}
function nl(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, d] = S.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = S.useState(r);
  Si(f, r) || h(r);
  const [p, g] = S.useState(null), [m, v] = S.useState(null), b = S.useCallback((Y) => {
    Y != M.current && (M.current = Y, g(Y));
  }, [g]), y = S.useCallback((Y) => {
    Y !== E.current && (E.current = Y, v(Y));
  }, [v]), w = i || p, x = s || m, M = S.useRef(null), E = S.useRef(null), C = S.useRef(u), O = Tc(l), R = Tc(o), D = S.useCallback(() => {
    if (!M.current || !E.current)
      return;
    const Y = {
      placement: e,
      strategy: n,
      middleware: f
    };
    R.current && (Y.platform = R.current), Qv(M.current, E.current, Y).then((H) => {
      const z = {
        ...H,
        isPositioned: !0
      };
      $.current && !Si(C.current, z) && (C.current = z, Nm.flushSync(() => {
        d(z);
      }));
    });
  }, [f, e, n, R]);
  di(() => {
    c === !1 && C.current.isPositioned && (C.current.isPositioned = !1, d((Y) => ({
      ...Y,
      isPositioned: !1
    })));
  }, [c]);
  const $ = S.useRef(!1);
  di(() => ($.current = !0, () => {
    $.current = !1;
  }), []), di(() => {
    if (w && (M.current = w), x && (E.current = x), w && x) {
      if (O.current)
        return O.current(w, x, D);
      D();
    }
  }, [w, x, D, O]);
  const T = S.useMemo(() => ({
    reference: M,
    floating: E,
    setReference: b,
    setFloating: y
  }), [b, y]), j = S.useMemo(() => ({
    reference: w,
    floating: x
  }), [w, x]), L = S.useMemo(() => {
    const Y = {
      position: n,
      left: 0,
      top: 0
    };
    if (!j.floating)
      return Y;
    const H = Dc(j.floating, u.x), z = Dc(j.floating, u.y);
    return a ? {
      ...Y,
      transform: "translate(" + H + "px, " + z + "px)",
      ...Tf(j.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: H,
      top: z
    };
  }, [n, a, j.floating, u.x, u.y]);
  return S.useMemo(() => ({
    ...u,
    update: D,
    refs: T,
    elements: j,
    floatingStyles: L
  }), [u, D, T, j, L]);
}
const Jv = /* @__PURE__ */ de((t, e) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = t;
  return /* @__PURE__ */ A(je.svg, ne({}, i, {
    ref: e,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), t.asChild ? n : /* @__PURE__ */ A("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), e0 = Jv;
function rl(t) {
  const [e, n] = ke(void 0);
  return Rn(() => {
    if (t) {
      n({
        width: t.offsetWidth,
        height: t.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          s = c.inlineSize, a = c.blockSize;
        } else
          s = t.offsetWidth, a = t.offsetHeight;
        n({
          width: s,
          height: a
        });
      });
      return r.observe(t, {
        box: "border-box"
      }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [
    t
  ]), e;
}
const If = "Popper", [$f, Qi] = sn(If), [t0, Nf] = $f(If), n0 = (t) => {
  const { __scopePopper: e, children: n } = t, [r, o] = ke(null);
  return /* @__PURE__ */ A(t0, {
    scope: e,
    anchor: r,
    onAnchorChange: o
  }, n);
}, r0 = "PopperAnchor", o0 = /* @__PURE__ */ de((t, e) => {
  const { __scopePopper: n, virtualRef: r, ...o } = t, i = Nf(r0, n), s = le(null), a = et(e, s);
  return ue(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
  }), r ? null : /* @__PURE__ */ A(je.div, ne({}, o, {
    ref: a
  }));
}), Rf = "PopperContent", [i0, s0] = $f(Rf), a0 = /* @__PURE__ */ de((t, e) => {
  var n, r, o, i, s, a, l, c;
  const { __scopePopper: u, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: g = 0, collisionBoundary: m = [], collisionPadding: v = 0, sticky: b = "partial", hideWhenDetached: y = !1, avoidCollisions: w = !0, onPlaced: x, ...M } = t, E = Nf(Rf, u), [C, O] = ke(null), R = et(
    e,
    (De) => O(De)
  ), [D, $] = ke(null), T = rl(D), j = (n = T == null ? void 0 : T.width) !== null && n !== void 0 ? n : 0, L = (r = T == null ? void 0 : T.height) !== null && r !== void 0 ? r : 0, Y = d + (h !== "center" ? "-" + h : ""), H = typeof v == "number" ? v : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...v
  }, z = Array.isArray(m) ? m : [
    m
  ], ee = z.length > 0, I = {
    padding: H,
    boundary: z.filter(d0),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: ee
  }, { refs: F, floatingStyles: te, placement: J, isPositioned: re, middlewareData: B } = nl({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: Y,
    whileElementsMounted: tl,
    elements: {
      reference: E.anchor
    },
    middleware: [
      qa({
        mainAxis: f + L,
        alignmentAxis: p
      }),
      w && Xa({
        mainAxis: !0,
        crossAxis: !1,
        limiter: b === "partial" ? _f() : void 0,
        ...I
      }),
      w && Ka({
        ...I
      }),
      Za({
        ...I,
        apply: ({ elements: De, rects: Re, availableWidth: wt, availableHeight: ct }) => {
          const { width: St, height: Wt } = Re.reference, it = De.floating.style;
          it.setProperty("--radix-popper-available-width", `${wt}px`), it.setProperty("--radix-popper-available-height", `${ct}px`), it.setProperty("--radix-popper-anchor-width", `${St}px`), it.setProperty("--radix-popper-anchor-height", `${Wt}px`);
        }
      }),
      D && Df({
        element: D,
        padding: g
      }),
      f0({
        arrowWidth: j,
        arrowHeight: L
      }),
      y && wf({
        strategy: "referenceHidden"
      })
    ]
  }), [N, W] = Af(J), V = ht(x);
  Rn(() => {
    re && (V == null || V());
  }, [
    re,
    V
  ]);
  const G = (o = B.arrow) === null || o === void 0 ? void 0 : o.x, oe = (i = B.arrow) === null || i === void 0 ? void 0 : i.y, X = ((s = B.arrow) === null || s === void 0 ? void 0 : s.centerOffset) !== 0, [U, be] = ke();
  return Rn(() => {
    C && be(window.getComputedStyle(C).zIndex);
  }, [
    C
  ]), /* @__PURE__ */ A("div", {
    ref: F.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...te,
      transform: re ? te.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: U,
      "--radix-popper-transform-origin": [
        (a = B.transformOrigin) === null || a === void 0 ? void 0 : a.x,
        (l = B.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: t.dir
  }, /* @__PURE__ */ A(i0, {
    scope: u,
    placedSide: N,
    onArrowChange: $,
    arrowX: G,
    arrowY: oe,
    shouldHideArrow: X
  }, /* @__PURE__ */ A(je.div, ne({
    "data-side": N,
    "data-align": W
  }, M, {
    ref: R,
    style: {
      ...M.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: re ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = B.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
}), l0 = "PopperArrow", c0 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, u0 = /* @__PURE__ */ de(function(e, n) {
  const { __scopePopper: r, ...o } = e, i = s0(l0, r), s = c0[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ A("span", {
      ref: i.onArrowChange,
      style: {
        position: "absolute",
        left: i.arrowX,
        top: i.arrowY,
        [s]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[i.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[i.placedSide],
        visibility: i.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ A(e0, ne({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function d0(t) {
  return t !== null;
}
const f0 = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, o, i, s;
    const { placement: a, rects: l, middlewareData: c } = e, d = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : t.arrowWidth, h = d ? 0 : t.arrowHeight, [p, g] = Af(a), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], v = ((r = (o = c.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2, b = ((i = (s = c.arrow) === null || s === void 0 ? void 0 : s.y) !== null && i !== void 0 ? i : 0) + h / 2;
    let y = "", w = "";
    return p === "bottom" ? (y = d ? m : `${v}px`, w = `${-h}px`) : p === "top" ? (y = d ? m : `${v}px`, w = `${l.floating.height + h}px`) : p === "right" ? (y = `${-h}px`, w = d ? m : `${b}px`) : p === "left" && (y = `${l.floating.width + h}px`, w = d ? m : `${b}px`), {
      data: {
        x: y,
        y: w
      }
    };
  }
});
function Af(t) {
  const [e, n = "center"] = t.split("-");
  return [
    e,
    n
  ];
}
const Lf = n0, ol = o0, Ff = a0, Hf = u0, il = /* @__PURE__ */ de((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = t;
  return r ? /* @__PURE__ */ af.createPortal(/* @__PURE__ */ A(je.div, ne({}, o, {
    ref: e
  })), r) : null;
}), h0 = il;
function p0(t, e) {
  return sf((n, r) => {
    const o = e[n][r];
    return o ?? n;
  }, t);
}
const ur = (t) => {
  const { present: e, children: n } = t, r = g0(e), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Or.only(n), i = et(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Ki(o, {
    ref: i
  }) : null;
};
ur.displayName = "Presence";
function g0(t) {
  const [e, n] = ke(), r = le({}), o = le(t), i = le("none"), s = t ? "mounted" : "unmounted", [a, l] = p0(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ue(() => {
    const c = Ho(r.current);
    i.current = a === "mounted" ? c : "none";
  }, [
    a
  ]), Rn(() => {
    const c = r.current, u = o.current;
    if (u !== t) {
      const f = i.current, h = Ho(c);
      t ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = t;
    }
  }, [
    t,
    l
  ]), Rn(() => {
    if (e) {
      const c = (d) => {
        const h = Ho(r.current).includes(d.animationName);
        d.target === e && h && lf(
          () => l("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === e && (i.current = Ho(r.current));
      };
      return e.addEventListener("animationstart", u), e.addEventListener("animationcancel", c), e.addEventListener("animationend", c), () => {
        e.removeEventListener("animationstart", u), e.removeEventListener("animationcancel", c), e.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    e,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: pe((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Ho(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function Wn({ prop: t, defaultProp: e, onChange: n = () => {
} }) {
  const [r, o] = m0({
    defaultProp: e,
    onChange: n
  }), i = t !== void 0, s = i ? t : r, a = ht(n), l = pe((c) => {
    if (i) {
      const d = typeof c == "function" ? c(t) : c;
      d !== t && a(d);
    } else
      o(c);
  }, [
    i,
    t,
    o,
    a
  ]);
  return [
    s,
    l
  ];
}
function m0({ defaultProp: t, onChange: e }) {
  const n = ke(t), [r] = n, o = le(r), i = ht(e);
  return ue(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const v0 = /* @__PURE__ */ de((t, e) => /* @__PURE__ */ A(je.span, ne({}, t, {
  ref: e,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...t.style
  }
}))), b0 = v0, [Ji, y8] = sn("Tooltip", [
  Qi
]), es = Qi(), y0 = "TooltipProvider", x0 = 700, da = "tooltip.open", [w0, sl] = Ji(y0), _0 = (t) => {
  const { __scopeTooltip: e, delayDuration: n = x0, skipDelayDuration: r = 300, disableHoverableContent: o = !1, children: i } = t, [s, a] = ke(!0), l = le(!1), c = le(0);
  return ue(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ A(w0, {
    scope: e,
    isOpenDelayed: s,
    delayDuration: n,
    onOpen: pe(() => {
      window.clearTimeout(c.current), a(!1);
    }, []),
    onClose: pe(() => {
      window.clearTimeout(c.current), c.current = window.setTimeout(
        () => a(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: l,
    onPointerInTransitChange: pe((u) => {
      l.current = u;
    }, []),
    disableHoverableContent: o
  }, i);
}, al = "Tooltip", [C0, Oo] = Ji(al), E0 = (t) => {
  const { __scopeTooltip: e, children: n, open: r, defaultOpen: o = !1, onOpenChange: i, disableHoverableContent: s, delayDuration: a } = t, l = sl(al, t.__scopeTooltip), c = es(e), [u, d] = ke(null), f = po(), h = le(0), p = s ?? l.disableHoverableContent, g = a ?? l.delayDuration, m = le(!1), [v = !1, b] = Wn({
    prop: r,
    defaultProp: o,
    onChange: (E) => {
      E ? (l.onOpen(), document.dispatchEvent(new CustomEvent(da))) : l.onClose(), i == null || i(E);
    }
  }), y = rr(() => v ? m.current ? "delayed-open" : "instant-open" : "closed", [
    v
  ]), w = pe(() => {
    window.clearTimeout(h.current), m.current = !1, b(!0);
  }, [
    b
  ]), x = pe(() => {
    window.clearTimeout(h.current), b(!1);
  }, [
    b
  ]), M = pe(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      m.current = !0, b(!0);
    }, g);
  }, [
    g,
    b
  ]);
  return ue(() => () => window.clearTimeout(h.current), []), /* @__PURE__ */ A(Lf, c, /* @__PURE__ */ A(C0, {
    scope: e,
    contentId: f,
    open: v,
    stateAttribute: y,
    trigger: u,
    onTriggerChange: d,
    onTriggerEnter: pe(() => {
      l.isOpenDelayed ? M() : w();
    }, [
      l.isOpenDelayed,
      M,
      w
    ]),
    onTriggerLeave: pe(() => {
      p ? x() : window.clearTimeout(h.current);
    }, [
      x,
      p
    ]),
    onOpen: w,
    onClose: x,
    disableHoverableContent: p
  }, n));
}, Ic = "TooltipTrigger", k0 = /* @__PURE__ */ de((t, e) => {
  const { __scopeTooltip: n, ...r } = t, o = Oo(Ic, n), i = sl(Ic, n), s = es(n), a = le(null), l = et(e, a, o.onTriggerChange), c = le(!1), u = le(!1), d = pe(
    () => c.current = !1,
    []
  );
  return ue(() => () => document.removeEventListener("pointerup", d), [
    d
  ]), /* @__PURE__ */ A(ol, ne({
    asChild: !0
  }, s), /* @__PURE__ */ A(je.button, ne({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": o.open ? o.contentId : void 0,
    "data-state": o.stateAttribute
  }, r, {
    ref: l,
    onPointerMove: ve(t.onPointerMove, (f) => {
      f.pointerType !== "touch" && !u.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
    }),
    onPointerLeave: ve(t.onPointerLeave, () => {
      o.onTriggerLeave(), u.current = !1;
    }),
    onPointerDown: ve(t.onPointerDown, () => {
      c.current = !0, document.addEventListener("pointerup", d, {
        once: !0
      });
    }),
    onFocus: ve(t.onFocus, () => {
      c.current || o.onOpen();
    }),
    onBlur: ve(t.onBlur, o.onClose),
    onClick: ve(t.onClick, o.onClose)
  })));
}), Wf = "TooltipPortal", [M0, O0] = Ji(Wf, {
  forceMount: void 0
}), P0 = (t) => {
  const { __scopeTooltip: e, forceMount: n, children: r, container: o } = t, i = Oo(Wf, e);
  return /* @__PURE__ */ A(M0, {
    scope: e,
    forceMount: n
  }, /* @__PURE__ */ A(ur, {
    present: n || i.open
  }, /* @__PURE__ */ A(il, {
    asChild: !0,
    container: o
  }, r)));
}, mo = "TooltipContent", S0 = /* @__PURE__ */ de((t, e) => {
  const n = O0(mo, t.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = t, s = Oo(mo, t.__scopeTooltip);
  return /* @__PURE__ */ A(ur, {
    present: r || s.open
  }, s.disableHoverableContent ? /* @__PURE__ */ A(Vf, ne({
    side: o
  }, i, {
    ref: e
  })) : /* @__PURE__ */ A(D0, ne({
    side: o
  }, i, {
    ref: e
  })));
}), D0 = /* @__PURE__ */ de((t, e) => {
  const n = Oo(mo, t.__scopeTooltip), r = sl(mo, t.__scopeTooltip), o = le(null), i = et(e, o), [s, a] = ke(null), { trigger: l, onClose: c } = n, u = o.current, { onPointerInTransitChange: d } = r, f = pe(() => {
    a(null), d(!1);
  }, [
    d
  ]), h = pe((p, g) => {
    const m = p.currentTarget, v = {
      x: p.clientX,
      y: p.clientY
    }, b = R0(v, m.getBoundingClientRect()), y = A0(v, b), w = L0(g.getBoundingClientRect()), x = H0([
      ...y,
      ...w
    ]);
    a(x), d(!0);
  }, [
    d
  ]);
  return ue(() => () => f(), [
    f
  ]), ue(() => {
    if (l && u) {
      const p = (m) => h(m, u), g = (m) => h(m, l);
      return l.addEventListener("pointerleave", p), u.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", p), u.removeEventListener("pointerleave", g);
      };
    }
  }, [
    l,
    u,
    h,
    f
  ]), ue(() => {
    if (s) {
      const p = (g) => {
        const m = g.target, v = {
          x: g.clientX,
          y: g.clientY
        }, b = (l == null ? void 0 : l.contains(m)) || (u == null ? void 0 : u.contains(m)), y = !F0(v, s);
        b ? f() : y && (f(), c());
      };
      return document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
    }
  }, [
    l,
    u,
    s,
    c,
    f
  ]), /* @__PURE__ */ A(Vf, ne({}, t, {
    ref: i
  }));
}), [T0, I0] = Ji(al, {
  isInside: !1
}), Vf = /* @__PURE__ */ de((t, e) => {
  const { __scopeTooltip: n, children: r, "aria-label": o, onEscapeKeyDown: i, onPointerDownOutside: s, ...a } = t, l = Oo(mo, n), c = es(n), { onClose: u } = l;
  return ue(() => (document.addEventListener(da, u), () => document.removeEventListener(da, u)), [
    u
  ]), ue(() => {
    if (l.trigger) {
      const d = (f) => {
        const h = f.target;
        h != null && h.contains(l.trigger) && u();
      };
      return window.addEventListener("scroll", d, {
        capture: !0
      }), () => window.removeEventListener("scroll", d, {
        capture: !0
      });
    }
  }, [
    l.trigger,
    u
  ]), /* @__PURE__ */ A(bf, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: i,
    onPointerDownOutside: s,
    onFocusOutside: (d) => d.preventDefault(),
    onDismiss: u
  }, /* @__PURE__ */ A(Ff, ne({
    "data-state": l.stateAttribute
  }, c, a, {
    ref: e,
    style: {
      ...a.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ A(cf, null, r), /* @__PURE__ */ A(T0, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ A(b0, {
    id: l.contentId,
    role: "tooltip"
  }, o || r))));
}), $0 = "TooltipArrow", N0 = /* @__PURE__ */ de((t, e) => {
  const { __scopeTooltip: n, ...r } = t, o = es(n);
  return I0($0, n).isInside ? null : /* @__PURE__ */ A(Hf, ne({}, o, r, {
    ref: e
  }));
});
function R0(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), o = Math.abs(e.right - t.x), i = Math.abs(e.left - t.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function A0(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push({
        x: t.x - n,
        y: t.y + n
      }, {
        x: t.x + n,
        y: t.y + n
      });
      break;
    case "bottom":
      r.push({
        x: t.x - n,
        y: t.y - n
      }, {
        x: t.x + n,
        y: t.y - n
      });
      break;
    case "left":
      r.push({
        x: t.x + n,
        y: t.y - n
      }, {
        x: t.x + n,
        y: t.y + n
      });
      break;
    case "right":
      r.push({
        x: t.x - n,
        y: t.y - n
      }, {
        x: t.x - n,
        y: t.y + n
      });
      break;
  }
  return r;
}
function L0(t) {
  const { top: e, right: n, bottom: r, left: o } = t;
  return [
    {
      x: o,
      y: e
    },
    {
      x: n,
      y: e
    },
    {
      x: n,
      y: r
    },
    {
      x: o,
      y: r
    }
  ];
}
function F0(t, e) {
  const { x: n, y: r } = t;
  let o = !1;
  for (let i = 0, s = e.length - 1; i < e.length; s = i++) {
    const a = e[i].x, l = e[i].y, c = e[s].x, u = e[s].y;
    l > r != u > r && n < (c - a) * (r - l) / (u - l) + a && (o = !o);
  }
  return o;
}
function H0(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), W0(e);
}
function W0(t) {
  if (t.length <= 1)
    return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    for (; e.length >= 2; ) {
      const i = e[e.length - 1], s = e[e.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x))
        e.pop();
      else
        break;
    }
    e.push(o);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const o = t[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], s = n[n.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
const V0 = _0, B0 = E0, j0 = k0, z0 = P0, Y0 = S0, U0 = N0, G0 = Kt(
  "z-50 border rounded-lg max-w-lg data-[state=delayed-open]:animate-fadeIn",
  {
    variants: {
      variant: {
        dark: "bg-foundations-inverse border-transparent text-foundations-inverse [&_.tooltip-arrow]:fill-[theme(backgroundColor.foundations-inverse)]",
        light: "bg-foundations-default border-foundations-subtle text-foundations-boldest [&_.tooltip-arrow]:fill-[theme(backgroundColor.foundations-default)] [&_.tooltip-arrow]:stroke [&_.tooltip-arrow]:stroke-[theme(borderColor.foundations-subtle)]"
      },
      size: {
        default: "text-sm p-2 lg:p-3 lg:[&_.tooltip-arrow]:w-8 lg:[&_.tooltip-arrow]:h-4",
        sm: "text-xs py-1.5 px-2.5"
      }
    },
    defaultVariants: {
      variant: "dark",
      size: "default"
    }
  }
), K0 = (t) => /* @__PURE__ */ _(V0, { delayDuration: 350, ...t }), ts = ({
  children: t,
  content: e,
  size: n,
  side: r = "top",
  sideOffset: o = 4,
  collisionPadding: i = 4,
  disableHoverableContent: s,
  defaultOpen: a,
  open: l,
  onOpenChange: c,
  variant: u,
  className: d,
  hideArrow: f = !1,
  disabled: h = !1,
  delayDuration: p
}) => /* @__PURE__ */ Z(
  B0,
  {
    defaultOpen: a,
    open: l,
    onOpenChange: c,
    disableHoverableContent: s,
    delayDuration: p,
    children: [
      /* @__PURE__ */ _(j0, { asChild: !0, children: t }),
      /* @__PURE__ */ _(z0, { children: /* @__PURE__ */ Z(
        Y0,
        {
          hidden: h,
          className: ye(G0({ variant: u, size: n }), d),
          side: r,
          sideOffset: o,
          collisionPadding: i,
          children: [
            e,
            !f && /* @__PURE__ */ _(U0, { className: "tooltip-arrow" })
          ]
        }
      ) })
    ]
  }
);
ts.displayName = "Tooltip";
const q0 = ({
  children: t,
  content: e,
  ...n
}) => {
  const [r, o] = S.useState(null), [i, s] = S.useState(!1);
  return S.useEffect(() => {
    if (!r)
      return;
    const a = () => {
      s(r.scrollWidth > r.clientWidth);
    }, l = new ResizeObserver((c) => {
      for (const u of c)
        u.contentBoxSize && a();
    });
    return l.observe(r), () => l.unobserve(r);
  }, [r]), S.Children.only(t) && S.isValidElement(t) ? /* @__PURE__ */ _(
    ts,
    {
      disabled: !i,
      content: e ?? (r == null ? void 0 : r.textContent),
      ...n,
      children: /* @__PURE__ */ _(zt, { className: "truncate", ref: o, children: t })
    }
  ) : null;
};
q0.displayName = "OverflowText";
const X0 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ _(
  "div",
  {
    ref: n,
    className: ye(
      "h-4 animate-pulse rounded-sm bg-foundations-subtlest",
      t
    ),
    ...e
  }
));
X0.displayName = "Skeleton";
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function Po(t) {
  return t + 0.5 | 0;
}
const Pn = (t, e, n) => Math.max(Math.min(t, n), e);
function eo(t) {
  return Pn(Po(t * 2.55), 0, 255);
}
function $n(t) {
  return Pn(Po(t * 255), 0, 255);
}
function mn(t) {
  return Pn(Po(t / 2.55) / 100, 0, 1);
}
function $c(t) {
  return Pn(Po(t * 100), 0, 100);
}
const Tt = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, fa = [..."0123456789ABCDEF"], Z0 = (t) => fa[t & 15], Q0 = (t) => fa[(t & 240) >> 4] + fa[t & 15], Wo = (t) => (t & 240) >> 4 === (t & 15), J0 = (t) => Wo(t.r) && Wo(t.g) && Wo(t.b) && Wo(t.a);
function eb(t) {
  var e = t.length, n;
  return t[0] === "#" && (e === 4 || e === 5 ? n = {
    r: 255 & Tt[t[1]] * 17,
    g: 255 & Tt[t[2]] * 17,
    b: 255 & Tt[t[3]] * 17,
    a: e === 5 ? Tt[t[4]] * 17 : 255
  } : (e === 7 || e === 9) && (n = {
    r: Tt[t[1]] << 4 | Tt[t[2]],
    g: Tt[t[3]] << 4 | Tt[t[4]],
    b: Tt[t[5]] << 4 | Tt[t[6]],
    a: e === 9 ? Tt[t[7]] << 4 | Tt[t[8]] : 255
  })), n;
}
const tb = (t, e) => t < 255 ? e(t) : "";
function nb(t) {
  var e = J0(t) ? Z0 : Q0;
  return t ? "#" + e(t.r) + e(t.g) + e(t.b) + tb(t.a, e) : void 0;
}
const rb = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Bf(t, e, n) {
  const r = e * Math.min(n, 1 - n), o = (i, s = (i + t / 30) % 12) => n - r * Math.max(Math.min(s - 3, 9 - s, 1), -1);
  return [o(0), o(8), o(4)];
}
function ob(t, e, n) {
  const r = (o, i = (o + t / 60) % 6) => n - n * e * Math.max(Math.min(i, 4 - i, 1), 0);
  return [r(5), r(3), r(1)];
}
function ib(t, e, n) {
  const r = Bf(t, 1, 0.5);
  let o;
  for (e + n > 1 && (o = 1 / (e + n), e *= o, n *= o), o = 0; o < 3; o++)
    r[o] *= 1 - e - n, r[o] += e;
  return r;
}
function sb(t, e, n, r, o) {
  return t === o ? (e - n) / r + (e < n ? 6 : 0) : e === o ? (n - t) / r + 2 : (t - e) / r + 4;
}
function ll(t) {
  const n = t.r / 255, r = t.g / 255, o = t.b / 255, i = Math.max(n, r, o), s = Math.min(n, r, o), a = (i + s) / 2;
  let l, c, u;
  return i !== s && (u = i - s, c = a > 0.5 ? u / (2 - i - s) : u / (i + s), l = sb(n, r, o, u, i), l = l * 60 + 0.5), [l | 0, c || 0, a];
}
function cl(t, e, n, r) {
  return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, n, r)).map($n);
}
function ul(t, e, n) {
  return cl(Bf, t, e, n);
}
function ab(t, e, n) {
  return cl(ib, t, e, n);
}
function lb(t, e, n) {
  return cl(ob, t, e, n);
}
function jf(t) {
  return (t % 360 + 360) % 360;
}
function cb(t) {
  const e = rb.exec(t);
  let n = 255, r;
  if (!e)
    return;
  e[5] !== r && (n = e[6] ? eo(+e[5]) : $n(+e[5]));
  const o = jf(+e[2]), i = +e[3] / 100, s = +e[4] / 100;
  return e[1] === "hwb" ? r = ab(o, i, s) : e[1] === "hsv" ? r = lb(o, i, s) : r = ul(o, i, s), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function ub(t, e) {
  var n = ll(t);
  n[0] = jf(n[0] + e), n = ul(n), t.r = n[0], t.g = n[1], t.b = n[2];
}
function db(t) {
  if (!t)
    return;
  const e = ll(t), n = e[0], r = $c(e[1]), o = $c(e[2]);
  return t.a < 255 ? `hsla(${n}, ${r}%, ${o}%, ${mn(t.a)})` : `hsl(${n}, ${r}%, ${o}%)`;
}
const Nc = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Rc = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function fb() {
  const t = {}, e = Object.keys(Rc), n = Object.keys(Nc);
  let r, o, i, s, a;
  for (r = 0; r < e.length; r++) {
    for (s = a = e[r], o = 0; o < n.length; o++)
      i = n[o], a = a.replace(i, Nc[i]);
    i = parseInt(Rc[s], 16), t[a] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return t;
}
let Vo;
function hb(t) {
  Vo || (Vo = fb(), Vo.transparent = [0, 0, 0, 0]);
  const e = Vo[t.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const pb = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function gb(t) {
  const e = pb.exec(t);
  let n = 255, r, o, i;
  if (e) {
    if (e[7] !== r) {
      const s = +e[7];
      n = e[8] ? eo(s) : Pn(s * 255, 0, 255);
    }
    return r = +e[1], o = +e[3], i = +e[5], r = 255 & (e[2] ? eo(r) : Pn(r, 0, 255)), o = 255 & (e[4] ? eo(o) : Pn(o, 0, 255)), i = 255 & (e[6] ? eo(i) : Pn(i, 0, 255)), {
      r,
      g: o,
      b: i,
      a: n
    };
  }
}
function mb(t) {
  return t && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${mn(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`);
}
const Cs = (t) => t <= 31308e-7 ? t * 12.92 : Math.pow(t, 1 / 2.4) * 1.055 - 0.055, xr = (t) => t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
function vb(t, e, n) {
  const r = xr(mn(t.r)), o = xr(mn(t.g)), i = xr(mn(t.b));
  return {
    r: $n(Cs(r + n * (xr(mn(e.r)) - r))),
    g: $n(Cs(o + n * (xr(mn(e.g)) - o))),
    b: $n(Cs(i + n * (xr(mn(e.b)) - i))),
    a: t.a + n * (e.a - t.a)
  };
}
function Bo(t, e, n) {
  if (t) {
    let r = ll(t);
    r[e] = Math.max(0, Math.min(r[e] + r[e] * n, e === 0 ? 360 : 1)), r = ul(r), t.r = r[0], t.g = r[1], t.b = r[2];
  }
}
function zf(t, e) {
  return t && Object.assign(e || {}, t);
}
function Ac(t) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(t) ? t.length >= 3 && (e = { r: t[0], g: t[1], b: t[2], a: 255 }, t.length > 3 && (e.a = $n(t[3]))) : (e = zf(t, { r: 0, g: 0, b: 0, a: 1 }), e.a = $n(e.a)), e;
}
function bb(t) {
  return t.charAt(0) === "r" ? gb(t) : cb(t);
}
class vo {
  constructor(e) {
    if (e instanceof vo)
      return e;
    const n = typeof e;
    let r;
    n === "object" ? r = Ac(e) : n === "string" && (r = eb(e) || hb(e) || bb(e)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = zf(this._rgb);
    return e && (e.a = mn(e.a)), e;
  }
  set rgb(e) {
    this._rgb = Ac(e);
  }
  rgbString() {
    return this._valid ? mb(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? nb(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? db(this._rgb) : void 0;
  }
  mix(e, n) {
    if (e) {
      const r = this.rgb, o = e.rgb;
      let i;
      const s = n === i ? 0.5 : n, a = 2 * s - 1, l = r.a - o.a, c = ((a * l === -1 ? a : (a + l) / (1 + a * l)) + 1) / 2;
      i = 1 - c, r.r = 255 & c * r.r + i * o.r + 0.5, r.g = 255 & c * r.g + i * o.g + 0.5, r.b = 255 & c * r.b + i * o.b + 0.5, r.a = s * r.a + (1 - s) * o.a, this.rgb = r;
    }
    return this;
  }
  interpolate(e, n) {
    return e && (this._rgb = vb(this._rgb, e._rgb, n)), this;
  }
  clone() {
    return new vo(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = $n(e), this;
  }
  clearer(e) {
    const n = this._rgb;
    return n.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, n = Po(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = n, this;
  }
  opaquer(e) {
    const n = this._rgb;
    return n.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return Bo(this._rgb, 2, e), this;
  }
  darken(e) {
    return Bo(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return Bo(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return Bo(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return ub(this._rgb, e), this;
  }
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function fn() {
}
const yb = (() => {
  let t = 0;
  return () => t++;
})();
function Fe(t) {
  return t === null || typeof t > "u";
}
function Ge(t) {
  if (Array.isArray && Array.isArray(t))
    return !0;
  const e = Object.prototype.toString.call(t);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function Se(t) {
  return t !== null && Object.prototype.toString.call(t) === "[object Object]";
}
function ot(t) {
  return (typeof t == "number" || t instanceof Number) && isFinite(+t);
}
function Et(t, e) {
  return ot(t) ? t : e;
}
function we(t, e) {
  return typeof t > "u" ? e : t;
}
const xb = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 * e : +t;
function ze(t, e, n) {
  if (t && typeof t.call == "function")
    return t.apply(n, e);
}
function Le(t, e, n, r) {
  let o, i, s;
  if (Ge(t))
    if (i = t.length, r)
      for (o = i - 1; o >= 0; o--)
        e.call(n, t[o], o);
    else
      for (o = 0; o < i; o++)
        e.call(n, t[o], o);
  else if (Se(t))
    for (s = Object.keys(t), i = s.length, o = 0; o < i; o++)
      e.call(n, t[s[o]], s[o]);
}
function Di(t, e) {
  let n, r, o, i;
  if (!t || !e || t.length !== e.length)
    return !1;
  for (n = 0, r = t.length; n < r; ++n)
    if (o = t[n], i = e[n], o.datasetIndex !== i.datasetIndex || o.index !== i.index)
      return !1;
  return !0;
}
function Ti(t) {
  if (Ge(t))
    return t.map(Ti);
  if (Se(t)) {
    const e = /* @__PURE__ */ Object.create(null), n = Object.keys(t), r = n.length;
    let o = 0;
    for (; o < r; ++o)
      e[n[o]] = Ti(t[n[o]]);
    return e;
  }
  return t;
}
function Yf(t) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(t) === -1;
}
function wb(t, e, n, r) {
  if (!Yf(t))
    return;
  const o = e[t], i = n[t];
  Se(o) && Se(i) ? bo(o, i, r) : e[t] = Ti(i);
}
function bo(t, e, n) {
  const r = Ge(e) ? e : [
    e
  ], o = r.length;
  if (!Se(t))
    return t;
  n = n || {};
  const i = n.merger || wb;
  let s;
  for (let a = 0; a < o; ++a) {
    if (s = r[a], !Se(s))
      continue;
    const l = Object.keys(s);
    for (let c = 0, u = l.length; c < u; ++c)
      i(l[c], t, s, n);
  }
  return t;
}
function io(t, e) {
  return bo(t, e, {
    merger: _b
  });
}
function _b(t, e, n) {
  if (!Yf(t))
    return;
  const r = e[t], o = n[t];
  Se(r) && Se(o) ? io(r, o) : Object.prototype.hasOwnProperty.call(e, t) || (e[t] = Ti(o));
}
const Lc = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (t) => t,
  // default resolvers
  x: (t) => t.x,
  y: (t) => t.y
};
function Cb(t) {
  const e = t.split("."), n = [];
  let r = "";
  for (const o of e)
    r += o, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function Eb(t) {
  const e = Cb(t);
  return (n) => {
    for (const r of e) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function Ir(t, e) {
  return (Lc[e] || (Lc[e] = Eb(e)))(t);
}
function dl(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const yo = (t) => typeof t < "u", Hn = (t) => typeof t == "function", Fc = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const n of t)
    if (!e.has(n))
      return !1;
  return !0;
};
function kb(t) {
  return t.type === "mouseup" || t.type === "click" || t.type === "contextmenu";
}
const lt = Math.PI, Rt = 2 * lt, Mb = Rt + lt, Ii = Number.POSITIVE_INFINITY, Ob = lt / 180, yt = lt / 2, zn = lt / 4, Hc = lt * 2 / 3, Sn = Math.log10, rn = Math.sign;
function so(t, e, n) {
  return Math.abs(t - e) < n;
}
function Wc(t) {
  const e = Math.round(t);
  t = so(t, e, t / 1e3) ? e : t;
  const n = Math.pow(10, Math.floor(Sn(t))), r = t / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function Pb(t) {
  const e = [], n = Math.sqrt(t);
  let r;
  for (r = 1; r < n; r++)
    t % r === 0 && (e.push(r), e.push(t / r));
  return n === (n | 0) && e.push(n), e.sort((o, i) => o - i).pop(), e;
}
function xo(t) {
  return !isNaN(parseFloat(t)) && isFinite(t);
}
function Sb(t, e) {
  const n = Math.round(t);
  return n - e <= t && n + e >= t;
}
function Uf(t, e, n) {
  let r, o, i;
  for (r = 0, o = t.length; r < o; r++)
    i = t[r][n], isNaN(i) || (e.min = Math.min(e.min, i), e.max = Math.max(e.max, i));
}
function Dn(t) {
  return t * (lt / 180);
}
function fl(t) {
  return t * (180 / lt);
}
function Vc(t) {
  if (!ot(t))
    return;
  let e = 1, n = 0;
  for (; Math.round(t * e) / e !== t; )
    e *= 10, n++;
  return n;
}
function Db(t, e) {
  const n = e.x - t.x, r = e.y - t.y, o = Math.sqrt(n * n + r * r);
  let i = Math.atan2(r, n);
  return i < -0.5 * lt && (i += Rt), {
    angle: i,
    distance: o
  };
}
function ha(t, e) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function Tb(t, e) {
  return (t - e + Mb) % Rt - lt;
}
function jt(t) {
  return (t % Rt + Rt) % Rt;
}
function Gf(t, e, n, r) {
  const o = jt(t), i = jt(e), s = jt(n), a = jt(i - o), l = jt(s - o), c = jt(o - i), u = jt(o - s);
  return o === i || o === s || r && i === s || a > l && c < u;
}
function Ot(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function Ib(t) {
  return Ot(t, -32768, 32767);
}
function Qn(t, e, n, r = 1e-6) {
  return t >= Math.min(e, n) - r && t <= Math.max(e, n) + r;
}
function hl(t, e, n) {
  n = n || ((s) => t[s] < e);
  let r = t.length - 1, o = 0, i;
  for (; r - o > 1; )
    i = o + r >> 1, n(i) ? o = i : r = i;
  return {
    lo: o,
    hi: r
  };
}
const Jn = (t, e, n, r) => hl(t, n, r ? (o) => {
  const i = t[o][e];
  return i < n || i === n && t[o + 1][e] === n;
} : (o) => t[o][e] < n), $b = (t, e, n) => hl(t, n, (r) => t[r][e] >= n);
function Nb(t, e, n) {
  let r = 0, o = t.length;
  for (; r < o && t[r] < e; )
    r++;
  for (; o > r && t[o - 1] > n; )
    o--;
  return r > 0 || o < t.length ? t.slice(r, o) : t;
}
const Kf = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function Rb(t, e) {
  if (t._chartjs) {
    t._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(t, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), Kf.forEach((n) => {
    const r = "_onData" + dl(n), o = t[n];
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const s = o.apply(this, i);
        return t._chartjs.listeners.forEach((a) => {
          typeof a[r] == "function" && a[r](...i);
        }), s;
      }
    });
  });
}
function Bc(t, e) {
  const n = t._chartjs;
  if (!n)
    return;
  const r = n.listeners, o = r.indexOf(e);
  o !== -1 && r.splice(o, 1), !(r.length > 0) && (Kf.forEach((i) => {
    delete t[i];
  }), delete t._chartjs);
}
function qf(t) {
  const e = new Set(t);
  return e.size === t.length ? t : Array.from(e);
}
const Xf = function() {
  return typeof window > "u" ? function(t) {
    return t();
  } : window.requestAnimationFrame;
}();
function Zf(t, e) {
  let n = [], r = !1;
  return function(...o) {
    n = o, r || (r = !0, Xf.call(window, () => {
      r = !1, t.apply(e, n);
    }));
  };
}
function Ab(t, e) {
  let n;
  return function(...r) {
    return e ? (clearTimeout(n), n = setTimeout(t, e, r)) : t.apply(this, r), e;
  };
}
const Qf = (t) => t === "start" ? "left" : t === "end" ? "right" : "center", Ct = (t, e, n) => t === "start" ? e : t === "end" ? n : (e + n) / 2, Lb = (t, e, n, r) => t === (r ? "left" : "right") ? n : t === "center" ? (e + n) / 2 : e;
function Fb(t, e, n) {
  const r = e.length;
  let o = 0, i = r;
  if (t._sorted) {
    const { iScale: s, _parsed: a } = t, l = s.axis, { min: c, max: u, minDefined: d, maxDefined: f } = s.getUserBounds();
    d && (o = Ot(Math.min(
      // @ts-expect-error Need to type _parsed
      Jn(a, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? r : Jn(e, l, s.getPixelForValue(c)).lo
    ), 0, r - 1)), f ? i = Ot(Math.max(
      // @ts-expect-error Need to type _parsed
      Jn(a, s.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : Jn(e, l, s.getPixelForValue(u), !0).hi + 1
    ), o, r) - o : i = r - o;
  }
  return {
    start: o,
    count: i
  };
}
function Hb(t) {
  const { xScale: e, yScale: n, _scaleRanges: r } = t, o = {
    xmin: e.min,
    xmax: e.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return t._scaleRanges = o, !0;
  const i = r.xmin !== e.min || r.xmax !== e.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, o), i;
}
const jo = (t) => t === 0 || t === 1, jc = (t, e, n) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * Rt / n)), zc = (t, e, n) => Math.pow(2, -10 * t) * Math.sin((t - e) * Rt / n) + 1, ao = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * yt) + 1,
  easeOutSine: (t) => Math.sin(t * yt),
  easeInOutSine: (t) => -0.5 * (Math.cos(lt * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => jo(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => jo(t) ? t : jc(t, 0.075, 0.3),
  easeOutElastic: (t) => jo(t) ? t : zc(t, 0.075, 0.3),
  easeInOutElastic(t) {
    return jo(t) ? t : t < 0.5 ? 0.5 * jc(t * 2, 0.1125, 0.45) : 0.5 + 0.5 * zc(t * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(t) {
    return t * t * ((1.70158 + 1) * t - 1.70158);
  },
  easeOutBack(t) {
    return (t -= 1) * t * ((1.70158 + 1) * t + 1.70158) + 1;
  },
  easeInOutBack(t) {
    let e = 1.70158;
    return (t /= 0.5) < 1 ? 0.5 * (t * t * (((e *= 1.525) + 1) * t - e)) : 0.5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2);
  },
  easeInBounce: (t) => 1 - ao.easeOutBounce(1 - t),
  easeOutBounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? ao.easeInBounce(t * 2) * 0.5 : ao.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function pl(t) {
  if (t && typeof t == "object") {
    const e = t.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function Yc(t) {
  return pl(t) ? t : new vo(t);
}
function Es(t) {
  return pl(t) ? t : new vo(t).saturate(0.5).darken(0.1).hexString();
}
const Wb = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], Vb = [
  "color",
  "borderColor",
  "backgroundColor"
];
function Bb(t) {
  t.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), t.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), t.set("animations", {
    colors: {
      type: "color",
      properties: Vb
    },
    numbers: {
      type: "number",
      properties: Wb
    }
  }), t.describe("animations", {
    _fallback: "animation"
  }), t.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function jb(t) {
  t.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Uc = /* @__PURE__ */ new Map();
function zb(t, e) {
  e = e || {};
  const n = t + JSON.stringify(e);
  let r = Uc.get(n);
  return r || (r = new Intl.NumberFormat(t, e), Uc.set(n, r)), r;
}
function gl(t, e, n) {
  return zb(e, n).format(t);
}
const Jf = {
  values(t) {
    return Ge(t) ? t : "" + t;
  },
  numeric(t, e, n) {
    if (t === 0)
      return "0";
    const r = this.chart.options.locale;
    let o, i = t;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (o = "scientific"), i = Yb(t, n);
    }
    const s = Sn(Math.abs(i)), a = isNaN(s) ? 1 : Math.max(Math.min(-1 * Math.floor(s), 20), 0), l = {
      notation: o,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(l, this.options.ticks.format), gl(t, r, l);
  },
  logarithmic(t, e, n) {
    if (t === 0)
      return "0";
    const r = n[e].significand || t / Math.pow(10, Math.floor(Sn(t)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(r) || e > 0.8 * n.length ? Jf.numeric.call(this, t, e, n) : "";
  }
};
function Yb(t, e) {
  let n = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(n) >= 1 && t !== Math.floor(t) && (n = t - Math.floor(t)), n;
}
var ns = {
  formatters: Jf
};
function Ub(t) {
  t.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, n) => n.lineWidth,
      tickColor: (e, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: ns.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), t.route("scale.ticks", "color", "", "color"), t.route("scale.grid", "color", "", "borderColor"), t.route("scale.border", "color", "", "borderColor"), t.route("scale.title", "color", "", "color"), t.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), t.describe("scales", {
    _fallback: "scale"
  }), t.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const ir = /* @__PURE__ */ Object.create(null), pa = /* @__PURE__ */ Object.create(null);
function lo(t, e) {
  if (!e)
    return t;
  const n = e.split(".");
  for (let r = 0, o = n.length; r < o; ++r) {
    const i = n[r];
    t = t[i] || (t[i] = /* @__PURE__ */ Object.create(null));
  }
  return t;
}
function ks(t, e, n) {
  return typeof e == "string" ? bo(lo(t, e), n) : bo(lo(t, ""), e);
}
class Gb {
  constructor(e, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, o) => Es(o.backgroundColor), this.hoverBorderColor = (r, o) => Es(o.borderColor), this.hoverColor = (r, o) => Es(o.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(n);
  }
  set(e, n) {
    return ks(this, e, n);
  }
  get(e) {
    return lo(this, e);
  }
  describe(e, n) {
    return ks(pa, e, n);
  }
  override(e, n) {
    return ks(ir, e, n);
  }
  route(e, n, r, o) {
    const i = lo(this, e), s = lo(this, r), a = "_" + n;
    Object.defineProperties(i, {
      [a]: {
        value: i[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[a], c = s[o];
          return Se(l) ? Object.assign({}, c, l) : we(l, c);
        },
        set(l) {
          this[a] = l;
        }
      }
    });
  }
  apply(e) {
    e.forEach((n) => n(this));
  }
}
var qe = /* @__PURE__ */ new Gb({
  _scriptable: (t) => !t.startsWith("on"),
  _indexable: (t) => t !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  Bb,
  jb,
  Ub
]);
function Kb(t) {
  return !t || Fe(t.size) || Fe(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
}
function $i(t, e, n, r, o) {
  let i = e[o];
  return i || (i = e[o] = t.measureText(o).width, n.push(o)), i > r && (r = i), r;
}
function qb(t, e, n, r) {
  r = r || {};
  let o = r.data = r.data || {}, i = r.garbageCollect = r.garbageCollect || [];
  r.font !== e && (o = r.data = {}, i = r.garbageCollect = [], r.font = e), t.save(), t.font = e;
  let s = 0;
  const a = n.length;
  let l, c, u, d, f;
  for (l = 0; l < a; l++)
    if (d = n[l], d != null && !Ge(d))
      s = $i(t, o, i, s, d);
    else if (Ge(d))
      for (c = 0, u = d.length; c < u; c++)
        f = d[c], f != null && !Ge(f) && (s = $i(t, o, i, s, f));
  t.restore();
  const h = i.length / 2;
  if (h > n.length) {
    for (l = 0; l < h; l++)
      delete o[i[l]];
    i.splice(0, h);
  }
  return s;
}
function Yn(t, e, n) {
  const r = t.currentDevicePixelRatio, o = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((e - o) * r) / r + o;
}
function Gc(t, e) {
  e = e || t.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, t.width, t.height), e.restore();
}
function ga(t, e, n, r) {
  eh(t, e, n, r, null);
}
function eh(t, e, n, r, o) {
  let i, s, a, l, c, u, d, f;
  const h = e.pointStyle, p = e.rotation, g = e.radius;
  let m = (p || 0) * Ob;
  if (h && typeof h == "object" && (i = h.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    t.save(), t.translate(n, r), t.rotate(m), t.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), t.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (t.beginPath(), h) {
      default:
        o ? t.ellipse(n, r, o / 2, g, 0, 0, Rt) : t.arc(n, r, g, 0, Rt), t.closePath();
        break;
      case "triangle":
        u = o ? o / 2 : g, t.moveTo(n + Math.sin(m) * u, r - Math.cos(m) * g), m += Hc, t.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * g), m += Hc, t.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * g), t.closePath();
        break;
      case "rectRounded":
        c = g * 0.516, l = g - c, s = Math.cos(m + zn) * l, d = Math.cos(m + zn) * (o ? o / 2 - c : l), a = Math.sin(m + zn) * l, f = Math.sin(m + zn) * (o ? o / 2 - c : l), t.arc(n - d, r - a, c, m - lt, m - yt), t.arc(n + f, r - s, c, m - yt, m), t.arc(n + d, r + a, c, m, m + yt), t.arc(n - f, r + s, c, m + yt, m + lt), t.closePath();
        break;
      case "rect":
        if (!p) {
          l = Math.SQRT1_2 * g, u = o ? o / 2 : l, t.rect(n - u, r - l, 2 * u, 2 * l);
          break;
        }
        m += zn;
      case "rectRot":
        d = Math.cos(m) * (o ? o / 2 : g), s = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), t.moveTo(n - d, r - a), t.lineTo(n + f, r - s), t.lineTo(n + d, r + a), t.lineTo(n - f, r + s), t.closePath();
        break;
      case "crossRot":
        m += zn;
      case "cross":
        d = Math.cos(m) * (o ? o / 2 : g), s = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), t.moveTo(n - d, r - a), t.lineTo(n + d, r + a), t.moveTo(n + f, r - s), t.lineTo(n - f, r + s);
        break;
      case "star":
        d = Math.cos(m) * (o ? o / 2 : g), s = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), t.moveTo(n - d, r - a), t.lineTo(n + d, r + a), t.moveTo(n + f, r - s), t.lineTo(n - f, r + s), m += zn, d = Math.cos(m) * (o ? o / 2 : g), s = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), t.moveTo(n - d, r - a), t.lineTo(n + d, r + a), t.moveTo(n + f, r - s), t.lineTo(n - f, r + s);
        break;
      case "line":
        s = o ? o / 2 : Math.cos(m) * g, a = Math.sin(m) * g, t.moveTo(n - s, r - a), t.lineTo(n + s, r + a);
        break;
      case "dash":
        t.moveTo(n, r), t.lineTo(n + Math.cos(m) * (o ? o / 2 : g), r + Math.sin(m) * g);
        break;
      case !1:
        t.closePath();
        break;
    }
    t.fill(), e.borderWidth > 0 && t.stroke();
  }
}
function vn(t, e, n) {
  return n = n || 0.5, !e || t && t.x > e.left - n && t.x < e.right + n && t.y > e.top - n && t.y < e.bottom + n;
}
function ml(t, e) {
  t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip();
}
function vl(t) {
  t.restore();
}
function Xb(t, e, n, r, o) {
  if (!e)
    return t.lineTo(n.x, n.y);
  if (o === "middle") {
    const i = (e.x + n.x) / 2;
    t.lineTo(i, e.y), t.lineTo(i, n.y);
  } else
    o === "after" != !!r ? t.lineTo(e.x, n.y) : t.lineTo(n.x, e.y);
  t.lineTo(n.x, n.y);
}
function Zb(t, e, n, r) {
  if (!e)
    return t.lineTo(n.x, n.y);
  t.bezierCurveTo(r ? e.cp1x : e.cp2x, r ? e.cp1y : e.cp2y, r ? n.cp2x : n.cp1x, r ? n.cp2y : n.cp1y, n.x, n.y);
}
function Qb(t, e) {
  e.translation && t.translate(e.translation[0], e.translation[1]), Fe(e.rotation) || t.rotate(e.rotation), e.color && (t.fillStyle = e.color), e.textAlign && (t.textAlign = e.textAlign), e.textBaseline && (t.textBaseline = e.textBaseline);
}
function Jb(t, e, n, r, o) {
  if (o.strikethrough || o.underline) {
    const i = t.measureText(r), s = e - i.actualBoundingBoxLeft, a = e + i.actualBoundingBoxRight, l = n - i.actualBoundingBoxAscent, c = n + i.actualBoundingBoxDescent, u = o.strikethrough ? (l + c) / 2 : c;
    t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = o.decorationWidth || 2, t.moveTo(s, u), t.lineTo(a, u), t.stroke();
  }
}
function e1(t, e) {
  const n = t.fillStyle;
  t.fillStyle = e.color, t.fillRect(e.left, e.top, e.width, e.height), t.fillStyle = n;
}
function $r(t, e, n, r, o, i = {}) {
  const s = Ge(e) ? e : [
    e
  ], a = i.strokeWidth > 0 && i.strokeColor !== "";
  let l, c;
  for (t.save(), t.font = o.string, Qb(t, i), l = 0; l < s.length; ++l)
    c = s[l], i.backdrop && e1(t, i.backdrop), a && (i.strokeColor && (t.strokeStyle = i.strokeColor), Fe(i.strokeWidth) || (t.lineWidth = i.strokeWidth), t.strokeText(c, n, r, i.maxWidth)), t.fillText(c, n, r, i.maxWidth), Jb(t, n, r, c, i), r += Number(o.lineHeight);
  t.restore();
}
function wo(t, e) {
  const { x: n, y: r, w: o, h: i, radius: s } = e;
  t.arc(n + s.topLeft, r + s.topLeft, s.topLeft, -yt, lt, !0), t.lineTo(n, r + i - s.bottomLeft), t.arc(n + s.bottomLeft, r + i - s.bottomLeft, s.bottomLeft, lt, yt, !0), t.lineTo(n + o - s.bottomRight, r + i), t.arc(n + o - s.bottomRight, r + i - s.bottomRight, s.bottomRight, yt, 0, !0), t.lineTo(n + o, r + s.topRight), t.arc(n + o - s.topRight, r + s.topRight, s.topRight, 0, -yt, !0), t.lineTo(n + s.topLeft, r);
}
const t1 = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, n1 = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function r1(t, e) {
  const n = ("" + t).match(t1);
  if (!n || n[1] === "normal")
    return e * 1.2;
  switch (t = +n[2], n[3]) {
    case "px":
      return t;
    case "%":
      t /= 100;
      break;
  }
  return e * t;
}
const o1 = (t) => +t || 0;
function th(t, e) {
  const n = {}, r = Se(e), o = r ? Object.keys(e) : e, i = Se(t) ? r ? (s) => we(t[s], t[e[s]]) : (s) => t[s] : () => t;
  for (const s of o)
    n[s] = o1(i(s));
  return n;
}
function nh(t) {
  return th(t, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function tr(t) {
  return th(t, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function pt(t) {
  const e = nh(t);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function at(t, e) {
  t = t || {}, e = e || qe.font;
  let n = we(t.size, e.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = we(t.style, e.style);
  r && !("" + r).match(n1) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const o = {
    family: we(t.family, e.family),
    lineHeight: r1(we(t.lineHeight, e.lineHeight), n),
    size: n,
    style: r,
    weight: we(t.weight, e.weight),
    string: ""
  };
  return o.string = Kb(o), o;
}
function zo(t, e, n, r) {
  let o = !0, i, s, a;
  for (i = 0, s = t.length; i < s; ++i)
    if (a = t[i], a !== void 0 && (e !== void 0 && typeof a == "function" && (a = a(e), o = !1), n !== void 0 && Ge(a) && (a = a[n % a.length], o = !1), a !== void 0))
      return r && !o && (r.cacheable = !1), a;
}
function i1(t, e, n) {
  const { min: r, max: o } = t, i = xb(e, (o - r) / 2), s = (a, l) => n && a === 0 ? 0 : a + l;
  return {
    min: s(r, -Math.abs(i)),
    max: s(o, i)
  };
}
function Vn(t, e) {
  return Object.assign(Object.create(t), e);
}
function bl(t, e = [
  ""
], n, r, o = () => t[0]) {
  const i = n || t;
  typeof r > "u" && (r = sh("_fallback", t));
  const s = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: t,
    _rootScopes: i,
    _fallback: r,
    _getTarget: o,
    override: (a) => bl([
      a,
      ...t
    ], e, i, r)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, l) {
      return delete a[l], delete a._keys, delete t[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, l) {
      return oh(a, l, () => h1(l, e, t, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, l) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, l) {
      return qc(a).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return qc(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, l, c) {
      const u = a._storage || (a._storage = o());
      return a[l] = u[l] = c, delete a._keys, !0;
    }
  });
}
function Nr(t, e, n, r) {
  const o = {
    _cacheable: !1,
    _proxy: t,
    _context: e,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: rh(t, r),
    setContext: (i) => Nr(t, i, n, r),
    override: (i) => Nr(t.override(i), e, n, r)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, s) {
      return delete i[s], delete t[s], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, s, a) {
      return oh(i, s, () => a1(i, s, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, s) {
      return i._descriptors.allKeys ? Reflect.has(t, s) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(t, s);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t);
    },
    /**
    * A trap for the in operator.
    */
    has(i, s) {
      return Reflect.has(t, s);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(t);
    },
    /**
    * A trap for setting property values.
    */
    set(i, s, a) {
      return t[s] = a, delete i[s], !0;
    }
  });
}
function rh(t, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = e.scriptable, _indexable: r = e.indexable, _allKeys: o = e.allKeys } = t;
  return {
    allKeys: o,
    scriptable: n,
    indexable: r,
    isScriptable: Hn(n) ? n : () => n,
    isIndexable: Hn(r) ? r : () => r
  };
}
const s1 = (t, e) => t ? t + dl(e) : e, yl = (t, e) => Se(e) && t !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function oh(t, e, n) {
  if (Object.prototype.hasOwnProperty.call(t, e))
    return t[e];
  const r = n();
  return t[e] = r, r;
}
function a1(t, e, n) {
  const { _proxy: r, _context: o, _subProxy: i, _descriptors: s } = t;
  let a = r[e];
  return Hn(a) && s.isScriptable(e) && (a = l1(e, a, t, n)), Ge(a) && a.length && (a = c1(e, a, t, s.isIndexable)), yl(e, a) && (a = Nr(a, o, i && i[e], s)), a;
}
function l1(t, e, n, r) {
  const { _proxy: o, _context: i, _subProxy: s, _stack: a } = n;
  if (a.has(t))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + t);
  a.add(t);
  let l = e(i, s || r);
  return a.delete(t), yl(t, l) && (l = xl(o._scopes, o, t, l)), l;
}
function c1(t, e, n, r) {
  const { _proxy: o, _context: i, _subProxy: s, _descriptors: a } = n;
  if (typeof i.index < "u" && r(t))
    return e[i.index % e.length];
  if (Se(e[0])) {
    const l = e, c = o._scopes.filter((u) => u !== l);
    e = [];
    for (const u of l) {
      const d = xl(c, o, t, u);
      e.push(Nr(d, i, s && s[t], a));
    }
  }
  return e;
}
function ih(t, e, n) {
  return Hn(t) ? t(e, n) : t;
}
const u1 = (t, e) => t === !0 ? e : typeof t == "string" ? Ir(e, t) : void 0;
function d1(t, e, n, r, o) {
  for (const i of e) {
    const s = u1(n, i);
    if (s) {
      t.add(s);
      const a = ih(s._fallback, n, o);
      if (typeof a < "u" && a !== n && a !== r)
        return a;
    } else if (s === !1 && typeof r < "u" && n !== r)
      return null;
  }
  return !1;
}
function xl(t, e, n, r) {
  const o = e._rootScopes, i = ih(e._fallback, n, r), s = [
    ...t,
    ...o
  ], a = /* @__PURE__ */ new Set();
  a.add(r);
  let l = Kc(a, s, n, i || n, r);
  return l === null || typeof i < "u" && i !== n && (l = Kc(a, s, i, l, r), l === null) ? !1 : bl(Array.from(a), [
    ""
  ], o, i, () => f1(e, n, r));
}
function Kc(t, e, n, r, o) {
  for (; n; )
    n = d1(t, e, n, r, o);
  return n;
}
function f1(t, e, n) {
  const r = t._getTarget();
  e in r || (r[e] = {});
  const o = r[e];
  return Ge(o) && Se(n) ? n : o || {};
}
function h1(t, e, n, r) {
  let o;
  for (const i of e)
    if (o = sh(s1(i, t), n), typeof o < "u")
      return yl(t, o) ? xl(n, r, t, o) : o;
}
function sh(t, e) {
  for (const n of e) {
    if (!n)
      continue;
    const r = n[t];
    if (typeof r < "u")
      return r;
  }
}
function qc(t) {
  let e = t._keys;
  return e || (e = t._keys = p1(t._scopes)), e;
}
function p1(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of t)
    for (const r of Object.keys(n).filter((o) => !o.startsWith("_")))
      e.add(r);
  return Array.from(e);
}
const g1 = Number.EPSILON || 1e-14, Rr = (t, e) => e < t.length && !t[e].skip && t[e], ah = (t) => t === "x" ? "y" : "x";
function m1(t, e, n, r) {
  const o = t.skip ? e : t, i = e, s = n.skip ? e : n, a = ha(i, o), l = ha(s, i);
  let c = a / (a + l), u = l / (a + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = r * c, f = r * u;
  return {
    previous: {
      x: i.x - d * (s.x - o.x),
      y: i.y - d * (s.y - o.y)
    },
    next: {
      x: i.x + f * (s.x - o.x),
      y: i.y + f * (s.y - o.y)
    }
  };
}
function v1(t, e, n) {
  const r = t.length;
  let o, i, s, a, l, c = Rr(t, 0);
  for (let u = 0; u < r - 1; ++u)
    if (l = c, c = Rr(t, u + 1), !(!l || !c)) {
      if (so(e[u], 0, g1)) {
        n[u] = n[u + 1] = 0;
        continue;
      }
      o = n[u] / e[u], i = n[u + 1] / e[u], a = Math.pow(o, 2) + Math.pow(i, 2), !(a <= 9) && (s = 3 / Math.sqrt(a), n[u] = o * s * e[u], n[u + 1] = i * s * e[u]);
    }
}
function b1(t, e, n = "x") {
  const r = ah(n), o = t.length;
  let i, s, a, l = Rr(t, 0);
  for (let c = 0; c < o; ++c) {
    if (s = a, a = l, l = Rr(t, c + 1), !a)
      continue;
    const u = a[n], d = a[r];
    s && (i = (u - s[n]) / 3, a[`cp1${n}`] = u - i, a[`cp1${r}`] = d - i * e[c]), l && (i = (l[n] - u) / 3, a[`cp2${n}`] = u + i, a[`cp2${r}`] = d + i * e[c]);
  }
}
function y1(t, e = "x") {
  const n = ah(e), r = t.length, o = Array(r).fill(0), i = Array(r);
  let s, a, l, c = Rr(t, 0);
  for (s = 0; s < r; ++s)
    if (a = l, l = c, c = Rr(t, s + 1), !!l) {
      if (c) {
        const u = c[e] - l[e];
        o[s] = u !== 0 ? (c[n] - l[n]) / u : 0;
      }
      i[s] = a ? c ? rn(o[s - 1]) !== rn(o[s]) ? 0 : (o[s - 1] + o[s]) / 2 : o[s - 1] : o[s];
    }
  v1(t, o, i), b1(t, i, e);
}
function Yo(t, e, n) {
  return Math.max(Math.min(t, n), e);
}
function x1(t, e) {
  let n, r, o, i, s, a = vn(t[0], e);
  for (n = 0, r = t.length; n < r; ++n)
    s = i, i = a, a = n < r - 1 && vn(t[n + 1], e), i && (o = t[n], s && (o.cp1x = Yo(o.cp1x, e.left, e.right), o.cp1y = Yo(o.cp1y, e.top, e.bottom)), a && (o.cp2x = Yo(o.cp2x, e.left, e.right), o.cp2y = Yo(o.cp2y, e.top, e.bottom)));
}
function w1(t, e, n, r, o) {
  let i, s, a, l;
  if (e.spanGaps && (t = t.filter((c) => !c.skip)), e.cubicInterpolationMode === "monotone")
    y1(t, o);
  else {
    let c = r ? t[t.length - 1] : t[0];
    for (i = 0, s = t.length; i < s; ++i)
      a = t[i], l = m1(c, a, t[Math.min(i + 1, s - (r ? 0 : 1)) % s], e.tension), a.cp1x = l.previous.x, a.cp1y = l.previous.y, a.cp2x = l.next.x, a.cp2y = l.next.y, c = a;
  }
  e.capBezierPoints && x1(t, n);
}
function lh() {
  return typeof window < "u" && typeof document < "u";
}
function wl(t) {
  let e = t.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function Ni(t, e, n) {
  let r;
  return typeof t == "string" ? (r = parseInt(t, 10), t.indexOf("%") !== -1 && (r = r / 100 * e.parentNode[n])) : r = t, r;
}
const rs = (t) => t.ownerDocument.defaultView.getComputedStyle(t, null);
function _1(t, e) {
  return rs(t).getPropertyValue(e);
}
const C1 = [
  "top",
  "right",
  "bottom",
  "left"
];
function nr(t, e, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let o = 0; o < 4; o++) {
    const i = C1[o];
    r[i] = parseFloat(t[e + "-" + i + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const E1 = (t, e, n) => (t > 0 || e > 0) && (!n || !n.shadowRoot);
function k1(t, e) {
  const n = t.touches, r = n && n.length ? n[0] : t, { offsetX: o, offsetY: i } = r;
  let s = !1, a, l;
  if (E1(o, i, t.target))
    a = o, l = i;
  else {
    const c = e.getBoundingClientRect();
    a = r.clientX - c.left, l = r.clientY - c.top, s = !0;
  }
  return {
    x: a,
    y: l,
    box: s
  };
}
function Kn(t, e) {
  if ("native" in t)
    return t;
  const { canvas: n, currentDevicePixelRatio: r } = e, o = rs(n), i = o.boxSizing === "border-box", s = nr(o, "padding"), a = nr(o, "border", "width"), { x: l, y: c, box: u } = k1(t, n), d = s.left + (u && a.left), f = s.top + (u && a.top);
  let { width: h, height: p } = e;
  return i && (h -= s.width + a.width, p -= s.height + a.height), {
    x: Math.round((l - d) / h * n.width / r),
    y: Math.round((c - f) / p * n.height / r)
  };
}
function M1(t, e, n) {
  let r, o;
  if (e === void 0 || n === void 0) {
    const i = wl(t);
    if (!i)
      e = t.clientWidth, n = t.clientHeight;
    else {
      const s = i.getBoundingClientRect(), a = rs(i), l = nr(a, "border", "width"), c = nr(a, "padding");
      e = s.width - c.width - l.width, n = s.height - c.height - l.height, r = Ni(a.maxWidth, i, "clientWidth"), o = Ni(a.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: e,
    height: n,
    maxWidth: r || Ii,
    maxHeight: o || Ii
  };
}
const Uo = (t) => Math.round(t * 10) / 10;
function O1(t, e, n, r) {
  const o = rs(t), i = nr(o, "margin"), s = Ni(o.maxWidth, t, "clientWidth") || Ii, a = Ni(o.maxHeight, t, "clientHeight") || Ii, l = M1(t, e, n);
  let { width: c, height: u } = l;
  if (o.boxSizing === "content-box") {
    const f = nr(o, "border", "width"), h = nr(o, "padding");
    c -= h.width + f.width, u -= h.height + f.height;
  }
  return c = Math.max(0, c - i.width), u = Math.max(0, r ? c / r : u - i.height), c = Uo(Math.min(c, s, l.maxWidth)), u = Uo(Math.min(u, a, l.maxHeight)), c && !u && (u = Uo(c / 2)), (e !== void 0 || n !== void 0) && r && l.height && u > l.height && (u = l.height, c = Uo(Math.floor(u * r))), {
    width: c,
    height: u
  };
}
function Xc(t, e, n) {
  const r = e || 1, o = Math.floor(t.height * r), i = Math.floor(t.width * r);
  t.height = Math.floor(t.height), t.width = Math.floor(t.width);
  const s = t.canvas;
  return s.style && (n || !s.style.height && !s.style.width) && (s.style.height = `${t.height}px`, s.style.width = `${t.width}px`), t.currentDevicePixelRatio !== r || s.height !== o || s.width !== i ? (t.currentDevicePixelRatio = r, s.height = o, s.width = i, t.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const P1 = function() {
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    };
    window.addEventListener("test", null, e), window.removeEventListener("test", null, e);
  } catch {
  }
  return t;
}();
function Zc(t, e) {
  const n = _1(t, e), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function qn(t, e, n, r) {
  return {
    x: t.x + n * (e.x - t.x),
    y: t.y + n * (e.y - t.y)
  };
}
function S1(t, e, n, r) {
  return {
    x: t.x + n * (e.x - t.x),
    y: r === "middle" ? n < 0.5 ? t.y : e.y : r === "after" ? n < 1 ? t.y : e.y : n > 0 ? e.y : t.y
  };
}
function D1(t, e, n, r) {
  const o = {
    x: t.cp2x,
    y: t.cp2y
  }, i = {
    x: e.cp1x,
    y: e.cp1y
  }, s = qn(t, o, n), a = qn(o, i, n), l = qn(i, e, n), c = qn(s, a, n), u = qn(a, l, n);
  return qn(c, u, n);
}
const T1 = function(t, e) {
  return {
    x(n) {
      return t + t + e - n;
    },
    setWidth(n) {
      e = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, I1 = function() {
  return {
    x(t) {
      return t;
    },
    setWidth(t) {
    },
    textAlign(t) {
      return t;
    },
    xPlus(t, e) {
      return t + e;
    },
    leftForLtr(t, e) {
      return t;
    }
  };
};
function Sr(t, e, n) {
  return t ? T1(e, n) : I1();
}
function ch(t, e) {
  let n, r;
  (e === "ltr" || e === "rtl") && (n = t.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", e, "important"), t.prevTextDirection = r);
}
function uh(t, e) {
  e !== void 0 && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]));
}
function dh(t) {
  return t === "angle" ? {
    between: Gf,
    compare: Tb,
    normalize: jt
  } : {
    between: Qn,
    compare: (e, n) => e - n,
    normalize: (e) => e
  };
}
function Qc({ start: t, end: e, count: n, loop: r, style: o }) {
  return {
    start: t % n,
    end: e % n,
    loop: r && (e - t + 1) % n === 0,
    style: o
  };
}
function $1(t, e, n) {
  const { property: r, start: o, end: i } = n, { between: s, normalize: a } = dh(r), l = e.length;
  let { start: c, end: u, loop: d } = t, f, h;
  if (d) {
    for (c += l, u += l, f = 0, h = l; f < h && s(a(e[c % l][r]), o, i); ++f)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: d,
    style: t.style
  };
}
function N1(t, e, n) {
  if (!n)
    return [
      t
    ];
  const { property: r, start: o, end: i } = n, s = e.length, { compare: a, between: l, normalize: c } = dh(r), { start: u, end: d, loop: f, style: h } = $1(t, e, n), p = [];
  let g = !1, m = null, v, b, y;
  const w = () => l(o, y, v) && a(o, y) !== 0, x = () => a(i, v) === 0 || l(i, y, v), M = () => g || w(), E = () => !g || x();
  for (let C = u, O = u; C <= d; ++C)
    b = e[C % s], !b.skip && (v = c(b[r]), v !== y && (g = l(v, o, i), m === null && M() && (m = a(v, o) === 0 ? C : O), m !== null && E() && (p.push(Qc({
      start: m,
      end: C,
      loop: f,
      count: s,
      style: h
    })), m = null), O = C, y = v));
  return m !== null && p.push(Qc({
    start: m,
    end: d,
    loop: f,
    count: s,
    style: h
  })), p;
}
function R1(t, e) {
  const n = [], r = t.segments;
  for (let o = 0; o < r.length; o++) {
    const i = N1(r[o], t.points, e);
    i.length && n.push(...i);
  }
  return n;
}
function A1(t, e, n, r) {
  let o = 0, i = e - 1;
  if (n && !r)
    for (; o < e && !t[o].skip; )
      o++;
  for (; o < e && t[o].skip; )
    o++;
  for (o %= e, n && (i += o); i > o && t[i % e].skip; )
    i--;
  return i %= e, {
    start: o,
    end: i
  };
}
function L1(t, e, n, r) {
  const o = t.length, i = [];
  let s = e, a = t[e], l;
  for (l = e + 1; l <= n; ++l) {
    const c = t[l % o];
    c.skip || c.stop ? a.skip || (r = !1, i.push({
      start: e % o,
      end: (l - 1) % o,
      loop: r
    }), e = s = c.stop ? l : null) : (s = l, a.skip && (e = l)), a = c;
  }
  return s !== null && i.push({
    start: e % o,
    end: s % o,
    loop: r
  }), i;
}
function F1(t, e) {
  const n = t.points, r = t.options.spanGaps, o = n.length;
  if (!o)
    return [];
  const i = !!t._loop, { start: s, end: a } = A1(n, o, i, r);
  if (r === !0)
    return Jc(t, [
      {
        start: s,
        end: a,
        loop: i
      }
    ], n, e);
  const l = a < s ? a + o : a, c = !!t._fullLoop && s === 0 && a === o - 1;
  return Jc(t, L1(n, s, l, c), n, e);
}
function Jc(t, e, n, r) {
  return !r || !r.setContext || !n ? e : H1(t, e, n, r);
}
function H1(t, e, n, r) {
  const o = t._chart.getContext(), i = eu(t.options), { _datasetIndex: s, options: { spanGaps: a } } = t, l = n.length, c = [];
  let u = i, d = e[0].start, f = d;
  function h(p, g, m, v) {
    const b = a ? -1 : 1;
    if (p !== g) {
      for (p += l; n[p % l].skip; )
        p -= b;
      for (; n[g % l].skip; )
        g += b;
      p % l !== g % l && (c.push({
        start: p % l,
        end: g % l,
        loop: m,
        style: v
      }), u = v, d = g % l);
    }
  }
  for (const p of e) {
    d = a ? d : p.start;
    let g = n[d % l], m;
    for (f = d + 1; f <= p.end; f++) {
      const v = n[f % l];
      m = eu(r.setContext(Vn(o, {
        type: "segment",
        p0: g,
        p1: v,
        p0DataIndex: (f - 1) % l,
        p1DataIndex: f % l,
        datasetIndex: s
      }))), W1(m, u) && h(d, f - 1, p.loop, u), g = v, u = m;
    }
    d < f - 1 && h(d, f - 1, p.loop, u);
  }
  return c;
}
function eu(t) {
  return {
    backgroundColor: t.backgroundColor,
    borderCapStyle: t.borderCapStyle,
    borderDash: t.borderDash,
    borderDashOffset: t.borderDashOffset,
    borderJoinStyle: t.borderJoinStyle,
    borderWidth: t.borderWidth,
    borderColor: t.borderColor
  };
}
function W1(t, e) {
  if (!e)
    return !1;
  const n = [], r = function(o, i) {
    return pl(i) ? (n.includes(i) || n.push(i), n.indexOf(i)) : i;
  };
  return JSON.stringify(t, r) !== JSON.stringify(e, r);
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class V1 {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, n, r, o) {
    const i = n.listeners[o], s = n.duration;
    i.forEach((a) => a({
      chart: e,
      initial: n.initial,
      numSteps: s,
      currentStep: Math.min(r - n.start, s)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Xf.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let n = 0;
    this._charts.forEach((r, o) => {
      if (!r.running || !r.items.length)
        return;
      const i = r.items;
      let s = i.length - 1, a = !1, l;
      for (; s >= 0; --s)
        l = i[s], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(e), a = !0) : (i[s] = i[i.length - 1], i.pop());
      a && (o.draw(), this._notify(o, r, e, "progress")), i.length || (r.running = !1, this._notify(o, r, e, "complete"), r.initial = !1), n += i.length;
    }), this._lastDate = e, n === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const n = this._charts;
    let r = n.get(e);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(e, r)), r;
  }
  listen(e, n, r) {
    this._getAnims(e).listeners[n].push(r);
  }
  add(e, n) {
    !n || !n.length || this._getAnims(e).items.push(...n);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const n = this._charts.get(e);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, o) => Math.max(r, o._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const n = this._charts.get(e);
    return !(!n || !n.running || !n.items.length);
  }
  stop(e) {
    const n = this._charts.get(e);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let o = r.length - 1;
    for (; o >= 0; --o)
      r[o].cancel();
    n.items = [], this._notify(e, n, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var pn = /* @__PURE__ */ new V1();
const tu = "transparent", B1 = {
  boolean(t, e, n) {
    return n > 0.5 ? e : t;
  },
  color(t, e, n) {
    const r = Yc(t || tu), o = r.valid && Yc(e || tu);
    return o && o.valid ? o.mix(r, n).hexString() : e;
  },
  number(t, e, n) {
    return t + (e - t) * n;
  }
};
class j1 {
  constructor(e, n, r, o) {
    const i = n[r];
    o = zo([
      e.to,
      o,
      i,
      e.from
    ]);
    const s = zo([
      e.from,
      i,
      o
    ]);
    this._active = !0, this._fn = e.fn || B1[e.type || typeof s], this._easing = ao[e.easing] || ao.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = n, this._prop = r, this._from = s, this._to = o, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, n, r) {
    if (this._active) {
      this._notify(!1);
      const o = this._target[this._prop], i = r - this._start, s = this._duration - i;
      this._start = r, this._duration = Math.floor(Math.max(s, e.duration)), this._total += i, this._loop = !!e.loop, this._to = zo([
        e.to,
        n,
        o,
        e.from
      ]), this._from = zo([
        e.from,
        o,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const n = e - this._start, r = this._duration, o = this._prop, i = this._from, s = this._loop, a = this._to;
    let l;
    if (this._active = i !== a && (s || n < r), !this._active) {
      this._target[o] = a, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[o] = i;
      return;
    }
    l = n / r % 2, l = s && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[o] = this._fn(i, a, l);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      e.push({
        res: n,
        rej: r
      });
    });
  }
  _notify(e) {
    const n = e ? "res" : "rej", r = this._promises || [];
    for (let o = 0; o < r.length; o++)
      r[o][n]();
  }
}
class fh {
  constructor(e, n) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(e) {
    if (!Se(e))
      return;
    const n = Object.keys(qe.animation), r = this._properties;
    Object.getOwnPropertyNames(e).forEach((o) => {
      const i = e[o];
      if (!Se(i))
        return;
      const s = {};
      for (const a of n)
        s[a] = i[a];
      (Ge(i.properties) && i.properties || [
        o
      ]).forEach((a) => {
        (a === o || !r.has(a)) && r.set(a, s);
      });
    });
  }
  _animateOptions(e, n) {
    const r = n.options, o = Y1(e, r);
    if (!o)
      return [];
    const i = this._createAnimations(o, r);
    return r.$shared && z1(e.options.$animations, r).then(() => {
      e.options = r;
    }, () => {
    }), i;
  }
  _createAnimations(e, n) {
    const r = this._properties, o = [], i = e.$animations || (e.$animations = {}), s = Object.keys(n), a = Date.now();
    let l;
    for (l = s.length - 1; l >= 0; --l) {
      const c = s[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        o.push(...this._animateOptions(e, n));
        continue;
      }
      const u = n[c];
      let d = i[c];
      const f = r.get(c);
      if (d)
        if (f && d.active()) {
          d.update(f, u, a);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        e[c] = u;
        continue;
      }
      i[c] = d = new j1(f, e, c, u), o.push(d);
    }
    return o;
  }
  update(e, n) {
    if (this._properties.size === 0) {
      Object.assign(e, n);
      return;
    }
    const r = this._createAnimations(e, n);
    if (r.length)
      return pn.add(this._chart, r), !0;
  }
}
function z1(t, e) {
  const n = [], r = Object.keys(e);
  for (let o = 0; o < r.length; o++) {
    const i = t[r[o]];
    i && i.active() && n.push(i.wait());
  }
  return Promise.all(n);
}
function Y1(t, e) {
  if (!e)
    return;
  let n = t.options;
  if (!n) {
    t.options = e;
    return;
  }
  return n.$shared && (t.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function nu(t, e) {
  const n = t && t.options || {}, r = n.reverse, o = n.min === void 0 ? e : 0, i = n.max === void 0 ? e : 0;
  return {
    start: r ? i : o,
    end: r ? o : i
  };
}
function U1(t, e, n) {
  if (n === !1)
    return !1;
  const r = nu(t, n), o = nu(e, n);
  return {
    top: o.end,
    right: r.end,
    bottom: o.start,
    left: r.start
  };
}
function G1(t) {
  let e, n, r, o;
  return Se(t) ? (e = t.top, n = t.right, r = t.bottom, o = t.left) : e = n = r = o = t, {
    top: e,
    right: n,
    bottom: r,
    left: o,
    disabled: t === !1
  };
}
function hh(t, e) {
  const n = [], r = t._getSortedDatasetMetas(e);
  let o, i;
  for (o = 0, i = r.length; o < i; ++o)
    n.push(r[o].index);
  return n;
}
function ru(t, e, n, r = {}) {
  const o = t.keys, i = r.mode === "single";
  let s, a, l, c;
  if (e !== null) {
    for (s = 0, a = o.length; s < a; ++s) {
      if (l = +o[s], l === n) {
        if (r.all)
          continue;
        break;
      }
      c = t.values[l], ot(c) && (i || e === 0 || rn(e) === rn(c)) && (e += c);
    }
    return e;
  }
}
function K1(t) {
  const e = Object.keys(t), n = new Array(e.length);
  let r, o, i;
  for (r = 0, o = e.length; r < o; ++r)
    i = e[r], n[r] = {
      x: i,
      y: t[i]
    };
  return n;
}
function ou(t, e) {
  const n = t && t.options.stacked;
  return n || n === void 0 && e.stack !== void 0;
}
function q1(t, e, n) {
  return `${t.id}.${e.id}.${n.stack || n.type}`;
}
function X1(t) {
  const { min: e, max: n, minDefined: r, maxDefined: o } = t.getUserBounds();
  return {
    min: r ? e : Number.NEGATIVE_INFINITY,
    max: o ? n : Number.POSITIVE_INFINITY
  };
}
function Z1(t, e, n) {
  const r = t[e] || (t[e] = {});
  return r[n] || (r[n] = {});
}
function iu(t, e, n, r) {
  for (const o of e.getMatchingVisibleMetas(r).reverse()) {
    const i = t[o.index];
    if (n && i > 0 || !n && i < 0)
      return o.index;
  }
  return null;
}
function su(t, e) {
  const { chart: n, _cachedMeta: r } = t, o = n._stacks || (n._stacks = {}), { iScale: i, vScale: s, index: a } = r, l = i.axis, c = s.axis, u = q1(i, s, r), d = e.length;
  let f;
  for (let h = 0; h < d; ++h) {
    const p = e[h], { [l]: g, [c]: m } = p, v = p._stacks || (p._stacks = {});
    f = v[c] = Z1(o, u, g), f[a] = m, f._top = iu(f, s, !0, r.type), f._bottom = iu(f, s, !1, r.type);
    const b = f._visualValues || (f._visualValues = {});
    b[a] = m;
  }
}
function Ms(t, e) {
  const n = t.scales;
  return Object.keys(n).filter((r) => n[r].axis === e).shift();
}
function Q1(t, e) {
  return Vn(t, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function J1(t, e, n) {
  return Vn(t, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: e,
    mode: "default",
    type: "data"
  });
}
function Ur(t, e) {
  const n = t.controller.index, r = t.vScale && t.vScale.axis;
  if (r) {
    e = e || t._parsed;
    for (const o of e) {
      const i = o._stacks;
      if (!i || i[r] === void 0 || i[r][n] === void 0)
        return;
      delete i[r][n], i[r]._visualValues !== void 0 && i[r]._visualValues[n] !== void 0 && delete i[r]._visualValues[n];
    }
  }
}
const Os = (t) => t === "reset" || t === "none", au = (t, e) => e ? t : Object.assign({}, t), ey = (t, e, n) => t && !e.hidden && e._stacked && {
  keys: hh(n, !0),
  values: null
};
class Dr {
  constructor(e, n) {
    this.chart = e, this._ctx = e.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = ou(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && Ur(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, n = this._cachedMeta, r = this.getDataset(), o = (d, f, h, p) => d === "x" ? f : d === "r" ? p : h, i = n.xAxisID = we(r.xAxisID, Ms(e, "x")), s = n.yAxisID = we(r.yAxisID, Ms(e, "y")), a = n.rAxisID = we(r.rAxisID, Ms(e, "r")), l = n.indexAxis, c = n.iAxisID = o(l, i, s, a), u = n.vAxisID = o(l, s, i, a);
    n.xScale = this.getScaleForId(i), n.yScale = this.getScaleForId(s), n.rScale = this.getScaleForId(a), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const n = this._cachedMeta;
    return e === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && Bc(this._data, this), e._stacked && Ur(e);
  }
  _dataCheck() {
    const e = this.getDataset(), n = e.data || (e.data = []), r = this._data;
    if (Se(n))
      this._data = K1(n);
    else if (r !== n) {
      if (r) {
        Bc(r, this);
        const o = this._cachedMeta;
        Ur(o), o._parsed = [];
      }
      n && Object.isExtensible(n) && Rb(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const n = this._cachedMeta, r = this.getDataset();
    let o = !1;
    this._dataCheck();
    const i = n._stacked;
    n._stacked = ou(n.vScale, n), n.stack !== r.stack && (o = !0, Ur(n), n.stack = r.stack), this._resyncElements(e), (o || i !== n._stacked) && su(this, n._parsed);
  }
  configure() {
    const e = this.chart.config, n = e.datasetScopeKeys(this._type), r = e.getOptionScopes(this.getDataset(), n, !0);
    this.options = e.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, n) {
    const { _cachedMeta: r, _data: o } = this, { iScale: i, _stacked: s } = r, a = i.axis;
    let l = e === 0 && n === o.length ? !0 : r._sorted, c = e > 0 && r._parsed[e - 1], u, d, f;
    if (this._parsing === !1)
      r._parsed = o, r._sorted = !0, f = o;
    else {
      Ge(o[e]) ? f = this.parseArrayData(r, o, e, n) : Se(o[e]) ? f = this.parseObjectData(r, o, e, n) : f = this.parsePrimitiveData(r, o, e, n);
      const h = () => d[a] === null || c && d[a] < c[a];
      for (u = 0; u < n; ++u)
        r._parsed[u + e] = d = f[u], l && (h() && (l = !1), c = d);
      r._sorted = l;
    }
    s && su(this, f);
  }
  parsePrimitiveData(e, n, r, o) {
    const { iScale: i, vScale: s } = e, a = i.axis, l = s.axis, c = i.getLabels(), u = i === s, d = new Array(o);
    let f, h, p;
    for (f = 0, h = o; f < h; ++f)
      p = f + r, d[f] = {
        [a]: u || i.parse(c[p], p),
        [l]: s.parse(n[p], p)
      };
    return d;
  }
  parseArrayData(e, n, r, o) {
    const { xScale: i, yScale: s } = e, a = new Array(o);
    let l, c, u, d;
    for (l = 0, c = o; l < c; ++l)
      u = l + r, d = n[u], a[l] = {
        x: i.parse(d[0], u),
        y: s.parse(d[1], u)
      };
    return a;
  }
  parseObjectData(e, n, r, o) {
    const { xScale: i, yScale: s } = e, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(o);
    let u, d, f, h;
    for (u = 0, d = o; u < d; ++u)
      f = u + r, h = n[f], c[u] = {
        x: i.parse(Ir(h, a), f),
        y: s.parse(Ir(h, l), f)
      };
    return c;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, n, r) {
    const o = this.chart, i = this._cachedMeta, s = n[e.axis], a = {
      keys: hh(o, !0),
      values: n._stacks[e.axis]._visualValues
    };
    return ru(a, s, i.index, {
      mode: r
    });
  }
  updateRangeFromParsed(e, n, r, o) {
    const i = r[n.axis];
    let s = i === null ? NaN : i;
    const a = o && r._stacks[n.axis];
    o && a && (o.values = a, s = ru(o, i, this._cachedMeta.index)), e.min = Math.min(e.min, s), e.max = Math.max(e.max, s);
  }
  getMinMax(e, n) {
    const r = this._cachedMeta, o = r._parsed, i = r._sorted && e === r.iScale, s = o.length, a = this._getOtherScale(e), l = ey(n, r, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = X1(a);
    let f, h;
    function p() {
      h = o[f];
      const g = h[a.axis];
      return !ot(h[e.axis]) || u > g || d < g;
    }
    for (f = 0; f < s && !(!p() && (this.updateRangeFromParsed(c, e, h, l), i)); ++f)
      ;
    if (i) {
      for (f = s - 1; f >= 0; --f)
        if (!p()) {
          this.updateRangeFromParsed(c, e, h, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(e) {
    const n = this._cachedMeta._parsed, r = [];
    let o, i, s;
    for (o = 0, i = n.length; o < i; ++o)
      s = n[o][e.axis], ot(s) && r.push(s);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, r = n.iScale, o = n.vScale, i = this.getParsed(e);
    return {
      label: r ? "" + r.getLabelForValue(i[r.axis]) : "",
      value: o ? "" + o.getLabelForValue(i[o.axis]) : ""
    };
  }
  _update(e) {
    const n = this._cachedMeta;
    this.update(e || "default"), n._clip = G1(we(this.options.clip, U1(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, n = this.chart, r = this._cachedMeta, o = r.data || [], i = n.chartArea, s = [], a = this._drawStart || 0, l = this._drawCount || o.length - a, c = this.options.drawActiveElementsOnTop;
    let u;
    for (r.dataset && r.dataset.draw(e, i, a, l), u = a; u < a + l; ++u) {
      const d = o[u];
      d.hidden || (d.active && c ? s.push(d) : d.draw(e, i));
    }
    for (u = 0; u < s.length; ++u)
      s[u].draw(e, i);
  }
  getStyle(e, n) {
    const r = n ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(e || 0, r);
  }
  getContext(e, n, r) {
    const o = this.getDataset();
    let i;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const s = this._cachedMeta.data[e];
      i = s.$context || (s.$context = J1(this.getContext(), e, s)), i.parsed = this.getParsed(e), i.raw = o.data[e], i.index = i.dataIndex = e;
    } else
      i = this.$context || (this.$context = Q1(this.chart.getContext(), this.index)), i.dataset = o, i.index = i.datasetIndex = this.index;
    return i.active = !!n, i.mode = r, i;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, e);
  }
  _resolveElementOptions(e, n = "default", r) {
    const o = n === "active", i = this._cachedDataOpts, s = e + "-" + n, a = i[s], l = this.enableOptionSharing && yo(r);
    if (a)
      return au(a, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, e), d = o ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], f = c.getOptionScopes(this.getDataset(), u), h = Object.keys(qe.elements[e]), p = () => this.getContext(r, o, n), g = c.resolveNamedOptions(f, h, p, d);
    return g.$shared && (g.$shared = l, i[s] = Object.freeze(au(g, l))), g;
  }
  _resolveAnimations(e, n, r) {
    const o = this.chart, i = this._cachedDataOpts, s = `animation-${n}`, a = i[s];
    if (a)
      return a;
    let l;
    if (o.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, n), f = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(f, this.getContext(e, r, n));
    }
    const c = new fh(o, l && l.animations);
    return l && l._cacheable && (i[s] = Object.freeze(c)), c;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, n) {
    return !n || Os(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, n) {
    const r = this.resolveDataElementOptions(e, n), o = this._sharedOptions, i = this.getSharedOptions(r), s = this.includeOptions(n, i) || i !== o;
    return this.updateSharedOptions(i, n, r), {
      sharedOptions: i,
      includeOptions: s
    };
  }
  updateElement(e, n, r, o) {
    Os(o) ? Object.assign(e, r) : this._resolveAnimations(n, o).update(e, r);
  }
  updateSharedOptions(e, n, r) {
    e && !Os(n) && this._resolveAnimations(void 0, n).update(e, r);
  }
  _setStyle(e, n, r, o) {
    e.active = o;
    const i = this.getStyle(n, o);
    this._resolveAnimations(n, r, o).update(e, {
      options: !o && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(e, n, r) {
    this._setStyle(e, r, "active", !1);
  }
  setHoverStyle(e, n, r) {
    this._setStyle(e, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [a, l, c] of this._syncList)
      this[a](l, c);
    this._syncList = [];
    const o = r.length, i = n.length, s = Math.min(i, o);
    s && this.parse(0, s), i > o ? this._insertElements(o, i - o, e) : i < o && this._removeElements(i, o - i);
  }
  _insertElements(e, n, r = !0) {
    const o = this._cachedMeta, i = o.data, s = e + n;
    let a;
    const l = (c) => {
      for (c.length += n, a = c.length - 1; a >= s; a--)
        c[a] = c[a - n];
    };
    for (l(i), a = e; a < s; ++a)
      i[a] = new this.dataElementType();
    this._parsing && l(o._parsed), this.parse(e, n), r && this.updateElements(i, e, n, "reset");
  }
  updateElements(e, n, r, o) {
  }
  _removeElements(e, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const o = r._parsed.splice(e, n);
      r._stacked && Ur(r, o);
    }
    r.data.splice(e, n);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [n, r, o] = e;
      this[n](r, o);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, n) {
    n && this._sync([
      "_removeElements",
      e,
      n
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      e,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
fe(Dr, "defaults", {}), fe(Dr, "datasetElementType", null), fe(Dr, "dataElementType", null);
function ty(t, e) {
  if (!t._cache.$bar) {
    const n = t.getMatchingVisibleMetas(e);
    let r = [];
    for (let o = 0, i = n.length; o < i; o++)
      r = r.concat(n[o].controller.getAllParsedValues(t));
    t._cache.$bar = qf(r.sort((o, i) => o - i));
  }
  return t._cache.$bar;
}
function ny(t) {
  const e = t.iScale, n = ty(e, t.type);
  let r = e._length, o, i, s, a;
  const l = () => {
    s === 32767 || s === -32768 || (yo(a) && (r = Math.min(r, Math.abs(s - a) || r)), a = s);
  };
  for (o = 0, i = n.length; o < i; ++o)
    s = e.getPixelForValue(n[o]), l();
  for (a = void 0, o = 0, i = e.ticks.length; o < i; ++o)
    s = e.getPixelForTick(o), l();
  return r;
}
function ry(t, e, n, r) {
  const o = n.barThickness;
  let i, s;
  return Fe(o) ? (i = e.min * n.categoryPercentage, s = n.barPercentage) : (i = o * r, s = 1), {
    chunk: i / r,
    ratio: s,
    start: e.pixels[t] - i / 2
  };
}
function oy(t, e, n, r) {
  const o = e.pixels, i = o[t];
  let s = t > 0 ? o[t - 1] : null, a = t < o.length - 1 ? o[t + 1] : null;
  const l = n.categoryPercentage;
  s === null && (s = i - (a === null ? e.end - e.start : a - i)), a === null && (a = i + i - s);
  const c = i - (i - Math.min(s, a)) / 2 * l;
  return {
    chunk: Math.abs(a - s) / 2 * l / r,
    ratio: n.barPercentage,
    start: c
  };
}
function iy(t, e, n, r) {
  const o = n.parse(t[0], r), i = n.parse(t[1], r), s = Math.min(o, i), a = Math.max(o, i);
  let l = s, c = a;
  Math.abs(s) > Math.abs(a) && (l = a, c = s), e[n.axis] = c, e._custom = {
    barStart: l,
    barEnd: c,
    start: o,
    end: i,
    min: s,
    max: a
  };
}
function ph(t, e, n, r) {
  return Ge(t) ? iy(t, e, n, r) : e[n.axis] = n.parse(t, r), e;
}
function lu(t, e, n, r) {
  const o = t.iScale, i = t.vScale, s = o.getLabels(), a = o === i, l = [];
  let c, u, d, f;
  for (c = n, u = n + r; c < u; ++c)
    f = e[c], d = {}, d[o.axis] = a || o.parse(s[c], c), l.push(ph(f, d, i, c));
  return l;
}
function Ps(t) {
  return t && t.barStart !== void 0 && t.barEnd !== void 0;
}
function sy(t, e, n) {
  return t !== 0 ? rn(t) : (e.isHorizontal() ? 1 : -1) * (e.min >= n ? 1 : -1);
}
function ay(t) {
  let e, n, r, o, i;
  return t.horizontal ? (e = t.base > t.x, n = "left", r = "right") : (e = t.base < t.y, n = "bottom", r = "top"), e ? (o = "end", i = "start") : (o = "start", i = "end"), {
    start: n,
    end: r,
    reverse: e,
    top: o,
    bottom: i
  };
}
function ly(t, e, n, r) {
  let o = e.borderSkipped;
  const i = {};
  if (!o) {
    t.borderSkipped = i;
    return;
  }
  if (o === !0) {
    t.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: s, end: a, reverse: l, top: c, bottom: u } = ay(t);
  o === "middle" && n && (t.enableBorderRadius = !0, (n._top || 0) === r ? o = c : (n._bottom || 0) === r ? o = u : (i[cu(u, s, a, l)] = !0, o = c)), i[cu(o, s, a, l)] = !0, t.borderSkipped = i;
}
function cu(t, e, n, r) {
  return r ? (t = cy(t, e, n), t = uu(t, n, e)) : t = uu(t, e, n), t;
}
function cy(t, e, n) {
  return t === e ? n : t === n ? e : t;
}
function uu(t, e, n) {
  return t === "start" ? e : t === "end" ? n : t;
}
function uy(t, { inflateAmount: e }, n) {
  t.inflateAmount = e === "auto" ? n === 1 ? 0.33 : 0 : e;
}
class fi extends Dr {
  parsePrimitiveData(e, n, r, o) {
    return lu(e, n, r, o);
  }
  parseArrayData(e, n, r, o) {
    return lu(e, n, r, o);
  }
  parseObjectData(e, n, r, o) {
    const { iScale: i, vScale: s } = e, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = i.axis === "x" ? a : l, u = s.axis === "x" ? a : l, d = [];
    let f, h, p, g;
    for (f = r, h = r + o; f < h; ++f)
      g = n[f], p = {}, p[i.axis] = i.parse(Ir(g, c), f), d.push(ph(Ir(g, u), p, s, f));
    return d;
  }
  updateRangeFromParsed(e, n, r, o) {
    super.updateRangeFromParsed(e, n, r, o);
    const i = r._custom;
    i && n === this._cachedMeta.vScale && (e.min = Math.min(e.min, i.min), e.max = Math.max(e.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, { iScale: r, vScale: o } = n, i = this.getParsed(e), s = i._custom, a = Ps(s) ? "[" + s.start + ", " + s.end + "]" : "" + o.getLabelForValue(i[o.axis]);
    return {
      label: "" + r.getLabelForValue(i[r.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const e = this._cachedMeta;
    e.stack = this.getDataset().stack;
  }
  update(e) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, e);
  }
  updateElements(e, n, r, o) {
    const i = o === "reset", { index: s, _cachedMeta: { vScale: a } } = this, l = a.getBasePixel(), c = a.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(n, o);
    for (let h = n; h < n + r; h++) {
      const p = this.getParsed(h), g = i || Fe(p[a.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), m = this._calculateBarIndexPixels(h, u), v = (p._stacks || {})[a.axis], b = {
        horizontal: c,
        base: g.base,
        enableBorderRadius: !v || Ps(p._custom) || s === v._top || s === v._bottom,
        x: c ? g.head : m.center,
        y: c ? m.center : g.head,
        height: c ? m.size : Math.abs(g.size),
        width: c ? Math.abs(g.size) : m.size
      };
      f && (b.options = d || this.resolveDataElementOptions(h, e[h].active ? "active" : o));
      const y = b.options || e[h].options;
      ly(b, y, v, s), uy(b, y, u.ratio), this.updateElement(e[h], h, b, o);
    }
  }
  _getStacks(e, n) {
    const { iScale: r } = this._cachedMeta, o = r.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), i = r.options.stacked, s = [], a = (l) => {
      const c = l.controller.getParsed(n), u = c && c[l.vScale.axis];
      if (Fe(u) || isNaN(u))
        return !0;
    };
    for (const l of o)
      if (!(n !== void 0 && a(l)) && ((i === !1 || s.indexOf(l.stack) === -1 || i === void 0 && l.stack === void 0) && s.push(l.stack), l.index === e))
        break;
    return s.length || s.push(void 0), s;
  }
  _getStackCount(e) {
    return this._getStacks(void 0, e).length;
  }
  _getStackIndex(e, n, r) {
    const o = this._getStacks(e, r), i = n !== void 0 ? o.indexOf(n) : -1;
    return i === -1 ? o.length - 1 : i;
  }
  _getRuler() {
    const e = this.options, n = this._cachedMeta, r = n.iScale, o = [];
    let i, s;
    for (i = 0, s = n.data.length; i < s; ++i)
      o.push(r.getPixelForValue(this.getParsed(i)[r.axis], i));
    const a = e.barThickness;
    return {
      min: a || ny(n),
      pixels: o,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: e.grouped,
      ratio: a ? 1 : e.categoryPercentage * e.barPercentage
    };
  }
  _calculateBarValuePixels(e) {
    const { _cachedMeta: { vScale: n, _stacked: r, index: o }, options: { base: i, minBarLength: s } } = this, a = i || 0, l = this.getParsed(e), c = l._custom, u = Ps(c);
    let d = l[n.axis], f = 0, h = r ? this.applyStack(n, l, r) : d, p, g;
    h !== d && (f = h - d, h = d), u && (d = c.barStart, h = c.barEnd - c.barStart, d !== 0 && rn(d) !== rn(c.barEnd) && (f = 0), f += d);
    const m = !Fe(i) && !u ? i : f;
    let v = n.getPixelForValue(m);
    if (this.chart.getDataVisibility(e) ? p = n.getPixelForValue(f + h) : p = v, g = p - v, Math.abs(g) < s) {
      g = sy(g, n, a) * s, d === a && (v -= g / 2);
      const b = n.getPixelForDecimal(0), y = n.getPixelForDecimal(1), w = Math.min(b, y), x = Math.max(b, y);
      v = Math.max(Math.min(v, x), w), p = v + g, r && !u && (l._stacks[n.axis]._visualValues[o] = n.getValueForPixel(p) - n.getValueForPixel(v));
    }
    if (v === n.getPixelForValue(a)) {
      const b = rn(g) * n.getLineWidthForValue(a) / 2;
      v += b, g -= b;
    }
    return {
      size: g,
      base: v,
      head: p,
      center: p + g / 2
    };
  }
  _calculateBarIndexPixels(e, n) {
    const r = n.scale, o = this.options, i = o.skipNull, s = we(o.maxBarThickness, 1 / 0);
    let a, l;
    if (n.grouped) {
      const c = i ? this._getStackCount(e) : n.stackCount, u = o.barThickness === "flex" ? oy(e, n, o, c) : ry(e, n, o, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, i ? e : void 0);
      a = u.start + u.chunk * d + u.chunk / 2, l = Math.min(s, u.chunk * u.ratio);
    } else
      a = r.getPixelForValue(this.getParsed(e)[r.axis], e), l = Math.min(s, n.min * n.ratio);
    return {
      base: a - l / 2,
      head: a + l / 2,
      center: a,
      size: l
    };
  }
  draw() {
    const e = this._cachedMeta, n = e.vScale, r = e.data, o = r.length;
    let i = 0;
    for (; i < o; ++i)
      this.getParsed(i)[n.axis] !== null && r[i].draw(this._ctx);
  }
}
fe(fi, "id", "bar"), fe(fi, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), fe(fi, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class hi extends Dr {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(e) {
    const n = this._cachedMeta, { dataset: r, data: o = [], _dataset: i } = n, s = this.chart._animationsDisabled;
    let { start: a, count: l } = Fb(n, o, s);
    this._drawStart = a, this._drawCount = l, Hb(n) && (a = 0, l = o.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!i._decimated, r.points = o;
    const c = this.resolveDatasetElementOptions(e);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !s,
      options: c
    }, e), this.updateElements(o, a, l, e);
  }
  updateElements(e, n, r, o) {
    const i = o === "reset", { iScale: s, vScale: a, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(n, o), f = s.axis, h = a.axis, { spanGaps: p, segment: g } = this.options, m = xo(p) ? p : Number.POSITIVE_INFINITY, v = this.chart._animationsDisabled || i || o === "none", b = n + r, y = e.length;
    let w = n > 0 && this.getParsed(n - 1);
    for (let x = 0; x < y; ++x) {
      const M = e[x], E = v ? M : {};
      if (x < n || x >= b) {
        E.skip = !0;
        continue;
      }
      const C = this.getParsed(x), O = Fe(C[h]), R = E[f] = s.getPixelForValue(C[f], x), D = E[h] = i || O ? a.getBasePixel() : a.getPixelForValue(l ? this.applyStack(a, C, l) : C[h], x);
      E.skip = isNaN(R) || isNaN(D) || O, E.stop = x > 0 && Math.abs(C[f] - w[f]) > m, g && (E.parsed = C, E.raw = c.data[x]), d && (E.options = u || this.resolveDataElementOptions(x, M.active ? "active" : o)), v || this.updateElement(M, x, E, o), w = C;
    }
  }
  getMaxOverflow() {
    const e = this._cachedMeta, n = e.dataset, r = n.options && n.options.borderWidth || 0, o = e.data || [];
    if (!o.length)
      return r;
    const i = o[0].size(this.resolveDataElementOptions(0)), s = o[o.length - 1].size(this.resolveDataElementOptions(o.length - 1));
    return Math.max(r, i, s) / 2;
  }
  draw() {
    const e = this._cachedMeta;
    e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw();
  }
}
fe(hi, "id", "line"), fe(hi, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), fe(hi, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function Un() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class _l {
  constructor(e) {
    fe(this, "options");
    this.options = e || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(_l.prototype, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Un();
  }
  parse() {
    return Un();
  }
  format() {
    return Un();
  }
  add() {
    return Un();
  }
  diff() {
    return Un();
  }
  startOf() {
    return Un();
  }
  endOf() {
    return Un();
  }
}
var gh = {
  _date: _l
};
function dy(t, e, n, r) {
  const { controller: o, data: i, _sorted: s } = t, a = o._cachedMeta.iScale;
  if (a && e === a.axis && e !== "r" && s && i.length) {
    const l = a._reversePixels ? $b : Jn;
    if (r) {
      if (o._sharedOptions) {
        const c = i[0], u = typeof c.getRange == "function" && c.getRange(e);
        if (u) {
          const d = l(i, e, n - u), f = l(i, e, n + u);
          return {
            lo: d.lo,
            hi: f.hi
          };
        }
      }
    } else
      return l(i, e, n);
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function So(t, e, n, r, o) {
  const i = t.getSortedVisibleDatasetMetas(), s = n[e];
  for (let a = 0, l = i.length; a < l; ++a) {
    const { index: c, data: u } = i[a], { lo: d, hi: f } = dy(i[a], e, s, o);
    for (let h = d; h <= f; ++h) {
      const p = u[h];
      p.skip || r(p, c, h);
    }
  }
}
function fy(t) {
  const e = t.indexOf("x") !== -1, n = t.indexOf("y") !== -1;
  return function(r, o) {
    const i = e ? Math.abs(r.x - o.x) : 0, s = n ? Math.abs(r.y - o.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(s, 2));
  };
}
function Ss(t, e, n, r, o) {
  const i = [];
  return !o && !t.isPointInArea(e) || So(t, n, e, function(a, l, c) {
    !o && !vn(a, t.chartArea, 0) || a.inRange(e.x, e.y, r) && i.push({
      element: a,
      datasetIndex: l,
      index: c
    });
  }, !0), i;
}
function hy(t, e, n, r) {
  let o = [];
  function i(s, a, l) {
    const { startAngle: c, endAngle: u } = s.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: d } = Db(s, {
      x: e.x,
      y: e.y
    });
    Gf(d, c, u) && o.push({
      element: s,
      datasetIndex: a,
      index: l
    });
  }
  return So(t, n, e, i), o;
}
function py(t, e, n, r, o, i) {
  let s = [];
  const a = fy(n);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, f) {
    const h = u.inRange(e.x, e.y, o);
    if (r && !h)
      return;
    const p = u.getCenterPoint(o);
    if (!(!!i || t.isPointInArea(p)) && !h)
      return;
    const m = a(e, p);
    m < l ? (s = [
      {
        element: u,
        datasetIndex: d,
        index: f
      }
    ], l = m) : m === l && s.push({
      element: u,
      datasetIndex: d,
      index: f
    });
  }
  return So(t, n, e, c), s;
}
function Ds(t, e, n, r, o, i) {
  return !i && !t.isPointInArea(e) ? [] : n === "r" && !r ? hy(t, e, n, o) : py(t, e, n, r, o, i);
}
function du(t, e, n, r, o) {
  const i = [], s = n === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return So(t, n, e, (l, c, u) => {
    l[s](e[n], o) && (i.push({
      element: l,
      datasetIndex: c,
      index: u
    }), a = a || l.inRange(e.x, e.y, o));
  }), r && !a ? [] : i;
}
var gy = {
  evaluateInteractionItems: So,
  modes: {
    index(t, e, n, r) {
      const o = Kn(e, t), i = n.axis || "x", s = n.includeInvisible || !1, a = n.intersect ? Ss(t, o, i, r, s) : Ds(t, o, i, !1, r, s), l = [];
      return a.length ? (t.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = a[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(t, e, n, r) {
      const o = Kn(e, t), i = n.axis || "xy", s = n.includeInvisible || !1;
      let a = n.intersect ? Ss(t, o, i, r, s) : Ds(t, o, i, !1, r, s);
      if (a.length > 0) {
        const l = a[0].datasetIndex, c = t.getDatasetMeta(l).data;
        a = [];
        for (let u = 0; u < c.length; ++u)
          a.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return a;
    },
    point(t, e, n, r) {
      const o = Kn(e, t), i = n.axis || "xy", s = n.includeInvisible || !1;
      return Ss(t, o, i, r, s);
    },
    nearest(t, e, n, r) {
      const o = Kn(e, t), i = n.axis || "xy", s = n.includeInvisible || !1;
      return Ds(t, o, i, n.intersect, r, s);
    },
    x(t, e, n, r) {
      const o = Kn(e, t);
      return du(t, o, "x", n.intersect, r);
    },
    y(t, e, n, r) {
      const o = Kn(e, t);
      return du(t, o, "y", n.intersect, r);
    }
  }
};
const mh = [
  "left",
  "top",
  "right",
  "bottom"
];
function Gr(t, e) {
  return t.filter((n) => n.pos === e);
}
function fu(t, e) {
  return t.filter((n) => mh.indexOf(n.pos) === -1 && n.box.axis === e);
}
function Kr(t, e) {
  return t.sort((n, r) => {
    const o = e ? r : n, i = e ? n : r;
    return o.weight === i.weight ? o.index - i.index : o.weight - i.weight;
  });
}
function my(t) {
  const e = [];
  let n, r, o, i, s, a;
  for (n = 0, r = (t || []).length; n < r; ++n)
    o = t[n], { position: i, options: { stack: s, stackWeight: a = 1 } } = o, e.push({
      index: n,
      box: o,
      pos: i,
      horizontal: o.isHorizontal(),
      weight: o.weight,
      stack: s && i + s,
      stackWeight: a
    });
  return e;
}
function vy(t) {
  const e = {};
  for (const n of t) {
    const { stack: r, pos: o, stackWeight: i } = n;
    if (!r || !mh.includes(o))
      continue;
    const s = e[r] || (e[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    s.count++, s.weight += i;
  }
  return e;
}
function by(t, e) {
  const n = vy(t), { vBoxMaxWidth: r, hBoxMaxHeight: o } = e;
  let i, s, a;
  for (i = 0, s = t.length; i < s; ++i) {
    a = t[i];
    const { fullSize: l } = a.box, c = n[a.stack], u = c && a.stackWeight / c.weight;
    a.horizontal ? (a.width = u ? u * r : l && e.availableWidth, a.height = o) : (a.width = r, a.height = u ? u * o : l && e.availableHeight);
  }
  return n;
}
function yy(t) {
  const e = my(t), n = Kr(e.filter((c) => c.box.fullSize), !0), r = Kr(Gr(e, "left"), !0), o = Kr(Gr(e, "right")), i = Kr(Gr(e, "top"), !0), s = Kr(Gr(e, "bottom")), a = fu(e, "x"), l = fu(e, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(i),
    rightAndBottom: o.concat(l).concat(s).concat(a),
    chartArea: Gr(e, "chartArea"),
    vertical: r.concat(o).concat(l),
    horizontal: i.concat(s).concat(a)
  };
}
function hu(t, e, n, r) {
  return Math.max(t[n], e[n]) + Math.max(t[r], e[r]);
}
function vh(t, e) {
  t.top = Math.max(t.top, e.top), t.left = Math.max(t.left, e.left), t.bottom = Math.max(t.bottom, e.bottom), t.right = Math.max(t.right, e.right);
}
function xy(t, e, n, r) {
  const { pos: o, box: i } = n, s = t.maxPadding;
  if (!Se(o)) {
    n.size && (t[o] -= n.size);
    const d = r[n.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, n.horizontal ? i.height : i.width), n.size = d.size / d.count, t[o] += n.size;
  }
  i.getPadding && vh(s, i.getPadding());
  const a = Math.max(0, e.outerWidth - hu(s, t, "left", "right")), l = Math.max(0, e.outerHeight - hu(s, t, "top", "bottom")), c = a !== t.w, u = l !== t.h;
  return t.w = a, t.h = l, n.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function wy(t) {
  const e = t.maxPadding;
  function n(r) {
    const o = Math.max(e[r] - t[r], 0);
    return t[r] += o, o;
  }
  t.y += n("top"), t.x += n("left"), n("right"), n("bottom");
}
function _y(t, e) {
  const n = e.maxPadding;
  function r(o) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return o.forEach((s) => {
      i[s] = Math.max(e[s], n[s]);
    }), i;
  }
  return r(t ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function to(t, e, n, r) {
  const o = [];
  let i, s, a, l, c, u;
  for (i = 0, s = t.length, c = 0; i < s; ++i) {
    a = t[i], l = a.box, l.update(a.width || e.w, a.height || e.h, _y(a.horizontal, e));
    const { same: d, other: f } = xy(e, n, a, r);
    c |= d && o.length, u = u || f, l.fullSize || o.push(a);
  }
  return c && to(o, e, n, r) || u;
}
function Go(t, e, n, r, o) {
  t.top = n, t.left = e, t.right = e + r, t.bottom = n + o, t.width = r, t.height = o;
}
function pu(t, e, n, r) {
  const o = n.padding;
  let { x: i, y: s } = e;
  for (const a of t) {
    const l = a.box, c = r[a.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = a.stackWeight / c.weight || 1;
    if (a.horizontal) {
      const d = e.w * u, f = c.size || l.height;
      yo(c.start) && (s = c.start), l.fullSize ? Go(l, o.left, s, n.outerWidth - o.right - o.left, f) : Go(l, e.left + c.placed, s, d, f), c.start = s, c.placed += d, s = l.bottom;
    } else {
      const d = e.h * u, f = c.size || l.width;
      yo(c.start) && (i = c.start), l.fullSize ? Go(l, i, o.top, f, n.outerHeight - o.bottom - o.top) : Go(l, i, e.top + c.placed, f, d), c.start = i, c.placed += d, i = l.right;
    }
  }
  e.x = i, e.y = s;
}
var Tn = {
  addBox(t, e) {
    t.boxes || (t.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            e.draw(n);
          }
        }
      ];
    }, t.boxes.push(e);
  },
  removeBox(t, e) {
    const n = t.boxes ? t.boxes.indexOf(e) : -1;
    n !== -1 && t.boxes.splice(n, 1);
  },
  configure(t, e, n) {
    e.fullSize = n.fullSize, e.position = n.position, e.weight = n.weight;
  },
  update(t, e, n, r) {
    if (!t)
      return;
    const o = pt(t.options.layout.padding), i = Math.max(e - o.width, 0), s = Math.max(n - o.height, 0), a = yy(t.boxes), l = a.vertical, c = a.horizontal;
    Le(t.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const u = l.reduce((g, m) => m.box.options && m.box.options.display === !1 ? g : g + 1, 0) || 1, d = Object.freeze({
      outerWidth: e,
      outerHeight: n,
      padding: o,
      availableWidth: i,
      availableHeight: s,
      vBoxMaxWidth: i / 2 / u,
      hBoxMaxHeight: s / 2
    }), f = Object.assign({}, o);
    vh(f, pt(r));
    const h = Object.assign({
      maxPadding: f,
      w: i,
      h: s,
      x: o.left,
      y: o.top
    }, o), p = by(l.concat(c), d);
    to(a.fullSize, h, d, p), to(l, h, d, p), to(c, h, d, p) && to(l, h, d, p), wy(h), pu(a.leftAndTop, h, d, p), h.x += h.w, h.y += h.h, pu(a.rightAndBottom, h, d, p), t.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, Le(a.chartArea, (g) => {
      const m = g.box;
      Object.assign(m, t.chartArea), m.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class bh {
  acquireContext(e, n) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, n, r) {
  }
  removeEventListener(e, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, n, r, o) {
    return n = Math.max(0, n || e.width), r = r || e.height, {
      width: n,
      height: Math.max(0, o ? Math.floor(n / o) : r)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class Cy extends bh {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const pi = "$chartjs", Ey = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, gu = (t) => t === null || t === "";
function ky(t, e) {
  const n = t.style, r = t.getAttribute("height"), o = t.getAttribute("width");
  if (t[pi] = {
    initial: {
      height: r,
      width: o,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", gu(o)) {
    const i = Zc(t, "width");
    i !== void 0 && (t.width = i);
  }
  if (gu(r))
    if (t.style.height === "")
      t.height = t.width / (e || 2);
    else {
      const i = Zc(t, "height");
      i !== void 0 && (t.height = i);
    }
  return t;
}
const yh = P1 ? {
  passive: !0
} : !1;
function My(t, e, n) {
  t.addEventListener(e, n, yh);
}
function Oy(t, e, n) {
  t.canvas.removeEventListener(e, n, yh);
}
function Py(t, e) {
  const n = Ey[t.type] || t.type, { x: r, y: o } = Kn(t, e);
  return {
    type: n,
    chart: e,
    native: t,
    x: r !== void 0 ? r : null,
    y: o !== void 0 ? o : null
  };
}
function Ri(t, e) {
  for (const n of t)
    if (n === e || n.contains(e))
      return !0;
}
function Sy(t, e, n) {
  const r = t.canvas, o = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || Ri(a.addedNodes, r), s = s && !Ri(a.removedNodes, r);
    s && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
function Dy(t, e, n) {
  const r = t.canvas, o = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || Ri(a.removedNodes, r), s = s && !Ri(a.addedNodes, r);
    s && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
const _o = /* @__PURE__ */ new Map();
let mu = 0;
function xh() {
  const t = window.devicePixelRatio;
  t !== mu && (mu = t, _o.forEach((e, n) => {
    n.currentDevicePixelRatio !== t && e();
  }));
}
function Ty(t, e) {
  _o.size || window.addEventListener("resize", xh), _o.set(t, e);
}
function Iy(t) {
  _o.delete(t), _o.size || window.removeEventListener("resize", xh);
}
function $y(t, e, n) {
  const r = t.canvas, o = r && wl(r);
  if (!o)
    return;
  const i = Zf((a, l) => {
    const c = o.clientWidth;
    n(a, l), c < o.clientWidth && n();
  }, window), s = new ResizeObserver((a) => {
    const l = a[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || i(c, u);
  });
  return s.observe(o), Ty(t, i), s;
}
function Ts(t, e, n) {
  n && n.disconnect(), e === "resize" && Iy(t);
}
function Ny(t, e, n) {
  const r = t.canvas, o = Zf((i) => {
    t.ctx !== null && n(Py(i, t));
  }, t);
  return My(r, e, o), o;
}
class Ry extends bh {
  acquireContext(e, n) {
    const r = e && e.getContext && e.getContext("2d");
    return r && r.canvas === e ? (ky(e, n), r) : null;
  }
  releaseContext(e) {
    const n = e.canvas;
    if (!n[pi])
      return !1;
    const r = n[pi].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const s = r[i];
      Fe(s) ? n.removeAttribute(i) : n.setAttribute(i, s);
    });
    const o = r.style || {};
    return Object.keys(o).forEach((i) => {
      n.style[i] = o[i];
    }), n.width = n.width, delete n[pi], !0;
  }
  addEventListener(e, n, r) {
    this.removeEventListener(e, n);
    const o = e.$proxies || (e.$proxies = {}), s = {
      attach: Sy,
      detach: Dy,
      resize: $y
    }[n] || Ny;
    o[n] = s(e, n, r);
  }
  removeEventListener(e, n) {
    const r = e.$proxies || (e.$proxies = {}), o = r[n];
    if (!o)
      return;
    ({
      attach: Ts,
      detach: Ts,
      resize: Ts
    }[n] || Oy)(e, n, o), r[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, n, r, o) {
    return O1(e, n, r, o);
  }
  isAttached(e) {
    const n = wl(e);
    return !!(n && n.isConnected);
  }
}
function Ay(t) {
  return !lh() || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas ? Cy : Ry;
}
var ui;
let dr = (ui = class {
  constructor() {
    fe(this, "x");
    fe(this, "y");
    fe(this, "active", !1);
    fe(this, "options");
    fe(this, "$animations");
  }
  tooltipPosition(e) {
    const { x: n, y: r } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: n,
      y: r
    };
  }
  hasValue() {
    return xo(this.x) && xo(this.y);
  }
  getProps(e, n) {
    const r = this.$animations;
    if (!n || !r)
      return this;
    const o = {};
    return e.forEach((i) => {
      o[i] = r[i] && r[i].active() ? r[i]._to : this[i];
    }), o;
  }
}, fe(ui, "defaults", {}), fe(ui, "defaultRoutes"), ui);
function Ly(t, e) {
  const n = t.options.ticks, r = Fy(t), o = Math.min(n.maxTicksLimit || r, r), i = n.major.enabled ? Wy(e) : [], s = i.length, a = i[0], l = i[s - 1], c = [];
  if (s > o)
    return Vy(e, c, i, s / o), c;
  const u = Hy(i, e, o);
  if (s > 0) {
    let d, f;
    const h = s > 1 ? Math.round((l - a) / (s - 1)) : null;
    for (Ko(e, c, u, Fe(h) ? 0 : a - h, a), d = 0, f = s - 1; d < f; d++)
      Ko(e, c, u, i[d], i[d + 1]);
    return Ko(e, c, u, l, Fe(h) ? e.length : l + h), c;
  }
  return Ko(e, c, u), c;
}
function Fy(t) {
  const e = t.options.offset, n = t._tickSize(), r = t._length / n + (e ? 0 : 1), o = t._maxLength / n;
  return Math.floor(Math.min(r, o));
}
function Hy(t, e, n) {
  const r = By(t), o = e.length / n;
  if (!r)
    return Math.max(o, 1);
  const i = Pb(r);
  for (let s = 0, a = i.length - 1; s < a; s++) {
    const l = i[s];
    if (l > o)
      return l;
  }
  return Math.max(o, 1);
}
function Wy(t) {
  const e = [];
  let n, r;
  for (n = 0, r = t.length; n < r; n++)
    t[n].major && e.push(n);
  return e;
}
function Vy(t, e, n, r) {
  let o = 0, i = n[0], s;
  for (r = Math.ceil(r), s = 0; s < t.length; s++)
    s === i && (e.push(t[s]), o++, i = n[o * r]);
}
function Ko(t, e, n, r, o) {
  const i = we(r, 0), s = Math.min(we(o, t.length), t.length);
  let a = 0, l, c, u;
  for (n = Math.ceil(n), o && (l = o - r, n = l / Math.floor(l / n)), u = i; u < 0; )
    a++, u = Math.round(i + a * n);
  for (c = Math.max(i, 0); c < s; c++)
    c === u && (e.push(t[c]), a++, u = Math.round(i + a * n));
}
function By(t) {
  const e = t.length;
  let n, r;
  if (e < 2)
    return !1;
  for (r = t[0], n = 1; n < e; ++n)
    if (t[n] - t[n - 1] !== r)
      return !1;
  return r;
}
const jy = (t) => t === "left" ? "right" : t === "right" ? "left" : t, vu = (t, e, n) => e === "top" || e === "left" ? t[e] + n : t[e] - n, bu = (t, e) => Math.min(e || t, t);
function yu(t, e) {
  const n = [], r = t.length / e, o = t.length;
  let i = 0;
  for (; i < o; i += r)
    n.push(t[Math.floor(i)]);
  return n;
}
function zy(t, e, n) {
  const r = t.ticks.length, o = Math.min(e, r - 1), i = t._startPixel, s = t._endPixel, a = 1e-6;
  let l = t.getPixelForTick(o), c;
  if (!(n && (r === 1 ? c = Math.max(l - i, s - l) : e === 0 ? c = (t.getPixelForTick(1) - l) / 2 : c = (l - t.getPixelForTick(o - 1)) / 2, l += o < e ? c : -c, l < i - a || l > s + a)))
    return l;
}
function Yy(t, e) {
  Le(t, (n) => {
    const r = n.gc, o = r.length / 2;
    let i;
    if (o > e) {
      for (i = 0; i < o; ++i)
        delete n.data[r[i]];
      r.splice(0, o);
    }
  });
}
function qr(t) {
  return t.drawTicks ? t.tickLength : 0;
}
function xu(t, e) {
  if (!t.display)
    return 0;
  const n = at(t.font, e), r = pt(t.padding);
  return (Ge(t.text) ? t.text.length : 1) * n.lineHeight + r.height;
}
function Uy(t, e) {
  return Vn(t, {
    scale: e,
    type: "scale"
  });
}
function Gy(t, e, n) {
  return Vn(t, {
    tick: n,
    index: e,
    type: "tick"
  });
}
function Ky(t, e, n) {
  let r = Qf(t);
  return (n && e !== "right" || !n && e === "right") && (r = jy(r)), r;
}
function qy(t, e, n, r) {
  const { top: o, left: i, bottom: s, right: a, chart: l } = t, { chartArea: c, scales: u } = l;
  let d = 0, f, h, p;
  const g = s - o, m = a - i;
  if (t.isHorizontal()) {
    if (h = Ct(r, i, a), Se(n)) {
      const v = Object.keys(n)[0], b = n[v];
      p = u[v].getPixelForValue(b) + g - e;
    } else
      n === "center" ? p = (c.bottom + c.top) / 2 + g - e : p = vu(t, n, e);
    f = a - i;
  } else {
    if (Se(n)) {
      const v = Object.keys(n)[0], b = n[v];
      h = u[v].getPixelForValue(b) - m + e;
    } else
      n === "center" ? h = (c.left + c.right) / 2 - m + e : h = vu(t, n, e);
    p = Ct(r, s, o), d = n === "left" ? -yt : yt;
  }
  return {
    titleX: h,
    titleY: p,
    maxWidth: f,
    rotation: d
  };
}
class fr extends dr {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, n) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: n, _suggestedMin: r, _suggestedMax: o } = this;
    return e = Et(e, Number.POSITIVE_INFINITY), n = Et(n, Number.NEGATIVE_INFINITY), r = Et(r, Number.POSITIVE_INFINITY), o = Et(o, Number.NEGATIVE_INFINITY), {
      min: Et(e, r),
      max: Et(n, o),
      minDefined: ot(e),
      maxDefined: ot(n)
    };
  }
  getMinMax(e) {
    let { min: n, max: r, minDefined: o, maxDefined: i } = this.getUserBounds(), s;
    if (o && i)
      return {
        min: n,
        max: r
      };
    const a = this.getMatchingVisibleMetas();
    for (let l = 0, c = a.length; l < c; ++l)
      s = a[l].controller.getMinMax(this, e), o || (n = Math.min(n, s.min)), i || (r = Math.max(r, s.max));
    return n = i && n > r ? r : n, r = o && n > r ? n : r, {
      min: Et(n, Et(r, n)),
      max: Et(r, Et(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    ze(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, n, r) {
    const { beginAtZero: o, grace: i, ticks: s } = this.options, a = s.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = i1(this, i, o), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = a < this.ticks.length;
    this._convertTicksToLabels(l ? yu(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), s.display && (s.autoSkip || s.source === "auto") && (this.ticks = Ly(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, e = !e), this._startPixel = n, this._endPixel = r, this._reversePixels = e, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    ze(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    ze(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    ze(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), ze(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    ze(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const n = this.options.ticks;
    let r, o, i;
    for (r = 0, o = e.length; r < o; r++)
      i = e[r], i.label = ze(n.callback, [
        i.value,
        r,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    ze(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    ze(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, n = e.ticks, r = bu(this.ticks.length, e.ticks.maxTicksLimit), o = n.minRotation || 0, i = n.maxRotation;
    let s = o, a, l, c;
    if (!this._isVisible() || !n.display || o >= i || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = o;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, f = u.highest.height, h = Ot(this.chart.width - d, 0, this.maxWidth);
    a = e.offset ? this.maxWidth / r : h / (r - 1), d + 6 > a && (a = h / (r - (e.offset ? 0.5 : 1)), l = this.maxHeight - qr(e.grid) - n.padding - xu(e.title, this.chart.options.font), c = Math.sqrt(d * d + f * f), s = fl(Math.min(Math.asin(Ot((u.highest.height + 6) / a, -1, 1)), Math.asin(Ot(l / c, -1, 1)) - Math.asin(Ot(f / c, -1, 1)))), s = Math.max(o, Math.min(i, s))), this.labelRotation = s;
  }
  afterCalculateLabelRotation() {
    ze(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    ze(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: o, grid: i } } = this, s = this._isVisible(), a = this.isHorizontal();
    if (s) {
      const l = xu(o, n.options.font);
      if (a ? (e.width = this.maxWidth, e.height = qr(i) + l) : (e.height = this.maxHeight, e.width = qr(i) + l), r.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: f } = this._getLabelSizes(), h = r.padding * 2, p = Dn(this.labelRotation), g = Math.cos(p), m = Math.sin(p);
        if (a) {
          const v = r.mirror ? 0 : m * d.width + g * f.height;
          e.height = Math.min(this.maxHeight, e.height + v + h);
        } else {
          const v = r.mirror ? 0 : g * d.width + m * f.height;
          e.width = Math.min(this.maxWidth, e.width + v + h);
        }
        this._calculatePadding(c, u, m, g);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, n, r, o) {
    const { ticks: { align: i, padding: s }, position: a } = this.options, l = this.labelRotation !== 0, c = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, h = 0;
      l ? c ? (f = o * e.width, h = r * n.height) : (f = r * e.height, h = o * n.width) : i === "start" ? h = n.width : i === "end" ? f = e.width : i !== "inner" && (f = e.width / 2, h = n.width / 2), this.paddingLeft = Math.max((f - u + s) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - d + s) * this.width / (this.width - d), 0);
    } else {
      let u = n.height / 2, d = e.height / 2;
      i === "start" ? (u = 0, d = e.height) : i === "end" && (u = n.height, d = 0), this.paddingTop = u + s, this.paddingBottom = d + s;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    ze(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: n } = this.options;
    return n === "top" || n === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let n, r;
    for (n = 0, r = e.length; n < r; n++)
      Fe(e[n].label) && (e.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = yu(r, n)), this._labelSizes = e = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, n, r) {
    const { ctx: o, _longestTextCache: i } = this, s = [], a = [], l = Math.floor(n / bu(n, r));
    let c = 0, u = 0, d, f, h, p, g, m, v, b, y, w, x;
    for (d = 0; d < n; d += l) {
      if (p = e[d].label, g = this._resolveTickFontOptions(d), o.font = m = g.string, v = i[m] = i[m] || {
        data: {},
        gc: []
      }, b = g.lineHeight, y = w = 0, !Fe(p) && !Ge(p))
        y = $i(o, v.data, v.gc, y, p), w = b;
      else if (Ge(p))
        for (f = 0, h = p.length; f < h; ++f)
          x = p[f], !Fe(x) && !Ge(x) && (y = $i(o, v.data, v.gc, y, x), w += b);
      s.push(y), a.push(w), c = Math.max(y, c), u = Math.max(w, u);
    }
    Yy(i, n);
    const M = s.indexOf(c), E = a.indexOf(u), C = (O) => ({
      width: s[O] || 0,
      height: a[O] || 0
    });
    return {
      first: C(0),
      last: C(n - 1),
      widest: C(M),
      highest: C(E),
      widths: s,
      heights: a
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, n) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const n = this._startPixel + e * this._length;
    return Ib(this._alignToPixels ? Yn(this.chart, n, 0) : n);
  }
  getDecimalForPixel(e) {
    const n = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: n } = this;
    return e < 0 && n < 0 ? n : e > 0 && n > 0 ? e : 0;
  }
  getContext(e) {
    const n = this.ticks || [];
    if (e >= 0 && e < n.length) {
      const r = n[e];
      return r.$context || (r.$context = Gy(this.getContext(), e, r));
    }
    return this.$context || (this.$context = Uy(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, n = Dn(this.labelRotation), r = Math.abs(Math.cos(n)), o = Math.abs(Math.sin(n)), i = this._getLabelSizes(), s = e.autoSkipPadding || 0, a = i ? i.widest.width + s : 0, l = i ? i.highest.height + s : 0;
    return this.isHorizontal() ? l * r > a * o ? a / r : l / o : l * o < a * r ? l / r : a / o;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const n = this.axis, r = this.chart, o = this.options, { grid: i, position: s, border: a } = o, l = i.offset, c = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), f = qr(i), h = [], p = a.setContext(this.getContext()), g = p.display ? p.width : 0, m = g / 2, v = function(Y) {
      return Yn(r, Y, g);
    };
    let b, y, w, x, M, E, C, O, R, D, $, T;
    if (s === "top")
      b = v(this.bottom), E = this.bottom - f, O = b - m, D = v(e.top) + m, T = e.bottom;
    else if (s === "bottom")
      b = v(this.top), D = e.top, T = v(e.bottom) - m, E = b + m, O = this.top + f;
    else if (s === "left")
      b = v(this.right), M = this.right - f, C = b - m, R = v(e.left) + m, $ = e.right;
    else if (s === "right")
      b = v(this.left), R = e.left, $ = v(e.right) - m, M = b + m, C = this.left + f;
    else if (n === "x") {
      if (s === "center")
        b = v((e.top + e.bottom) / 2 + 0.5);
      else if (Se(s)) {
        const Y = Object.keys(s)[0], H = s[Y];
        b = v(this.chart.scales[Y].getPixelForValue(H));
      }
      D = e.top, T = e.bottom, E = b + m, O = E + f;
    } else if (n === "y") {
      if (s === "center")
        b = v((e.left + e.right) / 2);
      else if (Se(s)) {
        const Y = Object.keys(s)[0], H = s[Y];
        b = v(this.chart.scales[Y].getPixelForValue(H));
      }
      M = b - m, C = M - f, R = e.left, $ = e.right;
    }
    const j = we(o.ticks.maxTicksLimit, d), L = Math.max(1, Math.ceil(d / j));
    for (y = 0; y < d; y += L) {
      const Y = this.getContext(y), H = i.setContext(Y), z = a.setContext(Y), ee = H.lineWidth, I = H.color, F = z.dash || [], te = z.dashOffset, J = H.tickWidth, re = H.tickColor, B = H.tickBorderDash || [], N = H.tickBorderDashOffset;
      w = zy(this, y, l), w !== void 0 && (x = Yn(r, w, ee), c ? M = C = R = $ = x : E = O = D = T = x, h.push({
        tx1: M,
        ty1: E,
        tx2: C,
        ty2: O,
        x1: R,
        y1: D,
        x2: $,
        y2: T,
        width: ee,
        color: I,
        borderDash: F,
        borderDashOffset: te,
        tickWidth: J,
        tickColor: re,
        tickBorderDash: B,
        tickBorderDashOffset: N
      }));
    }
    return this._ticksLength = d, this._borderValue = b, h;
  }
  _computeLabelItems(e) {
    const n = this.axis, r = this.options, { position: o, ticks: i } = r, s = this.isHorizontal(), a = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = i, f = qr(r.grid), h = f + u, p = d ? -u : h, g = -Dn(this.labelRotation), m = [];
    let v, b, y, w, x, M, E, C, O, R, D, $, T = "middle";
    if (o === "top")
      M = this.bottom - p, E = this._getXAxisLabelAlignment();
    else if (o === "bottom")
      M = this.top + p, E = this._getXAxisLabelAlignment();
    else if (o === "left") {
      const L = this._getYAxisLabelAlignment(f);
      E = L.textAlign, x = L.x;
    } else if (o === "right") {
      const L = this._getYAxisLabelAlignment(f);
      E = L.textAlign, x = L.x;
    } else if (n === "x") {
      if (o === "center")
        M = (e.top + e.bottom) / 2 + h;
      else if (Se(o)) {
        const L = Object.keys(o)[0], Y = o[L];
        M = this.chart.scales[L].getPixelForValue(Y) + h;
      }
      E = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (o === "center")
        x = (e.left + e.right) / 2 - h;
      else if (Se(o)) {
        const L = Object.keys(o)[0], Y = o[L];
        x = this.chart.scales[L].getPixelForValue(Y);
      }
      E = this._getYAxisLabelAlignment(f).textAlign;
    }
    n === "y" && (l === "start" ? T = "top" : l === "end" && (T = "bottom"));
    const j = this._getLabelSizes();
    for (v = 0, b = a.length; v < b; ++v) {
      y = a[v], w = y.label;
      const L = i.setContext(this.getContext(v));
      C = this.getPixelForTick(v) + i.labelOffset, O = this._resolveTickFontOptions(v), R = O.lineHeight, D = Ge(w) ? w.length : 1;
      const Y = D / 2, H = L.color, z = L.textStrokeColor, ee = L.textStrokeWidth;
      let I = E;
      s ? (x = C, E === "inner" && (v === b - 1 ? I = this.options.reverse ? "left" : "right" : v === 0 ? I = this.options.reverse ? "right" : "left" : I = "center"), o === "top" ? c === "near" || g !== 0 ? $ = -D * R + R / 2 : c === "center" ? $ = -j.highest.height / 2 - Y * R + R : $ = -j.highest.height + R / 2 : c === "near" || g !== 0 ? $ = R / 2 : c === "center" ? $ = j.highest.height / 2 - Y * R : $ = j.highest.height - D * R, d && ($ *= -1), g !== 0 && !L.showLabelBackdrop && (x += R / 2 * Math.sin(g))) : (M = C, $ = (1 - D) * R / 2);
      let F;
      if (L.showLabelBackdrop) {
        const te = pt(L.backdropPadding), J = j.heights[v], re = j.widths[v];
        let B = $ - te.top, N = 0 - te.left;
        switch (T) {
          case "middle":
            B -= J / 2;
            break;
          case "bottom":
            B -= J;
            break;
        }
        switch (E) {
          case "center":
            N -= re / 2;
            break;
          case "right":
            N -= re;
            break;
        }
        F = {
          left: N,
          top: B,
          width: re + te.width,
          height: J + te.height,
          color: L.backdropColor
        };
      }
      m.push({
        label: w,
        font: O,
        textOffset: $,
        options: {
          rotation: g,
          color: H,
          strokeColor: z,
          strokeWidth: ee,
          textAlign: I,
          textBaseline: T,
          translation: [
            x,
            M
          ],
          backdrop: F
        }
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: n } = this.options;
    if (-Dn(this.labelRotation))
      return e === "top" ? "left" : "right";
    let o = "center";
    return n.align === "start" ? o = "left" : n.align === "end" ? o = "right" : n.align === "inner" && (o = "inner"), o;
  }
  _getYAxisLabelAlignment(e) {
    const { position: n, ticks: { crossAlign: r, mirror: o, padding: i } } = this.options, s = this._getLabelSizes(), a = e + i, l = s.widest.width;
    let c, u;
    return n === "left" ? o ? (u = this.right + i, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - a, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : n === "right" ? o ? (u = this.left + i, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + a, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: n }, left: r, top: o, width: i, height: s } = this;
    n && (e.save(), e.fillStyle = n, e.fillRect(r, o, i, s), e.restore());
  }
  getLineWidthForValue(e) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const o = this.ticks.findIndex((i) => i.value === e);
    return o >= 0 ? n.setContext(this.getContext(o)).lineWidth : 0;
  }
  drawGrid(e) {
    const n = this.options.grid, r = this.ctx, o = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let i, s;
    const a = (l, c, u) => {
      !u.width || !u.color || (r.save(), r.lineWidth = u.width, r.strokeStyle = u.color, r.setLineDash(u.borderDash || []), r.lineDashOffset = u.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(c.x, c.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (i = 0, s = o.length; i < s; ++i) {
        const l = o[i];
        n.drawOnChartArea && a({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && a({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: n, options: { border: r, grid: o } } = this, i = r.setContext(this.getContext()), s = r.display ? i.width : 0;
    if (!s)
      return;
    const a = o.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, f;
    this.isHorizontal() ? (c = Yn(e, this.left, s) - s / 2, u = Yn(e, this.right, a) + a / 2, d = f = l) : (d = Yn(e, this.top, s) - s / 2, f = Yn(e, this.bottom, a) + a / 2, c = u = l), n.save(), n.lineWidth = i.width, n.strokeStyle = i.color, n.beginPath(), n.moveTo(c, d), n.lineTo(u, f), n.stroke(), n.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, o = this._computeLabelArea();
    o && ml(r, o);
    const i = this.getLabelItems(e);
    for (const s of i) {
      const a = s.options, l = s.font, c = s.label, u = s.textOffset;
      $r(r, c, 0, u, l, a);
    }
    o && vl(r);
  }
  drawTitle() {
    const { ctx: e, options: { position: n, title: r, reverse: o } } = this;
    if (!r.display)
      return;
    const i = at(r.font), s = pt(r.padding), a = r.align;
    let l = i.lineHeight / 2;
    n === "bottom" || n === "center" || Se(n) ? (l += s.bottom, Ge(r.text) && (l += i.lineHeight * (r.text.length - 1))) : l += s.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: f } = qy(this, l, n, a);
    $r(e, r.text, 0, 0, i, {
      color: r.color,
      maxWidth: d,
      rotation: f,
      textAlign: Ky(a, n, o),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, n = e.ticks && e.ticks.z || 0, r = we(e.grid && e.grid.z, -1), o = we(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== fr.prototype.draw ? [
      {
        z: n,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: r,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: o,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", o = [];
    let i, s;
    for (i = 0, s = n.length; i < s; ++i) {
      const a = n[i];
      a[r] === this.id && (!e || a.type === e) && o.push(a);
    }
    return o;
  }
  _resolveTickFontOptions(e) {
    const n = this.options.ticks.setContext(this.getContext(e));
    return at(n.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class qo {
  constructor(e, n, r) {
    this.type = e, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const n = Object.getPrototypeOf(e);
    let r;
    Qy(n) && (r = this.register(n));
    const o = this.items, i = e.id, s = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + e);
    return i in o || (o[i] = e, Xy(e, s, r), this.override && qe.override(e.id, e.overrides)), s;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const n = this.items, r = e.id, o = this.scope;
    r in n && delete n[r], o && r in qe[o] && (delete qe[o][r], this.override && delete ir[r]);
  }
}
function Xy(t, e, n) {
  const r = bo(/* @__PURE__ */ Object.create(null), [
    n ? qe.get(n) : {},
    qe.get(e),
    t.defaults
  ]);
  qe.set(e, r), t.defaultRoutes && Zy(e, t.defaultRoutes), t.descriptors && qe.describe(e, t.descriptors);
}
function Zy(t, e) {
  Object.keys(e).forEach((n) => {
    const r = n.split("."), o = r.pop(), i = [
      t
    ].concat(r).join("."), s = e[n].split("."), a = s.pop(), l = s.join(".");
    qe.route(i, o, l, a);
  });
}
function Qy(t) {
  return "id" in t && "defaults" in t;
}
class Jy {
  constructor() {
    this.controllers = new qo(Dr, "datasets", !0), this.elements = new qo(dr, "elements"), this.plugins = new qo(Object, "plugins"), this.scales = new qo(fr, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...e) {
    this._each("register", e);
  }
  remove(...e) {
    this._each("unregister", e);
  }
  addControllers(...e) {
    this._each("register", e, this.controllers);
  }
  addElements(...e) {
    this._each("register", e, this.elements);
  }
  addPlugins(...e) {
    this._each("register", e, this.plugins);
  }
  addScales(...e) {
    this._each("register", e, this.scales);
  }
  getController(e) {
    return this._get(e, this.controllers, "controller");
  }
  getElement(e) {
    return this._get(e, this.elements, "element");
  }
  getPlugin(e) {
    return this._get(e, this.plugins, "plugin");
  }
  getScale(e) {
    return this._get(e, this.scales, "scale");
  }
  removeControllers(...e) {
    this._each("unregister", e, this.controllers);
  }
  removeElements(...e) {
    this._each("unregister", e, this.elements);
  }
  removePlugins(...e) {
    this._each("unregister", e, this.plugins);
  }
  removeScales(...e) {
    this._each("unregister", e, this.scales);
  }
  _each(e, n, r) {
    [
      ...n
    ].forEach((o) => {
      const i = r || this._getRegistryForType(o);
      r || i.isForType(o) || i === this.plugins && o.id ? this._exec(e, i, o) : Le(o, (s) => {
        const a = r || this._getRegistryForType(s);
        this._exec(e, a, s);
      });
    });
  }
  _exec(e, n, r) {
    const o = dl(e);
    ze(r["before" + o], [], r), n[e](r), ze(r["after" + o], [], r);
  }
  _getRegistryForType(e) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const r = this._typedRegistries[n];
      if (r.isForType(e))
        return r;
    }
    return this.plugins;
  }
  _get(e, n, r) {
    const o = n.get(e);
    if (o === void 0)
      throw new Error('"' + e + '" is not a registered ' + r + ".");
    return o;
  }
}
var Qt = /* @__PURE__ */ new Jy();
class ex {
  constructor() {
    this._init = [];
  }
  notify(e, n, r, o) {
    n === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install"));
    const i = o ? this._descriptors(e).filter(o) : this._descriptors(e), s = this._notify(i, e, n, r);
    return n === "afterDestroy" && (this._notify(i, e, "stop"), this._notify(this._init, e, "uninstall")), s;
  }
  _notify(e, n, r, o) {
    o = o || {};
    for (const i of e) {
      const s = i.plugin, a = s[r], l = [
        n,
        o,
        i.options
      ];
      if (ze(a, l, s) === !1 && o.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    Fe(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), n;
  }
  _createDescriptors(e, n) {
    const r = e && e.config, o = we(r.options && r.options.plugins, {}), i = tx(r);
    return o === !1 && !n ? [] : rx(e, i, o, n);
  }
  _notifyStateChanges(e) {
    const n = this._oldCache || [], r = this._cache, o = (i, s) => i.filter((a) => !s.some((l) => a.plugin.id === l.plugin.id));
    this._notify(o(n, r), e, "stop"), this._notify(o(r, n), e, "start");
  }
}
function tx(t) {
  const e = {}, n = [], r = Object.keys(Qt.plugins.items);
  for (let i = 0; i < r.length; i++)
    n.push(Qt.getPlugin(r[i]));
  const o = t.plugins || [];
  for (let i = 0; i < o.length; i++) {
    const s = o[i];
    n.indexOf(s) === -1 && (n.push(s), e[s.id] = !0);
  }
  return {
    plugins: n,
    localIds: e
  };
}
function nx(t, e) {
  return !e && t === !1 ? null : t === !0 ? {} : t;
}
function rx(t, { plugins: e, localIds: n }, r, o) {
  const i = [], s = t.getContext();
  for (const a of e) {
    const l = a.id, c = nx(r[l], o);
    c !== null && i.push({
      plugin: a,
      options: ox(t.config, {
        plugin: a,
        local: n[l]
      }, c, s)
    });
  }
  return i;
}
function ox(t, { plugin: e, local: n }, r, o) {
  const i = t.pluginScopeKeys(e), s = t.getOptionScopes(r, i);
  return n && e.defaults && s.push(e.defaults), t.createResolver(s, o, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function ma(t, e) {
  const n = qe.datasets[t] || {};
  return ((e.datasets || {})[t] || {}).indexAxis || e.indexAxis || n.indexAxis || "x";
}
function ix(t, e) {
  let n = t;
  return t === "_index_" ? n = e : t === "_value_" && (n = e === "x" ? "y" : "x"), n;
}
function sx(t, e) {
  return t === e ? "_index_" : "_value_";
}
function wu(t) {
  if (t === "x" || t === "y" || t === "r")
    return t;
}
function ax(t) {
  if (t === "top" || t === "bottom")
    return "x";
  if (t === "left" || t === "right")
    return "y";
}
function va(t, ...e) {
  if (wu(t))
    return t;
  for (const n of e) {
    const r = n.axis || ax(n.position) || t.length > 1 && wu(t[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`);
}
function _u(t, e, n) {
  if (n[e + "AxisID"] === t)
    return {
      axis: e
    };
}
function lx(t, e) {
  if (e.data && e.data.datasets) {
    const n = e.data.datasets.filter((r) => r.xAxisID === t || r.yAxisID === t);
    if (n.length)
      return _u(t, "x", n[0]) || _u(t, "y", n[0]);
  }
  return {};
}
function cx(t, e) {
  const n = ir[t.type] || {
    scales: {}
  }, r = e.scales || {}, o = ma(t.type, e), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((s) => {
    const a = r[s];
    if (!Se(a))
      return console.error(`Invalid scale configuration for scale: ${s}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${s}`);
    const l = va(s, a, lx(s, t), qe.scales[a.type]), c = sx(l, o), u = n.scales || {};
    i[s] = io(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      a,
      u[l],
      u[c]
    ]);
  }), t.data.datasets.forEach((s) => {
    const a = s.type || t.type, l = s.indexAxis || ma(a, e), u = (ir[a] || {}).scales || {};
    Object.keys(u).forEach((d) => {
      const f = ix(d, l), h = s[f + "AxisID"] || f;
      i[h] = i[h] || /* @__PURE__ */ Object.create(null), io(i[h], [
        {
          axis: f
        },
        r[h],
        u[d]
      ]);
    });
  }), Object.keys(i).forEach((s) => {
    const a = i[s];
    io(a, [
      qe.scales[a.type],
      qe.scale
    ]);
  }), i;
}
function wh(t) {
  const e = t.options || (t.options = {});
  e.plugins = we(e.plugins, {}), e.scales = cx(t, e);
}
function _h(t) {
  return t = t || {}, t.datasets = t.datasets || [], t.labels = t.labels || [], t;
}
function ux(t) {
  return t = t || {}, t.data = _h(t.data), wh(t), t;
}
const Cu = /* @__PURE__ */ new Map(), Ch = /* @__PURE__ */ new Set();
function Xo(t, e) {
  let n = Cu.get(t);
  return n || (n = e(), Cu.set(t, n), Ch.add(n)), n;
}
const Xr = (t, e, n) => {
  const r = Ir(e, n);
  r !== void 0 && t.add(r);
};
class dx {
  constructor(e) {
    this._config = ux(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = _h(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), wh(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return Xo(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, n) {
    return Xo(`${e}.transition.${n}`, () => [
      [
        `datasets.${e}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, n) {
    return Xo(`${e}-${n}`, () => [
      [
        `datasets.${e}.elements.${n}`,
        `datasets.${e}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const n = e.id, r = this.type;
    return Xo(`${r}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, n) {
    const r = this._scopeCache;
    let o = r.get(e);
    return (!o || n) && (o = /* @__PURE__ */ new Map(), r.set(e, o)), o;
  }
  getOptionScopes(e, n, r) {
    const { options: o, type: i } = this, s = this._cachedScopes(e, r), a = s.get(n);
    if (a)
      return a;
    const l = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      e && (l.add(e), u.forEach((d) => Xr(l, e, d))), u.forEach((d) => Xr(l, o, d)), u.forEach((d) => Xr(l, ir[i] || {}, d)), u.forEach((d) => Xr(l, qe, d)), u.forEach((d) => Xr(l, pa, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), Ch.has(n) && s.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: e, type: n } = this;
    return [
      e,
      ir[n] || {},
      qe.datasets[n] || {},
      {
        type: n
      },
      qe,
      pa
    ];
  }
  resolveNamedOptions(e, n, r, o = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: s, subPrefixes: a } = Eu(this._resolverCache, e, o);
    let l = s;
    if (hx(s, n)) {
      i.$shared = !1, r = Hn(r) ? r() : r;
      const c = this.createResolver(e, r, a);
      l = Nr(s, r, c);
    }
    for (const c of n)
      i[c] = l[c];
    return i;
  }
  createResolver(e, n, r = [
    ""
  ], o) {
    const { resolver: i } = Eu(this._resolverCache, e, r);
    return Se(n) ? Nr(i, n, void 0, o) : i;
  }
}
function Eu(t, e, n) {
  let r = t.get(e);
  r || (r = /* @__PURE__ */ new Map(), t.set(e, r));
  const o = n.join();
  let i = r.get(o);
  return i || (i = {
    resolver: bl(e, n),
    subPrefixes: n.filter((a) => !a.toLowerCase().includes("hover"))
  }, r.set(o, i)), i;
}
const fx = (t) => Se(t) && Object.getOwnPropertyNames(t).reduce((e, n) => e || Hn(t[n]), !1);
function hx(t, e) {
  const { isScriptable: n, isIndexable: r } = rh(t);
  for (const o of e) {
    const i = n(o), s = r(o), a = (s || i) && t[o];
    if (i && (Hn(a) || fx(a)) || s && Ge(a))
      return !0;
  }
  return !1;
}
var px = "4.3.3";
const gx = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function ku(t, e) {
  return t === "top" || t === "bottom" || gx.indexOf(t) === -1 && e === "x";
}
function Mu(t, e) {
  return function(n, r) {
    return n[t] === r[t] ? n[e] - r[e] : n[t] - r[t];
  };
}
function Ou(t) {
  const e = t.chart, n = e.options.animation;
  e.notifyPlugins("afterRender"), ze(n && n.onComplete, [
    t
  ], e);
}
function mx(t) {
  const e = t.chart, n = e.options.animation;
  ze(n && n.onProgress, [
    t
  ], e);
}
function Eh(t) {
  return lh() && typeof t == "string" ? t = document.getElementById(t) : t && t.length && (t = t[0]), t && t.canvas && (t = t.canvas), t;
}
const gi = {}, Pu = (t) => {
  const e = Eh(t);
  return Object.values(gi).filter((n) => n.canvas === e).pop();
};
function vx(t, e, n) {
  const r = Object.keys(t);
  for (const o of r) {
    const i = +o;
    if (i >= e) {
      const s = t[o];
      delete t[o], (n > 0 || i > e) && (t[i + n] = s);
    }
  }
}
function bx(t, e, n, r) {
  return !n || t.type === "mouseout" ? null : r ? e : t;
}
function yx(t) {
  const { xScale: e, yScale: n } = t;
  if (e && n)
    return {
      left: e.left,
      right: e.right,
      top: n.top,
      bottom: n.bottom
    };
}
var kn;
let Cl = (kn = class {
  static register(...e) {
    Qt.add(...e), Su();
  }
  static unregister(...e) {
    Qt.remove(...e), Su();
  }
  constructor(e, n) {
    const r = this.config = new dx(n), o = Eh(e), i = Pu(o);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const s = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || Ay(o))(), this.platform.updateConfig(r);
    const a = this.platform.acquireContext(o, s.aspectRatio), l = a && a.canvas, c = l && l.height, u = l && l.width;
    if (this.id = yb(), this.ctx = a, this.canvas = l, this.width = u, this.height = c, this._options = s, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new ex(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = Ab((d) => this.update(d), s.resizeDelay || 0), this._dataChanges = [], gi[this.id] = this, !a || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    pn.listen(this, "complete", Ou), pn.listen(this, "progress", mx), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: n }, width: r, height: o, _aspectRatio: i } = this;
    return Fe(e) ? n && i ? i : o ? r / o : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return Qt;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Xc(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Gc(this.canvas, this.ctx), this;
  }
  stop() {
    return pn.stop(this), this;
  }
  resize(e, n) {
    pn.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: n
    } : this._resize(e, n);
  }
  _resize(e, n) {
    const r = this.options, o = this.canvas, i = r.maintainAspectRatio && this.aspectRatio, s = this.platform.getMaximumSize(o, e, n, i), a = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = s.width, this.height = s.height, this._aspectRatio = this.aspectRatio, Xc(this, a, !0) && (this.notifyPlugins("resize", {
      size: s
    }), ze(r.onResize, [
      this,
      s
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    Le(n, (r, o) => {
      r.id = o;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, n = e.scales, r = this.scales, o = Object.keys(r).reduce((s, a) => (s[a] = !1, s), {});
    let i = [];
    n && (i = i.concat(Object.keys(n).map((s) => {
      const a = n[s], l = va(s, a), c = l === "r", u = l === "x";
      return {
        options: a,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), Le(i, (s) => {
      const a = s.options, l = a.id, c = va(l, a), u = we(a.type, s.dtype);
      (a.position === void 0 || ku(a.position, c) !== ku(s.dposition)) && (a.position = s.dposition), o[l] = !0;
      let d = null;
      if (l in r && r[l].type === u)
        d = r[l];
      else {
        const f = Qt.getScale(u);
        d = new f({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), r[d.id] = d;
      }
      d.init(a, e);
    }), Le(o, (s, a) => {
      s || delete r[a];
    }), Le(r, (s) => {
      Tn.configure(this, s, s.options), Tn.addBox(this, s);
    });
  }
  _updateMetasets() {
    const e = this._metasets, n = this.data.datasets.length, r = e.length;
    if (e.sort((o, i) => o.index - i.index), r > n) {
      for (let o = n; o < r; ++o)
        this._destroyDatasetMeta(o);
      e.splice(n, r - n);
    }
    this._sortedMetasets = e.slice(0).sort(Mu("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: n } } = this;
    e.length > n.length && delete this._stacks, e.forEach((r, o) => {
      n.filter((i) => i === r._dataset).length === 0 && this._destroyDatasetMeta(o);
    });
  }
  buildOrUpdateControllers() {
    const e = [], n = this.data.datasets;
    let r, o;
    for (this._removeUnreferencedMetasets(), r = 0, o = n.length; r < o; r++) {
      const i = n[r];
      let s = this.getDatasetMeta(r);
      const a = i.type || this.config.type;
      if (s.type && s.type !== a && (this._destroyDatasetMeta(r), s = this.getDatasetMeta(r)), s.type = a, s.indexAxis = i.indexAxis || ma(a, this.options), s.order = i.order || 0, s.index = r, s.label = "" + i.label, s.visible = this.isDatasetVisible(r), s.controller)
        s.controller.updateIndex(r), s.controller.linkScales();
      else {
        const l = Qt.getController(a), { datasetElementType: c, dataElementType: u } = qe.datasets[a];
        Object.assign(l, {
          dataElementType: Qt.getElement(u),
          datasetElementType: c && Qt.getElement(c)
        }), s.controller = new l(this, r), e.push(s.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    Le(this.data.datasets, (e, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), o = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let s = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), f = !o && i.indexOf(d) === -1;
      d.buildOrUpdateElements(f), s = Math.max(+d.getMaxOverflow(), s);
    }
    s = this._minPadding = r.layout.autoPadding ? s : 0, this._updateLayout(s), o || Le(i, (c) => {
      c.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(Mu("z", "_idx"));
    const { _active: a, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    Le(this.scales, (e) => {
      Tn.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(e.events);
    (!Fc(n, r) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: o, count: i } of n) {
      const s = r === "_removeElements" ? -i : i;
      vx(e, o, s);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (i) => new Set(e.filter((s) => s[0] === i).map((s, a) => a + "," + s.splice(1).join(","))), o = r(0);
    for (let i = 1; i < n; i++)
      if (!Fc(o, r(i)))
        return;
    return Array.from(o).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Tn.update(this, this.width, this.height, e);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], Le(this.boxes, (o) => {
      r && o.position === "chartArea" || (o.configure && o.configure(), this._layers.push(...o._layers()));
    }, this), this._layers.forEach((o, i) => {
      o._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, Hn(e) ? e({
          datasetIndex: n
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, n) {
    const r = this.getDatasetMeta(e), o = {
      meta: r,
      index: e,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", o) !== !1 && (r.controller._update(n), o.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", o));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (pn.has(this) ? this.attached && !pn.running(this) && pn.start(this) : (this.draw(), Ou({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: r, height: o } = this._resizeBeforeDraw;
      this._resize(r, o), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (e = 0; e < n.length && n[e].z <= 0; ++e)
      n[e].draw(this.chartArea);
    for (this._drawDatasets(); e < n.length; ++e)
      n[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const n = this._sortedMetasets, r = [];
    let o, i;
    for (o = 0, i = n.length; o < i; ++o) {
      const s = n[o];
      (!e || s.visible) && r.push(s);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let n = e.length - 1; n >= 0; --n)
      this._drawDataset(e[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const n = this.ctx, r = e._clip, o = !r.disabled, i = yx(e) || this.chartArea, s = {
      meta: e,
      index: e.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", s) !== !1 && (o && ml(n, {
      left: r.left === !1 ? 0 : i.left - r.left,
      right: r.right === !1 ? this.width : i.right + r.right,
      top: r.top === !1 ? 0 : i.top - r.top,
      bottom: r.bottom === !1 ? this.height : i.bottom + r.bottom
    }), e.controller.draw(), o && vl(n), s.cancelable = !1, this.notifyPlugins("afterDatasetDraw", s));
  }
  isPointInArea(e) {
    return vn(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, n, r, o) {
    const i = gy.modes[n];
    return typeof i == "function" ? i(this, e, r, o) : [];
  }
  getDatasetMeta(e) {
    const n = this.data.datasets[e], r = this._metasets;
    let o = r.filter((i) => i && i._dataset === n).pop();
    return o || (o = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: e,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(o)), o;
  }
  getContext() {
    return this.$context || (this.$context = Vn(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const n = this.data.datasets[e];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(e);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(e, n) {
    const r = this.getDatasetMeta(e);
    r.hidden = !n;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, n, r) {
    const o = r ? "show" : "hide", i = this.getDatasetMeta(e), s = i.controller._resolveAnimations(void 0, o);
    yo(n) ? (i.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(e, r), s.update(i, {
      visible: r
    }), this.update((a) => a.datasetIndex === e ? o : void 0));
  }
  hide(e, n) {
    this._updateVisibility(e, n, !1);
  }
  show(e, n) {
    this._updateVisibility(e, n, !0);
  }
  _destroyDatasetMeta(e) {
    const n = this._metasets[e];
    n && n.controller && n.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, n;
    for (this.stop(), pn.remove(this), e = 0, n = this.data.datasets.length; e < n; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: n } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), Gc(e, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete gi[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, n = this.platform, r = (i, s) => {
      n.addEventListener(this, i, s), e[i] = s;
    }, o = (i, s, a) => {
      i.offsetX = s, i.offsetY = a, this._eventHandler(i);
    };
    Le(this.options.events, (i) => r(i, o));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, n = this.platform, r = (l, c) => {
      n.addEventListener(this, l, c), e[l] = c;
    }, o = (l, c) => {
      e[l] && (n.removeEventListener(this, l, c), delete e[l]);
    }, i = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let s;
    const a = () => {
      o("attach", a), this.attached = !0, this.resize(), r("resize", i), r("detach", s);
    };
    s = () => {
      this.attached = !1, o("resize", i), this._stop(), this._resize(0, 0), r("attach", a);
    }, n.isAttached(this.canvas) ? a() : s();
  }
  unbindEvents() {
    Le(this._listeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._listeners = {}, Le(this._responsiveListeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, n, r) {
    const o = r ? "set" : "remove";
    let i, s, a, l;
    for (n === "dataset" && (i = this.getDatasetMeta(e[0].datasetIndex), i.controller["_" + o + "DatasetHoverStyle"]()), a = 0, l = e.length; a < l; ++a) {
      s = e[a];
      const c = s && this.getDatasetMeta(s.datasetIndex).controller;
      c && c[o + "HoverStyle"](s.element, s.datasetIndex, s.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const n = this._active || [], r = e.map(({ datasetIndex: i, index: s }) => {
      const a = this.getDatasetMeta(i);
      if (!a)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: a.data[s],
        index: s
      };
    });
    !Di(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(e, n, r) {
    return this._plugins.notify(this, e, n, r);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((n) => n.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, n, r) {
    const o = this.options.hover, i = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), s = i(n, e), a = r ? e : i(e, n);
    s.length && this.updateHoverStyle(s, o.mode, !1), a.length && o.mode && this.updateHoverStyle(a, o.mode, !0);
  }
  _eventHandler(e, n) {
    const r = {
      event: e,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, o = (s) => (s.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", r, o) === !1)
      return;
    const i = this._handleEvent(e, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, o), (i || r.changed) && this.render(), this;
  }
  _handleEvent(e, n, r) {
    const { _active: o = [], options: i } = this, s = n, a = this._getActiveElements(e, o, r, s), l = kb(e), c = bx(e, this._lastEvent, r, l);
    r && (this._lastEvent = null, ze(i.onHover, [
      e,
      a,
      this
    ], this), l && ze(i.onClick, [
      e,
      a,
      this
    ], this));
    const u = !Di(a, o);
    return (u || n) && (this._active = a, this._updateHoverStyles(a, o, n)), this._lastEvent = c, u;
  }
  _getActiveElements(e, n, r, o) {
    if (e.type === "mouseout")
      return [];
    if (!r)
      return n;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(e, i.mode, i, o);
  }
}, fe(kn, "defaults", qe), fe(kn, "instances", gi), fe(kn, "overrides", ir), fe(kn, "registry", Qt), fe(kn, "version", px), fe(kn, "getChart", Pu), kn);
function Su() {
  return Le(Cl.instances, (t) => t._plugins.invalidate());
}
function kh(t, e, n = e) {
  t.lineCap = we(n.borderCapStyle, e.borderCapStyle), t.setLineDash(we(n.borderDash, e.borderDash)), t.lineDashOffset = we(n.borderDashOffset, e.borderDashOffset), t.lineJoin = we(n.borderJoinStyle, e.borderJoinStyle), t.lineWidth = we(n.borderWidth, e.borderWidth), t.strokeStyle = we(n.borderColor, e.borderColor);
}
function xx(t, e, n) {
  t.lineTo(n.x, n.y);
}
function wx(t) {
  return t.stepped ? Xb : t.tension || t.cubicInterpolationMode === "monotone" ? Zb : xx;
}
function Mh(t, e, n = {}) {
  const r = t.length, { start: o = 0, end: i = r - 1 } = n, { start: s, end: a } = e, l = Math.max(o, s), c = Math.min(i, a), u = o < s && i < s || o > a && i > a;
  return {
    count: r,
    start: l,
    loop: e.loop,
    ilen: c < l && !u ? r + c - l : c - l
  };
}
function _x(t, e, n, r) {
  const { points: o, options: i } = e, { count: s, start: a, loop: l, ilen: c } = Mh(o, n, r), u = wx(i);
  let { move: d = !0, reverse: f } = r || {}, h, p, g;
  for (h = 0; h <= c; ++h)
    p = o[(a + (f ? c - h : h)) % s], !p.skip && (d ? (t.moveTo(p.x, p.y), d = !1) : u(t, g, p, f, i.stepped), g = p);
  return l && (p = o[(a + (f ? c : 0)) % s], u(t, g, p, f, i.stepped)), !!l;
}
function Cx(t, e, n, r) {
  const o = e.points, { count: i, start: s, ilen: a } = Mh(o, n, r), { move: l = !0, reverse: c } = r || {};
  let u = 0, d = 0, f, h, p, g, m, v;
  const b = (w) => (s + (c ? a - w : w)) % i, y = () => {
    g !== m && (t.lineTo(u, m), t.lineTo(u, g), t.lineTo(u, v));
  };
  for (l && (h = o[b(0)], t.moveTo(h.x, h.y)), f = 0; f <= a; ++f) {
    if (h = o[b(f)], h.skip)
      continue;
    const w = h.x, x = h.y, M = w | 0;
    M === p ? (x < g ? g = x : x > m && (m = x), u = (d * u + w) / ++d) : (y(), t.lineTo(w, x), p = M, d = 0, g = m = x), v = x;
  }
  y();
}
function ba(t) {
  const e = t.options, n = e.borderDash && e.borderDash.length;
  return !t._decimated && !t._loop && !e.tension && e.cubicInterpolationMode !== "monotone" && !e.stepped && !n ? Cx : _x;
}
function Ex(t) {
  return t.stepped ? S1 : t.tension || t.cubicInterpolationMode === "monotone" ? D1 : qn;
}
function kx(t, e, n, r) {
  let o = e._path;
  o || (o = e._path = new Path2D(), e.path(o, n, r) && o.closePath()), kh(t, e.options), t.stroke(o);
}
function Mx(t, e, n, r) {
  const { segments: o, options: i } = e, s = ba(e);
  for (const a of o)
    kh(t, i, a.style), t.beginPath(), s(t, e, a, {
      start: n,
      end: n + r - 1
    }) && t.closePath(), t.stroke();
}
const Ox = typeof Path2D == "function";
function Px(t, e, n, r) {
  Ox && !e.options.segment ? kx(t, e, n, r) : Mx(t, e, n, r);
}
class no extends dr {
  constructor(e) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e);
  }
  updateControlPoints(e, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const o = r.spanGaps ? this._loop : this._fullLoop;
      w1(this._points, r, e, o, n), this._pointsUpdated = !0;
    }
  }
  set points(e) {
    this._points = e, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = F1(this, this.options.segment));
  }
  first() {
    const e = this.segments, n = this.points;
    return e.length && n[e[0].start];
  }
  last() {
    const e = this.segments, n = this.points, r = e.length;
    return r && n[e[r - 1].end];
  }
  interpolate(e, n) {
    const r = this.options, o = e[n], i = this.points, s = R1(this, {
      property: n,
      start: o,
      end: o
    });
    if (!s.length)
      return;
    const a = [], l = Ex(r);
    let c, u;
    for (c = 0, u = s.length; c < u; ++c) {
      const { start: d, end: f } = s[c], h = i[d], p = i[f];
      if (h === p) {
        a.push(h);
        continue;
      }
      const g = Math.abs((o - h[n]) / (p[n] - h[n])), m = l(h, p, g, r.stepped);
      m[n] = e[n], a.push(m);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(e, n, r) {
    return ba(this)(e, this, n, r);
  }
  path(e, n, r) {
    const o = this.segments, i = ba(this);
    let s = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const a of o)
      s &= i(e, this, a, {
        start: n,
        end: n + r - 1
      });
    return !!s;
  }
  draw(e, n, r, o) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (e.save(), Px(e, this, r, o), e.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
fe(no, "id", "line"), fe(no, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), fe(no, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), fe(no, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
});
function Du(t, e, n, r) {
  const o = t.options, { [n]: i } = t.getProps([
    n
  ], r);
  return Math.abs(e - i) < o.radius + o.hitRadius;
}
class mi extends dr {
  constructor(n) {
    super();
    fe(this, "parsed");
    fe(this, "skip");
    fe(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, r, o) {
    const i = this.options, { x: s, y: a } = this.getProps([
      "x",
      "y"
    ], o);
    return Math.pow(n - s, 2) + Math.pow(r - a, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(n, r) {
    return Du(this, n, "x", r);
  }
  inYRange(n, r) {
    return Du(this, n, "y", r);
  }
  getCenterPoint(n) {
    const { x: r, y: o } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: r,
      y: o
    };
  }
  size(n) {
    n = n || this.options || {};
    let r = n.radius || 0;
    r = Math.max(r, r && n.hoverRadius || 0);
    const o = r && n.borderWidth || 0;
    return (r + o) * 2;
  }
  draw(n, r) {
    const o = this.options;
    this.skip || o.radius < 0.1 || !vn(this, r, this.size(o) / 2) || (n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.fillStyle = o.backgroundColor, ga(n, o, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
fe(mi, "id", "point"), /**
* @type {any}
*/
fe(mi, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
fe(mi, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Oh(t, e) {
  const { x: n, y: r, base: o, width: i, height: s } = t.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], e);
  let a, l, c, u, d;
  return t.horizontal ? (d = s / 2, a = Math.min(n, o), l = Math.max(n, o), c = r - d, u = r + d) : (d = i / 2, a = n - d, l = n + d, c = Math.min(r, o), u = Math.max(r, o)), {
    left: a,
    top: c,
    right: l,
    bottom: u
  };
}
function In(t, e, n, r) {
  return t ? 0 : Ot(e, n, r);
}
function Sx(t, e, n) {
  const r = t.options.borderWidth, o = t.borderSkipped, i = nh(r);
  return {
    t: In(o.top, i.top, 0, n),
    r: In(o.right, i.right, 0, e),
    b: In(o.bottom, i.bottom, 0, n),
    l: In(o.left, i.left, 0, e)
  };
}
function Dx(t, e, n) {
  const { enableBorderRadius: r } = t.getProps([
    "enableBorderRadius"
  ]), o = t.options.borderRadius, i = tr(o), s = Math.min(e, n), a = t.borderSkipped, l = r || Se(o);
  return {
    topLeft: In(!l || a.top || a.left, i.topLeft, 0, s),
    topRight: In(!l || a.top || a.right, i.topRight, 0, s),
    bottomLeft: In(!l || a.bottom || a.left, i.bottomLeft, 0, s),
    bottomRight: In(!l || a.bottom || a.right, i.bottomRight, 0, s)
  };
}
function Tx(t) {
  const e = Oh(t), n = e.right - e.left, r = e.bottom - e.top, o = Sx(t, n / 2, r / 2), i = Dx(t, n / 2, r / 2);
  return {
    outer: {
      x: e.left,
      y: e.top,
      w: n,
      h: r,
      radius: i
    },
    inner: {
      x: e.left + o.l,
      y: e.top + o.t,
      w: n - o.l - o.r,
      h: r - o.t - o.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(o.t, o.l)),
        topRight: Math.max(0, i.topRight - Math.max(o.t, o.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(o.b, o.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(o.b, o.r))
      }
    }
  };
}
function Is(t, e, n, r) {
  const o = e === null, i = n === null, a = t && !(o && i) && Oh(t, r);
  return a && (o || Qn(e, a.left, a.right)) && (i || Qn(n, a.top, a.bottom));
}
function Ix(t) {
  return t.topLeft || t.topRight || t.bottomLeft || t.bottomRight;
}
function $x(t, e) {
  t.rect(e.x, e.y, e.w, e.h);
}
function $s(t, e, n = {}) {
  const r = t.x !== n.x ? -e : 0, o = t.y !== n.y ? -e : 0, i = (t.x + t.w !== n.x + n.w ? e : 0) - r, s = (t.y + t.h !== n.y + n.h ? e : 0) - o;
  return {
    x: t.x + r,
    y: t.y + o,
    w: t.w + i,
    h: t.h + s,
    radius: t.radius
  };
}
class vi extends dr {
  constructor(e) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, e && Object.assign(this, e);
  }
  draw(e) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: o } } = this, { inner: i, outer: s } = Tx(this), a = Ix(s.radius) ? wo : $x;
    e.save(), (s.w !== i.w || s.h !== i.h) && (e.beginPath(), a(e, $s(s, n, i)), e.clip(), a(e, $s(i, -n, s)), e.fillStyle = r, e.fill("evenodd")), e.beginPath(), a(e, $s(i, n)), e.fillStyle = o, e.fill(), e.restore();
  }
  inRange(e, n, r) {
    return Is(this, e, n, r);
  }
  inXRange(e, n) {
    return Is(this, e, null, n);
  }
  inYRange(e, n) {
    return Is(this, null, e, n);
  }
  getCenterPoint(e) {
    const { x: n, y: r, base: o, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], e);
    return {
      x: i ? (n + o) / 2 : n,
      y: i ? r : (r + o) / 2
    };
  }
  getRange(e) {
    return e === "x" ? this.width / 2 : this.height / 2;
  }
}
fe(vi, "id", "bar"), fe(vi, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), fe(vi, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
const Tu = (t, e) => {
  let { boxHeight: n = e, boxWidth: r = e } = t;
  return t.usePointStyle && (n = Math.min(n, e), r = t.pointStyleWidth || Math.min(r, e)), {
    boxWidth: r,
    boxHeight: n,
    itemHeight: Math.max(e, n)
  };
}, Nx = (t, e) => t !== null && e !== null && t.datasetIndex === e.datasetIndex && t.index === e.index;
class Iu extends dr {
  constructor(e) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n, r) {
    this.maxWidth = e, this.maxHeight = n, this._margins = r, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const e = this.options.labels || {};
    let n = ze(e.generateLabels, [
      this.chart
    ], this) || [];
    e.filter && (n = n.filter((r) => e.filter(r, this.chart.data))), e.sort && (n = n.sort((r, o) => e.sort(r, o, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: e, ctx: n } = this;
    if (!e.display) {
      this.width = this.height = 0;
      return;
    }
    const r = e.labels, o = at(r.font), i = o.size, s = this._computeTitleHeight(), { boxWidth: a, itemHeight: l } = Tu(r, i);
    let c, u;
    n.font = o.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(s, i, a, l) + 10) : (u = this.maxHeight, c = this._fitCols(s, o, a, l) + 10), this.width = Math.min(c, e.maxWidth || this.maxWidth), this.height = Math.min(u, e.maxHeight || this.maxHeight);
  }
  _fitRows(e, n, r, o) {
    const { ctx: i, maxWidth: s, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], u = o + a;
    let d = e;
    i.textAlign = "left", i.textBaseline = "middle";
    let f = -1, h = -u;
    return this.legendItems.forEach((p, g) => {
      const m = r + n / 2 + i.measureText(p.text).width;
      (g === 0 || c[c.length - 1] + m + 2 * a > s) && (d += u, c[c.length - (g > 0 ? 0 : 1)] = 0, h += u, f++), l[g] = {
        left: 0,
        top: h,
        row: f,
        width: m,
        height: o
      }, c[c.length - 1] += m + a;
    }), d;
  }
  _fitCols(e, n, r, o) {
    const { ctx: i, maxHeight: s, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = s - e;
    let d = a, f = 0, h = 0, p = 0, g = 0;
    return this.legendItems.forEach((m, v) => {
      const { itemWidth: b, itemHeight: y } = Rx(r, n, i, m, o);
      v > 0 && h + y + 2 * a > u && (d += f + a, c.push({
        width: f,
        height: h
      }), p += f + a, g++, f = h = 0), l[v] = {
        left: p,
        top: h,
        col: g,
        width: b,
        height: y
      }, f = Math.max(f, b), h += y + a;
    }), d += f, c.push({
      width: f,
      height: h
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const e = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: r, labels: { padding: o }, rtl: i } } = this, s = Sr(i, this.left, this.width);
    if (this.isHorizontal()) {
      let a = 0, l = Ct(r, this.left + o, this.right - this.lineWidths[a]);
      for (const c of n)
        a !== c.row && (a = c.row, l = Ct(r, this.left + o, this.right - this.lineWidths[a])), c.top += this.top + e + o, c.left = s.leftForLtr(s.x(l), c.width), l += c.width + o;
    } else {
      let a = 0, l = Ct(r, this.top + e + o, this.bottom - this.columnSizes[a].height);
      for (const c of n)
        c.col !== a && (a = c.col, l = Ct(r, this.top + e + o, this.bottom - this.columnSizes[a].height)), c.top = l, c.left += this.left + o, c.left = s.leftForLtr(s.x(c.left), c.width), l += c.height + o;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const e = this.ctx;
      ml(e, this), this._draw(), vl(e);
    }
  }
  _draw() {
    const { options: e, columnSizes: n, lineWidths: r, ctx: o } = this, { align: i, labels: s } = e, a = qe.color, l = Sr(e.rtl, this.left, this.width), c = at(s.font), { padding: u } = s, d = c.size, f = d / 2;
    let h;
    this.drawTitle(), o.textAlign = l.textAlign("left"), o.textBaseline = "middle", o.lineWidth = 0.5, o.font = c.string;
    const { boxWidth: p, boxHeight: g, itemHeight: m } = Tu(s, d), v = function(M, E, C) {
      if (isNaN(p) || p <= 0 || isNaN(g) || g < 0)
        return;
      o.save();
      const O = we(C.lineWidth, 1);
      if (o.fillStyle = we(C.fillStyle, a), o.lineCap = we(C.lineCap, "butt"), o.lineDashOffset = we(C.lineDashOffset, 0), o.lineJoin = we(C.lineJoin, "miter"), o.lineWidth = O, o.strokeStyle = we(C.strokeStyle, a), o.setLineDash(we(C.lineDash, [])), s.usePointStyle) {
        const R = {
          radius: g * Math.SQRT2 / 2,
          pointStyle: C.pointStyle,
          rotation: C.rotation,
          borderWidth: O
        }, D = l.xPlus(M, p / 2), $ = E + f;
        eh(o, R, D, $, s.pointStyleWidth && p);
      } else {
        const R = E + Math.max((d - g) / 2, 0), D = l.leftForLtr(M, p), $ = tr(C.borderRadius);
        o.beginPath(), Object.values($).some((T) => T !== 0) ? wo(o, {
          x: D,
          y: R,
          w: p,
          h: g,
          radius: $
        }) : o.rect(D, R, p, g), o.fill(), O !== 0 && o.stroke();
      }
      o.restore();
    }, b = function(M, E, C) {
      $r(o, C.text, M, E + m / 2, c, {
        strikethrough: C.hidden,
        textAlign: l.textAlign(C.textAlign)
      });
    }, y = this.isHorizontal(), w = this._computeTitleHeight();
    y ? h = {
      x: Ct(i, this.left + u, this.right - r[0]),
      y: this.top + u + w,
      line: 0
    } : h = {
      x: this.left + u,
      y: Ct(i, this.top + w + u, this.bottom - n[0].height),
      line: 0
    }, ch(this.ctx, e.textDirection);
    const x = m + u;
    this.legendItems.forEach((M, E) => {
      o.strokeStyle = M.fontColor, o.fillStyle = M.fontColor;
      const C = o.measureText(M.text).width, O = l.textAlign(M.textAlign || (M.textAlign = s.textAlign)), R = p + f + C;
      let D = h.x, $ = h.y;
      l.setWidth(this.width), y ? E > 0 && D + R + u > this.right && ($ = h.y += x, h.line++, D = h.x = Ct(i, this.left + u, this.right - r[h.line])) : E > 0 && $ + x > this.bottom && (D = h.x = D + n[h.line].width + u, h.line++, $ = h.y = Ct(i, this.top + w + u, this.bottom - n[h.line].height));
      const T = l.x(D);
      if (v(T, $, M), D = Lb(O, D + p + f, y ? D + R : this.right, e.rtl), b(l.x(D), $, M), y)
        h.x += R + u;
      else if (typeof M.text != "string") {
        const j = c.lineHeight;
        h.y += Ph(M, j) + u;
      } else
        h.y += x;
    }), uh(this.ctx, e.textDirection);
  }
  drawTitle() {
    const e = this.options, n = e.title, r = at(n.font), o = pt(n.padding);
    if (!n.display)
      return;
    const i = Sr(e.rtl, this.left, this.width), s = this.ctx, a = n.position, l = r.size / 2, c = o.top + l;
    let u, d = this.left, f = this.width;
    if (this.isHorizontal())
      f = Math.max(...this.lineWidths), u = this.top + c, d = Ct(e.align, d, this.right - f);
    else {
      const p = this.columnSizes.reduce((g, m) => Math.max(g, m.height), 0);
      u = c + Ct(e.align, this.top, this.bottom - p - e.labels.padding - this._computeTitleHeight());
    }
    const h = Ct(a, d, d + f);
    s.textAlign = i.textAlign(Qf(a)), s.textBaseline = "middle", s.strokeStyle = n.color, s.fillStyle = n.color, s.font = r.string, $r(s, n.text, h, u, r);
  }
  _computeTitleHeight() {
    const e = this.options.title, n = at(e.font), r = pt(e.padding);
    return e.display ? n.lineHeight + r.height : 0;
  }
  _getLegendItemAt(e, n) {
    let r, o, i;
    if (Qn(e, this.left, this.right) && Qn(n, this.top, this.bottom)) {
      for (i = this.legendHitBoxes, r = 0; r < i.length; ++r)
        if (o = i[r], Qn(e, o.left, o.left + o.width) && Qn(n, o.top, o.top + o.height))
          return this.legendItems[r];
    }
    return null;
  }
  handleEvent(e) {
    const n = this.options;
    if (!Fx(e.type, n))
      return;
    const r = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const o = this._hoveredItem, i = Nx(o, r);
      o && !i && ze(n.onLeave, [
        e,
        o,
        this
      ], this), this._hoveredItem = r, r && !i && ze(n.onHover, [
        e,
        r,
        this
      ], this);
    } else
      r && ze(n.onClick, [
        e,
        r,
        this
      ], this);
  }
}
function Rx(t, e, n, r, o) {
  const i = Ax(r, t, e, n), s = Lx(o, r, e.lineHeight);
  return {
    itemWidth: i,
    itemHeight: s
  };
}
function Ax(t, e, n, r) {
  let o = t.text;
  return o && typeof o != "string" && (o = o.reduce((i, s) => i.length > s.length ? i : s)), e + n.size / 2 + r.measureText(o).width;
}
function Lx(t, e, n) {
  let r = t;
  return typeof e.text != "string" && (r = Ph(e, n)), r;
}
function Ph(t, e) {
  const n = t.text ? t.text.length : 0;
  return e * n;
}
function Fx(t, e) {
  return !!((t === "mousemove" || t === "mouseout") && (e.onHover || e.onLeave) || e.onClick && (t === "click" || t === "mouseup"));
}
var Hx = {
  id: "legend",
  _element: Iu,
  start(t, e, n) {
    const r = t.legend = new Iu({
      ctx: t.ctx,
      options: n,
      chart: t
    });
    Tn.configure(t, r, n), Tn.addBox(t, r);
  },
  stop(t) {
    Tn.removeBox(t, t.legend), delete t.legend;
  },
  beforeUpdate(t, e, n) {
    const r = t.legend;
    Tn.configure(t, r, n), r.options = n;
  },
  afterUpdate(t) {
    const e = t.legend;
    e.buildLabels(), e.adjustHitBoxes();
  },
  afterEvent(t, e) {
    e.replay || t.legend.handleEvent(e.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(t, e, n) {
      const r = e.datasetIndex, o = n.chart;
      o.isDatasetVisible(r) ? (o.hide(r), e.hidden = !0) : (o.show(r), e.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (t) => t.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(t) {
        const e = t.data.datasets, { labels: { usePointStyle: n, pointStyle: r, textAlign: o, color: i, useBorderRadius: s, borderRadius: a } } = t.legend.options;
        return t._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(n ? 0 : void 0), u = pt(c.borderWidth);
          return {
            text: e[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: i,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: r || c.pointStyle,
            rotation: c.rotation,
            textAlign: o || c.textAlign,
            borderRadius: s && (a || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (t) => t.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (t) => !t.startsWith("on"),
    labels: {
      _scriptable: (t) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(t)
    }
  }
};
const ro = {
  average(t) {
    if (!t.length)
      return !1;
    let e, n, r = 0, o = 0, i = 0;
    for (e = 0, n = t.length; e < n; ++e) {
      const s = t[e].element;
      if (s && s.hasValue()) {
        const a = s.tooltipPosition();
        r += a.x, o += a.y, ++i;
      }
    }
    return {
      x: r / i,
      y: o / i
    };
  },
  nearest(t, e) {
    if (!t.length)
      return !1;
    let n = e.x, r = e.y, o = Number.POSITIVE_INFINITY, i, s, a;
    for (i = 0, s = t.length; i < s; ++i) {
      const l = t[i].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = ha(e, c);
        u < o && (o = u, a = l);
      }
    }
    if (a) {
      const l = a.tooltipPosition();
      n = l.x, r = l.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function Zt(t, e) {
  return e && (Ge(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t;
}
function gn(t) {
  return (typeof t == "string" || t instanceof String) && t.indexOf(`
`) > -1 ? t.split(`
`) : t;
}
function Wx(t, e) {
  const { element: n, datasetIndex: r, index: o } = e, i = t.getDatasetMeta(r).controller, { label: s, value: a } = i.getLabelAndValue(o);
  return {
    chart: t,
    label: s,
    parsed: i.getParsed(o),
    raw: t.data.datasets[r].data[o],
    formattedValue: a,
    dataset: i.getDataset(),
    dataIndex: o,
    datasetIndex: r,
    element: n
  };
}
function $u(t, e) {
  const n = t.chart.ctx, { body: r, footer: o, title: i } = t, { boxWidth: s, boxHeight: a } = e, l = at(e.bodyFont), c = at(e.titleFont), u = at(e.footerFont), d = i.length, f = o.length, h = r.length, p = pt(e.padding);
  let g = p.height, m = 0, v = r.reduce((w, x) => w + x.before.length + x.lines.length + x.after.length, 0);
  if (v += t.beforeBody.length + t.afterBody.length, d && (g += d * c.lineHeight + (d - 1) * e.titleSpacing + e.titleMarginBottom), v) {
    const w = e.displayColors ? Math.max(a, l.lineHeight) : l.lineHeight;
    g += h * w + (v - h) * l.lineHeight + (v - 1) * e.bodySpacing;
  }
  f && (g += e.footerMarginTop + f * u.lineHeight + (f - 1) * e.footerSpacing);
  let b = 0;
  const y = function(w) {
    m = Math.max(m, n.measureText(w).width + b);
  };
  return n.save(), n.font = c.string, Le(t.title, y), n.font = l.string, Le(t.beforeBody.concat(t.afterBody), y), b = e.displayColors ? s + 2 + e.boxPadding : 0, Le(r, (w) => {
    Le(w.before, y), Le(w.lines, y), Le(w.after, y);
  }), b = 0, n.font = u.string, Le(t.footer, y), n.restore(), m += p.width, {
    width: m,
    height: g
  };
}
function Vx(t, e) {
  const { y: n, height: r } = e;
  return n < r / 2 ? "top" : n > t.height - r / 2 ? "bottom" : "center";
}
function Bx(t, e, n, r) {
  const { x: o, width: i } = r, s = n.caretSize + n.caretPadding;
  if (t === "left" && o + i + s > e.width || t === "right" && o - i - s < 0)
    return !0;
}
function jx(t, e, n, r) {
  const { x: o, width: i } = n, { width: s, chartArea: { left: a, right: l } } = t;
  let c = "center";
  return r === "center" ? c = o <= (a + l) / 2 ? "left" : "right" : o <= i / 2 ? c = "left" : o >= s - i / 2 && (c = "right"), Bx(c, t, e, n) && (c = "center"), c;
}
function Nu(t, e, n) {
  const r = n.yAlign || e.yAlign || Vx(t, n);
  return {
    xAlign: n.xAlign || e.xAlign || jx(t, e, n, r),
    yAlign: r
  };
}
function zx(t, e) {
  let { x: n, width: r } = t;
  return e === "right" ? n -= r : e === "center" && (n -= r / 2), n;
}
function Yx(t, e, n) {
  let { y: r, height: o } = t;
  return e === "top" ? r += n : e === "bottom" ? r -= o + n : r -= o / 2, r;
}
function Ru(t, e, n, r) {
  const { caretSize: o, caretPadding: i, cornerRadius: s } = t, { xAlign: a, yAlign: l } = n, c = o + i, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: h } = tr(s);
  let p = zx(e, a);
  const g = Yx(e, l, c);
  return l === "center" ? a === "left" ? p += c : a === "right" && (p -= c) : a === "left" ? p -= Math.max(u, f) + o : a === "right" && (p += Math.max(d, h) + o), {
    x: Ot(p, 0, r.width - e.width),
    y: Ot(g, 0, r.height - e.height)
  };
}
function Zo(t, e, n) {
  const r = pt(n.padding);
  return e === "center" ? t.x + t.width / 2 : e === "right" ? t.x + t.width - r.right : t.x + r.left;
}
function Au(t) {
  return Zt([], gn(t));
}
function Ux(t, e, n) {
  return Vn(t, {
    tooltip: e,
    tooltipItems: n,
    type: "tooltip"
  });
}
function Lu(t, e) {
  const n = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return n ? t.override(n) : t;
}
const Sh = {
  beforeTitle: fn,
  title(t) {
    if (t.length > 0) {
      const e = t[0], n = e.chart.data.labels, r = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (r > 0 && e.dataIndex < r)
        return n[e.dataIndex];
    }
    return "";
  },
  afterTitle: fn,
  beforeBody: fn,
  beforeLabel: fn,
  label(t) {
    if (this && this.options && this.options.mode === "dataset")
      return t.label + ": " + t.formattedValue || t.formattedValue;
    let e = t.dataset.label || "";
    e && (e += ": ");
    const n = t.formattedValue;
    return Fe(n) || (e += n), e;
  },
  labelColor(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: fn,
  afterBody: fn,
  beforeFooter: fn,
  footer: fn,
  afterFooter: fn
};
function gt(t, e, n, r) {
  const o = t[e].call(n, r);
  return typeof o > "u" ? Sh[e].call(n, r) : o;
}
class ya extends dr {
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const n = this.chart, r = this.options.setContext(this.getContext()), o = r.enabled && n.options.animation && r.animations, i = new fh(this.chart, o);
    return o._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = Ux(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, n) {
    const { callbacks: r } = n, o = gt(r, "beforeTitle", this, e), i = gt(r, "title", this, e), s = gt(r, "afterTitle", this, e);
    let a = [];
    return a = Zt(a, gn(o)), a = Zt(a, gn(i)), a = Zt(a, gn(s)), a;
  }
  getBeforeBody(e, n) {
    return Au(gt(n.callbacks, "beforeBody", this, e));
  }
  getBody(e, n) {
    const { callbacks: r } = n, o = [];
    return Le(e, (i) => {
      const s = {
        before: [],
        lines: [],
        after: []
      }, a = Lu(r, i);
      Zt(s.before, gn(gt(a, "beforeLabel", this, i))), Zt(s.lines, gt(a, "label", this, i)), Zt(s.after, gn(gt(a, "afterLabel", this, i))), o.push(s);
    }), o;
  }
  getAfterBody(e, n) {
    return Au(gt(n.callbacks, "afterBody", this, e));
  }
  getFooter(e, n) {
    const { callbacks: r } = n, o = gt(r, "beforeFooter", this, e), i = gt(r, "footer", this, e), s = gt(r, "afterFooter", this, e);
    let a = [];
    return a = Zt(a, gn(o)), a = Zt(a, gn(i)), a = Zt(a, gn(s)), a;
  }
  _createItems(e) {
    const n = this._active, r = this.chart.data, o = [], i = [], s = [];
    let a = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      a.push(Wx(this.chart, n[l]));
    return e.filter && (a = a.filter((u, d, f) => e.filter(u, d, f, r))), e.itemSort && (a = a.sort((u, d) => e.itemSort(u, d, r))), Le(a, (u) => {
      const d = Lu(e.callbacks, u);
      o.push(gt(d, "labelColor", this, u)), i.push(gt(d, "labelPointStyle", this, u)), s.push(gt(d, "labelTextColor", this, u));
    }), this.labelColors = o, this.labelPointStyles = i, this.labelTextColors = s, this.dataPoints = a, a;
  }
  update(e, n) {
    const r = this.options.setContext(this.getContext()), o = this._active;
    let i, s = [];
    if (!o.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const a = ro[r.position].call(this, o, this._eventPosition);
      s = this._createItems(r), this.title = this.getTitle(s, r), this.beforeBody = this.getBeforeBody(s, r), this.body = this.getBody(s, r), this.afterBody = this.getAfterBody(s, r), this.footer = this.getFooter(s, r);
      const l = this._size = $u(this, r), c = Object.assign({}, a, l), u = Nu(this.chart, r, c), d = Ru(r, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, i = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = s, this.$context = void 0, i && this._resolveAnimations().update(this, i), e && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(e, n, r, o) {
    const i = this.getCaretPosition(e, r, o);
    n.lineTo(i.x1, i.y1), n.lineTo(i.x2, i.y2), n.lineTo(i.x3, i.y3);
  }
  getCaretPosition(e, n, r) {
    const { xAlign: o, yAlign: i } = this, { caretSize: s, cornerRadius: a } = r, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = tr(a), { x: f, y: h } = e, { width: p, height: g } = n;
    let m, v, b, y, w, x;
    return i === "center" ? (w = h + g / 2, o === "left" ? (m = f, v = m - s, y = w + s, x = w - s) : (m = f + p, v = m + s, y = w - s, x = w + s), b = m) : (o === "left" ? v = f + Math.max(l, u) + s : o === "right" ? v = f + p - Math.max(c, d) - s : v = this.caretX, i === "top" ? (y = h, w = y - s, m = v - s, b = v + s) : (y = h + g, w = y + s, m = v + s, b = v - s), x = y), {
      x1: m,
      x2: v,
      x3: b,
      y1: y,
      y2: w,
      y3: x
    };
  }
  drawTitle(e, n, r) {
    const o = this.title, i = o.length;
    let s, a, l;
    if (i) {
      const c = Sr(r.rtl, this.x, this.width);
      for (e.x = Zo(this, r.titleAlign, r), n.textAlign = c.textAlign(r.titleAlign), n.textBaseline = "middle", s = at(r.titleFont), a = r.titleSpacing, n.fillStyle = r.titleColor, n.font = s.string, l = 0; l < i; ++l)
        n.fillText(o[l], c.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + a, l + 1 === i && (e.y += r.titleMarginBottom - a);
    }
  }
  _drawColorBox(e, n, r, o, i) {
    const s = this.labelColors[r], a = this.labelPointStyles[r], { boxHeight: l, boxWidth: c } = i, u = at(i.bodyFont), d = Zo(this, "left", i), f = o.x(d), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, p = n.y + h;
    if (i.usePointStyle) {
      const g = {
        radius: Math.min(c, l) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, m = o.leftForLtr(f, c) + c / 2, v = p + l / 2;
      e.strokeStyle = i.multiKeyBackground, e.fillStyle = i.multiKeyBackground, ga(e, g, m, v), e.strokeStyle = s.borderColor, e.fillStyle = s.backgroundColor, ga(e, g, m, v);
    } else {
      e.lineWidth = Se(s.borderWidth) ? Math.max(...Object.values(s.borderWidth)) : s.borderWidth || 1, e.strokeStyle = s.borderColor, e.setLineDash(s.borderDash || []), e.lineDashOffset = s.borderDashOffset || 0;
      const g = o.leftForLtr(f, c), m = o.leftForLtr(o.xPlus(f, 1), c - 2), v = tr(s.borderRadius);
      Object.values(v).some((b) => b !== 0) ? (e.beginPath(), e.fillStyle = i.multiKeyBackground, wo(e, {
        x: g,
        y: p,
        w: c,
        h: l,
        radius: v
      }), e.fill(), e.stroke(), e.fillStyle = s.backgroundColor, e.beginPath(), wo(e, {
        x: m,
        y: p + 1,
        w: c - 2,
        h: l - 2,
        radius: v
      }), e.fill()) : (e.fillStyle = i.multiKeyBackground, e.fillRect(g, p, c, l), e.strokeRect(g, p, c, l), e.fillStyle = s.backgroundColor, e.fillRect(m, p + 1, c - 2, l - 2));
    }
    e.fillStyle = this.labelTextColors[r];
  }
  drawBody(e, n, r) {
    const { body: o } = this, { bodySpacing: i, bodyAlign: s, displayColors: a, boxHeight: l, boxWidth: c, boxPadding: u } = r, d = at(r.bodyFont);
    let f = d.lineHeight, h = 0;
    const p = Sr(r.rtl, this.x, this.width), g = function(C) {
      n.fillText(C, p.x(e.x + h), e.y + f / 2), e.y += f + i;
    }, m = p.textAlign(s);
    let v, b, y, w, x, M, E;
    for (n.textAlign = s, n.textBaseline = "middle", n.font = d.string, e.x = Zo(this, m, r), n.fillStyle = r.bodyColor, Le(this.beforeBody, g), h = a && m !== "right" ? s === "center" ? c / 2 + u : c + 2 + u : 0, w = 0, M = o.length; w < M; ++w) {
      for (v = o[w], b = this.labelTextColors[w], n.fillStyle = b, Le(v.before, g), y = v.lines, a && y.length && (this._drawColorBox(n, e, w, p, r), f = Math.max(d.lineHeight, l)), x = 0, E = y.length; x < E; ++x)
        g(y[x]), f = d.lineHeight;
      Le(v.after, g);
    }
    h = 0, f = d.lineHeight, Le(this.afterBody, g), e.y -= i;
  }
  drawFooter(e, n, r) {
    const o = this.footer, i = o.length;
    let s, a;
    if (i) {
      const l = Sr(r.rtl, this.x, this.width);
      for (e.x = Zo(this, r.footerAlign, r), e.y += r.footerMarginTop, n.textAlign = l.textAlign(r.footerAlign), n.textBaseline = "middle", s = at(r.footerFont), n.fillStyle = r.footerColor, n.font = s.string, a = 0; a < i; ++a)
        n.fillText(o[a], l.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(e, n, r, o) {
    const { xAlign: i, yAlign: s } = this, { x: a, y: l } = e, { width: c, height: u } = r, { topLeft: d, topRight: f, bottomLeft: h, bottomRight: p } = tr(o.cornerRadius);
    n.fillStyle = o.backgroundColor, n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.beginPath(), n.moveTo(a + d, l), s === "top" && this.drawCaret(e, n, r, o), n.lineTo(a + c - f, l), n.quadraticCurveTo(a + c, l, a + c, l + f), s === "center" && i === "right" && this.drawCaret(e, n, r, o), n.lineTo(a + c, l + u - p), n.quadraticCurveTo(a + c, l + u, a + c - p, l + u), s === "bottom" && this.drawCaret(e, n, r, o), n.lineTo(a + h, l + u), n.quadraticCurveTo(a, l + u, a, l + u - h), s === "center" && i === "left" && this.drawCaret(e, n, r, o), n.lineTo(a, l + d), n.quadraticCurveTo(a, l, a + d, l), n.closePath(), n.fill(), o.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(e) {
    const n = this.chart, r = this.$animations, o = r && r.x, i = r && r.y;
    if (o || i) {
      const s = ro[e.position].call(this, this._active, this._eventPosition);
      if (!s)
        return;
      const a = this._size = $u(this, e), l = Object.assign({}, s, this._size), c = Nu(n, e, l), u = Ru(e, l, c, n);
      (o._to !== u.x || i._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = a.width, this.height = a.height, this.caretX = s.x, this.caretY = s.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const o = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const s = pt(n.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && a && (e.save(), e.globalAlpha = r, this.drawBackground(i, e, o, n), ch(e, n.textDirection), i.y += s.top, this.drawTitle(i, e, n), this.drawBody(i, e, n), this.drawFooter(i, e, n), uh(e, n.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, n) {
    const r = this._active, o = e.map(({ datasetIndex: a, index: l }) => {
      const c = this.chart.getDatasetMeta(a);
      if (!c)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: c.data[l],
        index: l
      };
    }), i = !Di(r, o), s = this._positionChanged(o, n);
    (i || s) && (this._active = o, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const o = this.options, i = this._active || [], s = this._getActiveElements(e, i, n, r), a = this._positionChanged(s, e), l = n || !Di(s, i) || a;
    return l && (this._active = s, (o.enabled || o.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(e, n, r, o) {
    const i = this.options;
    if (e.type === "mouseout")
      return [];
    if (!o)
      return n;
    const s = this.chart.getElementsAtEventForMode(e, i.mode, i, r);
    return i.reverse && s.reverse(), s;
  }
  _positionChanged(e, n) {
    const { caretX: r, caretY: o, options: i } = this, s = ro[i.position].call(this, e, n);
    return s !== !1 && (r !== s.x || o !== s.y);
  }
}
fe(ya, "positioners", ro);
var Gx = {
  id: "tooltip",
  _element: ya,
  positioners: ro,
  afterInit(t, e, n) {
    n && (t.tooltip = new ya({
      chart: t,
      options: n
    }));
  },
  beforeUpdate(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  reset(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  afterDraw(t) {
    const e = t.tooltip;
    if (e && e._willRender()) {
      const n = {
        tooltip: e
      };
      if (t.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      e.draw(t.ctx), t.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(t, e) {
    if (t.tooltip) {
      const n = e.replay;
      t.tooltip.handleEvent(e.event, n, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (t, e) => e.bodyFont.size,
    boxWidth: (t, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Sh
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (t) => t !== "filter" && t !== "itemSort" && t !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const Kx = (t, e, n, r) => (typeof e == "string" ? (n = t.push(e) - 1, r.unshift({
  index: n,
  label: e
})) : isNaN(e) && (n = null), n);
function qx(t, e, n, r) {
  const o = t.indexOf(e);
  if (o === -1)
    return Kx(t, e, n, r);
  const i = t.lastIndexOf(e);
  return o !== i ? n : o;
}
const Xx = (t, e) => t === null ? null : Ot(Math.round(t), 0, e);
function Fu(t) {
  const e = this.getLabels();
  return t >= 0 && t < e.length ? e[t] : t;
}
class xa extends fr {
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: o, label: i } of n)
        r[o] === i && r.splice(o, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, n) {
    if (Fe(e))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === e ? n : qx(r, e, we(n, e), this._addedLabels), Xx(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: r, max: o } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (r = 0), n || (o = this.getLabels().length - 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const e = this.min, n = this.max, r = this.options.offset, o = [];
    let i = this.getLabels();
    i = e === 0 && n === i.length - 1 ? i : i.slice(e, n + 1), this._valueRange = Math.max(i.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let s = e; s <= n; s++)
      o.push({
        value: s
      });
    return o;
  }
  getLabelForValue(e) {
    return Fu.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
fe(xa, "id", "category"), fe(xa, "defaults", {
  ticks: {
    callback: Fu
  }
});
function Zx(t, e) {
  const n = [], { bounds: o, step: i, min: s, max: a, precision: l, count: c, maxTicks: u, maxDigits: d, includeBounds: f } = t, h = i || 1, p = u - 1, { min: g, max: m } = e, v = !Fe(s), b = !Fe(a), y = !Fe(c), w = (m - g) / (d + 1);
  let x = Wc((m - g) / p / h) * h, M, E, C, O;
  if (x < 1e-14 && !v && !b)
    return [
      {
        value: g
      },
      {
        value: m
      }
    ];
  O = Math.ceil(m / x) - Math.floor(g / x), O > p && (x = Wc(O * x / p / h) * h), Fe(l) || (M = Math.pow(10, l), x = Math.ceil(x * M) / M), o === "ticks" ? (E = Math.floor(g / x) * x, C = Math.ceil(m / x) * x) : (E = g, C = m), v && b && i && Sb((a - s) / i, x / 1e3) ? (O = Math.round(Math.min((a - s) / x, u)), x = (a - s) / O, E = s, C = a) : y ? (E = v ? s : E, C = b ? a : C, O = c - 1, x = (C - E) / O) : (O = (C - E) / x, so(O, Math.round(O), x / 1e3) ? O = Math.round(O) : O = Math.ceil(O));
  const R = Math.max(Vc(x), Vc(E));
  M = Math.pow(10, Fe(l) ? R : l), E = Math.round(E * M) / M, C = Math.round(C * M) / M;
  let D = 0;
  for (v && (f && E !== s ? (n.push({
    value: s
  }), E < s && D++, so(Math.round((E + D * x) * M) / M, s, Hu(s, w, t)) && D++) : E < s && D++); D < O; ++D) {
    const $ = Math.round((E + D * x) * M) / M;
    if (b && $ > a)
      break;
    n.push({
      value: $
    });
  }
  return b && f && C !== a ? n.length && so(n[n.length - 1].value, a, Hu(a, w, t)) ? n[n.length - 1].value = a : n.push({
    value: a
  }) : (!b || C === a) && n.push({
    value: C
  }), n;
}
function Hu(t, e, { horizontal: n, minRotation: r }) {
  const o = Dn(r), i = (n ? Math.sin(o) : Math.cos(o)) || 1e-3, s = 0.75 * e * ("" + t).length;
  return Math.min(e / i, s);
}
class Ai extends fr {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    return Fe(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: o, max: i } = this;
    const s = (l) => o = n ? o : l, a = (l) => i = r ? i : l;
    if (e) {
      const l = rn(o), c = rn(i);
      l < 0 && c < 0 ? a(0) : l > 0 && c > 0 && s(0);
    }
    if (o === i) {
      let l = i === 0 ? 1 : Math.abs(i * 0.05);
      a(i + l), e || s(o - l);
    }
    this.min = o, this.max = i;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = e, o;
    return r ? (o = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, o > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${o} ticks. Limiting to 1000.`), o = 1e3)) : (o = this.computeTickLimit(), n = n || 11), n && (o = Math.min(n, o)), o;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, n = e.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const o = {
      maxTicks: r,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, i = this._range || this, s = Zx(o, i);
    return e.bounds === "ticks" && Uf(s, this, "value"), e.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  configure() {
    const e = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const o = (r - n) / Math.max(e.length - 1, 1) / 2;
      n -= o, r += o;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(e) {
    return gl(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class wa extends Ai {
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = ot(e) ? e : 0, this.max = ot(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), n = e ? this.width : this.height, r = Dn(this.options.ticks.minRotation), o = (e ? Math.sin(r) : Math.cos(r)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, i.lineHeight / o));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
fe(wa, "id", "linear"), fe(wa, "defaults", {
  ticks: {
    callback: ns.formatters.numeric
  }
});
const Co = (t) => Math.floor(Sn(t)), Gn = (t, e) => Math.pow(10, Co(t) + e);
function Wu(t) {
  return t / Math.pow(10, Co(t)) === 1;
}
function Vu(t, e, n) {
  const r = Math.pow(10, n), o = Math.floor(t / r);
  return Math.ceil(e / r) - o;
}
function Qx(t, e) {
  const n = e - t;
  let r = Co(n);
  for (; Vu(t, e, r) > 10; )
    r++;
  for (; Vu(t, e, r) < 10; )
    r--;
  return Math.min(r, Co(t));
}
function Jx(t, { min: e, max: n }) {
  e = Et(t.min, e);
  const r = [], o = Co(e);
  let i = Qx(e, n), s = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
  const a = Math.pow(10, i), l = o > i ? Math.pow(10, o) : 0, c = Math.round((e - l) * s) / s, u = Math.floor((e - l) / a / 10) * a * 10;
  let d = Math.floor((c - u) / Math.pow(10, i)), f = Et(t.min, Math.round((l + u + d * Math.pow(10, i)) * s) / s);
  for (; f < n; )
    r.push({
      value: f,
      major: Wu(f),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (i++, d = 2, s = i >= 0 ? 1 : s), f = Math.round((l + u + d * Math.pow(10, i)) * s) / s;
  const h = Et(t.max, f);
  return r.push({
    value: h,
    major: Wu(h),
    significand: d
  }), r;
}
class Bu extends fr {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    const r = Ai.prototype.parse.apply(this, [
      e,
      n
    ]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return ot(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = ot(e) ? Math.max(0, e) : null, this.max = ot(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !ot(this._userMin) && (this.min = e === Gn(this.min, 0) ? Gn(this.min, -1) : Gn(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let r = this.min, o = this.max;
    const i = (a) => r = e ? r : a, s = (a) => o = n ? o : a;
    r === o && (r <= 0 ? (i(1), s(10)) : (i(Gn(r, -1)), s(Gn(o, 1)))), r <= 0 && i(Gn(o, -1)), o <= 0 && s(Gn(r, 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const e = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, r = Jx(n, this);
    return e.bounds === "ticks" && Uf(r, this, "value"), e.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(e) {
    return e === void 0 ? "0" : gl(e, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const e = this.min;
    super.configure(), this._startValue = Sn(e), this._valueRange = Sn(this.max) - Sn(e);
  }
  getPixelForValue(e) {
    return (e === void 0 || e === 0) && (e = this.min), e === null || isNaN(e) ? NaN : this.getPixelForDecimal(e === this.min ? 0 : (Sn(e) - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    const n = this.getDecimalForPixel(e);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
fe(Bu, "id", "logarithmic"), fe(Bu, "defaults", {
  ticks: {
    callback: ns.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function _a(t) {
  const e = t.ticks;
  if (e.display && t.display) {
    const n = pt(e.backdropPadding);
    return we(e.font && e.font.size, qe.font.size) + n.height;
  }
  return 0;
}
function ew(t, e, n) {
  return n = Ge(n) ? n : [
    n
  ], {
    w: qb(t, e.string, n),
    h: n.length * e.lineHeight
  };
}
function ju(t, e, n, r, o) {
  return t === r || t === o ? {
    start: e - n / 2,
    end: e + n / 2
  } : t < r || t > o ? {
    start: e - n,
    end: e
  } : {
    start: e,
    end: e + n
  };
}
function tw(t) {
  const e = {
    l: t.left + t._padding.left,
    r: t.right - t._padding.right,
    t: t.top + t._padding.top,
    b: t.bottom - t._padding.bottom
  }, n = Object.assign({}, e), r = [], o = [], i = t._pointLabels.length, s = t.options.pointLabels, a = s.centerPointLabels ? lt / i : 0;
  for (let l = 0; l < i; l++) {
    const c = s.setContext(t.getPointLabelContext(l));
    o[l] = c.padding;
    const u = t.getPointPosition(l, t.drawingArea + o[l], a), d = at(c.font), f = ew(t.ctx, d, t._pointLabels[l]);
    r[l] = f;
    const h = jt(t.getIndexAngle(l) + a), p = Math.round(fl(h)), g = ju(p, u.x, f.w, 0, 180), m = ju(p, u.y, f.h, 90, 270);
    nw(n, e, h, g, m);
  }
  t.setCenterPoint(e.l - n.l, n.r - e.r, e.t - n.t, n.b - e.b), t._pointLabelItems = iw(t, r, o);
}
function nw(t, e, n, r, o) {
  const i = Math.abs(Math.sin(n)), s = Math.abs(Math.cos(n));
  let a = 0, l = 0;
  r.start < e.l ? (a = (e.l - r.start) / i, t.l = Math.min(t.l, e.l - a)) : r.end > e.r && (a = (r.end - e.r) / i, t.r = Math.max(t.r, e.r + a)), o.start < e.t ? (l = (e.t - o.start) / s, t.t = Math.min(t.t, e.t - l)) : o.end > e.b && (l = (o.end - e.b) / s, t.b = Math.max(t.b, e.b + l));
}
function rw(t, e, n) {
  const r = t.drawingArea, { extra: o, additionalAngle: i, padding: s, size: a } = n, l = t.getPointPosition(e, r + o + s, i), c = Math.round(fl(jt(l.angle + yt))), u = lw(l.y, a.h, c), d = sw(c), f = aw(l.x, a.w, d);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: d,
    left: f,
    top: u,
    right: f + a.w,
    bottom: u + a.h
  };
}
function ow(t, e) {
  if (!e)
    return !0;
  const { left: n, top: r, right: o, bottom: i } = t;
  return !(vn({
    x: n,
    y: r
  }, e) || vn({
    x: n,
    y: i
  }, e) || vn({
    x: o,
    y: r
  }, e) || vn({
    x: o,
    y: i
  }, e));
}
function iw(t, e, n) {
  const r = [], o = t._pointLabels.length, i = t.options, { centerPointLabels: s, display: a } = i.pointLabels, l = {
    extra: _a(i) / 2,
    additionalAngle: s ? lt / o : 0
  };
  let c;
  for (let u = 0; u < o; u++) {
    l.padding = n[u], l.size = e[u];
    const d = rw(t, u, l);
    r.push(d), a === "auto" && (d.visible = ow(d, c), d.visible && (c = d));
  }
  return r;
}
function sw(t) {
  return t === 0 || t === 180 ? "center" : t < 180 ? "left" : "right";
}
function aw(t, e, n) {
  return n === "right" ? t -= e : n === "center" && (t -= e / 2), t;
}
function lw(t, e, n) {
  return n === 90 || n === 270 ? t -= e / 2 : (n > 270 || n < 90) && (t -= e), t;
}
function cw(t, e, n) {
  const { left: r, top: o, right: i, bottom: s } = n, { backdropColor: a } = e;
  if (!Fe(a)) {
    const l = tr(e.borderRadius), c = pt(e.backdropPadding);
    t.fillStyle = a;
    const u = r - c.left, d = o - c.top, f = i - r + c.width, h = s - o + c.height;
    Object.values(l).some((p) => p !== 0) ? (t.beginPath(), wo(t, {
      x: u,
      y: d,
      w: f,
      h,
      radius: l
    }), t.fill()) : t.fillRect(u, d, f, h);
  }
}
function uw(t, e) {
  const { ctx: n, options: { pointLabels: r } } = t;
  for (let o = e - 1; o >= 0; o--) {
    const i = t._pointLabelItems[o];
    if (!i.visible)
      continue;
    const s = r.setContext(t.getPointLabelContext(o));
    cw(n, s, i);
    const a = at(s.font), { x: l, y: c, textAlign: u } = i;
    $r(n, t._pointLabels[o], l, c + a.lineHeight / 2, a, {
      color: s.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function Dh(t, e, n, r) {
  const { ctx: o } = t;
  if (n)
    o.arc(t.xCenter, t.yCenter, e, 0, Rt);
  else {
    let i = t.getPointPosition(0, e);
    o.moveTo(i.x, i.y);
    for (let s = 1; s < r; s++)
      i = t.getPointPosition(s, e), o.lineTo(i.x, i.y);
  }
}
function dw(t, e, n, r, o) {
  const i = t.ctx, s = e.circular, { color: a, lineWidth: l } = e;
  !s && !r || !a || !l || n < 0 || (i.save(), i.strokeStyle = a, i.lineWidth = l, i.setLineDash(o.dash), i.lineDashOffset = o.dashOffset, i.beginPath(), Dh(t, n, s, r), i.closePath(), i.stroke(), i.restore());
}
function fw(t, e, n) {
  return Vn(t, {
    label: n,
    index: e,
    type: "pointLabel"
  });
}
class Qo extends Ai {
  constructor(e) {
    super(e), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const e = this._padding = pt(_a(this.options) / 2), n = this.width = this.maxWidth - e.width, r = this.height = this.maxHeight - e.height;
    this.xCenter = Math.floor(this.left + n / 2 + e.left), this.yCenter = Math.floor(this.top + r / 2 + e.top), this.drawingArea = Math.floor(Math.min(n, r) / 2);
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!1);
    this.min = ot(e) && !isNaN(e) ? e : 0, this.max = ot(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / _a(this.options));
  }
  generateTickLabels(e) {
    Ai.prototype.generateTickLabels.call(this, e), this._pointLabels = this.getLabels().map((n, r) => {
      const o = ze(this.options.pointLabels.callback, [
        n,
        r
      ], this);
      return o || o === 0 ? o : "";
    }).filter((n, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const e = this.options;
    e.display && e.pointLabels.display ? tw(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(e, n, r, o) {
    this.xCenter += Math.floor((e - n) / 2), this.yCenter += Math.floor((r - o) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(e, n, r, o));
  }
  getIndexAngle(e) {
    const n = Rt / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return jt(e * n + Dn(r));
  }
  getDistanceFromCenterForValue(e) {
    if (Fe(e))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - e) * n : (e - this.min) * n;
  }
  getValueForDistanceFromCenter(e) {
    if (Fe(e))
      return NaN;
    const n = e / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(e) {
    const n = this._pointLabels || [];
    if (e >= 0 && e < n.length) {
      const r = n[e];
      return fw(this.getContext(), e, r);
    }
  }
  getPointPosition(e, n, r = 0) {
    const o = this.getIndexAngle(e) - yt + r;
    return {
      x: Math.cos(o) * n + this.xCenter,
      y: Math.sin(o) * n + this.yCenter,
      angle: o
    };
  }
  getPointPositionForValue(e, n) {
    return this.getPointPosition(e, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(e) {
    return this.getPointPositionForValue(e || 0, this.getBaseValue());
  }
  getPointLabelPosition(e) {
    const { left: n, top: r, right: o, bottom: i } = this._pointLabelItems[e];
    return {
      left: n,
      top: r,
      right: o,
      bottom: i
    };
  }
  drawBackground() {
    const { backgroundColor: e, grid: { circular: n } } = this.options;
    if (e) {
      const r = this.ctx;
      r.save(), r.beginPath(), Dh(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), r.closePath(), r.fillStyle = e, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const e = this.ctx, n = this.options, { angleLines: r, grid: o, border: i } = n, s = this._pointLabels.length;
    let a, l, c;
    if (n.pointLabels.display && uw(this, s), o.display && this.ticks.forEach((u, d) => {
      if (d !== 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const f = this.getContext(d), h = o.setContext(f), p = i.setContext(f);
        dw(this, h, l, s, p);
      }
    }), r.display) {
      for (e.save(), a = s - 1; a >= 0; a--) {
        const u = r.setContext(this.getPointLabelContext(a)), { color: d, lineWidth: f } = u;
        !f || !d || (e.lineWidth = f, e.strokeStyle = d, e.setLineDash(u.borderDash), e.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), c = this.getPointPosition(a, l), e.beginPath(), e.moveTo(this.xCenter, this.yCenter), e.lineTo(c.x, c.y), e.stroke());
      }
      e.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const e = this.ctx, n = this.options, r = n.ticks;
    if (!r.display)
      return;
    const o = this.getIndexAngle(0);
    let i, s;
    e.save(), e.translate(this.xCenter, this.yCenter), e.rotate(o), e.textAlign = "center", e.textBaseline = "middle", this.ticks.forEach((a, l) => {
      if (l === 0 && !n.reverse)
        return;
      const c = r.setContext(this.getContext(l)), u = at(c.font);
      if (i = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        e.font = u.string, s = e.measureText(a.label).width, e.fillStyle = c.backdropColor;
        const d = pt(c.backdropPadding);
        e.fillRect(-s / 2 - d.left, -i - u.size / 2 - d.top, s + d.width, u.size + d.height);
      }
      $r(e, a.label, 0, -i, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), e.restore();
  }
  drawTitle() {
  }
}
fe(Qo, "id", "radialLinear"), fe(Qo, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: ns.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), fe(Qo, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), fe(Qo, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const os = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, mt = /* @__PURE__ */ Object.keys(os);
function zu(t, e) {
  return t - e;
}
function Yu(t, e) {
  if (Fe(e))
    return null;
  const n = t._adapter, { parser: r, round: o, isoWeekday: i } = t._parseOpts;
  let s = e;
  return typeof r == "function" && (s = r(s)), ot(s) || (s = typeof r == "string" ? n.parse(s, r) : n.parse(s)), s === null ? null : (o && (s = o === "week" && (xo(i) || i === !0) ? n.startOf(s, "isoWeek", i) : n.startOf(s, o)), +s);
}
function Uu(t, e, n, r) {
  const o = mt.length;
  for (let i = mt.indexOf(t); i < o - 1; ++i) {
    const s = os[mt[i]], a = s.steps ? s.steps : Number.MAX_SAFE_INTEGER;
    if (s.common && Math.ceil((n - e) / (a * s.size)) <= r)
      return mt[i];
  }
  return mt[o - 1];
}
function hw(t, e, n, r, o) {
  for (let i = mt.length - 1; i >= mt.indexOf(n); i--) {
    const s = mt[i];
    if (os[s].common && t._adapter.diff(o, r, s) >= e - 1)
      return s;
  }
  return mt[n ? mt.indexOf(n) : 0];
}
function pw(t) {
  for (let e = mt.indexOf(t) + 1, n = mt.length; e < n; ++e)
    if (os[mt[e]].common)
      return mt[e];
}
function Gu(t, e, n) {
  if (!n)
    t[e] = !0;
  else if (n.length) {
    const { lo: r, hi: o } = hl(n, e), i = n[r] >= e ? n[r] : n[o];
    t[i] = !0;
  }
}
function gw(t, e, n, r) {
  const o = t._adapter, i = +o.startOf(e[0].value, r), s = e[e.length - 1].value;
  let a, l;
  for (a = i; a <= s; a = +o.add(a, 1, r))
    l = n[a], l >= 0 && (e[l].major = !0);
  return e;
}
function Ku(t, e, n) {
  const r = [], o = {}, i = e.length;
  let s, a;
  for (s = 0; s < i; ++s)
    a = e[s], o[a] = s, r.push({
      value: a,
      major: !1
    });
  return i === 0 || !n ? r : gw(t, r, o, n);
}
class Eo extends fr {
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, n = {}) {
    const r = e.time || (e.time = {}), o = this._adapter = new gh._date(e.adapters.date);
    o.init(n), io(r.displayFormats, o.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(e), this._normalized = n.normalized;
  }
  parse(e, n) {
    return e === void 0 ? null : Yu(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, n = this._adapter, r = e.time.unit || "day";
    let { min: o, max: i, minDefined: s, maxDefined: a } = this.getUserBounds();
    function l(c) {
      !s && !isNaN(c.min) && (o = Math.min(o, c.min)), !a && !isNaN(c.max) && (i = Math.max(i, c.max));
    }
    (!s || !a) && (l(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && l(this.getMinMax(!1))), o = ot(o) && !isNaN(o) ? o : +n.startOf(Date.now(), r), i = ot(i) && !isNaN(i) ? i : +n.endOf(Date.now(), r) + 1, this.min = Math.min(o, i - 1), this.max = Math.max(o + 1, i);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return e.length && (n = e[0], r = e[e.length - 1]), {
      min: n,
      max: r
    };
  }
  buildTicks() {
    const e = this.options, n = e.time, r = e.ticks, o = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && o.length && (this.min = this._userMin || o[0], this.max = this._userMax || o[o.length - 1]);
    const i = this.min, s = this.max, a = Nb(o, i, s);
    return this._unit = n.unit || (r.autoSkip ? Uu(n.minUnit, this.min, this.max, this._getLabelCapacity(i)) : hw(this, a.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : pw(this._unit), this.initOffsets(o), e.reverse && a.reverse(), Ku(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let n = 0, r = 0, o, i;
    this.options.offset && e.length && (o = this.getDecimalForValue(e[0]), e.length === 1 ? n = 1 - o : n = (this.getDecimalForValue(e[1]) - o) / 2, i = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? r = i : r = (i - this.getDecimalForValue(e[e.length - 2])) / 2);
    const s = e.length < 3 ? 0.5 : 0.25;
    n = Ot(n, 0, s), r = Ot(r, 0, s), this._offsets = {
      start: n,
      end: r,
      factor: 1 / (n + 1 + r)
    };
  }
  _generate() {
    const e = this._adapter, n = this.min, r = this.max, o = this.options, i = o.time, s = i.unit || Uu(i.minUnit, n, r, this._getLabelCapacity(n)), a = we(o.ticks.stepSize, 1), l = s === "week" ? i.isoWeekday : !1, c = xo(l) || l === !0, u = {};
    let d = n, f, h;
    if (c && (d = +e.startOf(d, "isoWeek", l)), d = +e.startOf(d, c ? "day" : s), e.diff(r, n, s) > 1e5 * a)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + a + " " + s);
    const p = o.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, h = 0; f < r; f = +e.add(f, a, s), h++)
      Gu(u, f, p);
    return (f === r || o.bounds === "ticks" || h === 1) && Gu(u, f, p), Object.keys(u).sort(zu).map((g) => +g);
  }
  getLabelForValue(e) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(e, r.tooltipFormat) : n.format(e, r.displayFormats.datetime);
  }
  format(e, n) {
    const o = this.options.time.displayFormats, i = this._unit, s = n || o[i];
    return this._adapter.format(e, s);
  }
  _tickFormatFunction(e, n, r, o) {
    const i = this.options, s = i.ticks.callback;
    if (s)
      return ze(s, [
        e,
        n,
        r
      ], this);
    const a = i.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && a[l], d = c && a[c], f = r[n], h = c && d && f && f.major;
    return this._adapter.format(e, o || (h ? d : u));
  }
  generateTickLabels(e) {
    let n, r, o;
    for (n = 0, r = e.length; n < r; ++n)
      o = e[n], o.label = this._tickFormatFunction(o.value, n, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const n = this._offsets, r = this.getDecimalForValue(e);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(e) {
    const n = this._offsets, r = this.getDecimalForPixel(e) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(e) {
    const n = this.options.ticks, r = this.ctx.measureText(e).width, o = Dn(this.isHorizontal() ? n.maxRotation : n.minRotation), i = Math.cos(o), s = Math.sin(o), a = this._resolveTickFontOptions(0).size;
    return {
      w: r * i + a * s,
      h: r * s + a * i
    };
  }
  _getLabelCapacity(e) {
    const n = this.options.time, r = n.displayFormats, o = r[n.unit] || r.millisecond, i = this._tickFormatFunction(e, 0, Ku(this, [
      e
    ], this._majorUnit), o), s = this._getLabelSize(i), a = Math.floor(this.isHorizontal() ? this.width / s.w : this.height / s.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], n, r;
    if (e.length)
      return e;
    const o = this.getMatchingVisibleMetas();
    if (this._normalized && o.length)
      return this._cache.data = o[0].controller.getAllParsedValues(this);
    for (n = 0, r = o.length; n < r; ++n)
      e = e.concat(o[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let n, r;
    if (e.length)
      return e;
    const o = this.getLabels();
    for (n = 0, r = o.length; n < r; ++n)
      e.push(Yu(this, o[n]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return qf(e.sort(zu));
  }
}
fe(Eo, "id", "time"), fe(Eo, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Jo(t, e, n) {
  let r = 0, o = t.length - 1, i, s, a, l;
  n ? (e >= t[r].pos && e <= t[o].pos && ({ lo: r, hi: o } = Jn(t, "pos", e)), { pos: i, time: a } = t[r], { pos: s, time: l } = t[o]) : (e >= t[r].time && e <= t[o].time && ({ lo: r, hi: o } = Jn(t, "time", e)), { time: i, pos: a } = t[r], { time: s, pos: l } = t[o]);
  const c = s - i;
  return c ? a + (l - a) * (e - i) / c : a;
}
class qu extends Eo {
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(e);
    this._minPos = Jo(n, this.min), this._tableRange = Jo(n, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: n, max: r } = this, o = [], i = [];
    let s, a, l, c, u;
    for (s = 0, a = e.length; s < a; ++s)
      c = e[s], c >= n && c <= r && o.push(c);
    if (o.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (s = 0, a = o.length; s < a; ++s)
      u = o[s + 1], l = o[s - 1], c = o[s], Math.round((u + l) / 2) !== c && i.push({
        time: c,
        pos: s / (a - 1)
      });
    return i;
  }
  _generate() {
    const e = this.min, n = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(e) || !r.length) && r.splice(0, 0, e), (!r.includes(n) || r.length === 1) && r.push(n), r.sort((o, i) => o - i);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? e = this.normalize(n.concat(r)) : e = n.length ? n : r, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (Jo(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const n = this._offsets, r = this.getDecimalForPixel(e) / n.factor - n.end;
    return Jo(this._table, r * this._tableRange + this._minPos, !0);
  }
}
fe(qu, "id", "timeseries"), fe(qu, "defaults", Eo.defaults);
const Th = "label";
function Xu(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function mw(t, e) {
  const n = t.options;
  n && e && Object.assign(n, e);
}
function Ih(t, e) {
  t.labels = e;
}
function $h(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Th;
  const r = [];
  t.datasets = e.map((o) => {
    const i = t.datasets.find((s) => s[n] === o[n]);
    return !i || !o.data || r.includes(i) ? {
      ...o
    } : (r.push(i), Object.assign(i, o), i);
  });
}
function vw(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Th;
  const n = {
    labels: [],
    datasets: []
  };
  return Ih(n, t.labels), $h(n, t.datasets, e), n;
}
function bw(t, e) {
  const { height: n = 150, width: r = 300, redraw: o = !1, datasetIdKey: i, type: s, data: a, options: l, plugins: c = [], fallbackContent: u, updateMode: d, ...f } = t, h = le(null), p = le(), g = () => {
    h.current && (p.current = new Cl(h.current, {
      type: s,
      data: vw(a, i),
      options: l && {
        ...l
      },
      plugins: c
    }), Xu(e, p.current));
  }, m = () => {
    Xu(e, null), p.current && (p.current.destroy(), p.current = null);
  };
  return ue(() => {
    !o && p.current && l && mw(p.current, l);
  }, [
    o,
    l
  ]), ue(() => {
    !o && p.current && Ih(p.current.config.data, a.labels);
  }, [
    o,
    a.labels
  ]), ue(() => {
    !o && p.current && a.datasets && $h(p.current.config.data, a.datasets, i);
  }, [
    o,
    a.datasets
  ]), ue(() => {
    p.current && (o ? (m(), setTimeout(g)) : p.current.update(d));
  }, [
    o,
    l,
    a.labels,
    a.datasets,
    d
  ]), ue(() => {
    p.current && (m(), setTimeout(g));
  }, [
    s
  ]), ue(() => (g(), () => m()), []), /* @__PURE__ */ P.createElement("canvas", Object.assign({
    ref: h,
    role: "img",
    height: n,
    width: r
  }, f), u);
}
const yw = /* @__PURE__ */ de(bw);
function Yt(t) {
  "@babel/helpers - typeof";
  return Yt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yt(t);
}
function Ne(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function Q(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function ae(t) {
  Q(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || Yt(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Mt(t, e) {
  Q(2, arguments);
  var n = ae(t), r = Ne(e);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Ft(t, e) {
  Q(2, arguments);
  var n = ae(t), r = Ne(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var s = i.getDate();
  return o >= s ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), o), n);
}
function Do(t, e) {
  Q(2, arguments);
  var n = ae(t).getTime(), r = Ne(e);
  return new Date(n + r);
}
var xw = 36e5;
function ww(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Do(t, n * xw);
}
var _w = {};
function an() {
  return _w;
}
function Ht(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = an(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ae(t), h = f.getDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setDate(f.getDate() - p), f.setHours(0, 0, 0, 0), f;
}
function sr(t) {
  return Q(1, arguments), Ht(t, {
    weekStartsOn: 1
  });
}
function Cw(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var o = sr(r), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  var s = sr(i);
  return e.getTime() >= o.getTime() ? n + 1 : e.getTime() >= s.getTime() ? n : n - 1;
}
function Ew(t) {
  Q(1, arguments);
  var e = Cw(t), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0);
  var r = sr(n);
  return r;
}
function Ar(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function ar(t) {
  Q(1, arguments);
  var e = ae(t);
  return e.setHours(0, 0, 0, 0), e;
}
var kw = 864e5;
function Nt(t, e) {
  Q(2, arguments);
  var n = ar(t), r = ar(e), o = n.getTime() - Ar(n), i = r.getTime() - Ar(r);
  return Math.round((o - i) / kw);
}
var Mw = 6e4;
function Ow(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Do(t, n * Mw);
}
function Pw(t, e) {
  Q(2, arguments);
  var n = Ne(e), r = n * 3;
  return Ft(t, r);
}
function Sw(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Do(t, n * 1e3);
}
function Li(t, e) {
  Q(2, arguments);
  var n = Ne(e), r = n * 7;
  return Mt(t, r);
}
function Nh(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Ft(t, n * 12);
}
function Dw(t) {
  Q(1, arguments);
  var e;
  if (t && typeof t.forEach == "function")
    e = t;
  else if (Yt(t) === "object" && t !== null)
    e = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return e.forEach(function(r) {
    var o = ae(r);
    (n === void 0 || n < o || isNaN(Number(o))) && (n = o);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function Tw(t) {
  Q(1, arguments);
  var e;
  if (t && typeof t.forEach == "function")
    e = t;
  else if (Yt(t) === "object" && t !== null)
    e = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return e.forEach(function(r) {
    var o = ae(r);
    (n === void 0 || n > o || isNaN(o.getDate())) && (n = o);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function co(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
var is = 6e4, ss = 36e5, Iw = 1e3;
function vt(t, e) {
  Q(2, arguments);
  var n = ar(t), r = ar(e);
  return n.getTime() === r.getTime();
}
function El(t) {
  return Q(1, arguments), t instanceof Date || Yt(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function kl(t) {
  if (Q(1, arguments), !El(t) && typeof t != "number")
    return !1;
  var e = ae(t);
  return !isNaN(Number(e));
}
function Lr(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e), o = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return o * 12 + i;
}
var $w = 6048e5;
function Nw(t, e, n) {
  Q(2, arguments);
  var r = Ht(t, n), o = Ht(e, n), i = r.getTime() - Ar(r), s = o.getTime() - Ar(o);
  return Math.round((i - s) / $w);
}
function Rw(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e);
  return n.getFullYear() - r.getFullYear();
}
function Zu(t, e) {
  var n = t.getFullYear() - e.getFullYear() || t.getMonth() - e.getMonth() || t.getDate() - e.getDate() || t.getHours() - e.getHours() || t.getMinutes() - e.getMinutes() || t.getSeconds() - e.getSeconds() || t.getMilliseconds() - e.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Rh(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e), o = Zu(n, r), i = Math.abs(Nt(n, r));
  n.setDate(n.getDate() - o * i);
  var s = +(Zu(n, r) === -o), a = o * (i - s);
  return a === 0 ? 0 : a;
}
function as(t, e) {
  return Q(2, arguments), ae(t).getTime() - ae(e).getTime();
}
var Qu = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
  }
  // Math.trunc is not supported by IE
}, Aw = "trunc";
function To(t) {
  return t ? Qu[t] : Qu[Aw];
}
function Lw(t, e, n) {
  Q(2, arguments);
  var r = as(t, e) / ss;
  return To(n == null ? void 0 : n.roundingMethod)(r);
}
function Fw(t, e, n) {
  Q(2, arguments);
  var r = as(t, e) / is;
  return To(n == null ? void 0 : n.roundingMethod)(r);
}
function Ah(t) {
  Q(1, arguments);
  var e = ae(t);
  return e.setHours(23, 59, 59, 999), e;
}
function Io(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function Hw(t) {
  Q(1, arguments);
  var e = ae(t);
  return Ah(e).getTime() === Io(e).getTime();
}
function Lh(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e), o = co(n, r), i = Math.abs(Lr(n, r)), s;
  if (i < 1)
    s = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * i);
    var a = co(n, r) === -o;
    Hw(ae(t)) && i === 1 && co(t, r) === 1 && (a = !1), s = o * (i - Number(a));
  }
  return s === 0 ? 0 : s;
}
function Ww(t, e, n) {
  Q(2, arguments);
  var r = Lh(t, e) / 3;
  return To(n == null ? void 0 : n.roundingMethod)(r);
}
function Vw(t, e, n) {
  Q(2, arguments);
  var r = as(t, e) / 1e3;
  return To(n == null ? void 0 : n.roundingMethod)(r);
}
function Bw(t, e, n) {
  Q(2, arguments);
  var r = Rh(t, e) / 7;
  return To(n == null ? void 0 : n.roundingMethod)(r);
}
function jw(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e), o = co(n, r), i = Math.abs(Rw(n, r));
  n.setFullYear(1584), r.setFullYear(1584);
  var s = co(n, r) === -o, a = o * (i - Number(s));
  return a === 0 ? 0 : a;
}
function zw(t) {
  Q(1, arguments);
  var e = ae(t);
  return e.setSeconds(0, 0), e;
}
function Yw(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getMonth(), r = n - n % 3;
  return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
}
function ft(t) {
  Q(1, arguments);
  var e = ae(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function Uw(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
function Fh(t) {
  Q(1, arguments);
  var e = ae(t), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Gw(t) {
  Q(1, arguments);
  var e = ae(t);
  return e.setMinutes(59, 59, 999), e;
}
function ls(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = an(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ae(t), h = f.getDay(), p = (h < d ? -7 : 0) + 6 - (h - d);
  return f.setDate(f.getDate() + p), f.setHours(23, 59, 59, 999), f;
}
function Hh(t) {
  return Q(1, arguments), ls(t, {
    weekStartsOn: 1
  });
}
function Kw(t) {
  Q(1, arguments);
  var e = ae(t);
  return e.setSeconds(59, 999), e;
}
function qw(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getMonth(), r = n - n % 3 + 3;
  return e.setMonth(r, 0), e.setHours(23, 59, 59, 999), e;
}
function Xw(t) {
  Q(1, arguments);
  var e = ae(t);
  return e.setMilliseconds(999), e;
}
function Wh(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Do(t, -n);
}
var Zw = 864e5;
function Qw(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), o = n - r;
  return Math.floor(o / Zw) + 1;
}
function Fr(t) {
  Q(1, arguments);
  var e = 1, n = ae(t), r = n.getUTCDay(), o = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function Vh(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = Fr(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var s = Fr(i);
  return e.getTime() >= o.getTime() ? n + 1 : e.getTime() >= s.getTime() ? n : n - 1;
}
function Jw(t) {
  Q(1, arguments);
  var e = Vh(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Fr(n);
  return r;
}
var e_ = 6048e5;
function Bh(t) {
  Q(1, arguments);
  var e = ae(t), n = Fr(e).getTime() - Jw(e).getTime();
  return Math.round(n / e_) + 1;
}
function lr(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = an(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ae(t), h = f.getUTCDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setUTCDate(f.getUTCDate() - p), f.setUTCHours(0, 0, 0, 0), f;
}
function Ml(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = ae(t), d = u.getUTCFullYear(), f = an(), h = Ne((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(d + 1, 0, h), p.setUTCHours(0, 0, 0, 0);
  var g = lr(p, e), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(d, 0, h), m.setUTCHours(0, 0, 0, 0);
  var v = lr(m, e);
  return u.getTime() >= g.getTime() ? d + 1 : u.getTime() >= v.getTime() ? d : d - 1;
}
function t_(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = an(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = Ml(t, e), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f, 0, d), h.setUTCHours(0, 0, 0, 0);
  var p = lr(h, e);
  return p;
}
var n_ = 6048e5;
function jh(t, e) {
  Q(1, arguments);
  var n = ae(t), r = lr(n, e).getTime() - t_(n, e).getTime();
  return Math.round(r / n_) + 1;
}
function Ae(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var r_ = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return Ae(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : Ae(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return Ae(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return Ae(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return Ae(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return Ae(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return Ae(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, o = e.getUTCMilliseconds(), i = Math.floor(o * Math.pow(10, r - 3));
    return Ae(i, n.length);
  }
};
const En = r_;
var wr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, o_ = {
  // Era
  G: function(e, n, r) {
    var o = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var o = e.getUTCFullYear(), i = o > 0 ? o : 1 - o;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return En.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, o) {
    var i = Ml(e, o), s = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var a = s % 100;
      return Ae(a, 2);
    }
    return n === "Yo" ? r.ordinalNumber(s, {
      unit: "year"
    }) : Ae(s, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = Vh(e);
    return Ae(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return Ae(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var o = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return Ae(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var o = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return Ae(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var o = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return En.M(e, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var o = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return Ae(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, o) {
    var i = jh(e, o);
    return n === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : Ae(i, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var o = Bh(e);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : Ae(o, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : En.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var o = Qw(e);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : Ae(o, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var o = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, o) {
    var i = e.getUTCDay(), s = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(s);
      case "ee":
        return Ae(s, 2);
      case "eo":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, o) {
    var i = e.getUTCDay(), s = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(s);
      case "cc":
        return Ae(s, n.length);
      case "co":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var o = e.getUTCDay(), i = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(i);
      case "ii":
        return Ae(i, n.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var o = e.getUTCHours(), i = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var o = e.getUTCHours(), i;
    switch (o === 12 ? i = wr.noon : o === 0 ? i = wr.midnight : i = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var o = e.getUTCHours(), i;
    switch (o >= 17 ? i = wr.evening : o >= 12 ? i = wr.afternoon : o >= 4 ? i = wr.morning : i = wr.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var o = e.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return En.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : En.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var o = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : Ae(o, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var o = e.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : Ae(o, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : En.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : En.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return En.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (n) {
      case "X":
        return ed(s);
      case "XXXX":
      case "XX":
        return Xn(s);
      case "XXXXX":
      case "XXX":
      default:
        return Xn(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTimezoneOffset();
    switch (n) {
      case "x":
        return ed(s);
      case "xxxx":
      case "xx":
        return Xn(s);
      case "xxxxx":
      case "xxx":
      default:
        return Xn(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ju(s, ":");
      case "OOOO":
      default:
        return "GMT" + Xn(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ju(s, ":");
      case "zzzz":
      default:
        return "GMT" + Xn(s, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, o) {
    var i = o._originalDate || e, s = Math.floor(i.getTime() / 1e3);
    return Ae(s, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTime();
    return Ae(s, n.length);
  }
};
function Ju(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), o = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(o);
  var s = e || "";
  return n + String(o) + s + Ae(i, 2);
}
function ed(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + Ae(Math.abs(t) / 60, 2);
  }
  return Xn(t, e);
}
function Xn(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", o = Math.abs(t), i = Ae(Math.floor(o / 60), 2), s = Ae(o % 60, 2);
  return r + i + n + s;
}
const i_ = o_;
var td = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, zh = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, s_ = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], o = r[1], i = r[2];
  if (!i)
    return td(e, n);
  var s;
  switch (o) {
    case "P":
      s = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      s = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      s = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      s = n.dateTime({
        width: "full"
      });
      break;
  }
  return s.replace("{{date}}", td(o, n)).replace("{{time}}", zh(i, n));
}, a_ = {
  p: zh,
  P: s_
};
const Ca = a_;
var l_ = ["D", "DD"], c_ = ["YY", "YYYY"];
function Yh(t) {
  return l_.indexOf(t) !== -1;
}
function Uh(t) {
  return c_.indexOf(t) !== -1;
}
function Fi(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var u_ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, d_ = function(e, n, r) {
  var o, i = u_[e];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const f_ = d_;
function Ns(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var h_ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, p_ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, g_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, m_ = {
  date: Ns({
    formats: h_,
    defaultWidth: "full"
  }),
  time: Ns({
    formats: p_,
    defaultWidth: "full"
  }),
  dateTime: Ns({
    formats: g_,
    defaultWidth: "full"
  })
};
const v_ = m_;
var b_ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, y_ = function(e, n, r, o) {
  return b_[e];
};
const x_ = y_;
function Zr(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = t.formattingValues[s] || t.formattingValues[i];
    } else {
      var a = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      o = t.values[l] || t.values[a];
    }
    var c = t.argumentCallback ? t.argumentCallback(e) : e;
    return o[c];
  };
}
var w_ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, __ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, C_ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, E_ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, k_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, M_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, O_ = function(e, n) {
  var r = Number(e), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, P_ = {
  ordinalNumber: O_,
  era: Zr({
    values: w_,
    defaultWidth: "wide"
  }),
  quarter: Zr({
    values: __,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Zr({
    values: C_,
    defaultWidth: "wide"
  }),
  day: Zr({
    values: E_,
    defaultWidth: "wide"
  }),
  dayPeriod: Zr({
    values: k_,
    defaultWidth: "wide",
    formattingValues: M_,
    defaultFormattingWidth: "wide"
  })
};
const S_ = P_;
function Qr(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], i = e.match(o);
    if (!i)
      return null;
    var s = i[0], a = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(a) ? T_(a, function(d) {
      return d.test(s);
    }) : D_(a, function(d) {
      return d.test(s);
    }), c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = e.slice(s.length);
    return {
      value: c,
      rest: u
    };
  };
}
function D_(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function T_(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function I_(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r)
      return null;
    var o = r[0], i = e.match(t.parsePattern);
    if (!i)
      return null;
    var s = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    var a = e.slice(o.length);
    return {
      value: s,
      rest: a
    };
  };
}
var $_ = /^(\d+)(th|st|nd|rd)?/i, N_ = /\d+/i, R_ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, A_ = {
  any: [/^b/i, /^(a|c)/i]
}, L_ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, F_ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, H_ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, W_ = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, V_ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, B_ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, j_ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, z_ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Y_ = {
  ordinalNumber: I_({
    matchPattern: $_,
    parsePattern: N_,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Qr({
    matchPatterns: R_,
    defaultMatchWidth: "wide",
    parsePatterns: A_,
    defaultParseWidth: "any"
  }),
  quarter: Qr({
    matchPatterns: L_,
    defaultMatchWidth: "wide",
    parsePatterns: F_,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Qr({
    matchPatterns: H_,
    defaultMatchWidth: "wide",
    parsePatterns: W_,
    defaultParseWidth: "any"
  }),
  day: Qr({
    matchPatterns: V_,
    defaultMatchWidth: "wide",
    parsePatterns: B_,
    defaultParseWidth: "any"
  }),
  dayPeriod: Qr({
    matchPatterns: j_,
    defaultMatchWidth: "any",
    parsePatterns: z_,
    defaultParseWidth: "any"
  })
};
const U_ = Y_;
var G_ = {
  code: "en-US",
  formatDistance: f_,
  formatLong: v_,
  formatRelative: x_,
  localize: S_,
  match: U_,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Ol = G_;
var K_ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, q_ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, X_ = /^'([^]*?)'?$/, Z_ = /''/g, Q_ = /[a-zA-Z]/;
function xt(t, e, n) {
  var r, o, i, s, a, l, c, u, d, f, h, p, g, m, v, b, y, w;
  Q(2, arguments);
  var x = String(e), M = an(), E = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : M.locale) !== null && r !== void 0 ? r : Ol, C = Ne((i = (s = (a = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : M.firstWeekContainsDate) !== null && s !== void 0 ? s : (d = M.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(C >= 1 && C <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var O = Ne((h = (p = (g = (m = n == null ? void 0 : n.weekStartsOn) !== null && m !== void 0 ? m : n == null || (v = n.locale) === null || v === void 0 || (b = v.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && g !== void 0 ? g : M.weekStartsOn) !== null && p !== void 0 ? p : (y = M.locale) === null || y === void 0 || (w = y.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(O >= 0 && O <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!E.localize)
    throw new RangeError("locale must contain localize property");
  if (!E.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var R = ae(t);
  if (!kl(R))
    throw new RangeError("Invalid time value");
  var D = Ar(R), $ = Wh(R, D), T = {
    firstWeekContainsDate: C,
    weekStartsOn: O,
    locale: E,
    _originalDate: R
  }, j = x.match(q_).map(function(L) {
    var Y = L[0];
    if (Y === "p" || Y === "P") {
      var H = Ca[Y];
      return H(L, E.formatLong);
    }
    return L;
  }).join("").match(K_).map(function(L) {
    if (L === "''")
      return "'";
    var Y = L[0];
    if (Y === "'")
      return J_(L);
    var H = i_[Y];
    if (H)
      return !(n != null && n.useAdditionalWeekYearTokens) && Uh(L) && Fi(L, e, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && Yh(L) && Fi(L, e, String(t)), H($, L, E.localize, T);
    if (Y.match(Q_))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Y + "`");
    return L;
  }).join("");
  return j;
}
function J_(t) {
  var e = t.match(X_);
  return e ? e[1].replace(Z_, "'") : t;
}
function e2(t, e) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
function t2(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getFullYear(), r = e.getMonth(), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
var n2 = 6048e5;
function r2(t) {
  Q(1, arguments);
  var e = ae(t), n = sr(e).getTime() - Ew(e).getTime();
  return Math.round(n / n2) + 1;
}
function o2(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getTime();
  return n;
}
function i2(t) {
  return Q(1, arguments), Math.floor(o2(t) / 1e3);
}
function s2(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = ae(t), d = u.getFullYear(), f = an(), h = Ne((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setFullYear(d + 1, 0, h), p.setHours(0, 0, 0, 0);
  var g = Ht(p, e), m = /* @__PURE__ */ new Date(0);
  m.setFullYear(d, 0, h), m.setHours(0, 0, 0, 0);
  var v = Ht(m, e);
  return u.getTime() >= g.getTime() ? d + 1 : u.getTime() >= v.getTime() ? d : d - 1;
}
function a2(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = an(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = s2(t, e), h = /* @__PURE__ */ new Date(0);
  h.setFullYear(f, 0, d), h.setHours(0, 0, 0, 0);
  var p = Ht(h, e);
  return p;
}
var l2 = 6048e5;
function c2(t, e) {
  Q(1, arguments);
  var n = ae(t), r = Ht(n, e).getTime() - a2(n, e).getTime();
  return Math.round(r / l2) + 1;
}
function u2(t) {
  Q(1, arguments);
  var e = ae(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function d2(t, e) {
  return Q(1, arguments), Nw(u2(t), ft(t), e) + 1;
}
function Gh(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e);
  return n.getTime() > r.getTime();
}
function Kh(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e);
  return n.getTime() < r.getTime();
}
function nd(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function f2(t, e) {
  if (t) {
    if (typeof t == "string")
      return nd(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return nd(t, e);
  }
}
function rd(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = f2(t)) || e && t && typeof t.length == "number") {
      n && (t = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, s = !1, a;
  return {
    s: function() {
      n = n.call(t);
    },
    n: function() {
      var c = n.next();
      return i = c.done, c;
    },
    e: function(c) {
      s = !0, a = c;
    },
    f: function() {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (s)
          throw a;
      }
    }
  };
}
function ce(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ea(t, e) {
  return Ea = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Ea(t, e);
}
function Oe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && Ea(t, e);
}
function Hi(t) {
  return Hi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Hi(t);
}
function h2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function p2(t, e) {
  if (e && (Yt(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ce(t);
}
function Pe(t) {
  var e = h2();
  return function() {
    var r = Hi(t), o;
    if (e) {
      var i = Hi(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return p2(this, o);
  };
}
function Ce(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function g2(t, e) {
  if (Yt(t) !== "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (Yt(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function qh(t) {
  var e = g2(t, "string");
  return Yt(e) === "symbol" ? e : String(e);
}
function od(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, qh(r.key), r);
  }
}
function Ee(t, e, n) {
  return e && od(t.prototype, e), n && od(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function ie(t, e, n) {
  return e = qh(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var m2 = 10, Xh = /* @__PURE__ */ function() {
  function t() {
    Ce(this, t), ie(this, "priority", void 0), ie(this, "subPriority", 0);
  }
  return Ee(t, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), t;
}(), v2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n(r, o, i, s, a) {
    var l;
    return Ce(this, n), l = e.call(this), l.value = r, l.validateValue = o, l.setValue = i, l.priority = s, a && (l.subPriority = a), l;
  }
  return Ee(n, [{
    key: "validate",
    value: function(o, i) {
      return this.validateValue(o, this.value, i);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return this.setValue(o, i, this.value, s);
    }
  }]), n;
}(Xh), b2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", m2), ie(ce(r), "subPriority", -1), r;
  }
  return Ee(n, [{
    key: "set",
    value: function(o, i) {
      if (i.timestampIsSet)
        return o;
      var s = /* @__PURE__ */ new Date(0);
      return s.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), s.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), s;
    }
  }]), n;
}(Xh), Te = /* @__PURE__ */ function() {
  function t() {
    Ce(this, t), ie(this, "incompatibleTokens", void 0), ie(this, "priority", void 0), ie(this, "subPriority", void 0);
  }
  return Ee(t, [{
    key: "run",
    value: function(n, r, o, i) {
      var s = this.parse(n, r, o, i);
      return s ? {
        setter: new v2(s.value, this.validate, this.set, this.priority, this.subPriority),
        rest: s.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, o) {
      return !0;
    }
  }]), t;
}(), y2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 140), ie(ce(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return s.era(o, {
            width: "abbreviated"
          }) || s.era(o, {
            width: "narrow"
          });
        case "GGGGG":
          return s.era(o, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return s.era(o, {
            width: "wide"
          }) || s.era(o, {
            width: "abbreviated"
          }) || s.era(o, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return i.era = s, o.setUTCFullYear(s, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), Qe = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Jt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Je(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Ke(t, e) {
  var n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function en(t, e) {
  var n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, s = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * ss + i * is + s * Iw),
    rest: e.slice(n[0].length)
  };
}
function Zh(t) {
  return Ke(Qe.anyDigitsSigned, t);
}
function Xe(t, e) {
  switch (t) {
    case 1:
      return Ke(Qe.singleDigit, e);
    case 2:
      return Ke(Qe.twoDigits, e);
    case 3:
      return Ke(Qe.threeDigits, e);
    case 4:
      return Ke(Qe.fourDigits, e);
    default:
      return Ke(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function Wi(t, e) {
  switch (t) {
    case 1:
      return Ke(Qe.singleDigitSigned, e);
    case 2:
      return Ke(Qe.twoDigitsSigned, e);
    case 3:
      return Ke(Qe.threeDigitsSigned, e);
    case 4:
      return Ke(Qe.fourDigitsSigned, e);
    default:
      return Ke(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function Pl(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Qh(t, e) {
  var n = e > 0, r = n ? e : 1 - e, o;
  if (r <= 50)
    o = t || 100;
  else {
    var i = r + 50, s = Math.floor(i / 100) * 100, a = t >= i % 100;
    o = t + s - (a ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function Jh(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var x2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 130), ie(ce(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return Je(Xe(4, o), a);
        case "yo":
          return Je(s.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return Je(Xe(i.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = o.getUTCFullYear();
      if (s.isTwoDigitYear) {
        var l = Qh(s.year, a);
        return o.setUTCFullYear(l, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
      var c = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return o.setUTCFullYear(c, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), w2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 130), ie(ce(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return Je(Xe(4, o), a);
        case "Yo":
          return Je(s.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return Je(Xe(i.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      var l = Ml(o, a);
      if (s.isTwoDigitYear) {
        var c = Qh(s.year, l);
        return o.setUTCFullYear(c, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), lr(o, a);
      }
      var u = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return o.setUTCFullYear(u, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), lr(o, a);
    }
  }]), n;
}(Te), _2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 130), ie(ce(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      return Wi(i === "R" ? 4 : i.length, o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = /* @__PURE__ */ new Date(0);
      return a.setUTCFullYear(s, 0, 4), a.setUTCHours(0, 0, 0, 0), Fr(a);
    }
  }]), n;
}(Te), C2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 130), ie(ce(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      return Wi(i === "u" ? 4 : i.length, o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCFullYear(s, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), E2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 120), ie(ce(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "Q":
        case "QQ":
          return Xe(i.length, o);
        case "Qo":
          return s.ordinalNumber(o, {
            unit: "quarter"
          });
        case "QQQ":
          return s.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return s.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return s.quarter(o, {
            width: "wide",
            context: "formatting"
          }) || s.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth((s - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), k2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 120), ie(ce(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "q":
        case "qq":
          return Xe(i.length, o);
        case "qo":
          return s.ordinalNumber(o, {
            unit: "quarter"
          });
        case "qqq":
          return s.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return s.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return s.quarter(o, {
            width: "wide",
            context: "standalone"
          }) || s.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth((s - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), M2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ie(ce(r), "priority", 110), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return c - 1;
      };
      switch (i) {
        case "M":
          return Je(Ke(Qe.month, o), a);
        case "MM":
          return Je(Xe(2, o), a);
        case "Mo":
          return Je(s.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "MMM":
          return s.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return s.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return s.month(o, {
            width: "wide",
            context: "formatting"
          }) || s.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth(s, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), O2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 110), ie(ce(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return c - 1;
      };
      switch (i) {
        case "L":
          return Je(Ke(Qe.month, o), a);
        case "LL":
          return Je(Xe(2, o), a);
        case "Lo":
          return Je(s.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "LLL":
          return s.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return s.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return s.month(o, {
            width: "wide",
            context: "standalone"
          }) || s.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth(s, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te);
function P2(t, e, n) {
  Q(2, arguments);
  var r = ae(t), o = Ne(e), i = jh(r, n) - o;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
var S2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 100), ie(ce(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "w":
          return Ke(Qe.week, o);
        case "wo":
          return s.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return lr(P2(o, s, a), a);
    }
  }]), n;
}(Te);
function D2(t, e) {
  Q(2, arguments);
  var n = ae(t), r = Ne(e), o = Bh(n) - r;
  return n.setUTCDate(n.getUTCDate() - o * 7), n;
}
var T2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 100), ie(ce(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "I":
          return Ke(Qe.week, o);
        case "Io":
          return s.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return Fr(D2(o, s));
    }
  }]), n;
}(Te), I2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], $2 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], N2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 90), ie(ce(r), "subPriority", 1), ie(ce(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "d":
          return Ke(Qe.date, o);
        case "do":
          return s.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      var s = o.getUTCFullYear(), a = Jh(s), l = o.getUTCMonth();
      return a ? i >= 1 && i <= $2[l] : i >= 1 && i <= I2[l];
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCDate(s), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), R2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 90), ie(ce(r), "subpriority", 1), ie(ce(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "D":
        case "DD":
          return Ke(Qe.dayOfYear, o);
        case "Do":
          return s.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      var s = o.getUTCFullYear(), a = Jh(s);
      return a ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth(0, s), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te);
function Sl(t, e, n) {
  var r, o, i, s, a, l, c, u;
  Q(2, arguments);
  var d = an(), f = Ne((r = (o = (i = (s = n == null ? void 0 : n.weekStartsOn) !== null && s !== void 0 ? s : n == null || (a = n.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && o !== void 0 ? o : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ae(t), p = Ne(e), g = h.getUTCDay(), m = p % 7, v = (m + 7) % 7, b = (v < f ? 7 : 0) + p - g;
  return h.setUTCDate(h.getUTCDate() + b), h;
}
var A2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 90), ie(ce(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return o = Sl(o, s, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), L2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 90), ie(ce(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "e":
        case "ee":
          return Je(Xe(i.length, o), l);
        case "eo":
          return Je(s.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "eee":
          return s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return o = Sl(o, s, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), F2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 90), ie(ce(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "c":
        case "cc":
          return Je(Xe(i.length, o), l);
        case "co":
          return Je(s.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "ccc":
          return s.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(o, {
            width: "short",
            context: "standalone"
          }) || s.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return s.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return s.day(o, {
            width: "short",
            context: "standalone"
          }) || s.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return s.day(o, {
            width: "wide",
            context: "standalone"
          }) || s.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(o, {
            width: "short",
            context: "standalone"
          }) || s.day(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return o = Sl(o, s, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te);
function H2(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  n % 7 === 0 && (n = n - 7);
  var r = 1, o = ae(t), i = o.getUTCDay(), s = n % 7, a = (s + 7) % 7, l = (a < r ? 7 : 0) + n - i;
  return o.setUTCDate(o.getUTCDate() + l), o;
}
var W2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 90), ie(ce(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (i) {
        case "i":
        case "ii":
          return Xe(i.length, o);
        case "io":
          return s.ordinalNumber(o, {
            unit: "day"
          });
        case "iii":
          return Je(s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiii":
          return Je(s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiiii":
          return Je(s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiii":
        default:
          return Je(s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o = H2(o, s), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), V2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 80), ie(ce(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return s.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(Pl(s), 0, 0, 0), o;
    }
  }]), n;
}(Te), B2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 80), ie(ce(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return s.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(Pl(s), 0, 0, 0), o;
    }
  }]), n;
}(Te), j2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 80), ie(ce(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return s.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(Pl(s), 0, 0, 0), o;
    }
  }]), n;
}(Te), z2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 70), ie(ce(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "h":
          return Ke(Qe.hour12h, o);
        case "ho":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = o.getUTCHours() >= 12;
      return a && s < 12 ? o.setUTCHours(s + 12, 0, 0, 0) : !a && s === 12 ? o.setUTCHours(0, 0, 0, 0) : o.setUTCHours(s, 0, 0, 0), o;
    }
  }]), n;
}(Te), Y2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 70), ie(ce(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "H":
          return Ke(Qe.hour23h, o);
        case "Ho":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(s, 0, 0, 0), o;
    }
  }]), n;
}(Te), U2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 70), ie(ce(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "K":
          return Ke(Qe.hour11h, o);
        case "Ko":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = o.getUTCHours() >= 12;
      return a && s < 12 ? o.setUTCHours(s + 12, 0, 0, 0) : o.setUTCHours(s, 0, 0, 0), o;
    }
  }]), n;
}(Te), G2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 70), ie(ce(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "k":
          return Ke(Qe.hour24h, o);
        case "ko":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = s <= 24 ? s % 24 : s;
      return o.setUTCHours(a, 0, 0, 0), o;
    }
  }]), n;
}(Te), K2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 60), ie(ce(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "m":
          return Ke(Qe.minute, o);
        case "mo":
          return s.ordinalNumber(o, {
            unit: "minute"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMinutes(s, 0, 0), o;
    }
  }]), n;
}(Te), q2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 50), ie(ce(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "s":
          return Ke(Qe.second, o);
        case "so":
          return s.ordinalNumber(o, {
            unit: "second"
          });
        default:
          return Xe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCSeconds(s, 0), o;
    }
  }]), n;
}(Te), X2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 30), ie(ce(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      var s = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return Je(Xe(i.length, o), s);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMilliseconds(s), o;
    }
  }]), n;
}(Te), Z2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 10), ie(ce(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      switch (i) {
        case "X":
          return en(Jt.basicOptionalMinutes, o);
        case "XX":
          return en(Jt.basic, o);
        case "XXXX":
          return en(Jt.basicOptionalSeconds, o);
        case "XXXXX":
          return en(Jt.extendedOptionalSeconds, o);
        case "XXX":
        default:
          return en(Jt.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return i.timestampIsSet ? o : new Date(o.getTime() - s);
    }
  }]), n;
}(Te), Q2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 10), ie(ce(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      switch (i) {
        case "x":
          return en(Jt.basicOptionalMinutes, o);
        case "xx":
          return en(Jt.basic, o);
        case "xxxx":
          return en(Jt.basicOptionalSeconds, o);
        case "xxxxx":
          return en(Jt.extendedOptionalSeconds, o);
        case "xxx":
        default:
          return en(Jt.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return i.timestampIsSet ? o : new Date(o.getTime() - s);
    }
  }]), n;
}(Te), J2 = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 40), ie(ce(r), "incompatibleTokens", "*"), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o) {
      return Zh(o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return [new Date(s * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Te), eC = /* @__PURE__ */ function(t) {
  Oe(n, t);
  var e = Pe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), ie(ce(r), "priority", 20), ie(ce(r), "incompatibleTokens", "*"), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o) {
      return Zh(o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return [new Date(s), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Te), tC = {
  G: new y2(),
  y: new x2(),
  Y: new w2(),
  R: new _2(),
  u: new C2(),
  Q: new E2(),
  q: new k2(),
  M: new M2(),
  L: new O2(),
  w: new S2(),
  I: new T2(),
  d: new N2(),
  D: new R2(),
  E: new A2(),
  e: new L2(),
  c: new F2(),
  i: new W2(),
  a: new V2(),
  b: new B2(),
  B: new j2(),
  h: new z2(),
  H: new Y2(),
  K: new U2(),
  k: new G2(),
  m: new K2(),
  s: new q2(),
  S: new X2(),
  X: new Z2(),
  x: new Q2(),
  t: new J2(),
  T: new eC()
}, nC = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, rC = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, oC = /^'([^]*?)'?$/, iC = /''/g, sC = /\S/, aC = /[a-zA-Z]/;
function kr(t, e, n, r) {
  var o, i, s, a, l, c, u, d, f, h, p, g, m, v, b, y, w, x;
  Q(3, arguments);
  var M = String(t), E = String(e), C = an(), O = (o = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : C.locale) !== null && o !== void 0 ? o : Ol;
  if (!O.match)
    throw new RangeError("locale must contain match property");
  var R = Ne((s = (a = (l = (c = r == null ? void 0 : r.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (u = r.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : C.firstWeekContainsDate) !== null && a !== void 0 ? a : (f = C.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(R >= 1 && R <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var D = Ne((p = (g = (m = (v = r == null ? void 0 : r.weekStartsOn) !== null && v !== void 0 ? v : r == null || (b = r.locale) === null || b === void 0 || (y = b.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && m !== void 0 ? m : C.weekStartsOn) !== null && g !== void 0 ? g : (w = C.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(D >= 0 && D <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (E === "")
    return M === "" ? ae(n) : /* @__PURE__ */ new Date(NaN);
  var $ = {
    firstWeekContainsDate: R,
    weekStartsOn: D,
    locale: O
  }, T = [new b2()], j = E.match(rC).map(function(V) {
    var G = V[0];
    if (G in Ca) {
      var oe = Ca[G];
      return oe(V, O.formatLong);
    }
    return V;
  }).join("").match(nC), L = [], Y = rd(j), H;
  try {
    var z = function() {
      var G = H.value;
      !(r != null && r.useAdditionalWeekYearTokens) && Uh(G) && Fi(G, E, t), !(r != null && r.useAdditionalDayOfYearTokens) && Yh(G) && Fi(G, E, t);
      var oe = G[0], X = tC[oe];
      if (X) {
        var U = X.incompatibleTokens;
        if (Array.isArray(U)) {
          var be = L.find(function(Re) {
            return U.includes(Re.token) || Re.token === oe;
          });
          if (be)
            throw new RangeError("The format string mustn't contain `".concat(be.fullToken, "` and `").concat(G, "` at the same time"));
        } else if (X.incompatibleTokens === "*" && L.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(G, "` and any other token at the same time"));
        L.push({
          token: oe,
          fullToken: G
        });
        var De = X.run(M, G, O.match, $);
        if (!De)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        T.push(De.setter), M = De.rest;
      } else {
        if (oe.match(aC))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + oe + "`");
        if (G === "''" ? G = "'" : oe === "'" && (G = lC(G)), M.indexOf(G) === 0)
          M = M.slice(G.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (Y.s(); !(H = Y.n()).done; ) {
      var ee = z();
      if (Yt(ee) === "object")
        return ee.v;
    }
  } catch (V) {
    Y.e(V);
  } finally {
    Y.f();
  }
  if (M.length > 0 && sC.test(M))
    return /* @__PURE__ */ new Date(NaN);
  var I = T.map(function(V) {
    return V.priority;
  }).sort(function(V, G) {
    return G - V;
  }).filter(function(V, G, oe) {
    return oe.indexOf(V) === G;
  }).map(function(V) {
    return T.filter(function(G) {
      return G.priority === V;
    }).sort(function(G, oe) {
      return oe.subPriority - G.subPriority;
    });
  }).map(function(V) {
    return V[0];
  }), F = ae(n);
  if (isNaN(F.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var te = Wh(F, Ar(F)), J = {}, re = rd(I), B;
  try {
    for (re.s(); !(B = re.n()).done; ) {
      var N = B.value;
      if (!N.validate(te, $))
        return /* @__PURE__ */ new Date(NaN);
      var W = N.set(te, J, $);
      Array.isArray(W) ? (te = W[0], e2(J, W[1])) : te = W;
    }
  } catch (V) {
    re.e(V);
  } finally {
    re.f();
  }
  return te;
}
function lC(t) {
  return t.match(oC)[1].replace(iC, "'");
}
function cC(t) {
  Q(1, arguments);
  var e = ae(t);
  return e.setMinutes(0, 0, 0), e;
}
function Dl(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function uC(t) {
  Q(1, arguments);
  var e = ae(t);
  return e.setMilliseconds(0), e;
}
function dC(t, e) {
  Q(2, arguments);
  var n = ae(t), r = ae(e);
  return n.getFullYear() === r.getFullYear();
}
function id(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Mt(t, -n);
}
function fC(t, e) {
  var n;
  Q(1, arguments);
  var r = Ne((n = e == null ? void 0 : e.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = mC(t), i;
  if (o.date) {
    var s = vC(o.date, r);
    i = bC(s.restDateString, s.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var a = i.getTime(), l = 0, c;
  if (o.time && (l = yC(o.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (o.timezone) {
    if (c = xC(o.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(a + l), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), d.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), d;
  }
  return new Date(a + l + c);
}
var ei = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, hC = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, pC = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, gC = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function mC(t) {
  var e = {}, n = t.split(ei.dateTimeDelimiter), r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], ei.timeZoneDelimiter.test(e.date) && (e.date = t.split(ei.timeZoneDelimiter)[0], r = t.substr(e.date.length, t.length))), r) {
    var o = ei.timezone.exec(r);
    o ? (e.time = r.replace(o[1], ""), e.timezone = o[1]) : e.time = r;
  }
  return e;
}
function vC(t, e) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"), r = t.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var o = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? o : i * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function bC(t, e) {
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t.match(hC);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], o = Jr(n[1]), i = Jr(n[2]) - 1, s = Jr(n[3]), a = Jr(n[4]), l = Jr(n[5]) - 1;
  if (r)
    return kC(e, a, l) ? wC(e, a, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !CC(e, i, s) || !EC(e, o) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(e, i, Math.max(o, s)), c);
}
function Jr(t) {
  return t ? parseInt(t) : 1;
}
function yC(t) {
  var e = t.match(pC);
  if (!e)
    return NaN;
  var n = Rs(e[1]), r = Rs(e[2]), o = Rs(e[3]);
  return MC(n, r, o) ? n * ss + r * is + o * 1e3 : NaN;
}
function Rs(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function xC(t) {
  if (t === "Z")
    return 0;
  var e = t.match(gC);
  if (!e)
    return 0;
  var n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), o = e[3] && parseInt(e[3]) || 0;
  return OC(r, o) ? n * (r * ss + o * is) : NaN;
}
function wC(t, e, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var o = r.getUTCDay() || 7, i = (e - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var _C = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function ep(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function CC(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (_C[e] || (ep(t) ? 29 : 28));
}
function EC(t, e) {
  return e >= 1 && e <= (ep(t) ? 366 : 365);
}
function kC(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function MC(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function OC(t, e) {
  return e >= 0 && e <= 59;
}
function As(t, e) {
  Q(2, arguments);
  var n = ae(t), r = Ne(e), o = n.getFullYear(), i = n.getDate(), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(o, r, 15), s.setHours(0, 0, 0, 0);
  var a = t2(s);
  return n.setMonth(r, Math.min(i, a)), n;
}
function sd(t, e) {
  Q(2, arguments);
  var n = ae(t), r = Ne(e);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const PC = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
gh._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return PC;
  },
  parse: function(t, e) {
    if (t === null || typeof t > "u")
      return null;
    const n = typeof t;
    return n === "number" || t instanceof Date ? t = ae(t) : n === "string" && (typeof e == "string" ? t = kr(t, e, /* @__PURE__ */ new Date(), this.options) : t = fC(t, this.options)), kl(t) ? t.getTime() : null;
  },
  format: function(t, e) {
    return xt(t, e, this.options);
  },
  add: function(t, e, n) {
    switch (n) {
      case "millisecond":
        return Do(t, e);
      case "second":
        return Sw(t, e);
      case "minute":
        return Ow(t, e);
      case "hour":
        return ww(t, e);
      case "day":
        return Mt(t, e);
      case "week":
        return Li(t, e);
      case "month":
        return Ft(t, e);
      case "quarter":
        return Pw(t, e);
      case "year":
        return Nh(t, e);
      default:
        return t;
    }
  },
  diff: function(t, e, n) {
    switch (n) {
      case "millisecond":
        return as(t, e);
      case "second":
        return Vw(t, e);
      case "minute":
        return Fw(t, e);
      case "hour":
        return Lw(t, e);
      case "day":
        return Rh(t, e);
      case "week":
        return Bw(t, e);
      case "month":
        return Lh(t, e);
      case "quarter":
        return Ww(t, e);
      case "year":
        return jw(t, e);
      default:
        return 0;
    }
  },
  startOf: function(t, e, n) {
    switch (e) {
      case "second":
        return uC(t);
      case "minute":
        return zw(t);
      case "hour":
        return cC(t);
      case "day":
        return ar(t);
      case "week":
        return Ht(t);
      case "isoWeek":
        return Ht(t, { weekStartsOn: +n });
      case "month":
        return ft(t);
      case "quarter":
        return Yw(t);
      case "year":
        return Fh(t);
      default:
        return t;
    }
  },
  endOf: function(t, e) {
    switch (e) {
      case "second":
        return Xw(t);
      case "minute":
        return Kw(t);
      case "hour":
        return Gw(t);
      case "day":
        return Ah(t);
      case "week":
        return ls(t);
      case "month":
        return Io(t);
      case "quarter":
        return qw(t);
      case "year":
        return Uw(t);
      default:
        return t;
    }
  }
});
function Bt(t) {
  return `rgba(${getComputedStyle(document.documentElement).getPropertyValue(
    t
  )})`;
}
const tp = () => /* @__PURE__ */ Z("div", { className: "relative flex h-52 flex-1 flex-col  justify-between justify-self-end", children: [
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ Z("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-2.5", children: [
    /* @__PURE__ */ _(np, {}),
    /* @__PURE__ */ _("p", { className: "text-xs font-medium text-foundations-boldest", children: "No data in this period" })
  ] })
] }), np = ({ className: t }) => /* @__PURE__ */ Z(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "84",
    viewBox: "0 0 112 84",
    fill: "none",
    className: t,
    children: [
      /* @__PURE__ */ _(
        "path",
        {
          d: "M56.7368 84C79.9328 84 98.7368 65.196 98.7368 42C98.7368 18.804 79.9328 0 56.7368 0C33.5409 0 14.7368 18.804 14.7368 42C14.7368 65.196 33.5409 84 56.7368 84Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ _("g", { filter: "url(#filter0_d_18659_25530)", children: /* @__PURE__ */ _(
        "path",
        {
          d: "M8.19249 29.5547H103.392C104.328 29.5547 105.224 29.9262 105.886 30.5874C106.547 31.2486 106.918 32.1455 106.918 33.0806V50.7102C106.918 51.6454 106.547 52.5422 105.886 53.2034C105.224 53.8647 104.328 54.2362 103.392 54.2362H8.19249C7.25736 54.2362 6.36052 53.8647 5.69928 53.2034C5.03805 52.5422 4.66656 51.6454 4.66656 50.7102V33.0806C4.66656 32.1455 5.03805 31.2486 5.69928 30.5874C6.36052 29.9262 7.25736 29.5547 8.19249 29.5547V29.5547Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M53.324 35.1953H34.9892C33.8208 35.1953 32.8736 36.1425 32.8736 37.3109C32.8736 38.4793 33.8208 39.4264 34.9892 39.4264H53.324C54.4924 39.4264 55.4395 38.4793 55.4395 37.3109C55.4395 36.1425 54.4924 35.1953 53.324 35.1953Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M66.0171 44.3633H34.989C33.8206 44.3633 32.8734 45.3104 32.8734 46.4788C32.8734 47.6472 33.8206 48.5944 34.989 48.5944H66.0171C67.1855 48.5944 68.1327 47.6472 68.1327 46.4788C68.1327 45.3104 67.1855 44.3633 66.0171 44.3633Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M27.2341 41.8951C27.2341 36.2479 22.6562 31.6699 17.0089 31.6699C11.3617 31.6699 6.78375 36.2479 6.78375 41.8951C6.78375 47.5423 11.3617 52.1203 17.0089 52.1203C22.6562 52.1203 27.2341 47.5423 27.2341 41.8951Z",
          className: "fill-[theme(backgroundColor.chart-neutral)]"
        }
      ),
      /* @__PURE__ */ Z("g", { clipPath: "url(#clip0_18659_25530)", children: [
        /* @__PURE__ */ _(
          "path",
          {
            d: "M12.1339 42.6223C12.1339 42.2787 12.4124 42.0001 12.7561 42.0001H14.0005C14.3442 42.0001 14.6227 42.2787 14.6227 42.6223V45.7334C14.6227 46.0771 14.3442 46.3556 14.0005 46.3556H12.7561C12.4124 46.3556 12.1339 46.0771 12.1339 45.7334V42.6223Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M15.8672 40.1334C15.8672 39.7898 16.1458 39.5112 16.4894 39.5112H17.7338C18.0775 39.5112 18.3561 39.7898 18.3561 40.1334V45.7334C18.3561 46.0771 18.0775 46.3556 17.7338 46.3556H16.4894C16.1458 46.3556 15.8672 46.0771 15.8672 45.7334V40.1334Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M19.6005 38.2668C19.6005 37.9231 19.8791 37.6445 20.2227 37.6445H21.4672C21.8108 37.6445 22.0894 37.9231 22.0894 38.2668V45.7334C22.0894 46.0771 21.8108 46.3556 21.4672 46.3556H20.2227C19.8791 46.3556 19.6005 46.0771 19.6005 45.7334V38.2668Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] }),
      /* @__PURE__ */ Z("defs", { children: [
        /* @__PURE__ */ Z(
          "filter",
          {
            id: "filter0_d_18659_25530",
            x: "0.435454",
            y: "27.4391",
            width: "110.714",
            height: "33.1439",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ _(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ _("feOffset", { dy: "2.11556" }),
              /* @__PURE__ */ _("feGaussianBlur", { stdDeviation: "2.11556" }),
              /* @__PURE__ */ _(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
                }
              ),
              /* @__PURE__ */ _(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_18659_25530"
                }
              ),
              /* @__PURE__ */ _(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_18659_25530",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ _("clipPath", { id: "clip0_18659_25530", children: /* @__PURE__ */ _(
          "rect",
          {
            width: "12.4444",
            height: "12.4444",
            className: "fill-[theme(backgroundColor.foundations-default)]",
            transform: "translate(10.8894 35.7773)"
          }
        ) })
      ] })
    ]
  }
);
Cl.register(
  xa,
  wa,
  Eo,
  vi,
  no,
  mi,
  hi,
  fi,
  Hx,
  Gx
);
const SC = ({
  type: t,
  labels: e,
  datasets: n,
  horizontal: r = !1,
  hideLegend: o = !1,
  scaleXWeekFormat: i = !1,
  scaleYFormat: s,
  extraScales: a,
  tooltipCallbacks: l,
  ...c
}) => {
  const u = e.length > 50;
  return e.length === 0 ? /* @__PURE__ */ _(tp, {}) : /* @__PURE__ */ _(
    yw,
    {
      width: "100%",
      type: t,
      data: {
        labels: e,
        datasets: n
      },
      options: {
        responsive: !0,
        maintainAspectRatio: !1,
        indexAxis: r ? "y" : "x",
        // Large set of data make interaction easier
        interaction: u ? {
          axis: "x",
          intersect: !1
        } : void 0,
        elements: {
          point: {
            radius: 0,
            borderWidth: 0,
            hoverRadius: 4,
            hoverBorderWidth: 4,
            hoverBorderColor: Bt(
              "--background-foundations-inverse"
            ),
            hoverBackgroundColor: Bt(
              "--background-foundations-default"
            ),
            hitRadius: 4
          },
          line: {
            borderWidth: 2
          }
        },
        plugins: {
          legend: {
            display: !o,
            align: "end",
            labels: {
              boxWidth: 8,
              boxHeight: 8,
              borderRadius: 4,
              usePointStyle: !0,
              useBorderRadius: !0,
              color: Bt("--text-foundations-boldest")
            }
          },
          tooltip: {
            yAlign: "bottom",
            displayColors: !1,
            titleColor: Bt("--text-foundations-inverse"),
            bodyColor: Bt("--text-foundations-inverse"),
            backgroundColor: Bt(
              "--background-foundations-inverse"
            ),
            padding: 16,
            borderWidth: 2,
            borderColor: Bt(
              "--background-foundations-inverse"
            ),
            titleFont: {
              weight: "normal"
            },
            callbacks: l
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: u
              },
              pinch: {
                enabled: u
              },
              drag: {
                enabled: u
              },
              mode: "x"
            }
          }
        },
        scales: {
          y: {
            beginAtZero: !0,
            grace: "5%",
            grid: {
              color: Bt("--border-foundations-subtler"),
              drawTicks: !1
            },
            ticks: {
              padding: 8,
              color: Bt("--text-foundations-subtle"),
              format: s
            },
            border: {
              display: !1
            }
          },
          x: {
            type: "time",
            time: {
              unit: "day",
              displayFormats: {
                day: i ? "E" : "MMM d"
              },
              tooltipFormat: "d/M/yyyy"
            },
            grid: {
              display: !1
            },
            ticks: {
              padding: 8,
              color: Bt("--text-foundations-subtle")
            },
            border: {
              display: !1
            }
          },
          ...a
        }
      },
      plugins: [DC],
      ...c
    }
  );
};
SC.displayName = "Chart";
function _8(t) {
  return {
    grace: "5%",
    grid: {
      drawOnChartArea: !1,
      drawTicks: !1
    },
    ticks: {
      padding: 8,
      color: Bt("--text-foundations-subtle")
    },
    border: {
      display: !1
    },
    ...t
  };
}
const DC = {
  // plugin extra spacing for legend
  id: "legend-margin",
  beforeInit(t) {
    var n, r, o;
    if (!((o = (r = (n = t.config.options) == null ? void 0 : n.plugins) == null ? void 0 : r.legend) != null && o.display))
      return;
    const e = t.legend.fit;
    t.legend.fit = function() {
      e.bind(t.legend)(), this.height += 20;
    };
  }
}, TC = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ArrowNarrowShortUp/solid"
}, t), /* @__PURE__ */ S.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.293 9.707a1 1 0 0 1 0-1.414l4.005-4a1.002 1.002 0 0 1 1.416 0l4.005 4a1 1 0 0 1-1.416 1.414l-2.296-2.293V15a1 1 0 0 1-1.001 1 1.002 1.002 0 0 1-1.001-1V7.414L6.709 9.707a1.002 1.002 0 0 1-1.416 0Z",
  clipRule: "evenodd"
})), rp = (t) => Number(t.toFixed(2)), IC = Kt(
  "transition-all duration-1000 stroke-neutral-300",
  {
    variants: {
      variant: {
        success: "stroke-[theme(backgroundColor.chart-categorical-2-subtle)]",
        danger: "stroke-[theme(backgroundColor.chart-categorical-3-subtle)]",
        primary: "stroke-[theme(backgroundColor.info-bold)]"
      }
    }
  }
), op = S.forwardRef(
  ({
    variant: t,
    value: e,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    strokeLinecap: i = "round"
  }, s) => {
    const l = n / 2 - r, c = 2 * Math.PI * l, u = c * ((100 - (e || 0)) / 100);
    return /* @__PURE__ */ Z("svg", { ref: s, width: n, height: n, children: [
      /* @__PURE__ */ _(
        "circle",
        {
          className: ye("stroke-neutral-100", o),
          fill: "none",
          strokeWidth: r,
          r: l,
          cx: n / 2,
          cy: n / 2
        }
      ),
      /* @__PURE__ */ _(
        "circle",
        {
          className: ye(
            "stroke-[theme(backgroundColor.chart-neutral)]",
            IC({ variant: t })
          ),
          fill: "none",
          strokeWidth: r,
          r: l,
          cx: n / 2,
          cy: n / 2,
          strokeDasharray: c,
          strokeDashoffset: u,
          strokeLinecap: i,
          transform: "rotate(-90)",
          "transform-origin": "center"
        }
      )
    ] });
  }
), $C = S.forwardRef(
  ({
    variant: t,
    value: e,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    className: i,
    children: s
  }, a) => /* @__PURE__ */ Z("div", { ref: a, className: ye("relative inline-flex", i), children: [
    /* @__PURE__ */ _(
      op,
      {
        value: e,
        variant: t,
        size: n,
        strokeWidth: r,
        strokeClassName: o
      }
    ),
    /* @__PURE__ */ _("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-1.5", children: e === null ? /* @__PURE__ */ Z("div", { className: "flex scale-[0.8] flex-col items-center", children: [
      /* @__PURE__ */ _(np, {}),
      /* @__PURE__ */ _("p", { className: "-mt-4 text-xs font-medium text-foundations-boldest", children: "No data in this period" })
    ] }) : /* @__PURE__ */ Z(dt, { children: [
      /* @__PURE__ */ Z("p", { className: "text-xl font-bold text-foundations-boldest", children: [
        rp(e),
        "%"
      ] }),
      s
    ] }) })
  ] })
);
$C.displayName = "CircleChart";
const NC = Kt(
  "flex items-center justify-center rounded-md border border-foundations-bold bg-foundations-subtlest text-foundations-boldest py-0.5 px-1.5",
  {
    variants: {
      variant: {
        success: "bg-success-subtler border-success-subtle",
        danger: "bg-danger-subtler border-danger-subtle"
      }
    }
  }
), C8 = S.forwardRef(({ diffPercentage: t, variant: e, className: n, ...r }, o) => /* @__PURE__ */ Z(
  "span",
  {
    ref: o,
    className: ye(NC({ variant: e }), n),
    ...r,
    children: [
      !!t && /* @__PURE__ */ _(
        TC,
        {
          className: ye("h-4 w-4", t < 0 && " rotate-180")
        }
      ),
      /* @__PURE__ */ Z("span", { className: "text-xs font-medium", children: [
        rp(Math.abs(t)),
        "%"
      ] })
    ]
  }
)), RC = ({
  items: t,
  formatValue: e,
  tooltipContent: n
}) => {
  const r = S.useMemo(
    () => Math.max(...t.map((o) => o.value)),
    [t]
  );
  return t.length === 0 ? /* @__PURE__ */ _(tp, {}) : /* @__PURE__ */ _("div", { className: "space-y-4 text-xs font-medium", children: t.map((o) => /* @__PURE__ */ Z("div", { children: [
    /* @__PURE__ */ _("p", { className: "uppercase text-foundations-boldest", children: o.label }),
    /* @__PURE__ */ Z(
      "div",
      {
        className: "mt-0.5 flex items-center space-x-2",
        style: {
          width: `${o.value / r * 100}%`
        },
        children: [
          /* @__PURE__ */ _(
            ts,
            {
              content: n == null ? void 0 : n(o),
              disabled: !n,
              delayDuration: 0,
              children: /* @__PURE__ */ _(
                "div",
                {
                  className: ye(
                    "h-2 min-w-[2px] flex-1 bg-neutral-200",
                    o.barClassName
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ _("span", { className: "tabular-nums text-foundations-subtle", children: (e == null ? void 0 : e(o)) || o.value })
        ]
      }
    )
  ] }, o.label)) });
};
RC.displayName = "HorizontalBarsChart";
const AC = Kt(
  "inline-flex items-center py-0.5 text-xs font-medium flex-shrink-0 text-foundations-bolder",
  {
    variants: {
      variant: {
        primary: "border border-info-subtle bg-info-subtler",
        secondary: "bg-gold-400 text-white",
        warning: "border border-warning-subtle bg-warning-subtler",
        dimmed: "bg-foundations-bolder text-white",
        default: "border border-foundations-subtle bg-neutral-100",
        success: "border border-success-subtle bg-success-subtler",
        danger: "border border-danger-subtle bg-danger-subtler",
        pending: "bg-warning-subtler text-gold-400"
      },
      size: {
        sm: "px-2",
        md: "px-2.5"
      },
      shape: {
        pill: "rounded-full",
        square: "rounded-md"
      }
    },
    defaultVariants: {
      size: "md",
      shape: "pill",
      variant: "default"
    }
  }
), LC = P.forwardRef(
  ({ variant: t, size: e, shape: n, className: r, children: o, ...i }, s) => /* @__PURE__ */ _(
    "div",
    {
      ref: s,
      className: ye(AC({ variant: t, size: e, shape: n, className: r })),
      ...i,
      children: o
    }
  )
);
LC.displayName = "Badge";
const FC = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Calendar/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z"
})), cs = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Check/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m5 13 4 4L19 7"
})), ip = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronDown/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m19 9-7 7-7-7"
})), HC = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronLeft/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m15 19-7-7 7-7"
})), WC = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronRight/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m9 5 7 7-7 7"
})), ad = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExclamationCircle/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), VC = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExternalLink/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
})), BC = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "InformationCircle/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), jC = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "QuestionMarkCircle/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), zC = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Search/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
})), ld = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Upload/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4 16v1a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1m-4-8-4-4m0 0L8 8m4-4v12"
})), YC = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "XCircle/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m10 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m7-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), sp = (t) => /* @__PURE__ */ S.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "X/outline"
}, t), /* @__PURE__ */ S.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6 18 18 6M6 6l12 12"
})), UC = Kt(
  "relative flex items-center flex-shrink-0 w-full p-4 rounded-md overflow-hidden",
  {
    variants: {
      state: {
        success: "",
        danger: "",
        informative: "",
        warning: "",
        neutral: ""
      },
      contrast: {
        low: "border text-foundations-boldest [&_.icon]:w-5 [&_.icon]:h-5 [&_.icon_svg]:w-4 [&_.icon_svg]:h-4 [&_.close-btn]:text-foundations-subtle",
        medium: "text-foundations-inverse shadow-2 [&_.icon]:w-8 [&_.icon]:h-8 [&_.icon_svg]:w-6 [&_.icon_svg]:h-6"
      },
      fullWidth: {
        true: "",
        false: "max-w-[25rem]"
      }
    },
    defaultVariants: {
      state: "informative",
      contrast: "low",
      fullWidth: !1
    },
    compoundVariants: [
      {
        state: "success",
        contrast: "low",
        className: "bg-success-subtler border-success-subtle [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "low",
        className: "bg-danger-subtler border-danger-subtle [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "low",
        className: "bg-info-subtler border-info-subtle [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "low",
        className: "bg-warning-subtler border-warning-subtle [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "neutral",
        contrast: "low",
        className: "bg-foundations-subtlest border-foundations-bold [&_.icon]:bg-foundations-subtler [&_.icon]:text-foundations-inverse"
      },
      {
        state: "success",
        contrast: "medium",
        className: "bg-success-subtle text-foundations-boldest [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "medium",
        className: "bg-danger-subtle text-foundations-boldest [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "medium",
        className: "bg-info-subtle text-foundations-boldest [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "medium",
        className: "bg-warning-subtle text-foundations-boldest [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      }
    ]
  }
), GC = S.forwardRef(
  ({
    title: t,
    state: e = "neutral",
    contrast: n,
    fullWidth: r,
    className: o,
    onClose: i,
    actions: s,
    Icon: a,
    ...l
  }, c) => /* @__PURE__ */ Z(
    "div",
    {
      ref: c,
      className: ye(UC({ state: e, contrast: n, fullWidth: r }), o),
      ...l,
      children: [
        /* @__PURE__ */ _(ap, { state: e, CustomIcon: a }),
        /* @__PURE__ */ _("div", { className: "ml-4 flex-1", children: /* @__PURE__ */ _("div", { className: "text-sm font-medium", children: t }) }),
        s && /* @__PURE__ */ _("div", { className: "ml-4 space-x-2", children: s }),
        i && /* @__PURE__ */ _(
          "button",
          {
            onClick: i,
            className: "close-btn ml-2 flex-shrink-0 rounded-sm hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
            children: /* @__PURE__ */ _(sp, { className: "h-4 w-4 " })
          }
        )
      ]
    }
  )
);
GC.displayName = "Alert";
const KC = {
  success: cs,
  danger: sp,
  informative: BC,
  warning: ad,
  neutral: ad
}, ap = ({
  state: t,
  CustomIcon: e
}) => {
  const n = KC[t];
  return /* @__PURE__ */ _("div", { className: "icon flex flex-shrink-0 items-center justify-center rounded-full", children: e ? /* @__PURE__ */ _(e, {}) : /* @__PURE__ */ _(n, {}) });
};
ap.displayName = "AlertIcon";
const qC = S.forwardRef(
  ({ asChild: t, className: e, disableHover: n, ...r }, o) => /* @__PURE__ */ _(
    t ? zt : "div",
    {
      ref: o,
      className: ye(
        "block rounded-lg border border-foundations-subtle bg-foundations-default p-4 transition-colors focus:border-info-bold focus:outline-none focus:ring-1 focus:ring-info-bold [&:has(.link-overlay:focus)]:border-info-bold [&:has(.link-overlay:focus)]:ring-1 [&:has(.link-overlay:focus)]:ring-info-bold",
        !n && "hover:border-foundations-bold hover:shadow-3",
        e
      ),
      ...r
    }
  )
);
qC.displayName = "Card";
const XC = S.forwardRef(
  ({ asChild: t, className: e, ...n }, r) => /* @__PURE__ */ _(
    t ? zt : "div",
    {
      ref: r,
      className: ye(
        "relative [&_button]:relative [&_button]:z-[1] [&_a:not(.link-overlay)]:relative [&_a:not(.link-overlay)]:z-[1]",
        e
      ),
      ...n
    }
  )
);
XC.displayName = "LinkBox";
const ZC = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ _(
  "a",
  {
    ref: n,
    className: ye(
      "link-overlay before:absolute before:inset-0 focus:outline-none",
      t
    ),
    ...e
  }
));
ZC.displayName = "LinkOverlay";
const QC = (t) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 66,
    viewBox: "0 0 184 150",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/08", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Mask Group 3", children: [
        /* @__PURE__ */ Z("g", { id: "Group 26805", children: [
          /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
            "path",
            {
              id: "Path 25918",
              d: "M39.5 30.6754C38.3371 30.9512 37.2627 31.5449 36.4038 32.4038C35.1848 33.6228 34.5 35.2761 34.5 37V62C34.5 63.7239 35.1848 65.3772 36.4038 66.5962C37.6228 67.8152 39.2761 68.5 41 68.5H176C177.724 68.5 179.377 67.8152 180.596 66.5962C181.815 65.3772 182.5 63.7239 182.5 62V37C182.5 35.2761 181.815 33.6228 180.596 32.4038C179.377 31.1848 177.724 30.5 176 30.5H41H39.5V30.6754Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ Z("g", { id: "Group 26775", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5617",
                d: "M105 40H79C77.3431 40 76 41.3431 76 43C76 44.6569 77.3431 46 79 46H105C106.657 46 108 44.6569 108 43C108 41.3431 106.657 40 105 40Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5618",
                d: "M123 53H79C77.3431 53 76 54.3431 76 56C76 57.6569 77.3431 59 79 59H123C124.657 59 126 57.6569 126 56C126 54.3431 124.657 53 123 53Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ Z("g", { id: "Group 26804", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5624",
                d: "M68 49.5C68 41.4919 61.5081 35 53.5 35C45.4919 35 39 41.4919 39 49.5C39 57.5081 45.4919 64 53.5 64C61.5081 64 68 57.5081 68 49.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _("g", { id: "bx-search", children: /* @__PURE__ */ _(
              "path",
              {
                id: "Path 25920",
                d: "M52.6007 54.194C53.842 54.1939 55.0477 53.7785 56.0257 53.014L59.1007 56.089L60.0897 55.1L57.0137 52.024C57.7865 51.0248 58.1981 49.7934 58.1815 48.5303C58.1648 47.2672 57.7208 46.047 56.9219 45.0686C56.123 44.0901 55.0162 43.4111 53.782 43.1422C52.5478 42.8733 51.2588 43.0303 50.1253 43.5877C48.9917 44.1451 48.0804 45.07 47.5398 46.2117C46.9992 47.3533 46.8612 48.6444 47.1483 49.8746C47.4354 51.1047 48.1306 52.2013 49.1208 52.9857C50.1109 53.7701 51.3375 54.196 52.6007 54.194ZM52.6007 44.4C53.4314 44.4 54.2434 44.6464 54.9341 45.1079C55.6248 45.5694 56.1631 46.2253 56.481 46.9928C56.7989 47.7602 56.8821 48.6047 56.72 49.4194C56.5579 50.2341 56.1579 50.9825 55.5705 51.5699C54.9832 52.1573 54.2348 52.5573 53.4201 52.7193C52.6054 52.8814 51.7609 52.7982 50.9934 52.4803C50.226 52.1624 49.57 51.6241 49.1085 50.9334C48.647 50.2427 48.4007 49.4307 48.4007 48.6C48.4007 47.4861 48.8432 46.4178 49.6308 45.6302C50.4185 44.8425 51.4868 44.4 52.6007 44.4Z",
                className: "fill-[theme(backgroundColor.foundations-default)]"
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 26784", children: [
          /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5623",
              d: "M161 81.5H26C22.4101 81.5 19.5 84.4101 19.5 88V113C19.5 116.59 22.4101 119.5 26 119.5H161C164.59 119.5 167.5 116.59 167.5 113V88C167.5 84.4102 164.59 81.5 161 81.5Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ Z("g", { id: "Group 26775_2", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5617_2",
                d: "M90 91H64C62.3431 91 61 92.3431 61 94C61 95.6569 62.3431 97 64 97H90C91.6569 97 93 95.6569 93 94C93 92.3431 91.6569 91 90 91Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5618_2",
                d: "M108 104H64C62.3431 104 61 105.343 61 107C61 108.657 62.3431 110 64 110H108C109.657 110 111 108.657 111 107C111 105.343 109.657 104 108 104Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ Z("g", { id: "Group 26807", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5624_2",
                d: "M53 100.5C53 92.4919 46.5081 86 38.5 86C30.4919 86 24 92.4919 24 100.5C24 108.508 30.4919 115 38.5 115C46.5081 115 53 108.508 53 100.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _("g", { id: "bx-search_2", children: /* @__PURE__ */ _(
              "path",
              {
                id: "Path 25920_2",
                d: "M37.6007 105.194C38.842 105.194 40.0477 104.778 41.0257 104.014L44.1007 107.089L45.0897 106.1L42.0137 103.024C42.7865 102.025 43.1981 100.793 43.1815 99.5303C43.1648 98.2672 42.7208 97.047 41.9219 96.0686C41.123 95.0901 40.0162 94.4111 38.782 94.1422C37.5478 93.8733 36.2588 94.0303 35.1253 94.5877C33.9917 95.1451 33.0804 96.07 32.5398 97.2117C31.9992 98.3533 31.8612 99.6444 32.1483 100.875C32.4354 102.105 33.1306 103.201 34.1208 103.986C35.1109 104.77 36.3375 105.196 37.6007 105.194ZM37.6007 95.4C38.4314 95.4 39.2434 95.6464 39.9341 96.1079C40.6248 96.5694 41.1631 97.2253 41.481 97.9928C41.7989 98.7602 41.8821 99.6047 41.72 100.419C41.5579 101.234 41.1579 101.983 40.5705 102.57C39.9832 103.157 39.2348 103.557 38.4201 103.719C37.6054 103.881 36.7609 103.798 35.9934 103.48C35.226 103.162 34.57 102.624 34.1085 101.933C33.647 101.243 33.4007 100.431 33.4007 99.6C33.4007 98.4861 33.8432 97.4178 34.6308 96.6302C35.4185 95.8425 36.4868 95.4 37.6007 95.4Z",
                fill: "white"
              }
            ) })
          ] })
        ] })
      ] })
    ] })
  }
), lp = (t) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 150 153",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/07", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Subtraction 1",
          d: "M109.755 47.2509L109.748 47.2439C108.398 45.9026 107.328 44.3068 106.599 42.549C106.102 41.3514 105.77 40.0949 105.61 38.8138C105.395 37.0834 103.972 35.5 101.996 35.5H47.9978C46.0262 35.5 44.6038 37.0766 44.3853 38.8043C43.9832 41.9829 42.5372 44.9584 40.2478 47.2478C37.9584 49.5372 34.9829 50.9832 31.8043 51.3853C30.0766 51.6038 28.5 53.0262 28.5 54.9978V148C28.5 149.933 30.067 151.5 32 151.5H118C119.933 151.5 121.5 149.933 121.5 148V55.0044C121.5 53.0279 119.916 51.6052 118.186 51.3897C116.905 51.2301 115.648 50.8984 114.45 50.4015C112.692 49.6721 111.097 48.6013 109.755 47.2509Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 665",
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "ic_add_48px", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Path 25936",
          d: "M84.8995 87.8997C84.1184 88.6807 82.8521 88.6807 82.0711 87.8997L76.4142 82.2428C75.6332 81.4618 74.3668 81.4618 73.5858 82.2428L67.9289 87.8997C67.1479 88.6807 65.8816 88.6807 65.1005 87.8997C64.3195 87.1186 64.3195 85.8523 65.1005 85.0712L70.7574 79.4144C71.5384 78.6333 71.5384 77.367 70.7574 76.5859L65.1005 70.9291C64.3195 70.148 64.3195 68.8817 65.1005 68.1007C65.8816 67.3196 67.1479 67.3196 67.9289 68.1007L73.5858 73.7575C74.3668 74.5386 75.6332 74.5386 76.4142 73.7575L82.0711 68.1007C82.8521 67.3196 84.1184 67.3196 84.8995 68.1007C85.6805 68.8817 85.6805 70.148 84.8995 70.9291L79.2426 76.5859C78.4616 77.367 78.4616 78.6333 79.2426 79.4144L84.8995 85.0712C85.6805 85.8523 85.6805 87.1186 84.8995 87.8997Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5617",
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5618",
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      )
    ] })
  }
), E8 = (t) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/10", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Group 1489", children: [
        /* @__PURE__ */ Z("g", { id: "Group 3", children: [
          /* @__PURE__ */ _(
            "rect",
            {
              id: "Rectangle 1",
              x: 34,
              y: 46,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "circle",
            {
              id: "Ellipse 1",
              cx: 68,
              cy: 65,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 1", children: [
          /* @__PURE__ */ _(
            "rect",
            {
              id: "Rectangle 1_2",
              x: 49,
              y: 65,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "circle",
            {
              id: "Ellipse 1_2",
              cx: 83,
              cy: 84,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-default)]"
            }
          )
        ] })
      ] })
    ] })
  }
), k8 = (t) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 168,
    viewBox: "0 0 194 168",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/01", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5625",
          d: "M159 0H39C33.4772 0 29 5.37258 29 12V156C29 162.627 33.4772 168 39 168H159C164.523 168 169 162.627 169 156V12C169 5.37258 164.523 0 159 0Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Group 26800", children: [
        /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25918",
            d: "M49.5 64.6754C48.3371 64.9512 47.2627 65.5449 46.4038 66.4038C45.1848 67.6228 44.5 69.2761 44.5 71V96C44.5 97.7239 45.1848 99.3772 46.4038 100.596C47.6228 101.815 49.2761 102.5 51 102.5H186C187.724 102.5 189.377 101.815 190.596 100.596C191.815 99.3772 192.5 97.7239 192.5 96V71C192.5 69.2761 191.815 67.6228 190.596 66.4038C189.377 65.1848 187.724 64.5 186 64.5H51H49.5V64.6754Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617",
              d: "M125 74H99C97.3431 74 96 75.3431 96 77C96 78.6569 97.3431 80 99 80H125C126.657 80 128 78.6569 128 77C128 75.3431 126.657 74 125 74Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618",
              d: "M143 87H99C97.3431 87 96 88.3431 96 90C96 91.6569 97.3431 93 99 93H143C144.657 93 146 91.6569 146 90C146 88.3431 144.657 87 143 87Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26799", children: /* @__PURE__ */ _("g", { id: "Group 26756", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 647",
            d: "M76.5 93C81.7467 93 86 88.7467 86 83.5C86 78.2533 81.7467 74 76.5 74C71.2533 74 67 78.2533 67 83.5C67 88.7467 71.2533 93 76.5 93Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26798", children: [
        /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25919",
            d: "M6.5 112.675C5.33714 112.951 4.26267 113.545 3.40381 114.404C2.18482 115.623 1.5 117.276 1.5 119V144C1.5 145.724 2.18482 147.377 3.40381 148.596C4.62279 149.815 6.27609 150.5 8 150.5H143C144.724 150.5 146.377 149.815 147.596 148.596C148.815 147.377 149.5 145.724 149.5 144V119C149.5 117.276 148.815 115.623 147.596 114.404C146.377 113.185 144.724 112.5 143 112.5H8H6.5V112.675Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775_2", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M68 122H42C40.3431 122 39 123.343 39 125C39 126.657 40.3431 128 42 128H68C69.6569 128 71 126.657 71 125C71 123.343 69.6569 122 68 122Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M86 135H42C40.3431 135 39 136.343 39 138C39 139.657 40.3431 141 42 141H86C87.6569 141 89 139.657 89 138C89 136.343 87.6569 135 86 135Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26796", children: /* @__PURE__ */ _("g", { id: "Group 26757", children: /* @__PURE__ */ _("g", { id: "Ellipse 648", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Vector",
            d: "M20.5 141C25.7467 141 30 136.747 30 131.5C30 126.253 25.7467 122 20.5 122C15.2533 122 11 126.253 11 131.5C11 136.747 15.2533 141 20.5 141Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) }) })
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26802", children: [
        /* @__PURE__ */ _("g", { id: "Group_3", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5623",
            d: "M143 16.5H8C4.41015 16.5 1.5 19.4101 1.5 23V48C1.5 51.5899 4.41015 54.5 8 54.5H143C146.59 54.5 149.5 51.5899 149.5 48V23C149.5 19.4102 146.59 16.5 143 16.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775_3", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M80 26H54C52.3431 26 51 27.3431 51 29C51 30.6569 52.3431 32 54 32H80C81.6569 32 83 30.6569 83 29C83 27.3431 81.6569 26 80 26Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M98 39H54C52.3431 39 51 40.3431 51 42C51 43.6569 52.3431 45 54 45H98C99.6569 45 101 43.6569 101 42C101 40.3431 99.6569 39 98 39Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26801", children: /* @__PURE__ */ _("g", { id: "Group 26756_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 647_2",
            d: "M33.5 45C38.7467 45 43 40.7467 43 35.5C43 30.2533 38.7467 26 33.5 26C28.2533 26 24 30.2533 24 35.5C24 40.7467 28.2533 45 33.5 45Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] })
    ] })
  }
), M8 = (t) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 169,
    viewBox: "0 0 150 169",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/02", children: [
      /* @__PURE__ */ Z("g", { id: "Mask Group 1", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 652",
            d: "M75 158C116.421 158 150 124.421 150 83C150 41.5786 116.421 8 75 8C33.5786 8 0 41.5786 0 83C0 124.421 33.5786 158 75 158Z",
            className: "fill-[theme(backgroundColor.foundations-subtler)]"
          }
        ),
        /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5615",
            d: "M118 49.5H32C28.4101 49.5 25.5 52.4101 25.5 56V161C25.5 164.59 28.4101 167.5 32 167.5H118C121.59 167.5 124.5 164.59 124.5 161V56C124.5 52.4101 121.59 49.5 118 49.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26776", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617",
              d: "M65 66H39C37.3431 66 36 67.3431 36 69C36 70.6569 37.3431 72 39 72H65C66.6569 72 68 70.6569 68 69C68 67.3431 66.6569 66 65 66Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618",
              d: "M83 79H39C37.3431 79 36 80.3431 36 82C36 83.6569 37.3431 85 39 85H83C84.6569 85 86 83.6569 86 82C86 80.3431 84.6569 79 83 79Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 26777", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M65 93H39C37.3431 93 36 94.3431 36 96C36 97.6569 37.3431 99 39 99H65C66.6569 99 68 97.6569 68 96C68 94.3431 66.6569 93 65 93Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M83 106H39C37.3431 106 36 107.343 36 109C36 110.657 37.3431 112 39 112H83C84.6569 112 86 110.657 86 109C86 107.343 84.6569 106 83 106Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 26778", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M65 120H39C37.3431 120 36 121.343 36 123C36 124.657 37.3431 126 39 126H65C66.6569 126 68 124.657 68 123C68 121.343 66.6569 120 65 120Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M83 133H39C37.3431 133 36 134.343 36 136C36 137.657 37.3431 139 39 139H83C84.6569 139 86 137.657 86 136C86 134.343 84.6569 133 83 133Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26779", children: [
        /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5616",
            d: "M118 0H32C29.2386 0 27 2.23858 27 5V35C27 37.7614 29.2386 40 32 40H118C120.761 40 123 37.7614 123 35V5C123 2.23858 120.761 0 118 0Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_4",
              d: "M65 11H39C37.3431 11 36 12.3431 36 14C36 15.6569 37.3431 17 39 17H65C66.6569 17 68 15.6569 68 14C68 12.3431 66.6569 11 65 11Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_4",
              d: "M83 24H39C37.3431 24 36 25.3431 36 27C36 28.6569 37.3431 30 39 30H83C84.6569 30 86 28.6569 86 27C86 25.3431 84.6569 24 83 24Z",
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] })
      ] })
    ] })
  }
), O8 = (t) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 169,
    viewBox: "0 0 158 169",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/03", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 652",
          d: "M79 158C122.63 158 158 122.63 158 79C158 35.3695 122.63 0 79 0C35.3695 0 0 35.3695 0 79C0 122.63 35.3695 158 79 158Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _("g", { id: "Mask Group", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5615",
          d: "M122 49.5H36C32.4101 49.5 29.5 52.4101 29.5 56V161C29.5 164.59 32.4101 167.5 36 167.5H122C125.59 167.5 128.5 164.59 128.5 161V56C128.5 52.4101 125.59 49.5 122 49.5Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ) }) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5617",
          d: "M70 61H44C42.3431 61 41 62.3431 41 64C41 65.6569 42.3431 67 44 67H70C71.6569 67 73 65.6569 73 64C73 62.3431 71.6569 61 70 61Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5620",
          d: "M70 103H44C42.3431 103 41 104.343 41 106C41 107.657 42.3431 109 44 109H70C71.6569 109 73 107.657 73 106C73 104.343 71.6569 103 70 103Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "Rectangle 5618", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Vector",
          d: "M112 76H46C43.7909 76 42 77.7909 42 80V90C42 92.2091 43.7909 94 46 94H112C114.209 94 116 92.2091 116 90V80C116 77.7909 114.209 76 112 76Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5619",
          d: "M112 117H46C43.2386 117 41 119.239 41 122V130C41 132.761 43.2386 135 46 135H112C114.761 135 117 132.761 117 130V122C117 119.239 114.761 117 112 117Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Group 26781", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 654",
            d: "M57 40C59.2091 40 61 38.2091 61 36C61 33.7909 59.2091 32 57 32C54.7909 32 53 33.7909 53 36C53 38.2091 54.7909 40 57 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 655",
            d: "M79 40C81.2091 40 83 38.2091 83 36C83 33.7909 81.2091 32 79 32C76.7909 32 75 33.7909 75 36C75 38.2091 76.7909 40 79 40Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 656",
            d: "M101 40C103.209 40 105 38.2091 105 36C105 33.7909 103.209 32 101 32C98.7909 32 97 33.7909 97 36C97 38.2091 98.7909 40 101 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        )
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26782", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 658",
            d: "M90 96C92.7614 96 95 93.7614 95 91C95 88.2386 92.7614 86 90 86C87.2386 86 85 88.2386 85 91C85 93.7614 87.2386 96 90 96Z",
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25916",
            d: "M93.9071 112.37C93.1071 112.37 92.3601 112.37 91.6801 112.327C90.8425 112.27 90.0367 111.984 89.3515 111.499C88.6662 111.014 88.128 110.349 87.7961 109.578L83.5771 101.24C83.2676 100.88 83.1131 100.412 83.1472 99.938C83.1813 99.4643 83.4012 99.0233 83.7591 98.711C84.0522 98.4754 84.418 98.3485 84.7941 98.352C85.071 98.3601 85.3428 98.4281 85.5909 98.5513C85.839 98.6746 86.0574 98.8502 86.2311 99.066L88.1471 101.681L88.1761 101.715V91.78C88.1761 91.2871 88.3719 90.8144 88.7204 90.4659C89.069 90.1173 89.5417 89.9215 90.0346 89.9215C90.5275 89.9215 91.0002 90.1173 91.3487 90.4659C91.6973 90.8144 91.8931 91.2871 91.8931 91.78V98.28C91.8715 98.0408 91.9 97.7998 91.9767 97.5722C92.0534 97.3446 92.1767 97.1355 92.3387 96.9582C92.5007 96.781 92.6979 96.6394 92.9176 96.5425C93.1374 96.4456 93.3749 96.3956 93.6151 96.3956C93.8552 96.3956 94.0928 96.4456 94.3125 96.5425C94.5323 96.6394 94.7294 96.781 94.8914 96.9582C95.0534 97.1355 95.1767 97.3446 95.2535 97.5722C95.3302 97.7998 95.3587 98.0408 95.3371 98.28V99.635C95.3155 99.3958 95.344 99.1548 95.4207 98.9272C95.4974 98.6996 95.6207 98.4905 95.7827 98.3132C95.9447 98.136 96.1419 97.9944 96.3616 97.8975C96.5814 97.8006 96.8189 97.7506 97.0591 97.7506C97.2992 97.7506 97.5368 97.8006 97.7565 97.8975C97.9763 97.9944 98.1734 98.136 98.3354 98.3132C98.4974 98.4905 98.6207 98.6996 98.6975 98.9272C98.7742 99.1548 98.8027 99.3958 98.7811 99.635V100.679C98.7595 100.44 98.788 100.199 98.8647 99.9712C98.9414 99.7436 99.0647 99.5345 99.2267 99.3572C99.3887 99.18 99.5859 99.0384 99.8056 98.9415C100.025 98.8446 100.263 98.7946 100.503 98.7946C100.743 98.7946 100.981 98.8446 101.201 98.9415C101.42 99.0384 101.617 99.18 101.779 99.3572C101.941 99.5345 102.065 99.7436 102.141 99.9712C102.218 100.199 102.247 100.44 102.225 100.679V107.016C102.191 108.965 101.31 112.251 98.2111 112.251C97.9861 112.261 96.0801 112.371 93.9111 112.371L93.9071 112.37Z",
            className: "fill-[theme(backgroundColor.foundations-bold)] stroke-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] })
    ] })
  }
), P8 = (t) => /* @__PURE__ */ Z(
  "svg",
  {
    width: "150",
    height: "150",
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _(
        "path",
        {
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M120 150H30V53C34.242 52.9952 38.3089 51.308 41.3084 48.3085C44.308 45.3089 45.9952 41.242 46 37H104C103.996 39.1014 104.408 41.1828 105.213 43.1238C106.018 45.0648 107.2 46.8268 108.691 48.308C110.172 49.7991 111.934 50.9816 113.875 51.787C115.817 52.5924 117.898 53.0047 120 53V150Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ _("g", { clipPath: "url(#clip0_22879_245463)", children: /* @__PURE__ */ _(
        "path",
        {
          d: "M73.4 66.7992C73.4 65.9156 74.1163 65.1992 75 65.1992C75.8837 65.1992 76.6 65.9156 76.6 66.7992V75.5992C76.6 76.041 76.9582 76.3992 77.4 76.3992C77.8418 76.3992 78.2 76.041 78.2 75.5992V68.3992C78.2 67.5156 78.9163 66.7992 79.8 66.7992C80.6837 66.7992 81.4 67.5156 81.4 68.3992V75.5992C81.4 76.041 81.7582 76.3992 82.2 76.3992C82.6418 76.3992 83 76.041 83 75.5992V71.5992C83 70.7156 83.7163 69.9992 84.6 69.9992C85.4837 69.9992 86.2 70.7156 86.2 71.5992V79.5992C86.2 85.7848 81.1856 90.7992 75 90.7992C68.8144 90.7992 63.8 85.7848 63.8 79.5992V76.3992C63.8 75.5156 64.5163 74.7992 65.4 74.7992C66.2837 74.7992 67 75.5156 67 76.3992V80.3992C67 80.841 67.3582 81.1992 67.8 81.1992C68.2418 81.1992 68.6 80.841 68.6 80.3992V68.3992C68.6 67.5156 69.3163 66.7992 70.2 66.7992C71.0837 66.7992 71.8 67.5156 71.8 68.3992V75.5992C71.8 76.041 72.1582 76.3992 72.6 76.3992C73.0418 76.3992 73.4 76.041 73.4 75.5992V66.7992Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ _("clipPath", { id: "clip0_22879_245463", children: /* @__PURE__ */ _(
        "rect",
        {
          width: "32",
          height: "32",
          className: "fill-[theme(backgroundColor.foundations-default)]",
          transform: "translate(59 62)"
        }
      ) }) })
    ]
  }
), cp = de(
  ({
    type: t,
    value: e,
    defaultValue: n,
    name: r,
    label: o,
    helpText: i,
    onChange: s,
    icon: a,
    className: l,
    containerClassName: c,
    ...u
  }, d) => /* @__PURE__ */ Z("div", { className: c, children: [
    o && /* @__PURE__ */ _(
      "label",
      {
        htmlFor: r,
        className: "mb-4 block text-sm font-medium text-foundations-bold",
        children: o
      }
    ),
    /* @__PURE__ */ Z("div", { className: "relative block", children: [
      /* @__PURE__ */ _(
        "input",
        {
          type: t || "text",
          name: r,
          id: r,
          ref: d,
          defaultValue: n,
          value: e,
          placeholder: "Type your method...",
          onChange: (f) => s(f.currentTarget.value, f),
          className: ye(
            "peer block w-full min-w-0 flex-1 rounded-md border-foundations-bold bg-foundations-default text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:outline-none focus:ring-info-bold sm:text-sm",
            a ? "pl-8" : "",
            l
          ),
          ...u
        }
      ),
      /* @__PURE__ */ _("span", { className: "absolute inset-y-0 left-2 flex transform items-center text-foundations-subtler peer-focus:text-blue-500 pointer-events-none", children: a })
    ] }),
    i && /* @__PURE__ */ _(
      "p",
      {
        className: "mt-2 text-sm text-foundations-subtler",
        id: "email-description",
        children: i
      }
    )
  ] })
);
cp.displayName = "Input";
function JC(t) {
  return (e) => {
    t.forEach((n) => {
      typeof n == "function" ? n(e) : n != null && (n.current = e);
    });
  };
}
const up = S.forwardRef(
  ({ className: t, label: e, description: n, isIndeterminate: r = !1, ...o }, i) => {
    const s = S.useRef(null);
    return S.useEffect(() => {
      s.current && (s.current.indeterminate = r);
    }, [r]), /* @__PURE__ */ Z("label", { className: "flex space-x-2", children: [
      /* @__PURE__ */ _(
        "input",
        {
          ref: JC([s, i]),
          className: ye(
            "cursor-pointer rounded checked:bg-foundations-boldest indeterminate:bg-foundations-boldest hover:checked:bg-foundations-inverse hover:indeterminate:bg-foundations-inverse focus:ring-2 focus:ring-info-bold focus:ring-offset-0 focus:checked:bg-foundations-boldest focus:indeterminate:bg-foundations-boldest",
            e && "mt-0.5",
            t
          ),
          type: "checkbox",
          ...o
        }
      ),
      (e || n) && /* @__PURE__ */ Z("div", { className: "flex flex-col text-sm", children: [
        e && /* @__PURE__ */ _("span", { className: "font-medium text-foundations-boldest", children: e }),
        n && /* @__PURE__ */ _("span", { className: "text-foundations-subtle", children: n })
      ] })
    ] });
  }
);
up.displayName = "Checkbox";
function e5(t) {
  const e = le({
    value: t,
    previous: t
  });
  return rr(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [
    t
  ]);
}
const dp = "Switch", [t5, S8] = sn(dp), [n5, r5] = t5(dp), o5 = /* @__PURE__ */ de((t, e) => {
  const { __scopeSwitch: n, name: r, checked: o, defaultChecked: i, required: s, disabled: a, value: l = "on", onCheckedChange: c, ...u } = t, [d, f] = ke(null), h = et(
    e,
    (b) => f(b)
  ), p = le(!1), g = d ? !!d.closest("form") : !0, [m = !1, v] = Wn({
    prop: o,
    defaultProp: i,
    onChange: c
  });
  return /* @__PURE__ */ A(n5, {
    scope: n,
    checked: m,
    disabled: a
  }, /* @__PURE__ */ A(je.button, ne({
    type: "button",
    role: "switch",
    "aria-checked": m,
    "aria-required": s,
    "data-state": fp(m),
    "data-disabled": a ? "" : void 0,
    disabled: a,
    value: l
  }, u, {
    ref: h,
    onClick: ve(t.onClick, (b) => {
      v(
        (y) => !y
      ), g && (p.current = b.isPropagationStopped(), p.current || b.stopPropagation());
    })
  })), g && /* @__PURE__ */ A(a5, {
    control: d,
    bubbles: !p.current,
    name: r,
    value: l,
    checked: m,
    required: s,
    disabled: a,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), i5 = "SwitchThumb", s5 = /* @__PURE__ */ de((t, e) => {
  const { __scopeSwitch: n, ...r } = t, o = r5(i5, n);
  return /* @__PURE__ */ A(je.span, ne({
    "data-state": fp(o.checked),
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: e
  }));
}), a5 = (t) => {
  const { control: e, checked: n, bubbles: r = !0, ...o } = t, i = le(null), s = e5(n), a = rl(e);
  return ue(() => {
    const l = i.current, c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (s !== n && d) {
      const f = new Event("click", {
        bubbles: r
      });
      d.call(l, n), l.dispatchEvent(f);
    }
  }, [
    s,
    n,
    r
  ]), /* @__PURE__ */ A("input", ne({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: n
  }, o, {
    tabIndex: -1,
    ref: i,
    style: {
      ...t.style,
      ...a,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function fp(t) {
  return t ? "checked" : "unchecked";
}
const l5 = o5, c5 = s5, D8 = S.forwardRef(({ className: t, children: e, ...n }, r) => /* @__PURE__ */ Z(
  l5,
  {
    ref: r,
    className: ye(
      "group/switch relative h-6 w-11 rounded-full border-2 border-transparent bg-neutral-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-[theme(backgroundColor.foundations-default)] disabled:cursor-not-allowed data-[state=checked]:bg-blue-500 [[data-theme=dark]_&]:bg-neutral-300",
      e && "w-14",
      t
    ),
    ...n,
    children: [
      e && /* @__PURE__ */ _("span", { className: "absolute inset-y-0 left-auto right-1 z-0 inline-flex items-center text-xs font-medium tracking-wider text-foundations-subtle group-data-[state=checked]/switch:left-1 group-data-[state=checked]/switch:right-auto group-data-[state=checked]/switch:text-neutral-white", children: e }),
      /* @__PURE__ */ _(
        c5,
        {
          className: ye(
            "thumb block h-5 w-5 translate-x-0 rounded-full bg-white transition-transform duration-200 will-change-transform",
            e ? "data-[state=checked]:translate-x-8" : "data-[state=checked]:translate-x-5"
          )
        }
      )
    ]
  }
)), u5 = S.forwardRef(
  ({ className: t, label: e, description: n, ...r }, o) => /* @__PURE__ */ Z("label", { className: "flex space-x-2", children: [
    /* @__PURE__ */ _(
      "input",
      {
        ref: o,
        className: ye(
          "cursor-pointer border-foundations-subtle checked:border-neutral-700 checked:bg-neutral-700 hover:border-neutral-300 hover:checked:bg-neutral-800 focus:border-neutral-100 focus:checked:bg-neutral-700",
          e && "mt-0.5",
          t
        ),
        type: "radio",
        ...r
      }
    ),
    /* @__PURE__ */ Z("div", { className: "flex flex-col text-sm", children: [
      e && /* @__PURE__ */ _("span", { className: "font-medium text-foundations-bolder", children: e }),
      n && /* @__PURE__ */ _("span", { className: "text-foundations-subtle", children: n })
    ] })
  ] })
);
u5.displayName = "Radio";
const d5 = Kt(
  "group/link inline-flex items-center space-x-1 font-medium focus:text-info",
  {
    variants: {
      variant: {
        inline: "underline text-info hover:text-link-hovered",
        standalone: "text-info hover:text-link-hovered hover:underline focus:underline"
      },
      size: {
        sm: "text-xs",
        md: "text-sm",
        lg: "text-base"
      }
    },
    defaultVariants: {
      size: "md",
      variant: "standalone"
    }
  }
), f5 = S.forwardRef(
  ({ className: t, children: e, size: n, variant: r = "standalone", ...o }, i) => /* @__PURE__ */ Z(
    "a",
    {
      ref: i,
      className: ye(d5({ variant: r, size: n }), t),
      ...o,
      children: [
        /* @__PURE__ */ _("span", { children: e }),
        /* @__PURE__ */ _(VC, { className: "h-4 w-4 flex-shrink-0" })
      ]
    }
  )
);
f5.displayName = "Link";
function hp(t) {
  const e = t + "CollectionProvider", [n, r] = sn(e), [o, i] = n(e, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), s = (h) => {
    const { scope: p, children: g } = h, m = P.useRef(null), v = P.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ P.createElement(o, {
      scope: p,
      itemMap: v,
      collectionRef: m
    }, g);
  }, a = t + "CollectionSlot", l = /* @__PURE__ */ P.forwardRef((h, p) => {
    const { scope: g, children: m } = h, v = i(a, g), b = et(p, v.collectionRef);
    return /* @__PURE__ */ P.createElement(zt, {
      ref: b
    }, m);
  }), c = t + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ P.forwardRef((h, p) => {
    const { scope: g, children: m, ...v } = h, b = P.useRef(null), y = et(p, b), w = i(c, g);
    return P.useEffect(() => (w.itemMap.set(b, {
      ref: b,
      ...v
    }), () => void w.itemMap.delete(b))), /* @__PURE__ */ P.createElement(zt, {
      [u]: "",
      ref: y
    }, m);
  });
  function f(h) {
    const p = i(t + "CollectionConsumer", h);
    return P.useCallback(() => {
      const m = p.collectionRef.current;
      if (!m)
        return [];
      const v = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (w, x) => v.indexOf(w.ref.current) - v.indexOf(x.ref.current)
      );
    }, [
      p.collectionRef,
      p.itemMap
    ]);
  }
  return [
    {
      Provider: s,
      Slot: l,
      ItemSlot: d
    },
    f,
    r
  ];
}
const h5 = /* @__PURE__ */ At(void 0);
function Tl(t) {
  const e = Gt(h5);
  return t || e || "ltr";
}
const Ls = "rovingFocusGroup.onEntryFocus", p5 = {
  bubbles: !1,
  cancelable: !0
}, Il = "RovingFocusGroup", [ka, pp, g5] = hp(Il), [m5, us] = sn(Il, [
  g5
]), [v5, b5] = m5(Il), y5 = /* @__PURE__ */ de((t, e) => /* @__PURE__ */ A(ka.Provider, {
  scope: t.__scopeRovingFocusGroup
}, /* @__PURE__ */ A(ka.Slot, {
  scope: t.__scopeRovingFocusGroup
}, /* @__PURE__ */ A(x5, ne({}, t, {
  ref: e
}))))), x5 = /* @__PURE__ */ de((t, e) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: o = !1, dir: i, currentTabStopId: s, defaultCurrentTabStopId: a, onCurrentTabStopIdChange: l, onEntryFocus: c, ...u } = t, d = le(null), f = et(e, d), h = Tl(i), [p = null, g] = Wn({
    prop: s,
    defaultProp: a,
    onChange: l
  }), [m, v] = ke(!1), b = ht(c), y = pp(n), w = le(!1), [x, M] = ke(0);
  return ue(() => {
    const E = d.current;
    if (E)
      return E.addEventListener(Ls, b), () => E.removeEventListener(Ls, b);
  }, [
    b
  ]), /* @__PURE__ */ A(v5, {
    scope: n,
    orientation: r,
    dir: h,
    loop: o,
    currentTabStopId: p,
    onItemFocus: pe(
      (E) => g(E),
      [
        g
      ]
    ),
    onItemShiftTab: pe(
      () => v(!0),
      []
    ),
    onFocusableItemAdd: pe(
      () => M(
        (E) => E + 1
      ),
      []
    ),
    onFocusableItemRemove: pe(
      () => M(
        (E) => E - 1
      ),
      []
    )
  }, /* @__PURE__ */ A(je.div, ne({
    tabIndex: m || x === 0 ? -1 : 0,
    "data-orientation": r
  }, u, {
    ref: f,
    style: {
      outline: "none",
      ...t.style
    },
    onMouseDown: ve(t.onMouseDown, () => {
      w.current = !0;
    }),
    onFocus: ve(t.onFocus, (E) => {
      const C = !w.current;
      if (E.target === E.currentTarget && C && !m) {
        const O = new CustomEvent(Ls, p5);
        if (E.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
          const R = y().filter(
            (L) => L.focusable
          ), D = R.find(
            (L) => L.active
          ), $ = R.find(
            (L) => L.id === p
          ), j = [
            D,
            $,
            ...R
          ].filter(Boolean).map(
            (L) => L.ref.current
          );
          gp(j);
        }
      }
      w.current = !1;
    }),
    onBlur: ve(
      t.onBlur,
      () => v(!1)
    )
  })));
}), w5 = "RovingFocusGroupItem", _5 = /* @__PURE__ */ de((t, e) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: o = !1, tabStopId: i, ...s } = t, a = po(), l = i || a, c = b5(w5, n), u = c.currentTabStopId === l, d = pp(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = c;
  return ue(() => {
    if (r)
      return f(), () => h();
  }, [
    r,
    f,
    h
  ]), /* @__PURE__ */ A(ka.ItemSlot, {
    scope: n,
    id: l,
    focusable: r,
    active: o
  }, /* @__PURE__ */ A(je.span, ne({
    tabIndex: u ? 0 : -1,
    "data-orientation": c.orientation
  }, s, {
    ref: e,
    onMouseDown: ve(t.onMouseDown, (p) => {
      r ? c.onItemFocus(l) : p.preventDefault();
    }),
    onFocus: ve(
      t.onFocus,
      () => c.onItemFocus(l)
    ),
    onKeyDown: ve(t.onKeyDown, (p) => {
      if (p.key === "Tab" && p.shiftKey) {
        c.onItemShiftTab();
        return;
      }
      if (p.target !== p.currentTarget)
        return;
      const g = k5(p, c.orientation, c.dir);
      if (g !== void 0) {
        p.preventDefault();
        let v = d().filter(
          (b) => b.focusable
        ).map(
          (b) => b.ref.current
        );
        if (g === "last")
          v.reverse();
        else if (g === "prev" || g === "next") {
          g === "prev" && v.reverse();
          const b = v.indexOf(p.currentTarget);
          v = c.loop ? M5(v, b + 1) : v.slice(b + 1);
        }
        setTimeout(
          () => gp(v)
        );
      }
    })
  })));
}), C5 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function E5(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function k5(t, e, n) {
  const r = E5(t.key, n);
  if (!(e === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(e === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return C5[r];
}
function gp(t) {
  const e = document.activeElement;
  for (const n of t)
    if (n === e || (n.focus(), document.activeElement !== e))
      return;
}
function M5(t, e) {
  return t.map(
    (n, r) => t[(e + r) % t.length]
  );
}
const mp = y5, vp = _5, O5 = /* @__PURE__ */ de((t, e) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...i } = t, [s = !1, a] = Wn({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ A(je.button, ne({
    type: "button",
    "aria-pressed": s,
    "data-state": s ? "on" : "off",
    "data-disabled": t.disabled ? "" : void 0
  }, i, {
    ref: e,
    onClick: ve(t.onClick, () => {
      t.disabled || a(!s);
    })
  }));
}), ds = "ToggleGroup", [bp, T8] = sn(ds, [
  us
]), yp = us(), P5 = /* @__PURE__ */ P.forwardRef((t, e) => {
  const { type: n, ...r } = t;
  if (n === "single") {
    const o = r;
    return /* @__PURE__ */ P.createElement(S5, ne({}, o, {
      ref: e
    }));
  }
  if (n === "multiple") {
    const o = r;
    return /* @__PURE__ */ P.createElement(D5, ne({}, o, {
      ref: e
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${ds}\``);
}), [xp, wp] = bp(ds), S5 = /* @__PURE__ */ P.forwardRef((t, e) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...i } = t, [s, a] = Wn({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ P.createElement(xp, {
    scope: t.__scopeToggleGroup,
    type: "single",
    value: s ? [
      s
    ] : [],
    onItemActivate: a,
    onItemDeactivate: P.useCallback(
      () => a(""),
      [
        a
      ]
    )
  }, /* @__PURE__ */ P.createElement(_p, ne({}, i, {
    ref: e
  })));
}), D5 = /* @__PURE__ */ P.forwardRef((t, e) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...i } = t, [s = [], a] = Wn({
    prop: n,
    defaultProp: r,
    onChange: o
  }), l = P.useCallback(
    (u) => a(
      (d = []) => [
        ...d,
        u
      ]
    ),
    [
      a
    ]
  ), c = P.useCallback(
    (u) => a(
      (d = []) => d.filter(
        (f) => f !== u
      )
    ),
    [
      a
    ]
  );
  return /* @__PURE__ */ P.createElement(xp, {
    scope: t.__scopeToggleGroup,
    type: "multiple",
    value: s,
    onItemActivate: l,
    onItemDeactivate: c
  }, /* @__PURE__ */ P.createElement(_p, ne({}, i, {
    ref: e
  })));
}), [T5, I5] = bp(ds), _p = /* @__PURE__ */ P.forwardRef((t, e) => {
  const { __scopeToggleGroup: n, disabled: r = !1, rovingFocus: o = !0, orientation: i, dir: s, loop: a = !0, ...l } = t, c = yp(n), u = Tl(s), d = {
    role: "group",
    dir: u,
    ...l
  };
  return /* @__PURE__ */ P.createElement(T5, {
    scope: n,
    rovingFocus: o,
    disabled: r
  }, o ? /* @__PURE__ */ P.createElement(mp, ne({
    asChild: !0
  }, c, {
    orientation: i,
    dir: u,
    loop: a
  }), /* @__PURE__ */ P.createElement(je.div, ne({}, d, {
    ref: e
  }))) : /* @__PURE__ */ P.createElement(je.div, ne({}, d, {
    ref: e
  })));
}), Ma = "ToggleGroupItem", $5 = /* @__PURE__ */ P.forwardRef((t, e) => {
  const n = wp(Ma, t.__scopeToggleGroup), r = I5(Ma, t.__scopeToggleGroup), o = yp(t.__scopeToggleGroup), i = n.value.includes(t.value), s = r.disabled || t.disabled, a = {
    ...t,
    pressed: i,
    disabled: s
  }, l = P.useRef(null);
  return r.rovingFocus ? /* @__PURE__ */ P.createElement(vp, ne({
    asChild: !0
  }, o, {
    focusable: !s,
    active: i,
    ref: l
  }), /* @__PURE__ */ P.createElement(cd, ne({}, a, {
    ref: e
  }))) : /* @__PURE__ */ P.createElement(cd, ne({}, a, {
    ref: e
  }));
}), cd = /* @__PURE__ */ P.forwardRef((t, e) => {
  const { __scopeToggleGroup: n, value: r, ...o } = t, i = wp(Ma, n), s = {
    role: "radio",
    "aria-checked": t.pressed,
    "aria-pressed": void 0
  }, a = i.type === "single" ? s : void 0;
  return /* @__PURE__ */ P.createElement(O5, ne({}, a, o, {
    ref: e,
    onPressedChange: (l) => {
      l ? i.onItemActivate(r) : i.onItemDeactivate(r);
    }
  }));
}), N5 = P5, R5 = $5, A5 = S.forwardRef(({ onValueChange: t, className: e, canReset: n = !1, error: r, ...o }, i) => /* @__PURE__ */ _(
  N5,
  {
    ref: i,
    className: ye(
      "inline-flex flex-shrink-0 space-x-2 rounded-md border border-foundations-subtle bg-neutral-50 p-1",
      r && "border-red-500 focus:border-red-500 focus:ring-red-500",
      e
    ),
    type: "single",
    onValueChange: (s) => {
      (s || n) && t(s);
    },
    ...o
  }
));
A5.displayName = "OptionsGroup";
const L5 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ _(
  R5,
  {
    ref: n,
    type: "button",
    className: ye(
      "rounded px-2 py-1.5 text-sm font-medium text-foundations-subtle hover:bg-neutral-200 focus:bg-neutral-200 focus:outline-none aria-checked:bg-info-bold aria-checked:text-foundations-inverse aria-checked:focus:bg-info-bolder",
      t
    ),
    ...e
  }
));
L5.displayName = "Option";
var he = function() {
  return he = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, he.apply(this, arguments);
};
function F5(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function Cp(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = e.length, i; r < o; r++)
      (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function $o(t) {
  return t.mode === "multiple";
}
function No(t) {
  return t.mode === "range";
}
function fs(t) {
  return t.mode === "single";
}
var H5 = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function W5(t, e) {
  return xt(t, "LLLL y", e);
}
function V5(t, e) {
  return xt(t, "d", e);
}
function B5(t, e) {
  return xt(t, "LLLL", e);
}
function j5(t) {
  return "".concat(t);
}
function z5(t, e) {
  return xt(t, "cccccc", e);
}
function Y5(t, e) {
  return xt(t, "yyyy", e);
}
var U5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: W5,
  formatDay: V5,
  formatMonthCaption: B5,
  formatWeekNumber: j5,
  formatWeekdayName: z5,
  formatYearCaption: Y5
}), G5 = function(t, e, n) {
  return xt(t, "do MMMM (EEEE)", n);
}, K5 = function() {
  return "Month: ";
}, q5 = function() {
  return "Go to next month";
}, X5 = function() {
  return "Go to previous month";
}, Z5 = function(t, e) {
  return xt(t, "cccc", e);
}, Q5 = function(t) {
  return "Week n. ".concat(t);
}, J5 = function() {
  return "Year: ";
}, e6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: G5,
  labelMonthDropdown: K5,
  labelNext: q5,
  labelPrevious: X5,
  labelWeekNumber: Q5,
  labelWeekday: Z5,
  labelYearDropdown: J5
});
function t6() {
  var t = "buttons", e = H5, n = Ol, r = {}, o = {}, i = 1, s = {}, a = /* @__PURE__ */ new Date();
  return {
    captionLayout: t,
    classNames: e,
    formatters: U5,
    labels: e6,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: i,
    styles: s,
    today: a,
    mode: "default"
  };
}
function n6(t) {
  var e = t.fromYear, n = t.toYear, r = t.fromMonth, o = t.toMonth, i = t.fromDate, s = t.toDate;
  return r ? i = ft(r) : e && (i = new Date(e, 0, 1)), o ? s = Io(o) : n && (s = new Date(n, 11, 31)), {
    fromDate: i ? ar(i) : void 0,
    toDate: s ? ar(s) : void 0
  };
}
var Ep = At(void 0);
function r6(t) {
  var e, n = t.initialProps, r = t6(), o = n6(n), i = o.fromDate, s = o.toDate, a = (e = n.captionLayout) !== null && e !== void 0 ? e : r.captionLayout;
  a !== "buttons" && (!i || !s) && (a = "buttons");
  var l;
  (fs(n) || $o(n) || No(n)) && (l = n.onSelect);
  var c = he(he(he({}, r), n), { captionLayout: a, classNames: he(he({}, r.classNames), n.classNames), components: he({}, n.components), formatters: he(he({}, r.formatters), n.formatters), fromDate: i, labels: he(he({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: he(he({}, r.modifiers), n.modifiers), modifiersClassNames: he(he({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: he(he({}, r.styles), n.styles), toDate: s });
  return P.createElement(Ep.Provider, { value: c }, t.children);
}
function Ue() {
  var t = Gt(Ep);
  if (!t)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return t;
}
function kp(t) {
  var e = Ue(), n = e.locale, r = e.classNames, o = e.styles, i = e.formatters.formatCaption;
  return P.createElement("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: t.id }, i(t.displayMonth, { locale: n }));
}
function o6(t) {
  return P.createElement(
    "svg",
    he({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, t),
    P.createElement("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" })
  );
}
function Mp(t) {
  var e, n, r = t.onChange, o = t.value, i = t.children, s = t.caption, a = t.className, l = t.style, c = Ue(), u = (n = (e = c.components) === null || e === void 0 ? void 0 : e.IconDropdown) !== null && n !== void 0 ? n : o6;
  return P.createElement(
    "div",
    { className: a, style: l },
    P.createElement("span", { className: c.classNames.vhidden }, t["aria-label"]),
    P.createElement("select", { name: t.name, "aria-label": t["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: o, onChange: r }, i),
    P.createElement(
      "div",
      { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true" },
      s,
      P.createElement(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })
    )
  );
}
function i6(t) {
  var e, n = Ue(), r = n.fromDate, o = n.toDate, i = n.styles, s = n.locale, a = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!r)
    return P.createElement(P.Fragment, null);
  if (!o)
    return P.createElement(P.Fragment, null);
  var d = [];
  if (dC(r, o))
    for (var f = ft(r), h = r.getMonth(); h <= o.getMonth(); h++)
      d.push(As(f, h));
  else
    for (var f = ft(/* @__PURE__ */ new Date()), h = 0; h <= 11; h++)
      d.push(As(f, h));
  var p = function(m) {
    var v = Number(m.target.value), b = As(ft(t.displayMonth), v);
    t.onChange(b);
  }, g = (e = c == null ? void 0 : c.Dropdown) !== null && e !== void 0 ? e : Mp;
  return P.createElement(g, { name: "months", "aria-label": u(), className: l.dropdown_month, style: i.dropdown_month, onChange: p, value: t.displayMonth.getMonth(), caption: a(t.displayMonth, { locale: s }) }, d.map(function(m) {
    return P.createElement("option", { key: m.getMonth(), value: m.getMonth() }, a(m, { locale: s }));
  }));
}
function s6(t) {
  var e, n = t.displayMonth, r = Ue(), o = r.fromDate, i = r.toDate, s = r.locale, a = r.styles, l = r.classNames, c = r.components, u = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, f = [];
  if (!o)
    return P.createElement(P.Fragment, null);
  if (!i)
    return P.createElement(P.Fragment, null);
  for (var h = o.getFullYear(), p = i.getFullYear(), g = h; g <= p; g++)
    f.push(sd(Fh(/* @__PURE__ */ new Date()), g));
  var m = function(b) {
    var y = sd(ft(n), Number(b.target.value));
    t.onChange(y);
  }, v = (e = c == null ? void 0 : c.Dropdown) !== null && e !== void 0 ? e : Mp;
  return P.createElement(v, { name: "years", "aria-label": d(), className: l.dropdown_year, style: a.dropdown_year, onChange: m, value: n.getFullYear(), caption: u(n, { locale: s }) }, f.map(function(b) {
    return P.createElement("option", { key: b.getFullYear(), value: b.getFullYear() }, u(b, { locale: s }));
  }));
}
function a6(t, e) {
  var n = ke(t), r = n[0], o = n[1], i = e === void 0 ? r : e;
  return [i, o];
}
function l6(t) {
  var e = t.month, n = t.defaultMonth, r = t.today, o = e || n || r || /* @__PURE__ */ new Date(), i = t.toDate, s = t.fromDate, a = t.numberOfMonths, l = a === void 0 ? 1 : a;
  if (i && Lr(i, o) < 0) {
    var c = -1 * (l - 1);
    o = Ft(i, c);
  }
  return s && Lr(o, s) < 0 && (o = s), ft(o);
}
function c6() {
  var t = Ue(), e = l6(t), n = a6(e, t.month), r = n[0], o = n[1], i = function(s) {
    var a;
    if (!t.disableNavigation) {
      var l = ft(s);
      o(l), (a = t.onMonthChange) === null || a === void 0 || a.call(t, l);
    }
  };
  return [r, i];
}
function u6(t, e) {
  for (var n = e.reverseMonths, r = e.numberOfMonths, o = ft(t), i = ft(Ft(o, r)), s = Lr(i, o), a = [], l = 0; l < s; l++) {
    var c = Ft(o, l);
    a.push(c);
  }
  return n && (a = a.reverse()), a;
}
function d6(t, e) {
  if (!e.disableNavigation) {
    var n = e.toDate, r = e.pagedNavigation, o = e.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = ft(t);
    if (!n)
      return Ft(a, s);
    var l = Lr(n, t);
    if (!(l < i))
      return Ft(a, s);
  }
}
function f6(t, e) {
  if (!e.disableNavigation) {
    var n = e.fromDate, r = e.pagedNavigation, o = e.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = ft(t);
    if (!n)
      return Ft(a, -s);
    var l = Lr(a, n);
    if (!(l <= 0))
      return Ft(a, -s);
  }
}
var Op = At(void 0);
function h6(t) {
  var e = Ue(), n = c6(), r = n[0], o = n[1], i = u6(r, e), s = d6(r, e), a = f6(r, e), l = function(d) {
    return i.some(function(f) {
      return Dl(d, f);
    });
  }, c = function(d, f) {
    l(d) || (f && Kh(d, f) ? o(Ft(d, 1 + e.numberOfMonths * -1)) : o(d));
  }, u = {
    currentMonth: r,
    displayMonths: i,
    goToMonth: o,
    goToDate: c,
    previousMonth: a,
    nextMonth: s,
    isDateDisplayed: l
  };
  return P.createElement(Op.Provider, { value: u }, t.children);
}
function Br() {
  var t = Gt(Op);
  if (!t)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return t;
}
function ud(t) {
  var e, n = Ue(), r = n.classNames, o = n.styles, i = n.components, s = Br().goToMonth, a = function(u) {
    s(u);
  }, l = (e = i == null ? void 0 : i.CaptionLabel) !== null && e !== void 0 ? e : kp, c = P.createElement(l, { id: t.id, displayMonth: t.displayMonth });
  return P.createElement(
    "div",
    { className: r.caption_dropdowns, style: o.caption_dropdowns },
    P.createElement("div", { className: r.vhidden }, c),
    P.createElement(i6, { onChange: a, displayMonth: t.displayMonth }),
    P.createElement(s6, { onChange: a, displayMonth: t.displayMonth })
  );
}
function p6(t) {
  return P.createElement(
    "svg",
    he({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, t),
    P.createElement("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" })
  );
}
function g6(t) {
  return P.createElement(
    "svg",
    he({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, t),
    P.createElement("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" })
  );
}
var Vi = de(function(t, e) {
  var n = Ue(), r = n.classNames, o = n.styles, i = [r.button_reset, r.button];
  t.className && i.push(t.className);
  var s = i.join(" "), a = he(he({}, o.button_reset), o.button);
  return t.style && Object.assign(a, t.style), P.createElement("button", he({}, t, { ref: e, type: "button", className: s, style: a }));
});
function m6(t) {
  var e, n, r = Ue(), o = r.dir, i = r.locale, s = r.classNames, a = r.styles, l = r.labels, c = l.labelPrevious, u = l.labelNext, d = r.components;
  if (!t.nextMonth && !t.previousMonth)
    return P.createElement(P.Fragment, null);
  var f = c(t.previousMonth, { locale: i }), h = [
    s.nav_button,
    s.nav_button_previous
  ].join(" "), p = u(t.nextMonth, { locale: i }), g = [
    s.nav_button,
    s.nav_button_next
  ].join(" "), m = (e = d == null ? void 0 : d.IconRight) !== null && e !== void 0 ? e : g6, v = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : p6;
  return P.createElement(
    "div",
    { className: s.nav, style: a.nav },
    !t.hidePrevious && P.createElement(Vi, { name: "previous-month", "aria-label": f, className: h, style: a.nav_button_previous, disabled: !t.previousMonth, onClick: t.onPreviousClick }, o === "rtl" ? P.createElement(m, { className: s.nav_icon, style: a.nav_icon }) : P.createElement(v, { className: s.nav_icon, style: a.nav_icon })),
    !t.hideNext && P.createElement(Vi, { name: "next-month", "aria-label": p, className: g, style: a.nav_button_next, disabled: !t.nextMonth, onClick: t.onNextClick }, o === "rtl" ? P.createElement(v, { className: s.nav_icon, style: a.nav_icon }) : P.createElement(m, { className: s.nav_icon, style: a.nav_icon }))
  );
}
function dd(t) {
  var e = Ue().numberOfMonths, n = Br(), r = n.previousMonth, o = n.nextMonth, i = n.goToMonth, s = n.displayMonths, a = s.findIndex(function(p) {
    return Dl(t.displayMonth, p);
  }), l = a === 0, c = a === s.length - 1, u = e > 1 && (l || !c), d = e > 1 && (c || !l), f = function() {
    r && i(r);
  }, h = function() {
    o && i(o);
  };
  return P.createElement(m6, { displayMonth: t.displayMonth, hideNext: u, hidePrevious: d, nextMonth: o, previousMonth: r, onPreviousClick: f, onNextClick: h });
}
function v6(t) {
  var e, n = Ue(), r = n.classNames, o = n.disableNavigation, i = n.styles, s = n.captionLayout, a = n.components, l = (e = a == null ? void 0 : a.CaptionLabel) !== null && e !== void 0 ? e : kp, c;
  return o ? c = P.createElement(l, { id: t.id, displayMonth: t.displayMonth }) : s === "dropdown" ? c = P.createElement(ud, { displayMonth: t.displayMonth, id: t.id }) : s === "dropdown-buttons" ? c = P.createElement(
    P.Fragment,
    null,
    P.createElement(ud, { displayMonth: t.displayMonth, id: t.id }),
    P.createElement(dd, { displayMonth: t.displayMonth, id: t.id })
  ) : c = P.createElement(
    P.Fragment,
    null,
    P.createElement(l, { id: t.id, displayMonth: t.displayMonth }),
    P.createElement(dd, { displayMonth: t.displayMonth, id: t.id })
  ), P.createElement("div", { className: r.caption, style: i.caption }, c);
}
function b6(t) {
  var e = Ue(), n = e.footer, r = e.styles, o = e.classNames.tfoot;
  return n ? P.createElement(
    "tfoot",
    { className: o, style: r.tfoot },
    P.createElement(
      "tr",
      null,
      P.createElement("td", { colSpan: 8 }, n)
    )
  ) : P.createElement(P.Fragment, null);
}
function y6(t, e, n) {
  for (var r = n ? sr(/* @__PURE__ */ new Date()) : Ht(/* @__PURE__ */ new Date(), { locale: t, weekStartsOn: e }), o = [], i = 0; i < 7; i++) {
    var s = Mt(r, i);
    o.push(s);
  }
  return o;
}
function x6() {
  var t = Ue(), e = t.classNames, n = t.styles, r = t.showWeekNumber, o = t.locale, i = t.weekStartsOn, s = t.ISOWeek, a = t.formatters.formatWeekdayName, l = t.labels.labelWeekday, c = y6(o, i, s);
  return P.createElement(
    "tr",
    { style: n.head_row, className: e.head_row },
    r && P.createElement("td", { style: n.head_cell, className: e.head_cell }),
    c.map(function(u, d) {
      return P.createElement("th", { key: d, scope: "col", className: e.head_cell, style: n.head_cell, "aria-label": l(u, { locale: o }) }, a(u, { locale: o }));
    })
  );
}
function w6() {
  var t, e = Ue(), n = e.classNames, r = e.styles, o = e.components, i = (t = o == null ? void 0 : o.HeadRow) !== null && t !== void 0 ? t : x6;
  return P.createElement(
    "thead",
    { style: r.head, className: n.head },
    P.createElement(i, null)
  );
}
function _6(t) {
  var e = Ue(), n = e.locale, r = e.formatters.formatDay;
  return P.createElement(P.Fragment, null, r(t.date, { locale: n }));
}
var $l = At(void 0);
function C6(t) {
  if (!$o(t.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return P.createElement($l.Provider, { value: e }, t.children);
  }
  return P.createElement(E6, { initialProps: t.initialProps, children: t.children });
}
function E6(t) {
  var e = t.initialProps, n = t.children, r = e.selected, o = e.min, i = e.max, s = function(c, u, d) {
    var f, h;
    (f = e.onDayClick) === null || f === void 0 || f.call(e, c, u, d);
    var p = !!(u.selected && o && (r == null ? void 0 : r.length) === o);
    if (!p) {
      var g = !!(!u.selected && i && (r == null ? void 0 : r.length) === i);
      if (!g) {
        var m = r ? Cp([], r, !0) : [];
        if (u.selected) {
          var v = m.findIndex(function(b) {
            return vt(c, b);
          });
          m.splice(v, 1);
        } else
          m.push(c);
        (h = e.onSelect) === null || h === void 0 || h.call(e, m, c, u, d);
      }
    }
  }, a = {
    disabled: []
  };
  r && a.disabled.push(function(c) {
    var u = i && r.length > i - 1, d = r.some(function(f) {
      return vt(f, c);
    });
    return !!(u && !d);
  });
  var l = {
    selected: r,
    onDayClick: s,
    modifiers: a
  };
  return P.createElement($l.Provider, { value: l }, n);
}
function Nl() {
  var t = Gt($l);
  if (!t)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return t;
}
function k6(t, e) {
  var n = e || {}, r = n.from, o = n.to;
  if (!r)
    return { from: t, to: void 0 };
  if (!o && vt(r, t))
    return { from: r, to: t };
  if (!o && Kh(t, r))
    return { from: t, to: r };
  if (!o)
    return { from: r, to: t };
  if (!(vt(o, t) && vt(r, t))) {
    if (vt(o, t))
      return { from: o, to: void 0 };
    if (!vt(r, t))
      return Gh(r, t) ? { from: t, to: o } : { from: r, to: t };
  }
}
var Rl = At(void 0);
function M6(t) {
  if (!No(t.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return P.createElement(Rl.Provider, { value: e }, t.children);
  }
  return P.createElement(O6, { initialProps: t.initialProps, children: t.children });
}
function O6(t) {
  var e = t.initialProps, n = t.children, r = e.selected, o = r || {}, i = o.from, s = o.to, a = e.min, l = e.max, c = function(h, p, g) {
    var m, v;
    (m = e.onDayClick) === null || m === void 0 || m.call(e, h, p, g);
    var b = k6(h, r);
    (v = e.onSelect) === null || v === void 0 || v.call(e, b, h, p, g);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i && (u.range_start = [i], s ? (u.range_end = [s], vt(i, s) || (u.range_middle = [
    {
      after: i,
      before: s
    }
  ])) : u.range_end = [i]), a && (i && !s && u.disabled.push({
    after: id(i, a - 1),
    before: Mt(i, a - 1)
  }), i && s && u.disabled.push({
    after: i,
    before: Mt(i, a - 1)
  })), l && (i && !s && (u.disabled.push({
    before: Mt(i, -l + 1)
  }), u.disabled.push({
    after: Mt(i, l - 1)
  })), i && s)) {
    var d = Nt(s, i) + 1, f = l - d;
    u.disabled.push({
      before: id(i, f)
    }), u.disabled.push({
      after: Mt(s, f)
    });
  }
  return P.createElement(Rl.Provider, { value: { selected: r, onDayClick: c, modifiers: u } }, n);
}
function Al() {
  var t = Gt(Rl);
  if (!t)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return t;
}
function bi(t) {
  return Array.isArray(t) ? Cp([], t, !0) : t !== void 0 ? [t] : [];
}
function P6(t) {
  var e = {};
  return Object.entries(t).forEach(function(n) {
    var r = n[0], o = n[1];
    e[r] = bi(o);
  }), e;
}
var Ut;
(function(t) {
  t.Outside = "outside", t.Disabled = "disabled", t.Selected = "selected", t.Hidden = "hidden", t.Today = "today", t.RangeStart = "range_start", t.RangeEnd = "range_end", t.RangeMiddle = "range_middle";
})(Ut || (Ut = {}));
var S6 = Ut.Selected, hn = Ut.Disabled, D6 = Ut.Hidden, T6 = Ut.Today, Fs = Ut.RangeEnd, Hs = Ut.RangeMiddle, Ws = Ut.RangeStart, I6 = Ut.Outside;
function $6(t, e, n) {
  var r, o = (r = {}, r[S6] = bi(t.selected), r[hn] = bi(t.disabled), r[D6] = bi(t.hidden), r[T6] = [t.today], r[Fs] = [], r[Hs] = [], r[Ws] = [], r[I6] = [], r);
  return t.fromDate && o[hn].push({ before: t.fromDate }), t.toDate && o[hn].push({ after: t.toDate }), $o(t) ? o[hn] = o[hn].concat(e.modifiers[hn]) : No(t) && (o[hn] = o[hn].concat(n.modifiers[hn]), o[Ws] = n.modifiers[Ws], o[Hs] = n.modifiers[Hs], o[Fs] = n.modifiers[Fs]), o;
}
var Pp = At(void 0);
function N6(t) {
  var e = Ue(), n = Nl(), r = Al(), o = $6(e, n, r), i = P6(e.modifiers), s = he(he({}, o), i);
  return P.createElement(Pp.Provider, { value: s }, t.children);
}
function Sp() {
  var t = Gt(Pp);
  if (!t)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return t;
}
function R6(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function A6(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function L6(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function F6(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function H6(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function W6(t, e) {
  var n, r = e.from, o = e.to;
  if (!r)
    return !1;
  if (!o && vt(r, t))
    return !0;
  if (!o)
    return !1;
  var i = Nt(o, r) < 0;
  i && (n = [o, r], r = n[0], o = n[1]);
  var s = Nt(t, r) >= 0 && Nt(o, t) >= 0;
  return s;
}
function V6(t) {
  return El(t);
}
function B6(t) {
  return Array.isArray(t) && t.every(El);
}
function j6(t, e) {
  return e.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (V6(n))
      return vt(t, n);
    if (B6(n))
      return n.includes(t);
    if (A6(n))
      return W6(t, n);
    if (H6(n))
      return n.dayOfWeek.includes(t.getDay());
    if (R6(n)) {
      var r = Nt(n.before, t), o = Nt(n.after, t), i = r > 0, s = o < 0, a = Gh(n.before, n.after);
      return a ? s && i : i || s;
    }
    return L6(n) ? Nt(t, n.after) > 0 : F6(n) ? Nt(n.before, t) > 0 : typeof n == "function" ? n(t) : !1;
  });
}
function Ll(t, e, n) {
  var r = Object.keys(e).reduce(function(i, s) {
    var a = e[s];
    return j6(t, a) && i.push(s), i;
  }, []), o = {};
  return r.forEach(function(i) {
    return o[i] = !0;
  }), n && !Dl(t, n) && (o.outside = !0), o;
}
function z6(t, e) {
  for (var n = ft(t[0]), r = Io(t[t.length - 1]), o, i, s = n; s <= r; ) {
    var a = Ll(s, e), l = !a.disabled && !a.hidden;
    if (!l) {
      s = Mt(s, 1);
      continue;
    }
    if (a.selected)
      return s;
    a.today && !i && (i = s), o || (o = s), s = Mt(s, 1);
  }
  return i || o;
}
var Y6 = 365;
function Dp(t, e) {
  var n = e.moveBy, r = e.direction, o = e.context, i = e.modifiers, s = e.retry, a = s === void 0 ? { count: 0, lastFocused: t } : s, l = o.weekStartsOn, c = o.fromDate, u = o.toDate, d = o.locale, f = {
    day: Mt,
    week: Li,
    month: Ft,
    year: Nh,
    startOfWeek: function(m) {
      return o.ISOWeek ? sr(m) : Ht(m, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(m) {
      return o.ISOWeek ? Hh(m) : ls(m, { locale: d, weekStartsOn: l });
    }
  }, h = f[n](t, r === "after" ? 1 : -1);
  r === "before" && c ? h = Dw([c, h]) : r === "after" && u && (h = Tw([u, h]));
  var p = !0;
  if (i) {
    var g = Ll(h, i);
    p = !g.disabled && !g.hidden;
  }
  return p ? h : a.count > Y6 ? a.lastFocused : Dp(h, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: i,
    retry: he(he({}, a), { count: a.count + 1 })
  });
}
var Tp = At(void 0);
function U6(t) {
  var e = Br(), n = Sp(), r = ke(), o = r[0], i = r[1], s = ke(), a = s[0], l = s[1], c = z6(e.displayMonths, n), u = o ?? (a && e.isDateDisplayed(a)) ? a : c, d = function() {
    l(o), i(void 0);
  }, f = function(m) {
    i(m);
  }, h = Ue(), p = function(m, v) {
    if (o) {
      var b = Dp(o, {
        moveBy: m,
        direction: v,
        context: h,
        modifiers: n
      });
      vt(o, b) || (e.goToDate(b, o), f(b));
    }
  }, g = {
    focusedDay: o,
    focusTarget: u,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return p("day", "after");
    },
    focusDayBefore: function() {
      return p("day", "before");
    },
    focusWeekAfter: function() {
      return p("week", "after");
    },
    focusWeekBefore: function() {
      return p("week", "before");
    },
    focusMonthBefore: function() {
      return p("month", "before");
    },
    focusMonthAfter: function() {
      return p("month", "after");
    },
    focusYearBefore: function() {
      return p("year", "before");
    },
    focusYearAfter: function() {
      return p("year", "after");
    },
    focusStartOfWeek: function() {
      return p("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return p("endOfWeek", "after");
    }
  };
  return P.createElement(Tp.Provider, { value: g }, t.children);
}
function Fl() {
  var t = Gt(Tp);
  if (!t)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return t;
}
function G6(t, e) {
  var n = Sp(), r = Ll(t, n, e);
  return r;
}
var Hl = At(void 0);
function K6(t) {
  if (!fs(t.initialProps)) {
    var e = {
      selected: void 0
    };
    return P.createElement(Hl.Provider, { value: e }, t.children);
  }
  return P.createElement(q6, { initialProps: t.initialProps, children: t.children });
}
function q6(t) {
  var e = t.initialProps, n = t.children, r = function(i, s, a) {
    var l, c, u;
    if ((l = e.onDayClick) === null || l === void 0 || l.call(e, i, s, a), s.selected && !e.required) {
      (c = e.onSelect) === null || c === void 0 || c.call(e, void 0, i, s, a);
      return;
    }
    (u = e.onSelect) === null || u === void 0 || u.call(e, i, i, s, a);
  }, o = {
    selected: e.selected,
    onDayClick: r
  };
  return P.createElement(Hl.Provider, { value: o }, n);
}
function Ip() {
  var t = Gt(Hl);
  if (!t)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return t;
}
function X6(t, e) {
  var n = Ue(), r = Ip(), o = Nl(), i = Al(), s = Fl(), a = s.focusDayAfter, l = s.focusDayBefore, c = s.focusWeekAfter, u = s.focusWeekBefore, d = s.blur, f = s.focus, h = s.focusMonthBefore, p = s.focusMonthAfter, g = s.focusYearBefore, m = s.focusYearAfter, v = s.focusStartOfWeek, b = s.focusEndOfWeek, y = function(H) {
    var z, ee, I, F;
    fs(n) ? (z = r.onDayClick) === null || z === void 0 || z.call(r, t, e, H) : $o(n) ? (ee = o.onDayClick) === null || ee === void 0 || ee.call(o, t, e, H) : No(n) ? (I = i.onDayClick) === null || I === void 0 || I.call(i, t, e, H) : (F = n.onDayClick) === null || F === void 0 || F.call(n, t, e, H);
  }, w = function(H) {
    var z;
    f(t), (z = n.onDayFocus) === null || z === void 0 || z.call(n, t, e, H);
  }, x = function(H) {
    var z;
    d(), (z = n.onDayBlur) === null || z === void 0 || z.call(n, t, e, H);
  }, M = function(H) {
    var z;
    (z = n.onDayMouseEnter) === null || z === void 0 || z.call(n, t, e, H);
  }, E = function(H) {
    var z;
    (z = n.onDayMouseLeave) === null || z === void 0 || z.call(n, t, e, H);
  }, C = function(H) {
    var z;
    (z = n.onDayPointerEnter) === null || z === void 0 || z.call(n, t, e, H);
  }, O = function(H) {
    var z;
    (z = n.onDayPointerLeave) === null || z === void 0 || z.call(n, t, e, H);
  }, R = function(H) {
    var z;
    (z = n.onDayTouchCancel) === null || z === void 0 || z.call(n, t, e, H);
  }, D = function(H) {
    var z;
    (z = n.onDayTouchEnd) === null || z === void 0 || z.call(n, t, e, H);
  }, $ = function(H) {
    var z;
    (z = n.onDayTouchMove) === null || z === void 0 || z.call(n, t, e, H);
  }, T = function(H) {
    var z;
    (z = n.onDayTouchStart) === null || z === void 0 || z.call(n, t, e, H);
  }, j = function(H) {
    var z;
    (z = n.onDayKeyUp) === null || z === void 0 || z.call(n, t, e, H);
  }, L = function(H) {
    var z;
    switch (H.key) {
      case "ArrowLeft":
        H.preventDefault(), H.stopPropagation(), n.dir === "rtl" ? a() : l();
        break;
      case "ArrowRight":
        H.preventDefault(), H.stopPropagation(), n.dir === "rtl" ? l() : a();
        break;
      case "ArrowDown":
        H.preventDefault(), H.stopPropagation(), c();
        break;
      case "ArrowUp":
        H.preventDefault(), H.stopPropagation(), u();
        break;
      case "PageUp":
        H.preventDefault(), H.stopPropagation(), H.shiftKey ? g() : h();
        break;
      case "PageDown":
        H.preventDefault(), H.stopPropagation(), H.shiftKey ? m() : p();
        break;
      case "Home":
        H.preventDefault(), H.stopPropagation(), v();
        break;
      case "End":
        H.preventDefault(), H.stopPropagation(), b();
        break;
    }
    (z = n.onDayKeyDown) === null || z === void 0 || z.call(n, t, e, H);
  }, Y = {
    onClick: y,
    onFocus: w,
    onBlur: x,
    onKeyDown: L,
    onKeyUp: j,
    onMouseEnter: M,
    onMouseLeave: E,
    onPointerEnter: C,
    onPointerLeave: O,
    onTouchCancel: R,
    onTouchEnd: D,
    onTouchMove: $,
    onTouchStart: T
  };
  return Y;
}
function Z6() {
  var t = Ue(), e = Ip(), n = Nl(), r = Al(), o = fs(t) ? e.selected : $o(t) ? n.selected : No(t) ? r.selected : void 0;
  return o;
}
function Q6(t) {
  return Object.values(Ut).includes(t);
}
function J6(t, e) {
  var n = [t.classNames.day];
  return Object.keys(e).forEach(function(r) {
    var o = t.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if (Q6(r)) {
      var i = t.classNames["day_".concat(r)];
      i && n.push(i);
    }
  }), n;
}
function e3(t, e) {
  var n = he({}, t.styles.day);
  return Object.keys(e).forEach(function(r) {
    var o;
    n = he(he({}, n), (o = t.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function t3(t, e, n) {
  var r, o, i, s = Ue(), a = Fl(), l = G6(t, e), c = X6(t, l), u = Z6(), d = !!(s.onDayClick || s.mode !== "default");
  ue(function() {
    var M;
    l.outside || a.focusedDay && d && vt(a.focusedDay, t) && ((M = n.current) === null || M === void 0 || M.focus());
  }, [
    a.focusedDay,
    t,
    n,
    d,
    l.outside
  ]);
  var f = J6(s, l).join(" "), h = e3(s, l), p = !!(l.outside && !s.showOutsideDays || l.hidden), g = (i = (o = s.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && i !== void 0 ? i : _6, m = P.createElement(g, { date: t, displayMonth: e, activeModifiers: l }), v = {
    style: h,
    className: f,
    children: m,
    role: "gridcell"
  }, b = a.focusTarget && vt(a.focusTarget, t) && !l.outside, y = a.focusedDay && vt(a.focusedDay, t), w = he(he(he({}, v), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = y || b ? 0 : -1, r)), c), x = {
    isButton: d,
    isHidden: p,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: w,
    divProps: v
  };
  return x;
}
function n3(t) {
  var e = le(null), n = t3(t.date, t.displayMonth, e);
  return n.isHidden ? P.createElement("div", { role: "gridcell" }) : n.isButton ? P.createElement(Vi, he({ name: "day", ref: e }, n.buttonProps)) : P.createElement("div", he({}, n.divProps));
}
function r3(t) {
  var e = t.number, n = t.dates, r = Ue(), o = r.onWeekNumberClick, i = r.styles, s = r.classNames, a = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, u = c(Number(e), { locale: a });
  if (!o)
    return P.createElement("span", { className: s.weeknumber, style: i.weeknumber }, u);
  var d = l(Number(e), { locale: a }), f = function(h) {
    o(e, n, h);
  };
  return P.createElement(Vi, { name: "week-number", "aria-label": d, className: s.weeknumber, style: i.weeknumber, onClick: f }, u);
}
function o3(t) {
  var e, n, r = Ue(), o = r.styles, i = r.classNames, s = r.showWeekNumber, a = r.components, l = (e = a == null ? void 0 : a.Day) !== null && e !== void 0 ? e : n3, c = (n = a == null ? void 0 : a.WeekNumber) !== null && n !== void 0 ? n : r3, u;
  return s && (u = P.createElement(
    "td",
    { className: i.cell, style: o.cell },
    P.createElement(c, { number: t.weekNumber, dates: t.dates })
  )), P.createElement(
    "tr",
    { className: i.row, style: o.row },
    u,
    t.dates.map(function(d) {
      return P.createElement(
        "td",
        { className: i.cell, style: o.cell, key: i2(d), role: "presentation" },
        P.createElement(l, { displayMonth: t.displayMonth, date: d })
      );
    })
  );
}
function fd(t, e, n) {
  for (var r = n != null && n.ISOWeek ? Hh(e) : ls(e, n), o = n != null && n.ISOWeek ? sr(t) : Ht(t, n), i = Nt(r, o), s = [], a = 0; a <= i; a++)
    s.push(Mt(o, a));
  var l = s.reduce(function(c, u) {
    var d = n != null && n.ISOWeek ? r2(u) : c2(u, n), f = c.find(function(h) {
      return h.weekNumber === d;
    });
    return f ? (f.dates.push(u), c) : (c.push({
      weekNumber: d,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function i3(t, e) {
  var n = fd(ft(t), Io(t), e);
  if (e != null && e.useFixedWeeks) {
    var r = d2(t, e);
    if (r < 6) {
      var o = n[n.length - 1], i = o.dates[o.dates.length - 1], s = Li(i, 6 - r), a = fd(Li(i, 1), s, e);
      n.push.apply(n, a);
    }
  }
  return n;
}
function s3(t) {
  var e, n, r, o = Ue(), i = o.locale, s = o.classNames, a = o.styles, l = o.hideHead, c = o.fixedWeeks, u = o.components, d = o.weekStartsOn, f = o.firstWeekContainsDate, h = o.ISOWeek, p = i3(t.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: h,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), g = (e = u == null ? void 0 : u.Head) !== null && e !== void 0 ? e : w6, m = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : o3, v = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : b6;
  return P.createElement(
    "table",
    { id: t.id, className: s.table, style: a.table, role: "grid", "aria-labelledby": t["aria-labelledby"] },
    !l && P.createElement(g, null),
    P.createElement("tbody", { className: s.tbody, style: a.tbody, role: "rowgroup" }, p.map(function(b) {
      return P.createElement(m, { displayMonth: t.displayMonth, key: b.weekNumber, dates: b.dates, weekNumber: b.weekNumber });
    })),
    P.createElement(v, { displayMonth: t.displayMonth })
  );
}
function a3() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var l3 = a3() ? S.useLayoutEffect : S.useEffect, Vs = !1, c3 = 0;
function hd() {
  return "react-day-picker-".concat(++c3);
}
function u3(t) {
  var e, n = t ?? (Vs ? hd() : null), r = S.useState(n), o = r[0], i = r[1];
  return l3(function() {
    o === null && i(hd());
  }, []), S.useEffect(function() {
    Vs === !1 && (Vs = !0);
  }, []), (e = t ?? o) !== null && e !== void 0 ? e : void 0;
}
function d3(t) {
  var e, n, r = Ue(), o = r.dir, i = r.classNames, s = r.styles, a = r.components, l = Br().displayMonths, c = u3(r.id ? "".concat(r.id, "-").concat(t.displayIndex) : void 0), u = r.id ? "".concat(r.id, "-grid-").concat(t.displayIndex) : void 0, d = [i.month], f = s.month, h = t.displayIndex === 0, p = t.displayIndex === l.length - 1, g = !h && !p;
  o === "rtl" && (e = [h, p], p = e[0], h = e[1]), h && (d.push(i.caption_start), f = he(he({}, f), s.caption_start)), p && (d.push(i.caption_end), f = he(he({}, f), s.caption_end)), g && (d.push(i.caption_between), f = he(he({}, f), s.caption_between));
  var m = (n = a == null ? void 0 : a.Caption) !== null && n !== void 0 ? n : v6;
  return P.createElement(
    "div",
    { key: t.displayIndex, className: d.join(" "), style: f },
    P.createElement(m, { id: c, displayMonth: t.displayMonth }),
    P.createElement(s3, { id: u, "aria-labelledby": c, displayMonth: t.displayMonth })
  );
}
function f3(t) {
  var e = t.initialProps, n = Ue(), r = Fl(), o = Br(), i = ke(!1), s = i[0], a = i[1];
  ue(function() {
    n.initialFocus && r.focusTarget && (s || (r.focus(r.focusTarget), a(!0)));
  }, [
    n.initialFocus,
    s,
    r.focus,
    r.focusTarget,
    r
  ]);
  var l = [n.classNames.root, n.className];
  n.numberOfMonths > 1 && l.push(n.classNames.multiple_months), n.showWeekNumber && l.push(n.classNames.with_weeknumber);
  var c = he(he({}, n.styles.root), n.style), u = Object.keys(e).filter(function(d) {
    return d.startsWith("data-");
  }).reduce(function(d, f) {
    var h;
    return he(he({}, d), (h = {}, h[f] = e[f], h));
  }, {});
  return P.createElement(
    "div",
    he({ className: l.join(" "), style: c, dir: n.dir, id: n.id }, u),
    P.createElement("div", { className: n.classNames.months, style: n.styles.months }, o.displayMonths.map(function(d, f) {
      return P.createElement(d3, { key: f, displayIndex: f, displayMonth: d });
    }))
  );
}
function h3(t) {
  var e = t.children, n = F5(t, ["children"]);
  return P.createElement(
    r6,
    { initialProps: n },
    P.createElement(
      h6,
      null,
      P.createElement(
        K6,
        { initialProps: n },
        P.createElement(
          C6,
          { initialProps: n },
          P.createElement(
            M6,
            { initialProps: n },
            P.createElement(
              N6,
              null,
              P.createElement(U6, null, e)
            )
          )
        )
      )
    )
  );
}
function p3(t) {
  return P.createElement(
    h3,
    he({}, t),
    P.createElement(f3, { initialProps: t })
  );
}
const $p = ({
  className: t,
  ...e
}) => /* @__PURE__ */ _(
  p3,
  {
    showOutsideDays: !0,
    fixedWeeks: !0,
    weekStartsOn: 1,
    className: ye(
      "flex rounded-lg bg-foundations-default px-6 py-3",
      t
    ),
    formatters: {
      formatWeekdayName: (n) => xt(n, "E")
    },
    classNames: {
      table: "w-full border-collapse space-y-4",
      head_row: "flex",
      head_cell: "w-9 text-xs text-foundations-subtle font-normal uppercase",
      row: "flex w-full mt-2",
      cell: "p-0 flex justify-center group/cell",
      day: "h-9 w-9 p-0 font-normal text-foundations-boldest text-sm rounded-full aria-selected:!text-neutral-white hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-info-bold focus:z-10",
      day_selected: "!bg-info-bold hover:!bg-info-bolder focus:bg-info-bolder",
      day_today: "bg-neutral-100 rounded-full",
      day_range_start: "start rounded-l-full rounded-r-none",
      day_range_end: "end rounded-l-none [&.start]:rounded-full",
      day_outside: "[&:not(:disabled)]:text-foundations-subtle",
      day_disabled: "!text-neutral-300 cursor-not-allowed",
      day_range_middle: "bg-info-bold rounded-none group-first/cell:rounded-l-full group-last/cell:rounded-r-full",
      day_hidden: "invisible"
    },
    components: {
      Caption: g3
    },
    ...e
  }
);
$p.displayName = "Calendar";
const g3 = (t) => {
  const { goToMonth: e, nextMonth: n, previousMonth: r } = Br();
  return /* @__PURE__ */ Z("div", { className: "mb-4 flex items-center justify-between", children: [
    /* @__PURE__ */ _(
      aa,
      {
        variant: "tertiary",
        size: "xs",
        disabled: !r,
        onClick: () => r && e(r),
        "aria-label": "Go to previous month",
        children: /* @__PURE__ */ _(HC, {})
      }
    ),
    /* @__PURE__ */ _(
      "div",
      {
        id: t.id,
        "aria-live": "polite",
        role: "presentation",
        className: "text-sm font-medium text-foundations-boldest",
        children: xt(t.displayMonth, "MMMM yyyy")
      }
    ),
    /* @__PURE__ */ _(
      aa,
      {
        variant: "tertiary",
        size: "xs",
        disabled: !n,
        onClick: () => n && e(n),
        "aria-label": "Go to next month",
        children: /* @__PURE__ */ _(WC, {})
      }
    )
  ] });
}, m3 = (t) => t.querySelector("input,textarea") || t, hs = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class v3 {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const e = this.past.pop();
    e && this.now && (this.future.push(this.now), this.updateElement(e, "historyUndo"));
  }
  redo() {
    const e = this.future.pop();
    e && this.now && (this.past.push(this.now), this.updateElement(e, "historyRedo"));
  }
  updateHistory(e) {
    if (!this.now) {
      this.now = e;
      return;
    }
    const n = this.now.value !== e.value, r = this.now.selection.some((o, i) => o !== e.selection[i]);
    !n && !r || (n && (this.past.push(this.now), this.future = []), this.now = e);
  }
  updateElement(e, n) {
    this.now = e, this.updateElementState(e, {
      inputType: n,
      data: null
    });
  }
}
function b3(t, ...e) {
  return e.every(({
    value: n
  }) => n === t.value);
}
function y3(t, ...e) {
  return e.every(({
    value: n,
    selection: r
  }) => n === t.value && r[0] === t.selection[0] && r[1] === t.selection[1]);
}
function x3({
  value: t,
  selection: e
}, n, r) {
  const [o, i] = e, s = typeof r == "function" ? r({
    value: t,
    selection: e
  }) : r;
  return {
    value: t,
    selection: s === "replace" ? [o, o + n.length] : [o, i]
  };
}
function ps(t) {
  return typeof t == "string";
}
function pd(t, e, n, r) {
  let o = "";
  for (let i = e.length; i < t.length; i++) {
    const s = t[i], a = (r == null ? void 0 : r.value[i]) === s;
    if (!ps(s) || s === n && !a)
      return o;
    o += s;
  }
  return o;
}
function Np(t, e) {
  return Array.isArray(e) ? t.length === e.length && Array.from(t).every((n, r) => {
    const o = e[r];
    return ps(o) ? n === o : n.match(o);
  }) : e.test(t);
}
function w3(t, e, n) {
  let r = null, o = null;
  const i = Array.from(t.value).reduce((a, l, c) => {
    const u = pd(e, a, l, n), d = a + u, f = e[d.length];
    return ps(f) ? d + f : l.match(f) ? (r === null && c >= t.selection[0] && (r = d.length), o === null && c >= t.selection[1] && (o = d.length), d + l) : d;
  }, ""), s = pd(e, i, "", n);
  return {
    value: Np(i + s, e) ? i + s : i,
    selection: [r ?? i.length, o ?? i.length]
  };
}
function _3({
  value: t,
  selection: e
}, n) {
  const [r, o] = e;
  let i = r, s = o;
  return {
    value: Array.from(t).reduce((l, c, u) => {
      const d = l + c;
      return r === u && (i = l.length), o === u && (s = l.length), d.match(n) ? d : l;
    }, ""),
    selection: [i, s]
  };
}
function ti(t, e, n = null) {
  if (Np(t.value, e))
    return t;
  const {
    value: r,
    selection: o
  } = Array.isArray(e) ? w3(t, e, n) : _3(t, e);
  return {
    selection: o,
    value: Array.isArray(e) ? r.slice(0, e.length) : r
  };
}
function gd(t, e) {
  if (!Array.isArray(e))
    return t;
  const [n, r] = t.selection, o = [], i = Array.from(t.value).reduce((s, a, l) => {
    const c = e[l];
    return l === n && o.push(s.length), l === r && o.push(s.length), ps(c) && c === a ? s : s + a;
  }, "");
  return o.length < 2 && o.push(...Array(2 - o.length).fill(i.length)), {
    value: i,
    selection: [o[0], o[1]]
  };
}
class Oa {
  constructor(e, n) {
    this.initialElementState = e, this.maskOptions = n, this.value = "", this.selection = [0, 0];
    const {
      value: r,
      selection: o
    } = ti(e, this.getMaskExpression(e));
    this.value = r, this.selection = o;
  }
  addCharacters([e, n], r) {
    const {
      value: o
    } = this, i = this.getMaskExpression({
      value: o.slice(0, e) + r + o.slice(n),
      selection: [e + r.length, e + r.length]
    }), s = {
      value: o,
      selection: [e, n]
    }, a = gd(s, i), [l, c] = x3(a, r, this.maskOptions.overwriteMode).selection, u = a.value.slice(0, l) + r, d = u.length, f = ti({
      value: u + a.value.slice(c),
      selection: [d, d]
    }, i, s);
    if (o.slice(0, l) === ti({
      value: u,
      selection: [d, d]
    }, i, s).value || y3(this, f))
      throw new Error("Invalid mask value");
    this.value = f.value, this.selection = f.selection;
  }
  deleteCharacters([e, n]) {
    if (e === n || !n)
      return;
    const {
      value: r
    } = this, o = this.getMaskExpression({
      value: r.slice(0, e) + r.slice(n),
      selection: [e, e]
    }), i = {
      value: r,
      selection: [e, n]
    }, s = gd(i, o), [a, l] = s.selection, c = s.value.slice(0, a) + s.value.slice(l), u = ti({
      value: c,
      selection: [a, a]
    }, o, i);
    this.value = u.value, this.selection = u.selection;
  }
  getMaskExpression(e) {
    const {
      mask: n
    } = this.maskOptions;
    return typeof n == "function" ? n(e) : n;
  }
}
class C3 {
  constructor(e) {
    this.element = e, this.listeners = [];
  }
  listen(e, n, r) {
    const o = n;
    this.element.addEventListener(e, o, r), this.listeners.push(() => this.element.removeEventListener(e, o));
  }
  destroy() {
    this.listeners.forEach((e) => e());
  }
}
function uo(t, e, n) {
  return t.ctrlKey === !!(e & 1) && t.altKey === !!(e & 2) && t.shiftKey === !!(e & 4) && t.metaKey === !!(e & 8) && t.keyCode === n;
}
function E3(t) {
  return uo(
    t,
    1,
    89
    /* Y */
  ) || // Windows
  uo(
    t,
    5,
    90
    /* Z */
  ) || // Windows & Android
  uo(
    t,
    12,
    90
    /* Z */
  );
}
function k3(t) {
  return uo(
    t,
    1,
    90
    /* Z */
  ) || // Windows & Android
  uo(
    t,
    8,
    90
    /* Z */
  );
}
function M3(t) {
  return "onbeforeinput" in t;
}
function O3({
  key: t,
  ctrlKey: e,
  metaKey: n,
  altKey: r
}) {
  const o = e || n || r, i = /^.$/u.test(t);
  return !o && t !== "Backspace" && i;
}
function P3({
  value: t,
  selection: e
}, n) {
  const [r, o] = e;
  if (r !== o)
    return [r, o];
  const i = n ? t.slice(r).indexOf(`
`) + 1 || t.length : t.slice(0, o).lastIndexOf(`
`) + 1;
  return [n ? r : i, n ? i : o];
}
function md({
  value: t,
  selection: e
}, n) {
  const [r, o] = e;
  return r !== o ? [r, o] : (n ? [r, o + 1] : [r - 1, o]).map((s) => Math.min(Math.max(s, 0), t.length));
}
const vd = /\s+$/g, bd = /^\s+/g, yd = /\s/;
function S3({
  value: t,
  selection: e
}, n) {
  const [r, o] = e;
  if (r !== o)
    return [r, o];
  if (n) {
    const l = t.slice(r), [c] = l.match(bd) || [""], u = l.replace(bd, "").search(yd);
    return [r, u !== -1 ? r + c.length + u : t.length];
  }
  const i = t.slice(0, o), [s] = i.match(vd) || [""], a = i.replace(vd, "").split("").reverse().findIndex((l) => l.match(yd));
  return [a !== -1 ? o - s.length - a : 0, o];
}
function Bi(t = []) {
  return (e, ...n) => t.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...n)), e);
}
function D3(t, e) {
  const n = Object.assign(Object.assign({}, hs), e), r = Bi(n.preprocessors), o = Bi(n.postprocessors), i = typeof t == "string" ? {
    value: t,
    selection: [0, 0]
  } : t, {
    elementState: s
  } = r({
    elementState: i,
    data: ""
  }, "validation"), a = new Oa(s, n), {
    value: l,
    selection: c
  } = o(a, i);
  return typeof t == "string" ? l : {
    value: l,
    selection: c
  };
}
class T3 extends v3 {
  constructor(e, n) {
    super(), this.element = e, this.maskitoOptions = n, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new C3(this.element), this.options = Object.assign(Object.assign({}, hs), this.maskitoOptions), this.preprocessor = Bi(this.options.preprocessors), this.postprocessor = Bi(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.ensureValueFitsMask(), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (E3(r))
        return r.preventDefault(), this.redo();
      if (k3(r))
        return r.preventDefault(), this.undo();
    }), M3(e) ? this.eventListener.listen("beforeinput", (r) => {
      const o = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "historyRedo":
          return r.preventDefault(), this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: md(this.elementState, o)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: S3(this.elementState, o),
            force: !0
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: P3(this.elementState, o),
            force: !0
          });
        case "insertLineBreak":
          return this.handleEnter(r);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(r, r.data || "");
      }
    }) : (this.eventListener.listen("keydown", (r) => this.handleKeydown(r)), this.eventListener.listen("paste", (r) => {
      var o;
      return this.handleInsert(r, ((o = r.clipboardData) === null || o === void 0 ? void 0 : o.getData("text/plain")) || "");
    })), this.eventListener.listen("input", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  get elementState() {
    const {
      value: e,
      selectionStart: n,
      selectionEnd: r
    } = this.element;
    return {
      value: e,
      selection: [n || 0, r || 0]
    };
  }
  get maxLength() {
    const {
      maxLength: e
    } = this.element;
    return e === -1 ? 1 / 0 : e;
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((e) => e == null ? void 0 : e());
  }
  updateElementState({
    value: e,
    selection: n
  }, r = {
    inputType: "insertText",
    data: null
  }) {
    const o = this.elementState.value;
    this.updateValue(e), this.updateSelectionRange(n), o !== e && this.dispatchInputEvent(r);
  }
  updateSelectionRange([e, n]) {
    var r, o;
    (this.element.selectionStart !== e || this.element.selectionEnd !== n) && ((o = (r = this.element).setSelectionRange) === null || o === void 0 || o.call(r, e, n));
  }
  updateValue(e) {
    this.element.value = e;
  }
  ensureValueFitsMask() {
    this.updateElementState(D3(this.elementState, this.options));
  }
  dispatchInputEvent(e = {
    inputType: "insertText",
    data: null
  }) {
    const n = typeof window < "u" ? window : globalThis;
    n != null && n.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, e), {
      bubbles: !0,
      cancelable: !1
    })));
  }
  handleKeydown(e) {
    const n = e.key, r = n === "Delete";
    switch (n) {
      case "Backspace":
      case "Delete":
        return this.handleDelete({
          event: e,
          isForward: r,
          selection: md(this.elementState, r)
        });
      case "Enter":
        return this.handleEnter(e);
    }
    O3(e) && this.handleInsert(e, n);
  }
  handleDelete({
    event: e,
    selection: n,
    isForward: r,
    force: o = !1
  }) {
    const i = {
      value: this.elementState.value,
      selection: n
    }, [s, a] = i.selection, {
      elementState: l
    } = this.preprocessor({
      elementState: i,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), c = new Oa(l, this.options), [u, d] = l.selection;
    c.deleteCharacters([u, d]);
    const f = this.postprocessor(c, i);
    if (i.value.slice(0, s) + i.value.slice(a) === f.value && !o)
      return;
    if (e.preventDefault(), b3(i, l, c, f))
      return this.updateSelectionRange(r ? [d, d] : [u, u]);
    const p = r ? "deleteContentForward" : "deleteContentBackward";
    this.updateElementState(f, {
      inputType: "inputType" in e ? e.inputType : p,
      data: null
    }), this.updateHistory(f);
  }
  handleInsert(e, n) {
    const r = this.elementState, {
      elementState: o,
      data: i = n
    } = this.preprocessor({
      data: n,
      elementState: r
    }, "insert"), s = new Oa(o, this.options);
    try {
      s.addCharacters(o.selection, i);
    } catch {
      return e.preventDefault();
    }
    const [a, l] = o.selection, c = o.value.slice(0, a) + n + o.value.slice(l), u = this.postprocessor(s, r);
    if (u.value.length > this.maxLength)
      return e.preventDefault();
    c !== u.value && (e.preventDefault(), this.updateElementState(u, {
      data: n,
      inputType: "inputType" in e ? e.inputType : "insertText"
    }), this.updateHistory(u));
  }
  handleEnter(e) {
    this.isTextArea && this.handleInsert(e, `
`);
  }
}
const I3 = /* @__PURE__ */ new Date("0001-01-01"), $3 = /* @__PURE__ */ new Date("9999-12-31"), N3 = "–", R3 = "—", A3 = "-", L3 = "−", F3 = [A3, N3, R3, L3], H3 = [":", "."];
function Pa(t, e, n) {
  const r = Math.min(Number(n), Math.max(Number(e), Number(t)));
  return t instanceof Date ? new Date(r) : r;
}
const Rp = (t) => {
  var e, n, r;
  return {
    day: ((e = t.match(/d/g)) === null || e === void 0 ? void 0 : e.length) || 0,
    month: ((n = t.match(/m/g)) === null || n === void 0 ? void 0 : n.length) || 0,
    year: ((r = t.match(/y/g)) === null || r === void 0 ? void 0 : r.length) || 0
  };
};
function W3(t) {
  return {
    day: String(t.getDate()).padStart(2, "0"),
    month: String(t.getMonth() + 1).padStart(2, "0"),
    year: String(t.getFullYear()).padStart(4, "0"),
    hours: String(t.getHours()).padStart(2, "0"),
    minutes: String(t.getMinutes()).padStart(2, "0"),
    seconds: String(t.getSeconds()).padStart(2, "0"),
    milliseconds: String(t.getMilliseconds()).padStart(3, "0")
  };
}
function V3(t, e) {
  return t.length < e.length ? !1 : t.split(/\D/).every((n) => !n.match(/^0+$/));
}
function Ap(t, e, n) {
  const r = e.replace(/\W/g, "").length;
  return t.replace(n, "").match(new RegExp(`(\\D*\\d[^\\d\\s]*){1,${r}}`, "g")) || [];
}
function Lp(t) {
  return t.reduce((e, [n, r]) => Object.assign(Object.assign({}, e), {
    [n]: r
  }), {});
}
function Fp(t, e) {
  const n = e.replace(/[^dmy]/g, ""), r = t.replace(/\D+/g, ""), o = {
    day: r.slice(n.indexOf("d"), n.lastIndexOf("d") + 1),
    month: r.slice(n.indexOf("m"), n.lastIndexOf("m") + 1),
    year: r.slice(n.indexOf("y"), n.lastIndexOf("y") + 1)
  };
  return Lp(Object.entries(o).filter(([i, s]) => !!s).sort(([i], [s]) => e.toLowerCase().indexOf(i[0]) > e.toLowerCase().indexOf(s[0]) ? 1 : -1));
}
function B3(t, e) {
  var n, r, o, i, s, a, l;
  const c = ((n = t.year) === null || n === void 0 ? void 0 : n.length) === 2 ? `20${t.year}` : t.year, u = new Date(Number(c ?? "0"), Number((r = t.month) !== null && r !== void 0 ? r : "1") - 1, Number((o = t.day) !== null && o !== void 0 ? o : "1"), Number((i = e == null ? void 0 : e.hours) !== null && i !== void 0 ? i : "0"), Number((s = e == null ? void 0 : e.minutes) !== null && s !== void 0 ? s : "0"), Number((a = e == null ? void 0 : e.seconds) !== null && a !== void 0 ? a : "0"), Number((l = e == null ? void 0 : e.milliseconds) !== null && l !== void 0 ? l : "0"));
  return u.setFullYear(Number(c ?? "0")), u;
}
const j3 = ", ";
function ji({
  day: t,
  month: e,
  year: n,
  hours: r,
  minutes: o,
  seconds: i,
  milliseconds: s
}, a, l) {
  var c;
  const u = ((c = a.match(/y/g)) === null || c === void 0 ? void 0 : c.length) === 2 ? n == null ? void 0 : n.slice(-2) : n;
  return (a + (l ? j3 + l : "")).replace(/d+/g, t ?? "").replace(/m+/g, e ?? "").replace(/y+/g, u ?? "").replace(/H+/g, r ?? "").replace(/MSS/g, s ?? "").replace(/M+/g, o ?? "").replace(/S+/g, i ?? "").replace(/^\D+/g, "").replace(/\D+$/g, "");
}
function Sa(t, e, n = 0) {
  return Number(t.padEnd(e.length, "0")) <= Number(e) ? {
    validatedSegmentValue: t,
    prefixedZeroesCount: n
  } : t.endsWith("0") ? Sa(`0${t.slice(0, e.length - 1)}`, e, n + 1) : Sa(`${t.slice(0, e.length - 1)}0`, e, n);
}
const z3 = {
  day: 31,
  month: 12,
  year: 9999
};
function Y3({
  dateString: t,
  dateModeTemplate: e,
  offset: n,
  selection: [r, o]
}) {
  const i = Fp(t, e), s = Object.entries(i), a = {};
  let l = 0;
  for (const [d, f] of s) {
    const h = ji(a, e), p = z3[d], g = h.length && 1, m = n + h.length + g + Rp(e)[d], v = m >= r && m === o;
    if (v && Number(f) > Number(p))
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    if (v && Number(f) < 1)
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    const {
      validatedSegmentValue: b,
      prefixedZeroesCount: y
    } = Sa(f, `${p}`);
    l += y, a[d] = b;
  }
  const c = ji(a, e), u = c.length - t.length;
  return {
    validatedDateString: c,
    updatedSelection: [r + l + u, o + l + u]
  };
}
const Hp = /[\\^$.*+?()[\]{}|]/g, U3 = RegExp(Hp.source);
function Wp(t) {
  return t && U3.test(t) ? t.replace(Hp, "\\$&") : t;
}
function G3({
  activeElement: t
}) {
  if (!(t != null && t.shadowRoot))
    return t;
  let e = t.shadowRoot.activeElement;
  for (; e != null && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function K3(t, e) {
  const n = Rp(e);
  return Lp(Object.entries(t).map(([r, o]) => {
    const i = n[r];
    return [r, o.length === i && o.match(/^0+$/) ? "1".padStart(i, "0") : o];
  }));
}
function q3({
  dateModeTemplate: t,
  min: e = I3,
  max: n = $3,
  rangeSeparator: r = "",
  dateSegmentSeparator: o = "."
}) {
  return ({
    value: i,
    selection: s
  }) => {
    const a = r && i.endsWith(r), l = Ap(i, t, r);
    let c = "";
    for (const u of l) {
      c += c ? r : "";
      const d = Fp(u, t);
      if (!V3(u, t)) {
        const p = K3(d, t), g = ji(p, t), m = u.endsWith(o) ? o : "";
        c += g + m;
        continue;
      }
      const f = B3(d), h = Pa(f, e, n);
      c += ji(W3(h), t);
    }
    return {
      selection: s,
      value: c + (a ? r : "")
    };
  };
}
function X3({
  dateModeTemplate: t,
  dateSegmentsSeparator: e,
  rangeSeparator: n = ""
}) {
  return ({
    elementState: r,
    data: o
  }) => {
    const {
      value: i,
      selection: s
    } = r;
    if (o === e)
      return {
        elementState: r,
        data: s[0] === i.length ? o : ""
      };
    if (F3.includes(o))
      return {
        elementState: r,
        data: n
      };
    const a = o.replace(new RegExp(`[^\\d${Wp(e)}${n}]`, "g"), "");
    if (!a)
      return {
        elementState: r,
        data: ""
      };
    const [l, c] = s;
    let u = c + o.length;
    const d = i.slice(0, l) + a + i.slice(u), f = Ap(d, t, n);
    let h = "";
    const p = !!n && d.includes(n);
    for (const m of f) {
      const {
        validatedDateString: v,
        updatedSelection: b
      } = Y3({
        dateString: m,
        dateModeTemplate: t,
        offset: h ? h.length + n.length : 0,
        selection: [l, u]
      });
      if (m && !v)
        return {
          elementState: r,
          data: ""
        };
      u = b[1], h += p && h ? n + v : v;
    }
    const g = h.slice(l, u);
    return {
      elementState: {
        selection: s,
        value: h.slice(0, l) + g.split(e).map((m) => "0".repeat(m.length)).join(e) + h.slice(u)
      },
      data: g
    };
  };
}
function Z3(t) {
  return (e) => {
    const n = e.ownerDocument;
    let r = 0;
    const o = () => r++, i = () => r--, s = () => {
      if (G3(n) !== e)
        return;
      if (r)
        return n.addEventListener("mouseup", s, {
          once: !0,
          passive: !0
        });
      const a = e.selectionStart || 0, l = e.selectionEnd || 0, [c, u] = t(e.value, [a, l]);
      (c > a || u < l) && e.setSelectionRange(Pa(a, c, u), Pa(l, c, u));
    };
    return n.addEventListener("selectionchange", s, {
      passive: !0
    }), n.addEventListener("mousedown", o, {
      passive: !0
    }), n.addEventListener("mouseup", i, {
      passive: !0
    }), () => {
      n.removeEventListener("selectionchange", s), n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", i);
    };
  };
}
function xd(t, e, n) {
  return (r, o) => {
    const i = () => e(r, o);
    return r.addEventListener(t, i, n), () => r.removeEventListener(t, i, n);
  };
}
function Q3(t, e = !1) {
  const n = (i) => {
    for (let s = i.length - 1; s >= 0; s--)
      if (i[s] !== t[s])
        return i.slice(0, s + 1);
    return "";
  }, r = [Z3((i) => [0, n(i).length])];
  let o = !1;
  if (e) {
    const i = xd("focus", (a) => {
      o = !0, a.value += t.slice(a.value.length), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    }), s = xd("blur", (a) => {
      o = !1, a.value = n(a.value), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    });
    r.push(i, s);
  }
  return {
    plugins: r,
    removePlaceholder: n,
    preprocessors: [({
      elementState: i,
      data: s
    }) => {
      const {
        value: a,
        selection: l
      } = i;
      return {
        elementState: {
          selection: l,
          value: n(a)
        },
        data: s
      };
    }],
    postprocessors: [({
      value: i,
      selection: s
    }, a) => a.value && (o || !e) ? {
      value: i + t.slice(i.length),
      selection: s
    } : {
      value: i,
      selection: s
    }]
  };
}
function J3() {
  return ({
    elementState: t
  }, e) => {
    const {
      value: n,
      selection: r
    } = t;
    if (!n || e9(n, r))
      return {
        elementState: t
      };
    const [o, i] = r, s = n.slice(o, i).replace(/\d/g, "0"), a = n.slice(0, o) + s + n.slice(i);
    return e === "validation" || e === "insert" && o === i ? {
      elementState: {
        selection: r,
        value: a
      }
    } : {
      elementState: {
        selection: e === "deleteBackward" || e === "insert" ? [o, o] : [i, i],
        value: a
      }
    };
  };
}
function e9(t, [e, n]) {
  return n === t.length;
}
function t9({
  mode: t,
  separator: e = ".",
  max: n,
  min: r
}) {
  const o = t.split("/").join(e);
  return Object.assign(Object.assign({}, hs), {
    mask: Array.from(o).map((i) => i === e ? i : /\d/),
    overwriteMode: "replace",
    preprocessors: [J3(), X3({
      dateModeTemplate: o,
      dateSegmentsSeparator: e
    })],
    postprocessors: [q3({
      min: r,
      max: n,
      dateModeTemplate: o,
      dateSegmentSeparator: e
    })]
  });
}
new RegExp(`[${H3.map(Wp).join("")}]$`);
const n9 = typeof window < "u" ? qi : ue, r9 = ({
  options: t = hs,
  elementPredicate: e = m3
} = {}) => {
  const [n, r] = ke(null), o = pe((i) => {
    r(i);
  }, []);
  return n9(() => {
    if (!n)
      return;
    const i = new T3(e(n), t);
    return () => {
      i.destroy();
    };
  }, [t, n, e]), o;
};
let Bs = 0;
function Vp() {
  ue(() => {
    var t, e;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (t = n[0]) !== null && t !== void 0 ? t : wd()), document.body.insertAdjacentElement("beforeend", (e = n[1]) !== null && e !== void 0 ? e : wd()), Bs++, () => {
      Bs === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Bs--;
    };
  }, []);
}
function wd() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", t;
}
const js = "focusScope.autoFocusOnMount", zs = "focusScope.autoFocusOnUnmount", _d = {
  bubbles: !1,
  cancelable: !0
}, o9 = /* @__PURE__ */ de((t, e) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...s } = t, [a, l] = ke(null), c = ht(o), u = ht(i), d = le(null), f = et(
    e,
    (g) => l(g)
  ), h = le({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ue(() => {
    if (r) {
      let g = function(y) {
        if (h.paused || !a)
          return;
        const w = y.target;
        a.contains(w) ? d.current = w : Mn(d.current, {
          select: !0
        });
      }, m = function(y) {
        if (h.paused || !a)
          return;
        const w = y.relatedTarget;
        w !== null && (a.contains(w) || Mn(d.current, {
          select: !0
        }));
      }, v = function(y) {
        const w = document.activeElement;
        for (const x of y)
          x.removedNodes.length > 0 && (a != null && a.contains(w) || Mn(a));
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const b = new MutationObserver(v);
      return a && b.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), b.disconnect();
      };
    }
  }, [
    r,
    a,
    h.paused
  ]), ue(() => {
    if (a) {
      Ed.add(h);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const v = new CustomEvent(js, _d);
        a.addEventListener(js, c), a.dispatchEvent(v), v.defaultPrevented || (i9(u9(Bp(a)), {
          select: !0
        }), document.activeElement === g && Mn(a));
      }
      return () => {
        a.removeEventListener(js, c), setTimeout(() => {
          const v = new CustomEvent(zs, _d);
          a.addEventListener(zs, u), a.dispatchEvent(v), v.defaultPrevented || Mn(g ?? document.body, {
            select: !0
          }), a.removeEventListener(zs, u), Ed.remove(h);
        }, 0);
      };
    }
  }, [
    a,
    c,
    u,
    h
  ]);
  const p = pe((g) => {
    if (!n && !r || h.paused)
      return;
    const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, v = document.activeElement;
    if (m && v) {
      const b = g.currentTarget, [y, w] = s9(b);
      y && w ? !g.shiftKey && v === w ? (g.preventDefault(), n && Mn(y, {
        select: !0
      })) : g.shiftKey && v === y && (g.preventDefault(), n && Mn(w, {
        select: !0
      })) : v === b && g.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ A(je.div, ne({
    tabIndex: -1
  }, s, {
    ref: f,
    onKeyDown: p
  }));
});
function i9(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Mn(r, {
      select: e
    }), document.activeElement !== n)
      return;
}
function s9(t) {
  const e = Bp(t), n = Cd(e, t), r = Cd(e.reverse(), t);
  return [
    n,
    r
  ];
}
function Bp(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function Cd(t, e) {
  for (const n of t)
    if (!a9(n, {
      upTo: e
    }))
      return n;
}
function a9(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function l9(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Mn(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({
      preventScroll: !0
    }), t !== n && l9(t) && e && t.select();
  }
}
const Ed = c9();
function c9() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = kd(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = kd(t, e), (n = t[0]) === null || n === void 0 || n.resume();
    }
  };
}
function kd(t, e) {
  const n = [
    ...t
  ], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function u9(t) {
  return t.filter(
    (e) => e.tagName !== "A"
  );
}
var d9 = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, _r = /* @__PURE__ */ new WeakMap(), ni = /* @__PURE__ */ new WeakMap(), ri = {}, Ys = 0, jp = function(t) {
  return t && (t.host || jp(t.parentNode));
}, f9 = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = jp(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, h9 = function(t, e, n, r) {
  var o = f9(e, Array.isArray(t) ? t : [t]);
  ri[n] || (ri[n] = /* @__PURE__ */ new WeakMap());
  var i = ri[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else {
        var h = f.getAttribute(r), p = h !== null && h !== "false", g = (_r.get(f) || 0) + 1, m = (i.get(f) || 0) + 1;
        _r.set(f, g), i.set(f, m), s.push(f), g === 1 && p && ni.set(f, !0), m === 1 && f.setAttribute(n, "true"), p || f.setAttribute(r, "true");
      }
    });
  };
  return u(e), a.clear(), Ys++, function() {
    s.forEach(function(d) {
      var f = _r.get(d) - 1, h = i.get(d) - 1;
      _r.set(d, f), i.set(d, h), f || (ni.has(d) || d.removeAttribute(r), ni.delete(d)), h || d.removeAttribute(n);
    }), Ys--, Ys || (_r = /* @__PURE__ */ new WeakMap(), _r = /* @__PURE__ */ new WeakMap(), ni = /* @__PURE__ */ new WeakMap(), ri = {});
  };
}, zp = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), o = e || d9(t);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), h9(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, bt = function() {
  return bt = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, bt.apply(this, arguments);
};
function Yp(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function p9(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = e.length, i; r < o; r++)
      (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
var yi = "right-scroll-bar-position", xi = "width-before-scroll-bar", g9 = "with-scroll-bars-hidden", m9 = "--removed-body-scroll-bar-size";
function v9(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function b9(t, e) {
  var n = ke(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
function y9(t, e) {
  return b9(e || null, function(n) {
    return t.forEach(function(r) {
      return v9(r, n);
    });
  });
}
function x9(t) {
  return t;
}
function w9(t, e) {
  e === void 0 && (e = x9);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(i) {
      var s = e(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var l = function() {
        var u = s;
        s = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          s.push(u), c();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return o;
}
function _9(t) {
  t === void 0 && (t = {});
  var e = w9(null);
  return e.options = bt({ async: !0, ssr: !1 }, t), e;
}
var Up = function(t) {
  var e = t.sideCar, n = Yp(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return S.createElement(r, bt({}, n));
};
Up.isSideCarExport = !0;
function C9(t, e) {
  return t.useMedium(e), Up;
}
var Gp = _9(), Us = function() {
}, gs = S.forwardRef(function(t, e) {
  var n = S.useRef(null), r = S.useState({
    onScrollCapture: Us,
    onWheelCapture: Us,
    onTouchMoveCapture: Us
  }), o = r[0], i = r[1], s = t.forwardProps, a = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, d = t.shards, f = t.sideCar, h = t.noIsolation, p = t.inert, g = t.allowPinchZoom, m = t.as, v = m === void 0 ? "div" : m, b = Yp(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), y = f, w = y9([n, e]), x = bt(bt({}, b), o);
  return S.createElement(
    S.Fragment,
    null,
    u && S.createElement(y, { sideCar: Gp, removeScrollBar: c, shards: d, noIsolation: h, inert: p, setCallbacks: i, allowPinchZoom: !!g, lockRef: n }),
    s ? S.cloneElement(S.Children.only(a), bt(bt({}, x), { ref: w })) : S.createElement(v, bt({}, x, { className: l, ref: w }), a)
  );
});
gs.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
gs.classNames = {
  fullWidth: xi,
  zeroRight: yi
};
var Md, E9 = function() {
  if (Md)
    return Md;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function k9() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = E9();
  return e && t.setAttribute("nonce", e), t;
}
function M9(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function O9(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var P9 = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = k9()) && (M9(e, n), O9(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, S9 = function() {
  var t = P9();
  return function(e, n) {
    S.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, Kp = function() {
  var t = S9(), e = function(n) {
    var r = n.styles, o = n.dynamic;
    return t(r, o), null;
  };
  return e;
}, D9 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Gs = function(t) {
  return parseInt(t || "", 10) || 0;
}, T9 = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], o = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [Gs(n), Gs(r), Gs(o)];
}, I9 = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return D9;
  var e = T9(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, $9 = Kp(), N9 = function(t, e, n, r) {
  var o = t.left, i = t.top, s = t.right, a = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(g9, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(yi, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(xi, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(yi, " .").concat(yi, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(xi, " .").concat(xi, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(m9, ": ").concat(a, `px;
  }
`);
}, R9 = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, o = r === void 0 ? "margin" : r, i = S.useMemo(function() {
    return I9(o);
  }, [o]);
  return S.createElement($9, { styles: N9(i, !e, o, n ? "" : "!important") });
}, Da = !1;
if (typeof window < "u")
  try {
    var oi = Object.defineProperty({}, "passive", {
      get: function() {
        return Da = !0, !0;
      }
    });
    window.addEventListener("test", oi, oi), window.removeEventListener("test", oi, oi);
  } catch {
    Da = !1;
  }
var Cr = Da ? { passive: !1 } : !1, A9 = function(t) {
  return t.tagName === "TEXTAREA";
}, qp = function(t, e) {
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !A9(t) && n[e] === "visible")
  );
}, L9 = function(t) {
  return qp(t, "overflowY");
}, F9 = function(t) {
  return qp(t, "overflowX");
}, Od = function(t, e) {
  var n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = Xp(t, n);
    if (r) {
      var o = Zp(t, n), i = o[1], s = o[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, H9 = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, W9 = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, Xp = function(t, e) {
  return t === "v" ? L9(e) : F9(e);
}, Zp = function(t, e) {
  return t === "v" ? H9(e) : W9(e);
}, V9 = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, B9 = function(t, e, n, r, o) {
  var i = V9(t, window.getComputedStyle(e).direction), s = i * r, a = n.target, l = e.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    var h = Zp(t, a), p = h[0], g = h[1], m = h[2], v = g - m - i * p;
    (p || v) && Xp(t, a) && (d += v, f += p), a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (e.contains(a) || e === a)
  );
  return (u && (o && d === 0 || !o && s > d) || !u && (o && f === 0 || !o && -s > f)) && (c = !0), c;
}, ii = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, Pd = function(t) {
  return [t.deltaX, t.deltaY];
}, Sd = function(t) {
  return t && "current" in t ? t.current : t;
}, j9 = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, z9 = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, Y9 = 0, Er = [];
function U9(t) {
  var e = S.useRef([]), n = S.useRef([0, 0]), r = S.useRef(), o = S.useState(Y9++)[0], i = S.useState(function() {
    return Kp();
  })[0], s = S.useRef(t);
  S.useEffect(function() {
    s.current = t;
  }, [t]), S.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = p9([t.lockRef.current], (t.shards || []).map(Sd), !0).filter(Boolean);
      return g.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var a = S.useCallback(function(g, m) {
    if ("touches" in g && g.touches.length === 2)
      return !s.current.allowPinchZoom;
    var v = ii(g), b = n.current, y = "deltaX" in g ? g.deltaX : b[0] - v[0], w = "deltaY" in g ? g.deltaY : b[1] - v[1], x, M = g.target, E = Math.abs(y) > Math.abs(w) ? "h" : "v";
    if ("touches" in g && E === "h" && M.type === "range")
      return !1;
    var C = Od(E, M);
    if (!C)
      return !0;
    if (C ? x = E : (x = E === "v" ? "h" : "v", C = Od(E, M)), !C)
      return !1;
    if (!r.current && "changedTouches" in g && (y || w) && (r.current = x), !x)
      return !0;
    var O = r.current || x;
    return B9(O, m, g, O === "h" ? y : w, !0);
  }, []), l = S.useCallback(function(g) {
    var m = g;
    if (!(!Er.length || Er[Er.length - 1] !== i)) {
      var v = "deltaY" in m ? Pd(m) : ii(m), b = e.current.filter(function(x) {
        return x.name === m.type && x.target === m.target && j9(x.delta, v);
      })[0];
      if (b && b.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!b) {
        var y = (s.current.shards || []).map(Sd).filter(Boolean).filter(function(x) {
          return x.contains(m.target);
        }), w = y.length > 0 ? a(m, y[0]) : !s.current.noIsolation;
        w && m.cancelable && m.preventDefault();
      }
    }
  }, []), c = S.useCallback(function(g, m, v, b) {
    var y = { name: g, delta: m, target: v, should: b };
    e.current.push(y), setTimeout(function() {
      e.current = e.current.filter(function(w) {
        return w !== y;
      });
    }, 1);
  }, []), u = S.useCallback(function(g) {
    n.current = ii(g), r.current = void 0;
  }, []), d = S.useCallback(function(g) {
    c(g.type, Pd(g), g.target, a(g, t.lockRef.current));
  }, []), f = S.useCallback(function(g) {
    c(g.type, ii(g), g.target, a(g, t.lockRef.current));
  }, []);
  S.useEffect(function() {
    return Er.push(i), t.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Cr), document.addEventListener("touchmove", l, Cr), document.addEventListener("touchstart", u, Cr), function() {
      Er = Er.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, Cr), document.removeEventListener("touchmove", l, Cr), document.removeEventListener("touchstart", u, Cr);
    };
  }, []);
  var h = t.removeScrollBar, p = t.inert;
  return S.createElement(
    S.Fragment,
    null,
    p ? S.createElement(i, { styles: z9(o) }) : null,
    h ? S.createElement(R9, { gapMode: "margin" }) : null
  );
}
const G9 = C9(Gp, U9);
var Qp = S.forwardRef(function(t, e) {
  return S.createElement(gs, bt({}, t, { ref: e, sideCar: G9 }));
});
Qp.classNames = gs.classNames;
const Jp = Qp, eg = "Popover", [tg, I8] = sn(eg, [
  Qi
]), Ro = Qi(), [K9, Bn] = tg(eg), q9 = (t) => {
  const { __scopePopover: e, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: s = !1 } = t, a = Ro(e), l = le(null), [c, u] = ke(!1), [d = !1, f] = Wn({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ A(Lf, a, /* @__PURE__ */ A(K9, {
    scope: e,
    contentId: po(),
    triggerRef: l,
    open: d,
    onOpenChange: f,
    onOpenToggle: pe(
      () => f(
        (h) => !h
      ),
      [
        f
      ]
    ),
    hasCustomAnchor: c,
    onCustomAnchorAdd: pe(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: pe(
      () => u(!1),
      []
    ),
    modal: s
  }, n));
}, X9 = "PopoverAnchor", Z9 = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, ...r } = t, o = Bn(X9, n), i = Ro(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: a } = o;
  return ue(() => (s(), () => a()), [
    s,
    a
  ]), /* @__PURE__ */ A(ol, ne({}, i, r, {
    ref: e
  }));
}), Q9 = "PopoverTrigger", J9 = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, ...r } = t, o = Bn(Q9, n), i = Ro(n), s = et(e, o.triggerRef), a = /* @__PURE__ */ A(je.button, ne({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": og(o.open)
  }, r, {
    ref: s,
    onClick: ve(t.onClick, o.onOpenToggle)
  }));
  return o.hasCustomAnchor ? a : /* @__PURE__ */ A(ol, ne({
    asChild: !0
  }, i), a);
}), ng = "PopoverPortal", [e4, t4] = tg(ng, {
  forceMount: void 0
}), n4 = (t) => {
  const { __scopePopover: e, forceMount: n, children: r, container: o } = t, i = Bn(ng, e);
  return /* @__PURE__ */ A(e4, {
    scope: e,
    forceMount: n
  }, /* @__PURE__ */ A(ur, {
    present: n || i.open
  }, /* @__PURE__ */ A(il, {
    asChild: !0,
    container: o
  }, r)));
}, ko = "PopoverContent", r4 = /* @__PURE__ */ de((t, e) => {
  const n = t4(ko, t.__scopePopover), { forceMount: r = n.forceMount, ...o } = t, i = Bn(ko, t.__scopePopover);
  return /* @__PURE__ */ A(ur, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ A(o4, ne({}, o, {
    ref: e
  })) : /* @__PURE__ */ A(i4, ne({}, o, {
    ref: e
  })));
}), o4 = /* @__PURE__ */ de((t, e) => {
  const n = Bn(ko, t.__scopePopover), r = le(null), o = et(e, r), i = le(!1);
  return ue(() => {
    const s = r.current;
    if (s)
      return zp(s);
  }, []), /* @__PURE__ */ A(Jp, {
    as: zt,
    allowPinchZoom: !0
  }, /* @__PURE__ */ A(rg, ne({}, t, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: ve(t.onCloseAutoFocus, (s) => {
      var a;
      s.preventDefault(), i.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: ve(t.onPointerDownOutside, (s) => {
      const a = s.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0, c = a.button === 2 || l;
      i.current = c;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: ve(
      t.onFocusOutside,
      (s) => s.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), i4 = /* @__PURE__ */ de((t, e) => {
  const n = Bn(ko, t.__scopePopover), r = le(!1), o = le(!1);
  return /* @__PURE__ */ A(rg, ne({}, t, {
    ref: e,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var s;
      if ((s = t.onCloseAutoFocus) === null || s === void 0 || s.call(t, i), !i.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var s, a;
      (s = t.onInteractOutside) === null || s === void 0 || s.call(t, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = i.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), rg = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, disableOutsidePointerEvents: s, onEscapeKeyDown: a, onPointerDownOutside: l, onFocusOutside: c, onInteractOutside: u, ...d } = t, f = Bn(ko, n), h = Ro(n);
  return Vp(), /* @__PURE__ */ A(o9, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ A(bf, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onInteractOutside: u,
    onEscapeKeyDown: a,
    onPointerDownOutside: l,
    onFocusOutside: c,
    onDismiss: () => f.onOpenChange(!1)
  }, /* @__PURE__ */ A(Ff, ne({
    "data-state": og(f.open),
    role: "dialog",
    id: f.contentId
  }, h, d, {
    ref: e,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), s4 = "PopoverClose", a4 = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, ...r } = t, o = Bn(s4, n);
  return /* @__PURE__ */ A(je.button, ne({
    type: "button"
  }, r, {
    ref: e,
    onClick: ve(
      t.onClick,
      () => o.onOpenChange(!1)
    )
  }));
}), l4 = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, ...r } = t, o = Ro(n);
  return /* @__PURE__ */ A(Hf, ne({}, o, r, {
    ref: e
  }));
});
function og(t) {
  return t ? "open" : "closed";
}
const ig = q9, c4 = Z9, sg = J9, ag = n4, lg = r4, u4 = a4, d4 = l4, f4 = ({
  name: t,
  id: e,
  className: n,
  selected: r,
  onSelect: o,
  disablePortal: i = !1,
  fromDate: s,
  toDate: a
}) => {
  const [l, c] = S.useState(!1), { inputRef: u, inputProps: d, setInputValue: f, month: h, setMonth: p } = It(
    {
      onSelect: o,
      selected: r,
      fromDate: s,
      toDate: a
    }
  ), g = (v) => {
    v ? (o(xt(v, It.valueFormatString)), c(!1)) : (o(""), f(""));
  }, m = i ? S.Fragment : ag;
  return /* @__PURE__ */ Z(ig, { open: l, onOpenChange: c, children: [
    /* @__PURE__ */ _(c4, { asChild: !0, children: /* @__PURE__ */ _(
      g4,
      {
        ref: u,
        icon: /* @__PURE__ */ _(sg, { className: "-m-1 rounded p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500", children: /* @__PURE__ */ _(FC, { className: "h-5 w-5" }) }),
        className: n,
        id: e,
        name: t,
        ...d
      }
    ) }),
    /* @__PURE__ */ _(m, { children: /* @__PURE__ */ _(
      lg,
      {
        className: "z-10",
        side: "bottom",
        sideOffset: 4,
        collisionPadding: 4,
        children: /* @__PURE__ */ _(
          $p,
          {
            mode: "single",
            className: "shadow-3",
            initialFocus: !0,
            onSelect: g,
            selected: r ? kr(r, It.valueFormatString, /* @__PURE__ */ new Date()) : void 0,
            month: h,
            onMonthChange: p,
            fromDate: s,
            toDate: a
          }
        )
      }
    ) })
  ] });
};
f4.displayName = "DatePicker";
const si = t9({
  mode: "dd/mm/yyyy",
  separator: "-"
}), { plugins: h4, ...Dd } = Q3(
  "dd-mm-yyyy",
  !0
), p4 = {
  ...si,
  plugins: h4.concat(si.plugins || []),
  preprocessors: [
    // Always put it BEFORE all other preprocessors
    ...Dd.preprocessors,
    ...si.preprocessors
  ],
  postprocessors: [
    ...si.postprocessors,
    // Always put it AFTER all other postprocessors
    ...Dd.postprocessors
  ]
}, It = ({
  selected: t,
  onSelect: e,
  fromDate: n,
  toDate: r
}) => {
  const [o, i] = S.useState(""), [s, a] = S.useState(), l = r9({ options: p4 });
  return S.useEffect(() => {
    t && (a(kr(t, It.valueFormatString, /* @__PURE__ */ new Date())), i(
      xt(
        kr(t, It.valueFormatString, /* @__PURE__ */ new Date()),
        It.inputFormatString
      )
    ));
  }, [t]), {
    inputRef: l,
    setInputValue: i,
    month: s,
    setMonth: a,
    inputProps: {
      value: o,
      onBlur: (c) => {
        if (!c.target.value) {
          e(""), a(/* @__PURE__ */ new Date());
          return;
        }
        const u = kr(
          c.target.value,
          It.inputFormatString,
          /* @__PURE__ */ new Date()
        ), d = n && Nt(n, u) > 0, f = r && Nt(u, r) > 0;
        if (!kl(u) || d || f) {
          i(
            t ? xt(
              kr(t, It.valueFormatString, /* @__PURE__ */ new Date()),
              It.inputFormatString
            ) : ""
          );
          return;
        }
        e(xt(u, It.valueFormatString)), a(u);
      },
      onChange: () => {
      },
      onInput: (c) => i(c.currentTarget.value)
    }
  };
};
It.valueFormatString = "yyyy-MM-dd";
It.inputFormatString = "dd-MM-yyyy";
const g4 = S.forwardRef(({ className: t, icon: e, ...n }, r) => /* @__PURE__ */ _(
  cp,
  {
    ref: r,
    containerClassName: t,
    icon: e,
    type: "text",
    placeholder: "dd-mm-yyyy",
    ...n
  }
)), m4 = ig, v4 = sg, b4 = u4, $8 = d4, y4 = P.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ _(ag, { children: /* @__PURE__ */ _(lg, { ...e, ref: n, children: t }) })), x4 = ({ children: t }) => /* @__PURE__ */ _(h0, { asChild: !0, children: t });
function w4(t, e, n = []) {
  S.useEffect(() => {
    const r = setTimeout(() => {
      t();
    }, e);
    return () => {
      clearTimeout(r);
    };
  }, [e, ...n]);
}
const cg = S.createContext(null), _n = () => {
  const t = S.useContext(cg);
  if (!t)
    throw new Error(
      "useDropdownSearchContext must be used within <DropdownSearch />"
    );
  return t;
};
function tn(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(e.indexOf(o) >= 0) && (n[o] = t[o]);
  return n;
}
function me() {
  return me = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, me.apply(this, arguments);
}
function Td(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ta(t, e) {
  return Ta = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Ta(t, e);
}
function _4(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, Ta(t, e);
}
var Ia = { exports: {} }, ai = { exports: {} }, Ie = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Id;
function C4() {
  if (Id)
    return Ie;
  Id = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, b = t ? Symbol.for("react.scope") : 60119;
  function y(x) {
    if (typeof x == "object" && x !== null) {
      var M = x.$$typeof;
      switch (M) {
        case e:
          switch (x = x.type, x) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case a:
                case u:
                case p:
                case h:
                case s:
                  return x;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function w(x) {
    return y(x) === c;
  }
  return Ie.AsyncMode = l, Ie.ConcurrentMode = c, Ie.ContextConsumer = a, Ie.ContextProvider = s, Ie.Element = e, Ie.ForwardRef = u, Ie.Fragment = r, Ie.Lazy = p, Ie.Memo = h, Ie.Portal = n, Ie.Profiler = i, Ie.StrictMode = o, Ie.Suspense = d, Ie.isAsyncMode = function(x) {
    return w(x) || y(x) === l;
  }, Ie.isConcurrentMode = w, Ie.isContextConsumer = function(x) {
    return y(x) === a;
  }, Ie.isContextProvider = function(x) {
    return y(x) === s;
  }, Ie.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === e;
  }, Ie.isForwardRef = function(x) {
    return y(x) === u;
  }, Ie.isFragment = function(x) {
    return y(x) === r;
  }, Ie.isLazy = function(x) {
    return y(x) === p;
  }, Ie.isMemo = function(x) {
    return y(x) === h;
  }, Ie.isPortal = function(x) {
    return y(x) === n;
  }, Ie.isProfiler = function(x) {
    return y(x) === i;
  }, Ie.isStrictMode = function(x) {
    return y(x) === o;
  }, Ie.isSuspense = function(x) {
    return y(x) === d;
  }, Ie.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === c || x === i || x === o || x === d || x === f || typeof x == "object" && x !== null && (x.$$typeof === p || x.$$typeof === h || x.$$typeof === s || x.$$typeof === a || x.$$typeof === u || x.$$typeof === m || x.$$typeof === v || x.$$typeof === b || x.$$typeof === g);
  }, Ie.typeOf = y, Ie;
}
var $e = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $d;
function E4() {
  return $d || ($d = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, b = t ? Symbol.for("react.scope") : 60119;
    function y(U) {
      return typeof U == "string" || typeof U == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      U === r || U === c || U === i || U === o || U === d || U === f || typeof U == "object" && U !== null && (U.$$typeof === p || U.$$typeof === h || U.$$typeof === s || U.$$typeof === a || U.$$typeof === u || U.$$typeof === m || U.$$typeof === v || U.$$typeof === b || U.$$typeof === g);
    }
    function w(U) {
      if (typeof U == "object" && U !== null) {
        var be = U.$$typeof;
        switch (be) {
          case e:
            var De = U.type;
            switch (De) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case d:
                return De;
              default:
                var Re = De && De.$$typeof;
                switch (Re) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case s:
                    return Re;
                  default:
                    return be;
                }
            }
          case n:
            return be;
        }
      }
    }
    var x = l, M = c, E = a, C = s, O = e, R = u, D = r, $ = p, T = h, j = n, L = i, Y = o, H = d, z = !1;
    function ee(U) {
      return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(U) || w(U) === l;
    }
    function I(U) {
      return w(U) === c;
    }
    function F(U) {
      return w(U) === a;
    }
    function te(U) {
      return w(U) === s;
    }
    function J(U) {
      return typeof U == "object" && U !== null && U.$$typeof === e;
    }
    function re(U) {
      return w(U) === u;
    }
    function B(U) {
      return w(U) === r;
    }
    function N(U) {
      return w(U) === p;
    }
    function W(U) {
      return w(U) === h;
    }
    function V(U) {
      return w(U) === n;
    }
    function G(U) {
      return w(U) === i;
    }
    function oe(U) {
      return w(U) === o;
    }
    function X(U) {
      return w(U) === d;
    }
    $e.AsyncMode = x, $e.ConcurrentMode = M, $e.ContextConsumer = E, $e.ContextProvider = C, $e.Element = O, $e.ForwardRef = R, $e.Fragment = D, $e.Lazy = $, $e.Memo = T, $e.Portal = j, $e.Profiler = L, $e.StrictMode = Y, $e.Suspense = H, $e.isAsyncMode = ee, $e.isConcurrentMode = I, $e.isContextConsumer = F, $e.isContextProvider = te, $e.isElement = J, $e.isForwardRef = re, $e.isFragment = B, $e.isLazy = N, $e.isMemo = W, $e.isPortal = V, $e.isProfiler = G, $e.isStrictMode = oe, $e.isSuspense = X, $e.isValidElementType = y, $e.typeOf = w;
  }()), $e;
}
var Nd;
function ug() {
  return Nd || (Nd = 1, process.env.NODE_ENV === "production" ? ai.exports = C4() : ai.exports = E4()), ai.exports;
}
var Ks, Rd;
function Wl() {
  if (Rd)
    return Ks;
  Rd = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ks = t, Ks;
}
var qs, Ad;
function dg() {
  return Ad || (Ad = 1, qs = Function.call.bind(Object.prototype.hasOwnProperty)), qs;
}
var Xs, Ld;
function k4() {
  if (Ld)
    return Xs;
  Ld = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Wl(), n = {}, r = dg();
    t = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[u](s, u, l, a, null, e);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            t(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Xs = o, Xs;
}
var Zs, Fd;
function M4() {
  if (Fd)
    return Zs;
  Fd = 1;
  var t = ug(), e = Wa(), n = Wl(), r = dg(), o = k4(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Zs = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(I) {
      var F = I && (c && I[c] || I[u]);
      if (typeof F == "function")
        return F;
    }
    var f = "<<anonymous>>", h = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: b(),
      arrayOf: y,
      element: w(),
      elementType: x(),
      instanceOf: M,
      node: R(),
      objectOf: C,
      oneOf: E,
      oneOfType: O,
      shape: $,
      exact: T
    };
    function p(I, F) {
      return I === F ? I !== 0 || 1 / I === 1 / F : I !== I && F !== F;
    }
    function g(I, F) {
      this.message = I, this.data = F && typeof F == "object" ? F : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(I) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, te = 0;
      function J(B, N, W, V, G, oe, X) {
        if (V = V || f, oe = oe || W, X !== n) {
          if (l) {
            var U = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw U.name = "Invariant Violation", U;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var be = V + ":" + W;
            !F[be] && // Avoid spamming the console because they are often not actionable except for lib authors
            te < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + oe + "` prop on `" + V + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[be] = !0, te++);
          }
        }
        return N[W] == null ? B ? N[W] === null ? new g("The " + G + " `" + oe + "` is marked as required " + ("in `" + V + "`, but its value is `null`.")) : new g("The " + G + " `" + oe + "` is marked as required in " + ("`" + V + "`, but its value is `undefined`.")) : null : I(N, W, V, G, oe);
      }
      var re = J.bind(null, !1);
      return re.isRequired = J.bind(null, !0), re;
    }
    function v(I) {
      function F(te, J, re, B, N, W) {
        var V = te[J], G = Y(V);
        if (G !== I) {
          var oe = H(V);
          return new g(
            "Invalid " + B + " `" + N + "` of type " + ("`" + oe + "` supplied to `" + re + "`, expected ") + ("`" + I + "`."),
            { expectedType: I }
          );
        }
        return null;
      }
      return m(F);
    }
    function b() {
      return m(s);
    }
    function y(I) {
      function F(te, J, re, B, N) {
        if (typeof I != "function")
          return new g("Property `" + N + "` of component `" + re + "` has invalid PropType notation inside arrayOf.");
        var W = te[J];
        if (!Array.isArray(W)) {
          var V = Y(W);
          return new g("Invalid " + B + " `" + N + "` of type " + ("`" + V + "` supplied to `" + re + "`, expected an array."));
        }
        for (var G = 0; G < W.length; G++) {
          var oe = I(W, G, re, B, N + "[" + G + "]", n);
          if (oe instanceof Error)
            return oe;
        }
        return null;
      }
      return m(F);
    }
    function w() {
      function I(F, te, J, re, B) {
        var N = F[te];
        if (!a(N)) {
          var W = Y(N);
          return new g("Invalid " + re + " `" + B + "` of type " + ("`" + W + "` supplied to `" + J + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(I);
    }
    function x() {
      function I(F, te, J, re, B) {
        var N = F[te];
        if (!t.isValidElementType(N)) {
          var W = Y(N);
          return new g("Invalid " + re + " `" + B + "` of type " + ("`" + W + "` supplied to `" + J + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(I);
    }
    function M(I) {
      function F(te, J, re, B, N) {
        if (!(te[J] instanceof I)) {
          var W = I.name || f, V = ee(te[J]);
          return new g("Invalid " + B + " `" + N + "` of type " + ("`" + V + "` supplied to `" + re + "`, expected ") + ("instance of `" + W + "`."));
        }
        return null;
      }
      return m(F);
    }
    function E(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function F(te, J, re, B, N) {
        for (var W = te[J], V = 0; V < I.length; V++)
          if (p(W, I[V]))
            return null;
        var G = JSON.stringify(I, function(X, U) {
          var be = H(U);
          return be === "symbol" ? String(U) : U;
        });
        return new g("Invalid " + B + " `" + N + "` of value `" + String(W) + "` " + ("supplied to `" + re + "`, expected one of " + G + "."));
      }
      return m(F);
    }
    function C(I) {
      function F(te, J, re, B, N) {
        if (typeof I != "function")
          return new g("Property `" + N + "` of component `" + re + "` has invalid PropType notation inside objectOf.");
        var W = te[J], V = Y(W);
        if (V !== "object")
          return new g("Invalid " + B + " `" + N + "` of type " + ("`" + V + "` supplied to `" + re + "`, expected an object."));
        for (var G in W)
          if (r(W, G)) {
            var oe = I(W, G, re, B, N + "." + G, n);
            if (oe instanceof Error)
              return oe;
          }
        return null;
      }
      return m(F);
    }
    function O(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var F = 0; F < I.length; F++) {
        var te = I[F];
        if (typeof te != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + z(te) + " at index " + F + "."
          ), s;
      }
      function J(re, B, N, W, V) {
        for (var G = [], oe = 0; oe < I.length; oe++) {
          var X = I[oe], U = X(re, B, N, W, V, n);
          if (U == null)
            return null;
          U.data && r(U.data, "expectedType") && G.push(U.data.expectedType);
        }
        var be = G.length > 0 ? ", expected one of type [" + G.join(", ") + "]" : "";
        return new g("Invalid " + W + " `" + V + "` supplied to " + ("`" + N + "`" + be + "."));
      }
      return m(J);
    }
    function R() {
      function I(F, te, J, re, B) {
        return j(F[te]) ? null : new g("Invalid " + re + " `" + B + "` supplied to " + ("`" + J + "`, expected a ReactNode."));
      }
      return m(I);
    }
    function D(I, F, te, J, re) {
      return new g(
        (I || "React class") + ": " + F + " type `" + te + "." + J + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + re + "`."
      );
    }
    function $(I) {
      function F(te, J, re, B, N) {
        var W = te[J], V = Y(W);
        if (V !== "object")
          return new g("Invalid " + B + " `" + N + "` of type `" + V + "` " + ("supplied to `" + re + "`, expected `object`."));
        for (var G in I) {
          var oe = I[G];
          if (typeof oe != "function")
            return D(re, B, N, G, H(oe));
          var X = oe(W, G, re, B, N + "." + G, n);
          if (X)
            return X;
        }
        return null;
      }
      return m(F);
    }
    function T(I) {
      function F(te, J, re, B, N) {
        var W = te[J], V = Y(W);
        if (V !== "object")
          return new g("Invalid " + B + " `" + N + "` of type `" + V + "` " + ("supplied to `" + re + "`, expected `object`."));
        var G = e({}, te[J], I);
        for (var oe in G) {
          var X = I[oe];
          if (r(I, oe) && typeof X != "function")
            return D(re, B, N, oe, H(X));
          if (!X)
            return new g(
              "Invalid " + B + " `" + N + "` key `" + oe + "` supplied to `" + re + "`.\nBad object: " + JSON.stringify(te[J], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(I), null, "  ")
            );
          var U = X(W, oe, re, B, N + "." + oe, n);
          if (U)
            return U;
        }
        return null;
      }
      return m(F);
    }
    function j(I) {
      switch (typeof I) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !I;
        case "object":
          if (Array.isArray(I))
            return I.every(j);
          if (I === null || a(I))
            return !0;
          var F = d(I);
          if (F) {
            var te = F.call(I), J;
            if (F !== I.entries) {
              for (; !(J = te.next()).done; )
                if (!j(J.value))
                  return !1;
            } else
              for (; !(J = te.next()).done; ) {
                var re = J.value;
                if (re && !j(re[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L(I, F) {
      return I === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function Y(I) {
      var F = typeof I;
      return Array.isArray(I) ? "array" : I instanceof RegExp ? "object" : L(F, I) ? "symbol" : F;
    }
    function H(I) {
      if (typeof I > "u" || I === null)
        return "" + I;
      var F = Y(I);
      if (F === "object") {
        if (I instanceof Date)
          return "date";
        if (I instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function z(I) {
      var F = H(I);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function ee(I) {
      return !I.constructor || !I.constructor.name ? f : I.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, Zs;
}
var Qs, Hd;
function O4() {
  if (Hd)
    return Qs;
  Hd = 1;
  var t = Wl();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, Qs = function() {
    function r(s, a, l, c, u, d) {
      if (d !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, Qs;
}
if (process.env.NODE_ENV !== "production") {
  var P4 = ug(), S4 = !0;
  Ia.exports = M4()(P4.isElement, S4);
} else
  Ia.exports = O4()();
var D4 = Ia.exports;
const K = /* @__PURE__ */ Rm(D4);
var $a = { exports: {} }, He = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wd;
function T4() {
  if (Wd)
    return He;
  Wd = 1;
  var t = 60103, e = 60106, n = 60107, r = 60108, o = 60114, i = 60109, s = 60110, a = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, m = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var v = Symbol.for;
    t = v("react.element"), e = v("react.portal"), n = v("react.fragment"), r = v("react.strict_mode"), o = v("react.profiler"), i = v("react.provider"), s = v("react.context"), a = v("react.forward_ref"), l = v("react.suspense"), c = v("react.suspense_list"), u = v("react.memo"), d = v("react.lazy"), f = v("react.block"), h = v("react.server.block"), p = v("react.fundamental"), g = v("react.debug_trace_mode"), m = v("react.legacy_hidden");
  }
  function b(T) {
    if (typeof T == "object" && T !== null) {
      var j = T.$$typeof;
      switch (j) {
        case t:
          switch (T = T.type, T) {
            case n:
            case o:
            case r:
            case l:
            case c:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case s:
                case a:
                case d:
                case u:
                case i:
                  return T;
                default:
                  return j;
              }
          }
        case e:
          return j;
      }
    }
  }
  var y = i, w = t, x = a, M = n, E = d, C = u, O = e, R = o, D = r, $ = l;
  return He.ContextConsumer = s, He.ContextProvider = y, He.Element = w, He.ForwardRef = x, He.Fragment = M, He.Lazy = E, He.Memo = C, He.Portal = O, He.Profiler = R, He.StrictMode = D, He.Suspense = $, He.isAsyncMode = function() {
    return !1;
  }, He.isConcurrentMode = function() {
    return !1;
  }, He.isContextConsumer = function(T) {
    return b(T) === s;
  }, He.isContextProvider = function(T) {
    return b(T) === i;
  }, He.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, He.isForwardRef = function(T) {
    return b(T) === a;
  }, He.isFragment = function(T) {
    return b(T) === n;
  }, He.isLazy = function(T) {
    return b(T) === d;
  }, He.isMemo = function(T) {
    return b(T) === u;
  }, He.isPortal = function(T) {
    return b(T) === e;
  }, He.isProfiler = function(T) {
    return b(T) === o;
  }, He.isStrictMode = function(T) {
    return b(T) === r;
  }, He.isSuspense = function(T) {
    return b(T) === l;
  }, He.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === n || T === o || T === g || T === r || T === l || T === c || T === m || typeof T == "object" && T !== null && (T.$$typeof === d || T.$$typeof === u || T.$$typeof === i || T.$$typeof === s || T.$$typeof === a || T.$$typeof === p || T.$$typeof === f || T[0] === h);
  }, He.typeOf = b, He;
}
var We = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vd;
function I4() {
  return Vd || (Vd = 1, process.env.NODE_ENV !== "production" && function() {
    var t = 60103, e = 60106, n = 60107, r = 60108, o = 60114, i = 60109, s = 60110, a = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, m = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var v = Symbol.for;
      t = v("react.element"), e = v("react.portal"), n = v("react.fragment"), r = v("react.strict_mode"), o = v("react.profiler"), i = v("react.provider"), s = v("react.context"), a = v("react.forward_ref"), l = v("react.suspense"), c = v("react.suspense_list"), u = v("react.memo"), d = v("react.lazy"), f = v("react.block"), h = v("react.server.block"), p = v("react.fundamental"), v("react.scope"), v("react.opaque.id"), g = v("react.debug_trace_mode"), v("react.offscreen"), m = v("react.legacy_hidden");
    }
    var b = !1;
    function y(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === n || X === o || X === g || X === r || X === l || X === c || X === m || b || typeof X == "object" && X !== null && (X.$$typeof === d || X.$$typeof === u || X.$$typeof === i || X.$$typeof === s || X.$$typeof === a || X.$$typeof === p || X.$$typeof === f || X[0] === h));
    }
    function w(X) {
      if (typeof X == "object" && X !== null) {
        var U = X.$$typeof;
        switch (U) {
          case t:
            var be = X.type;
            switch (be) {
              case n:
              case o:
              case r:
              case l:
              case c:
                return be;
              default:
                var De = be && be.$$typeof;
                switch (De) {
                  case s:
                  case a:
                  case d:
                  case u:
                  case i:
                    return De;
                  default:
                    return U;
                }
            }
          case e:
            return U;
        }
      }
    }
    var x = s, M = i, E = t, C = a, O = n, R = d, D = u, $ = e, T = o, j = r, L = l, Y = !1, H = !1;
    function z(X) {
      return Y || (Y = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ee(X) {
      return H || (H = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function I(X) {
      return w(X) === s;
    }
    function F(X) {
      return w(X) === i;
    }
    function te(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function J(X) {
      return w(X) === a;
    }
    function re(X) {
      return w(X) === n;
    }
    function B(X) {
      return w(X) === d;
    }
    function N(X) {
      return w(X) === u;
    }
    function W(X) {
      return w(X) === e;
    }
    function V(X) {
      return w(X) === o;
    }
    function G(X) {
      return w(X) === r;
    }
    function oe(X) {
      return w(X) === l;
    }
    We.ContextConsumer = x, We.ContextProvider = M, We.Element = E, We.ForwardRef = C, We.Fragment = O, We.Lazy = R, We.Memo = D, We.Portal = $, We.Profiler = T, We.StrictMode = j, We.Suspense = L, We.isAsyncMode = z, We.isConcurrentMode = ee, We.isContextConsumer = I, We.isContextProvider = F, We.isElement = te, We.isForwardRef = J, We.isFragment = re, We.isLazy = B, We.isMemo = N, We.isPortal = W, We.isProfiler = V, We.isStrictMode = G, We.isSuspense = oe, We.isValidElementType = y, We.typeOf = w;
  }()), We;
}
process.env.NODE_ENV === "production" ? $a.exports = T4() : $a.exports = I4();
var Bd = $a.exports;
let jd = (t) => typeof t == "object" && t != null && t.nodeType === 1, zd = (t, e) => (!e || t !== "hidden") && t !== "visible" && t !== "clip", Js = (t, e) => {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    let n = getComputedStyle(t, null);
    return zd(n.overflowY, e) || zd(n.overflowX, e) || ((r) => {
      let o = ((i) => {
        if (!i.ownerDocument || !i.ownerDocument.defaultView)
          return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
    })(t);
  }
  return !1;
}, li = (t, e, n, r, o, i, s, a) => i < t && s > e || i > t && s < e ? 0 : i <= t && a <= n || s >= e && a >= n ? i - t - r : s > e && a < n || i < t && a > n ? s - e + o : 0, $4 = (t) => {
  let e = t.parentElement;
  return e ?? (t.getRootNode().host || null);
};
var N4 = (t, e) => {
  var n, r, o, i, s, a;
  if (typeof document > "u")
    return [];
  let { scrollMode: l, block: c, inline: u, boundary: d, skipOverflowHiddenElements: f } = e, h = typeof d == "function" ? d : (j) => j !== d;
  if (!jd(t))
    throw new TypeError("Invalid target");
  let p = document.scrollingElement || document.documentElement, g = [], m = t;
  for (; jd(m) && h(m); ) {
    if (m = $4(m), m === p) {
      g.push(m);
      break;
    }
    m != null && m === document.body && Js(m) && !Js(document.documentElement) || m != null && Js(m, f) && g.push(m);
  }
  let v = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, b = (i = (o = window.visualViewport) == null ? void 0 : o.height) != null ? i : innerHeight, y = (s = window.scrollX) != null ? s : pageXOffset, w = (a = window.scrollY) != null ? a : pageYOffset, { height: x, width: M, top: E, right: C, bottom: O, left: R } = t.getBoundingClientRect(), D = c === "start" || c === "nearest" ? E : c === "end" ? O : E + x / 2, $ = u === "center" ? R + M / 2 : u === "end" ? C : R, T = [];
  for (let j = 0; j < g.length; j++) {
    let L = g[j], { height: Y, width: H, top: z, right: ee, bottom: I, left: F } = L.getBoundingClientRect();
    if (l === "if-needed" && E >= 0 && R >= 0 && O <= b && C <= v && E >= z && O <= I && R >= F && C <= ee)
      return T;
    let te = getComputedStyle(L), J = parseInt(te.borderLeftWidth, 10), re = parseInt(te.borderTopWidth, 10), B = parseInt(te.borderRightWidth, 10), N = parseInt(te.borderBottomWidth, 10), W = 0, V = 0, G = "offsetWidth" in L ? L.offsetWidth - L.clientWidth - J - B : 0, oe = "offsetHeight" in L ? L.offsetHeight - L.clientHeight - re - N : 0, X = "offsetWidth" in L ? L.offsetWidth === 0 ? 0 : H / L.offsetWidth : 0, U = "offsetHeight" in L ? L.offsetHeight === 0 ? 0 : Y / L.offsetHeight : 0;
    if (p === L)
      W = c === "start" ? D : c === "end" ? D - b : c === "nearest" ? li(w, w + b, b, re, N, w + D, w + D + x, x) : D - b / 2, V = u === "start" ? $ : u === "center" ? $ - v / 2 : u === "end" ? $ - v : li(y, y + v, v, J, B, y + $, y + $ + M, M), W = Math.max(0, W + w), V = Math.max(0, V + y);
    else {
      W = c === "start" ? D - z - re : c === "end" ? D - I + N + oe : c === "nearest" ? li(z, I, Y, re, N + oe, D, D + x, x) : D - (z + Y / 2) + oe / 2, V = u === "start" ? $ - F - J : u === "center" ? $ - (F + H / 2) + G / 2 : u === "end" ? $ - ee + B + G : li(F, ee, H, J, B + G, $, $ + M, M);
      let { scrollLeft: be, scrollTop: De } = L;
      W = Math.max(0, Math.min(De + W / U, L.scrollHeight - Y / U + oe)), V = Math.max(0, Math.min(be + V / X, L.scrollWidth - H / X + G)), D += De - W, $ += be - V;
    }
    T.push({ el: L, top: W, left: V });
  }
  return T;
}, R4 = 0;
function Yd(t) {
  return typeof t == "function" ? t : $t;
}
function $t() {
}
function fg(t, e) {
  if (t) {
    var n = N4(t, {
      boundary: e,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var o = r.el, i = r.top, s = r.left;
      o.scrollTop = i, o.scrollLeft = s;
    });
  }
}
function Ud(t, e, n) {
  var r = t === e || e instanceof n.Node && t.contains && t.contains(e);
  return r;
}
function Vl(t, e) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function o() {
    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    r(), n = setTimeout(function() {
      n = null, t.apply(void 0, s);
    }, e);
  }
  return o.cancel = r, o;
}
function nt() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
      i[s - 1] = arguments[s];
    return e.some(function(a) {
      return a && a.apply(void 0, [r].concat(i)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Mr() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    e.forEach(function(o) {
      typeof o == "function" ? o(r) : o && (o.current = r);
    });
  };
}
function hg() {
  return String(R4++);
}
function pg(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Gd(t, e) {
  return t = Array.isArray(t) ? (
    /* istanbul ignore next (preact) */
    t[0]
  ) : t, !t && e ? e : t;
}
function gg(t) {
  return typeof t.type == "string";
}
function mg(t) {
  return t.props;
}
function A4(t, e) {
  console.error('The property "' + e + '" is required in "' + t + '"');
}
var L4 = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function ci(t) {
  t === void 0 && (t = {});
  var e = {};
  return L4.forEach(function(n) {
    t.hasOwnProperty(n) && (e[n] = t[n]);
  }), e;
}
function zi(t, e) {
  return Object.keys(t).reduce(function(n, r) {
    return n[r] = Yi(e, r) ? e[r] : t[r], n;
  }, {});
}
function Yi(t, e) {
  return t[e] !== void 0;
}
function Na(t) {
  var e = t.key, n = t.keyCode;
  return n >= 37 && n <= 40 && e.indexOf("Arrow") !== 0 ? "Arrow" + e : e;
}
function F4(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function er(t, e, n, r, o) {
  o === void 0 && (o = !1);
  var i = n.length;
  if (i === 0)
    return -1;
  var s = i - 1;
  (typeof t != "number" || t < 0 || t > s) && (t = e > 0 ? -1 : s + 1);
  var a = t + e;
  a < 0 ? a = o ? s : 0 : a > s && (a = o ? 0 : s);
  var l = Hr(a, e < 0, n, r, o);
  return l === -1 ? t >= i ? -1 : t : l;
}
function Hr(t, e, n, r, o) {
  o === void 0 && (o = !1);
  var i = n.length;
  if (e) {
    for (var s = t; s >= 0; s--)
      if (!r(n[s], s))
        return s;
  } else
    for (var a = t; a < i; a++)
      if (!r(n[a], a))
        return a;
  return o ? Hr(e ? i - 1 : 0, e, n, r) : -1;
}
function Ui(t, e, n, r) {
  return r === void 0 && (r = !0), e.some(function(o) {
    return o && (Ud(o, t, n) || r && Ud(o, n.document.activeElement, n));
  });
}
var Bl = $t;
process.env.NODE_ENV !== "production" && (Bl = function(e, n, r) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(e).forEach(function(i) {
    n[i] !== void 0 && r[i] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + i + '" to be uncontrolled. ' + o) : n[i] === void 0 && r[i] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + i + '" to be controlled. ' + o);
  });
});
var H4 = Vl(function(t) {
  bg(t).textContent = "";
}, 500);
function vg(t, e) {
  var n = bg(e);
  t && (n.textContent = t, H4(e));
}
function bg(t) {
  t === void 0 && (t = document);
  var e = t.getElementById("a11y-status-message");
  return e || (e = t.createElement("div"), e.setAttribute("id", "a11y-status-message"), e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-relevant", "additions text"), Object.assign(e.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(e), e);
}
var yg = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, xg = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, wg = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, wi = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, _i = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, _g = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Cg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Eg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, kg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Mg = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, Og = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Pg = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Sg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, Ra = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Dg = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, Tg = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Ig = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, W4 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: yg,
  mouseUp: xg,
  itemMouseEnter: wg,
  keyDownArrowUp: wi,
  keyDownArrowDown: _i,
  keyDownEscape: _g,
  keyDownEnter: Cg,
  keyDownHome: Eg,
  keyDownEnd: kg,
  clickItem: Mg,
  blurInput: Og,
  changeInput: Pg,
  keyDownSpaceButton: Sg,
  clickButton: Ra,
  blurButton: Dg,
  controlledPropUpdatedSelectedItem: Tg,
  touchEnd: Ig
}), V4 = ["refKey", "ref"], B4 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], j4 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], z4 = ["refKey", "ref"], Y4 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], U4 = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(e) {
    _4(n, e);
    function n(o) {
      var i;
      i = e.call(this, o) || this, i.id = i.props.id || "downshift-" + hg(), i.menuId = i.props.menuId || i.id + "-menu", i.labelId = i.props.labelId || i.id + "-label", i.inputId = i.props.inputId || i.id + "-input", i.getItemId = i.props.getItemId || function(b) {
        return i.id + "-item-" + b;
      }, i.input = null, i.items = [], i.itemCount = null, i.previousResultCount = 0, i.timeoutIds = [], i.internalSetTimeout = function(b, y) {
        var w = setTimeout(function() {
          i.timeoutIds = i.timeoutIds.filter(function(x) {
            return x !== w;
          }), b();
        }, y);
        i.timeoutIds.push(w);
      }, i.setItemCount = function(b) {
        i.itemCount = b;
      }, i.unsetItemCount = function() {
        i.itemCount = null;
      }, i.isItemDisabled = function(b, y) {
        var w = i.getItemNodeFromIndex(y);
        return w && w.hasAttribute("disabled");
      }, i.setHighlightedIndex = function(b, y) {
        b === void 0 && (b = i.props.defaultHighlightedIndex), y === void 0 && (y = {}), y = ci(y), i.internalSetState(me({
          highlightedIndex: b
        }, y));
      }, i.clearSelection = function(b) {
        i.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: i.props.defaultHighlightedIndex,
          isOpen: i.props.defaultIsOpen
        }, b);
      }, i.selectItem = function(b, y, w) {
        y = ci(y), i.internalSetState(me({
          isOpen: i.props.defaultIsOpen,
          highlightedIndex: i.props.defaultHighlightedIndex,
          selectedItem: b,
          inputValue: i.props.itemToString(b)
        }, y), w);
      }, i.selectItemAtIndex = function(b, y, w) {
        var x = i.items[b];
        x != null && i.selectItem(x, y, w);
      }, i.selectHighlightedItem = function(b, y) {
        return i.selectItemAtIndex(i.getState().highlightedIndex, b, y);
      }, i.internalSetState = function(b, y) {
        var w, x, M = {}, E = typeof b == "function";
        return !E && b.hasOwnProperty("inputValue") && i.props.onInputValueChange(b.inputValue, me({}, i.getStateAndHelpers(), b)), i.setState(function(C) {
          C = i.getState(C);
          var O = E ? b(C) : b;
          O = i.props.stateReducer(C, O), w = O.hasOwnProperty("selectedItem");
          var R = {};
          return w && O.selectedItem !== C.selectedItem && (x = O.selectedItem), O.type = O.type || yg, Object.keys(O).forEach(function(D) {
            C[D] !== O[D] && (M[D] = O[D]), D !== "type" && (O[D], Yi(i.props, D) || (R[D] = O[D]));
          }), E && O.hasOwnProperty("inputValue") && i.props.onInputValueChange(O.inputValue, me({}, i.getStateAndHelpers(), O)), R;
        }, function() {
          Yd(y)();
          var C = Object.keys(M).length > 1;
          C && i.props.onStateChange(M, i.getStateAndHelpers()), w && i.props.onSelect(b.selectedItem, i.getStateAndHelpers()), x !== void 0 && i.props.onChange(x, i.getStateAndHelpers()), i.props.onUserAction(M, i.getStateAndHelpers());
        });
      }, i.rootRef = function(b) {
        return i._rootNode = b;
      }, i.getRootProps = function(b, y) {
        var w, x = b === void 0 ? {} : b, M = x.refKey, E = M === void 0 ? "ref" : M, C = x.ref, O = tn(x, V4), R = y === void 0 ? {} : y, D = R.suppressRefError, $ = D === void 0 ? !1 : D;
        i.getRootProps.called = !0, i.getRootProps.refKey = E, i.getRootProps.suppressRefError = $;
        var T = i.getState(), j = T.isOpen;
        return me((w = {}, w[E] = Mr(C, i.rootRef), w.role = "combobox", w["aria-expanded"] = j, w["aria-haspopup"] = "listbox", w["aria-owns"] = j ? i.menuId : void 0, w["aria-labelledby"] = i.labelId, w), O);
      }, i.keyDownHandlers = {
        ArrowDown: function(y) {
          var w = this;
          if (y.preventDefault(), this.getState().isOpen) {
            var x = y.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(x, {
              type: _i
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: _i
            }, function() {
              var M = w.getItemCount();
              if (M > 0) {
                var E = w.getState(), C = E.highlightedIndex, O = er(C, 1, {
                  length: M
                }, w.isItemDisabled, !0);
                w.setHighlightedIndex(O, {
                  type: _i
                });
              }
            });
        },
        ArrowUp: function(y) {
          var w = this;
          if (y.preventDefault(), this.getState().isOpen) {
            var x = y.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(x, {
              type: wi
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: wi
            }, function() {
              var M = w.getItemCount();
              if (M > 0) {
                var E = w.getState(), C = E.highlightedIndex, O = er(C, -1, {
                  length: M
                }, w.isItemDisabled, !0);
                w.setHighlightedIndex(O, {
                  type: wi
                });
              }
            });
        },
        Enter: function(y) {
          if (y.which !== 229) {
            var w = this.getState(), x = w.isOpen, M = w.highlightedIndex;
            if (x && M != null) {
              y.preventDefault();
              var E = this.items[M], C = this.getItemNodeFromIndex(M);
              if (E == null || C && C.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Cg
              });
            }
          }
        },
        Escape: function(y) {
          y.preventDefault(), this.reset(me({
            type: _g
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, i.buttonKeyDownHandlers = me({}, i.keyDownHandlers, {
        " ": function(y) {
          y.preventDefault(), this.toggleMenu({
            type: Sg
          });
        }
      }), i.inputKeyDownHandlers = me({}, i.keyDownHandlers, {
        Home: function(y) {
          var w = this.getState(), x = w.isOpen;
          if (x) {
            y.preventDefault();
            var M = this.getItemCount();
            if (!(M <= 0 || !x)) {
              var E = Hr(0, !1, {
                length: M
              }, this.isItemDisabled);
              this.setHighlightedIndex(E, {
                type: Eg
              });
            }
          }
        },
        End: function(y) {
          var w = this.getState(), x = w.isOpen;
          if (x) {
            y.preventDefault();
            var M = this.getItemCount();
            if (!(M <= 0 || !x)) {
              var E = Hr(M - 1, !0, {
                length: M
              }, this.isItemDisabled);
              this.setHighlightedIndex(E, {
                type: kg
              });
            }
          }
        }
      }), i.getToggleButtonProps = function(b) {
        var y = b === void 0 ? {} : b, w = y.onClick;
        y.onPress;
        var x = y.onKeyDown, M = y.onKeyUp, E = y.onBlur, C = tn(y, B4), O = i.getState(), R = O.isOpen, D = {
          onClick: nt(w, i.buttonHandleClick),
          onKeyDown: nt(x, i.buttonHandleKeyDown),
          onKeyUp: nt(M, i.buttonHandleKeyUp),
          onBlur: nt(E, i.buttonHandleBlur)
        }, $ = C.disabled ? {} : D;
        return me({
          type: "button",
          role: "button",
          "aria-label": R ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, $, C);
      }, i.buttonHandleKeyUp = function(b) {
        b.preventDefault();
      }, i.buttonHandleKeyDown = function(b) {
        var y = Na(b);
        i.buttonKeyDownHandlers[y] && i.buttonKeyDownHandlers[y].call(Td(i), b);
      }, i.buttonHandleClick = function(b) {
        b.preventDefault(), i.props.environment.document.activeElement === i.props.environment.document.body && b.target.focus(), process.env.NODE_ENV === "test" ? i.toggleMenu({
          type: Ra
        }) : i.internalSetTimeout(function() {
          return i.toggleMenu({
            type: Ra
          });
        });
      }, i.buttonHandleBlur = function(b) {
        var y = b.target;
        i.internalSetTimeout(function() {
          !i.isMouseDown && (i.props.environment.document.activeElement == null || i.props.environment.document.activeElement.id !== i.inputId) && i.props.environment.document.activeElement !== y && i.reset({
            type: Dg
          });
        });
      }, i.getLabelProps = function(b) {
        return me({
          htmlFor: i.inputId,
          id: i.labelId
        }, b);
      }, i.getInputProps = function(b) {
        var y = b === void 0 ? {} : b, w = y.onKeyDown, x = y.onBlur, M = y.onChange, E = y.onInput;
        y.onChangeText;
        var C = tn(y, j4), O, R = {};
        O = "onChange";
        var D = i.getState(), $ = D.inputValue, T = D.isOpen, j = D.highlightedIndex;
        if (!C.disabled) {
          var L;
          R = (L = {}, L[O] = nt(M, E, i.inputHandleChange), L.onKeyDown = nt(w, i.inputHandleKeyDown), L.onBlur = nt(x, i.inputHandleBlur), L);
        }
        return me({
          "aria-autocomplete": "list",
          "aria-activedescendant": T && typeof j == "number" && j >= 0 ? i.getItemId(j) : void 0,
          "aria-controls": T ? i.menuId : void 0,
          "aria-labelledby": C && C["aria-label"] ? void 0 : i.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: $,
          id: i.inputId
        }, R, C);
      }, i.inputHandleKeyDown = function(b) {
        var y = Na(b);
        y && i.inputKeyDownHandlers[y] && i.inputKeyDownHandlers[y].call(Td(i), b);
      }, i.inputHandleChange = function(b) {
        i.internalSetState({
          type: Pg,
          isOpen: !0,
          inputValue: b.target.value,
          highlightedIndex: i.props.defaultHighlightedIndex
        });
      }, i.inputHandleBlur = function() {
        i.internalSetTimeout(function() {
          var b = i.props.environment.document && !!i.props.environment.document.activeElement && !!i.props.environment.document.activeElement.dataset && i.props.environment.document.activeElement.dataset.toggle && i._rootNode && i._rootNode.contains(i.props.environment.document.activeElement);
          !i.isMouseDown && !b && i.reset({
            type: Og
          });
        });
      }, i.menuRef = function(b) {
        i._menuNode = b;
      }, i.getMenuProps = function(b, y) {
        var w, x = b === void 0 ? {} : b, M = x.refKey, E = M === void 0 ? "ref" : M, C = x.ref, O = tn(x, z4), R = y === void 0 ? {} : y, D = R.suppressRefError, $ = D === void 0 ? !1 : D;
        return i.getMenuProps.called = !0, i.getMenuProps.refKey = E, i.getMenuProps.suppressRefError = $, me((w = {}, w[E] = Mr(C, i.menuRef), w.role = "listbox", w["aria-labelledby"] = O && O["aria-label"] ? void 0 : i.labelId, w.id = i.menuId, w), O);
      }, i.getItemProps = function(b) {
        var y, w = b === void 0 ? {} : b, x = w.onMouseMove, M = w.onMouseDown, E = w.onClick;
        w.onPress;
        var C = w.index, O = w.item, R = O === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : A4("getItemProps", "item") : O, D = tn(w, Y4);
        C === void 0 ? (i.items.push(R), C = i.items.indexOf(R)) : i.items[C] = R;
        var $ = "onClick", T = E, j = (y = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: nt(x, function() {
            C !== i.getState().highlightedIndex && (i.setHighlightedIndex(C, {
              type: wg
            }), i.avoidScrolling = !0, i.internalSetTimeout(function() {
              return i.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: nt(M, function(Y) {
            Y.preventDefault();
          })
        }, y[$] = nt(T, function() {
          i.selectItemAtIndex(C, {
            type: Mg
          });
        }), y), L = D.disabled ? {
          onMouseDown: j.onMouseDown
        } : j;
        return me({
          id: i.getItemId(C),
          role: "option",
          "aria-selected": i.getState().highlightedIndex === C
        }, L, D);
      }, i.clearItems = function() {
        i.items = [];
      }, i.reset = function(b, y) {
        b === void 0 && (b = {}), b = ci(b), i.internalSetState(function(w) {
          var x = w.selectedItem;
          return me({
            isOpen: i.props.defaultIsOpen,
            highlightedIndex: i.props.defaultHighlightedIndex,
            inputValue: i.props.itemToString(x)
          }, b);
        }, y);
      }, i.toggleMenu = function(b, y) {
        b === void 0 && (b = {}), b = ci(b), i.internalSetState(function(w) {
          var x = w.isOpen;
          return me({
            isOpen: !x
          }, x && {
            highlightedIndex: i.props.defaultHighlightedIndex
          }, b);
        }, function() {
          var w = i.getState(), x = w.isOpen, M = w.highlightedIndex;
          x && i.getItemCount() > 0 && typeof M == "number" && i.setHighlightedIndex(M, b), Yd(y)();
        });
      }, i.openMenu = function(b) {
        i.internalSetState({
          isOpen: !0
        }, b);
      }, i.closeMenu = function(b) {
        i.internalSetState({
          isOpen: !1
        }, b);
      }, i.updateStatus = Vl(function() {
        var b = i.getState(), y = i.items[b.highlightedIndex], w = i.getItemCount(), x = i.props.getA11yStatusMessage(me({
          itemToString: i.props.itemToString,
          previousResultCount: i.previousResultCount,
          resultCount: w,
          highlightedItem: y
        }, b));
        i.previousResultCount = w, vg(x, i.props.environment.document);
      }, 200);
      var s = i.props, a = s.defaultHighlightedIndex, l = s.initialHighlightedIndex, c = l === void 0 ? a : l, u = s.defaultIsOpen, d = s.initialIsOpen, f = d === void 0 ? u : d, h = s.initialInputValue, p = h === void 0 ? "" : h, g = s.initialSelectedItem, m = g === void 0 ? null : g, v = i.getState({
        highlightedIndex: c,
        isOpen: f,
        inputValue: p,
        selectedItem: m
      });
      return v.selectedItem != null && i.props.initialInputValue === void 0 && (v.inputValue = i.props.itemToString(v.selectedItem)), i.state = v, i;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(i) {
        clearTimeout(i);
      }), this.timeoutIds = [];
    }, r.getState = function(i) {
      return i === void 0 && (i = this.state), zi(i, this.props);
    }, r.getItemCount = function() {
      var i = this.items.length;
      return this.itemCount != null ? i = this.itemCount : this.props.itemCount !== void 0 && (i = this.props.itemCount), i;
    }, r.getItemNodeFromIndex = function(i) {
      return this.props.environment.document.getElementById(this.getItemId(i));
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var i = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(i, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(i, s) {
      var a = this.getItemCount(), l = this.getState(), c = l.highlightedIndex;
      if (a > 0) {
        var u = er(c, i, {
          length: a
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(u, s);
      }
    }, r.getStateAndHelpers = function() {
      var i = this.getState(), s = i.highlightedIndex, a = i.inputValue, l = i.selectedItem, c = i.isOpen, u = this.props.itemToString, d = this.id, f = this.getRootProps, h = this.getToggleButtonProps, p = this.getLabelProps, g = this.getMenuProps, m = this.getInputProps, v = this.getItemProps, b = this.openMenu, y = this.closeMenu, w = this.toggleMenu, x = this.selectItem, M = this.selectItemAtIndex, E = this.selectHighlightedItem, C = this.setHighlightedIndex, O = this.clearSelection, R = this.clearItems, D = this.reset, $ = this.setItemCount, T = this.unsetItemCount, j = this.internalSetState;
      return {
        // prop getters
        getRootProps: f,
        getToggleButtonProps: h,
        getLabelProps: p,
        getMenuProps: g,
        getInputProps: m,
        getItemProps: v,
        // actions
        reset: D,
        openMenu: b,
        closeMenu: y,
        toggleMenu: w,
        selectItem: x,
        selectItemAtIndex: M,
        selectHighlightedItem: E,
        setHighlightedIndex: C,
        clearSelection: O,
        clearItems: R,
        setItemCount: $,
        unsetItemCount: T,
        setState: j,
        // props
        itemToString: u,
        // derived
        id: d,
        // state
        highlightedIndex: s,
        inputValue: a,
        isOpen: c,
        selectedItem: l
      };
    }, r.componentDidMount = function() {
      var i = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && Kd(this._menuNode, this.getMenuProps);
      {
        var s = function() {
          i.isMouseDown = !0;
        }, a = function(h) {
          i.isMouseDown = !1;
          var p = Ui(h.target, [i._rootNode, i._menuNode], i.props.environment);
          !p && i.getState().isOpen && i.reset({
            type: xg
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, l = function() {
          i.isTouchMove = !1;
        }, c = function() {
          i.isTouchMove = !0;
        }, u = function(h) {
          var p = Ui(h.target, [i._rootNode, i._menuNode], i.props.environment, !1);
          !i.isTouchMove && !p && i.getState().isOpen && i.reset({
            type: Ig
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, d = this.props.environment;
        d.addEventListener("mousedown", s), d.addEventListener("mouseup", a), d.addEventListener("touchstart", l), d.addEventListener("touchmove", c), d.addEventListener("touchend", u), this.cleanup = function() {
          i.internalClearTimeouts(), i.updateStatus.cancel(), d.removeEventListener("mousedown", s), d.removeEventListener("mouseup", a), d.removeEventListener("touchstart", l), d.removeEventListener("touchmove", c), d.removeEventListener("touchend", u);
        };
      }
    }, r.shouldScroll = function(i, s) {
      var a = this.props.highlightedIndex === void 0 ? this.getState() : this.props, l = a.highlightedIndex, c = s.highlightedIndex === void 0 ? i : s, u = c.highlightedIndex, d = l && this.getState().isOpen && !i.isOpen, f = l !== u;
      return d || f;
    }, r.componentDidUpdate = function(i, s) {
      process.env.NODE_ENV !== "production" && (Bl(this.state, i, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && Kd(this._menuNode, this.getMenuProps)), Yi(this.props, "selectedItem") && this.props.selectedItemChanged(i.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: Tg,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(s, i) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var i = Gd(this.props.children, $t);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var s = Gd(i(this.getStateAndHelpers()));
      if (!s)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && G4(s, this.getRootProps), s;
      if (gg(s))
        return /* @__PURE__ */ Ki(s, this.getRootProps(mg(s)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }($m);
  return t.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: pg,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && F4(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: $t,
    onInputValueChange: $t,
    onUserAction: $t,
    onChange: $t,
    onSelect: $t,
    onOuterClick: $t,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: fg
  }, t.stateChangeTypes = W4, t;
}();
process.env.NODE_ENV !== "production" && (U4.propTypes = {
  children: K.func,
  defaultHighlightedIndex: K.number,
  defaultIsOpen: K.bool,
  initialHighlightedIndex: K.number,
  initialSelectedItem: K.any,
  initialInputValue: K.string,
  initialIsOpen: K.bool,
  getA11yStatusMessage: K.func,
  itemToString: K.func,
  onChange: K.func,
  onSelect: K.func,
  onStateChange: K.func,
  onInputValueChange: K.func,
  onUserAction: K.func,
  onOuterClick: K.func,
  selectedItemChanged: K.func,
  stateReducer: K.func,
  itemCount: K.number,
  id: K.string,
  environment: K.shape({
    addEventListener: K.func.isRequired,
    removeEventListener: K.func.isRequired,
    document: K.shape({
      createElement: K.func.isRequired,
      getElementById: K.func.isRequired,
      activeElement: K.any.isRequired,
      body: K.any.isRequired
    }).isRequired,
    Node: K.func.isRequired
  }),
  suppressRefError: K.bool,
  scrollIntoView: K.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: K.any,
  isOpen: K.bool,
  inputValue: K.string,
  highlightedIndex: K.number,
  labelId: K.string,
  inputId: K.string,
  menuId: K.string,
  getItemId: K.func
  /* eslint-enable react/no-unused-prop-types */
});
function Kd(t, e) {
  var n = e.refKey;
  t || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function G4(t, e) {
  var n = e.refKey, r = n !== "ref", o = !gg(t);
  o && !r && !Bd.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !o && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !Bd.isForwardRef(t) && !mg(t)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var K4 = ["isInitialMount", "highlightedIndex", "items", "environment"], $g = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function q4(t, e, n) {
  var r = t.props, o = t.type, i = {};
  Object.keys(e).forEach(function(s) {
    X4(s, t, e, n), n[s] !== e[s] && (i[s] = n[s]);
  }), r.onStateChange && Object.keys(i).length && r.onStateChange(me({
    type: o
  }, i));
}
function X4(t, e, n, r) {
  var o = e.props, i = e.type, s = "on" + jl(t) + "Change";
  o[s] && r[t] !== void 0 && r[t] !== n[t] && o[s](me({
    type: i
  }, r));
}
function Z4(t, e) {
  return e.changes;
}
function Q4(t) {
  var e = t.selectedItem, n = t.itemToString;
  return e ? n(e) + " has been selected." : "";
}
var J4 = Vl(function(t, e) {
  vg(t(), e);
}, 200), eE = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? qi : ue, tE = "useId" in P ? function(e) {
  var n = e.id, r = e.labelId, o = e.menuId, i = e.getItemId, s = e.toggleButtonId, a = e.inputId, l = "downshift-" + P.useId();
  n || (n = l);
  var c = le({
    labelId: r || n + "-label",
    menuId: o || n + "-menu",
    getItemId: i || function(u) {
      return n + "-item-" + u;
    },
    toggleButtonId: s || n + "-toggle-button",
    inputId: a || n + "-input"
  });
  return c.current;
} : function(e) {
  var n = e.id, r = n === void 0 ? "downshift-" + hg() : n, o = e.labelId, i = e.menuId, s = e.getItemId, a = e.toggleButtonId, l = e.inputId, c = le({
    labelId: o || r + "-label",
    menuId: i || r + "-menu",
    getItemId: s || function(u) {
      return r + "-item-" + u;
    },
    toggleButtonId: a || r + "-toggle-button",
    inputId: l || r + "-input"
  });
  return c.current;
};
function nE(t, e, n, r) {
  var o, i;
  if (t === void 0) {
    if (e === void 0)
      throw new Error(r);
    o = n[e], i = e;
  } else
    i = e === void 0 ? n.indexOf(t) : e, o = t;
  return [o, i];
}
function rE(t) {
  return t ? String(t) : "";
}
function jl(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function Ng(t) {
  var e = le(t);
  return e.current = t, e;
}
function oE(t, e, n) {
  var r = le(), o = le(), i = pe(function(f, h) {
    o.current = h, f = zi(f, h.props);
    var p = t(f, h), g = h.props.stateReducer(f, me({}, h, {
      changes: p
    }));
    return g;
  }, [t]), s = sf(i, e), a = s[0], l = s[1], c = Ng(n), u = pe(function(f) {
    return l(me({
      props: c.current
    }, f));
  }, [c]), d = o.current;
  return ue(function() {
    d && r.current && r.current !== a && q4(d, zi(r.current, d.props), a), r.current = a;
  }, [a, n, d]), [a, u];
}
var fo = {
  itemToString: rE,
  stateReducer: Z4,
  getA11ySelectionMessage: Q4,
  scrollIntoView: fg,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function nn(t, e, n) {
  n === void 0 && (n = $g);
  var r = t["default" + jl(e)];
  return r !== void 0 ? r : n[e];
}
function oo(t, e, n) {
  n === void 0 && (n = $g);
  var r = t[e];
  if (r !== void 0)
    return r;
  var o = t["initial" + jl(e)];
  return o !== void 0 ? o : nn(t, e, n);
}
function iE(t) {
  var e = oo(t, "selectedItem"), n = oo(t, "isOpen"), r = oo(t, "highlightedIndex"), o = oo(t, "inputValue");
  return {
    highlightedIndex: r < 0 && e && n ? t.items.indexOf(e) : r,
    isOpen: n,
    selectedItem: e,
    inputValue: o
  };
}
function ho(t, e, n) {
  var r = t.items, o = t.initialHighlightedIndex, i = t.defaultHighlightedIndex, s = e.selectedItem, a = e.highlightedIndex;
  return r.length === 0 ? -1 : o !== void 0 && a === o ? o : i !== void 0 ? i : s ? r.indexOf(s) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function sE(t, e, n, r) {
  var o = le({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return ue(function() {
    if ((n == null ? void 0 : n.addEventListener) != null) {
      var i = function() {
        o.current.isMouseDown = !0;
      }, s = function(d) {
        o.current.isMouseDown = !1, t && !Ui(d.target, e.map(function(f) {
          return f.current;
        }), n) && r();
      }, a = function() {
        o.current.isTouchMove = !1;
      }, l = function() {
        o.current.isTouchMove = !0;
      }, c = function(d) {
        t && !o.current.isTouchMove && !Ui(d.target, e.map(function(f) {
          return f.current;
        }), n, !1) && r();
      };
      return n.addEventListener("mousedown", i), n.addEventListener("mouseup", s), n.addEventListener("touchstart", a), n.addEventListener("touchmove", l), n.addEventListener("touchend", c), function() {
        n.removeEventListener("mousedown", i), n.removeEventListener("mouseup", s), n.removeEventListener("touchstart", a), n.removeEventListener("touchmove", l), n.removeEventListener("touchend", c);
      };
    }
  }, [t, n]), o;
}
var Rg = function() {
  return $t;
};
process.env.NODE_ENV !== "production" && (Rg = function() {
  for (var e = le(!0), n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  var i = le(r.reduce(function(a, l) {
    return a[l] = {}, a;
  }, {}));
  ue(function() {
    Object.keys(i.current).forEach(function(a) {
      var l = i.current[a];
      if (e.current && !Object.keys(l).length) {
        console.error("downshift: You forgot to call the " + a + " getter function on your component / element.");
        return;
      }
      var c = l.suppressRefError, u = l.refKey, d = l.elementRef;
      (!d || !d.current) && !c && console.error('downshift: The ref prop "' + u + '" from ' + a + " was not applied correctly on your element.");
    }), e.current = !1;
  });
  var s = pe(function(a, l, c, u) {
    i.current[a] = {
      suppressRefError: l,
      refKey: c,
      elementRef: u
    };
  }, []);
  return s;
});
function qd(t, e, n) {
  var r = n.isInitialMount, o = n.highlightedIndex, i = n.items, s = n.environment, a = tn(n, K4);
  ue(function() {
    r || J4(function() {
      return t(me({
        highlightedIndex: o,
        highlightedItem: i[o],
        resultCount: i.length
      }, a));
    }, s.document);
  }, e);
}
function aE(t) {
  var e = t.highlightedIndex, n = t.isOpen, r = t.itemRefs, o = t.getItemNodeFromIndex, i = t.menuElement, s = t.scrollIntoView, a = le(!0);
  return eE(function() {
    e < 0 || !n || !Object.keys(r.current).length || (a.current === !1 ? a.current = !0 : s(o(e), i));
  }, [e]), a;
}
var Ag = $t;
process.env.NODE_ENV !== "production" && (Ag = function(e) {
  var n = e.isInitialMount, r = e.props, o = e.state, i = le(r);
  ue(function() {
    n || (Bl(o, i.current, r), i.current = r);
  }, [o, r, n]);
});
function Xd(t, e, n) {
  var r;
  n === void 0 && (n = !0);
  var o = ((r = t.items) == null ? void 0 : r.length) && e >= 0;
  return me({
    isOpen: !1,
    highlightedIndex: -1
  }, o && me({
    selectedItem: t.items[e],
    isOpen: nn(t, "isOpen"),
    highlightedIndex: nn(t, "highlightedIndex")
  }, n && {
    inputValue: t.itemToString(t.items[e])
  }));
}
var Lg = {
  environment: K.shape({
    addEventListener: K.func.isRequired,
    removeEventListener: K.func.isRequired,
    document: K.shape({
      createElement: K.func.isRequired,
      getElementById: K.func.isRequired,
      activeElement: K.any.isRequired,
      body: K.any.isRequired
    }).isRequired,
    Node: K.func.isRequired
  }),
  itemToString: K.func,
  stateReducer: K.func
}, Fg = me({}, Lg, {
  getA11yStatusMessage: K.func,
  highlightedIndex: K.number,
  defaultHighlightedIndex: K.number,
  initialHighlightedIndex: K.number,
  isOpen: K.bool,
  defaultIsOpen: K.bool,
  initialIsOpen: K.bool,
  selectedItem: K.any,
  initialSelectedItem: K.any,
  defaultSelectedItem: K.any,
  id: K.string,
  labelId: K.string,
  menuId: K.string,
  getItemId: K.func,
  toggleButtonId: K.string,
  onSelectedItemChange: K.func,
  onHighlightedIndexChange: K.func,
  onStateChange: K.func,
  onIsOpenChange: K.func,
  scrollIntoView: K.func
});
function lE(t, e, n) {
  var r = e.type, o = e.props, i;
  switch (r) {
    case n.ItemMouseMove:
      i = {
        highlightedIndex: e.disabled ? -1 : e.index
      };
      break;
    case n.MenuMouseLeave:
      i = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      i = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : ho(o, t, 0)
      };
      break;
    case n.FunctionOpenMenu:
      i = {
        isOpen: !0,
        highlightedIndex: ho(o, t, 0)
      };
      break;
    case n.FunctionCloseMenu:
      i = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      i = {
        highlightedIndex: e.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      i = {
        inputValue: e.inputValue
      };
      break;
    case n.FunctionReset:
      i = {
        highlightedIndex: nn(o, "highlightedIndex"),
        isOpen: nn(o, "isOpen"),
        selectedItem: nn(o, "selectedItem"),
        inputValue: nn(o, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return me({}, t, i);
}
bt(bt({}, Fg), { items: K.array.isRequired, isItemDisabled: K.func, getA11ySelectionMessage: K.func });
function cE(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
bt(bt({}, fo), { getA11yStatusMessage: cE, isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var zl = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Yl = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, Ul = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Gl = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Kl = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, ql = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Xl = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Zl = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Ql = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Gi = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Jl = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, Hg = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, Wg = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, ec = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, Vg = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, Bg = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, jg = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, zg = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, Yg = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, tc = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Ug = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, Gg = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, nc = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, Kg = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: zl,
  InputKeyDownArrowUp: Yl,
  InputKeyDownEscape: Ul,
  InputKeyDownHome: Gl,
  InputKeyDownEnd: Kl,
  InputKeyDownPageUp: ql,
  InputKeyDownPageDown: Xl,
  InputKeyDownEnter: Zl,
  InputChange: Ql,
  InputBlur: Gi,
  InputClick: Jl,
  MenuMouseLeave: Hg,
  ItemMouseMove: Wg,
  ItemClick: ec,
  ToggleButtonClick: Vg,
  FunctionToggleMenu: Bg,
  FunctionOpenMenu: jg,
  FunctionCloseMenu: zg,
  FunctionSetHighlightedIndex: Yg,
  FunctionSelectItem: tc,
  FunctionSetInputValue: Ug,
  FunctionReset: Gg,
  ControlledPropUpdatedSelectedItem: nc
});
function uE(t) {
  var e = iE(t), n = e.selectedItem, r = e.inputValue;
  return r === "" && n && t.defaultInputValue === void 0 && t.initialInputValue === void 0 && t.inputValue === void 0 && (r = t.itemToString(n)), me({}, e, {
    inputValue: r
  });
}
var dE = me({}, Fg, {
  items: K.array.isRequired,
  isItemDisabled: K.func,
  selectedItemChanged: K.func,
  getA11ySelectionMessage: K.func,
  inputValue: K.string,
  defaultInputValue: K.string,
  initialInputValue: K.string,
  inputId: K.string,
  onInputValueChange: K.func
});
function fE(t, e, n) {
  var r = le(), o = oE(t, e, n), i = o[0], s = o[1];
  return ue(function() {
    Yi(n, "selectedItem") && (n.selectedItemChanged(r.current, n.selectedItem) && s({
      type: nc,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = i.selectedItem === r.current ? n.selectedItem : i.selectedItem);
  }, [i.selectedItem, n.selectedItem]), [zi(i, n), s];
}
var qg = $t;
process.env.NODE_ENV !== "production" && (qg = function(e, n) {
  K.checkPropTypes(dE, e, "prop", n.name);
});
var hE = me({}, fo, {
  selectedItemChanged: function(e, n) {
    return e !== n;
  },
  getA11yStatusMessage: pg,
  isItemDisabled: function() {
    return !1;
  }
});
function pE(t, e) {
  var n, r = e.type, o = e.props, i = e.altKey, s;
  switch (r) {
    case ec:
      s = {
        isOpen: nn(o, "isOpen"),
        highlightedIndex: nn(o, "highlightedIndex"),
        selectedItem: o.items[e.index],
        inputValue: o.itemToString(o.items[e.index])
      };
      break;
    case zl:
      t.isOpen ? s = {
        highlightedIndex: er(t.highlightedIndex, 1, o.items, o.isItemDisabled, !0)
      } : s = {
        highlightedIndex: i && t.selectedItem == null ? -1 : ho(o, t, 1),
        isOpen: o.items.length >= 0
      };
      break;
    case Yl:
      t.isOpen ? i ? s = Xd(o, t.highlightedIndex) : s = {
        highlightedIndex: er(t.highlightedIndex, -1, o.items, o.isItemDisabled, !0)
      } : s = {
        highlightedIndex: ho(o, t, -1),
        isOpen: o.items.length >= 0
      };
      break;
    case Zl:
      s = Xd(o, t.highlightedIndex);
      break;
    case Ul:
      s = me({
        isOpen: !1,
        highlightedIndex: -1
      }, !t.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case ql:
      s = {
        highlightedIndex: er(t.highlightedIndex, -10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Xl:
      s = {
        highlightedIndex: er(t.highlightedIndex, 10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Gl:
      s = {
        highlightedIndex: Hr(0, !1, o.items, o.isItemDisabled)
      };
      break;
    case Kl:
      s = {
        highlightedIndex: Hr(o.items.length - 1, !0, o.items, o.isItemDisabled)
      };
      break;
    case Gi:
      s = me({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((n = o.items) == null ? void 0 : n.length) && e.selectItem && {
        selectedItem: o.items[t.highlightedIndex],
        inputValue: o.itemToString(o.items[t.highlightedIndex])
      });
      break;
    case Ql:
      s = {
        isOpen: !0,
        highlightedIndex: nn(o, "highlightedIndex"),
        inputValue: e.inputValue
      };
      break;
    case Jl:
      s = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : ho(o, t, 0)
      };
      break;
    case tc:
      s = {
        selectedItem: e.selectedItem,
        inputValue: o.itemToString(e.selectedItem)
      };
      break;
    case nc:
      s = {
        inputValue: e.inputValue
      };
      break;
    default:
      return lE(t, e, Kg);
  }
  return me({}, t, s);
}
var gE = ["onMouseLeave", "refKey", "ref"], mE = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], vE = ["onClick", "onPress", "refKey", "ref"], bE = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
st.stateChangeTypes = Kg;
function st(t) {
  t === void 0 && (t = {}), qg(t, st);
  var e = me({}, hE, t), n = e.items, r = e.scrollIntoView, o = e.environment, i = e.getA11yStatusMessage, s = e.getA11ySelectionMessage, a = e.itemToString, l = uE(e), c = fE(pE, l, e), u = c[0], d = c[1], f = u.isOpen, h = u.highlightedIndex, p = u.selectedItem, g = u.inputValue, m = le(null), v = le({}), b = le(null), y = le(null), w = le(!0), x = tE(e), M = le(), E = Ng({
    state: u,
    props: e
  }), C = pe(function(B) {
    return v.current[x.getItemId(B)];
  }, [x]);
  qd(i, [f, h, g, n], me({
    isInitialMount: w.current,
    previousResultCount: M.current,
    items: n,
    environment: o,
    itemToString: a
  }, u)), qd(s, [p], me({
    isInitialMount: w.current,
    previousResultCount: M.current,
    items: n,
    environment: o,
    itemToString: a
  }, u));
  var O = aE({
    menuElement: m.current,
    highlightedIndex: h,
    isOpen: f,
    itemRefs: v,
    scrollIntoView: r,
    getItemNodeFromIndex: C
  });
  Ag({
    isInitialMount: w.current,
    props: e,
    state: u
  }), ue(function() {
    var B = oo(e, "isOpen");
    B && b.current && b.current.focus();
  }, []), ue(function() {
    w.current || (M.current = n.length);
  });
  var R = sE(f, [b, m, y], o, function() {
    d({
      type: Gi,
      selectItem: !1
    });
  }), D = Rg("getInputProps", "getMenuProps");
  ue(function() {
    return w.current = !1, function() {
      w.current = !0;
    };
  }, []), ue(function() {
    var B;
    if (!f)
      v.current = {};
    else if (((B = o.document) == null ? void 0 : B.activeElement) !== b.current) {
      var N;
      b == null || (N = b.current) == null || N.focus();
    }
  }, [f, o]);
  var $ = rr(function() {
    return {
      ArrowDown: function(N) {
        N.preventDefault(), d({
          type: zl,
          altKey: N.altKey
        });
      },
      ArrowUp: function(N) {
        N.preventDefault(), d({
          type: Yl,
          altKey: N.altKey
        });
      },
      Home: function(N) {
        E.current.state.isOpen && (N.preventDefault(), d({
          type: Gl
        }));
      },
      End: function(N) {
        E.current.state.isOpen && (N.preventDefault(), d({
          type: Kl
        }));
      },
      Escape: function(N) {
        var W = E.current.state;
        (W.isOpen || W.inputValue || W.selectedItem || W.highlightedIndex > -1) && (N.preventDefault(), d({
          type: Ul
        }));
      },
      Enter: function(N) {
        var W = E.current.state;
        !W.isOpen || N.which === 229 || (N.preventDefault(), d({
          type: Zl
        }));
      },
      PageUp: function(N) {
        E.current.state.isOpen && (N.preventDefault(), d({
          type: ql
        }));
      },
      PageDown: function(N) {
        E.current.state.isOpen && (N.preventDefault(), d({
          type: Xl
        }));
      }
    };
  }, [d, E]), T = pe(function(B) {
    return me({
      id: x.labelId,
      htmlFor: x.inputId
    }, B);
  }, [x]), j = pe(function(B, N) {
    var W, V = B === void 0 ? {} : B, G = V.onMouseLeave, oe = V.refKey, X = oe === void 0 ? "ref" : oe, U = V.ref, be = tn(V, gE), De = N === void 0 ? {} : N, Re = De.suppressRefError, wt = Re === void 0 ? !1 : Re;
    return D("getMenuProps", wt, X, m), me((W = {}, W[X] = Mr(U, function(ct) {
      m.current = ct;
    }), W.id = x.menuId, W.role = "listbox", W["aria-labelledby"] = be && be["aria-label"] ? void 0 : "" + x.labelId, W.onMouseLeave = nt(G, function() {
      d({
        type: Hg
      });
    }), W), be);
  }, [d, D, x]), L = pe(function(B) {
    var N, W, V = B === void 0 ? {} : B, G = V.item, oe = V.index, X = V.refKey, U = X === void 0 ? "ref" : X, be = V.ref, De = V.onMouseMove, Re = V.onMouseDown, wt = V.onClick;
    V.onPress;
    var ct = V.disabled, St = tn(V, mE);
    ct !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var Wt = E.current, it = Wt.props, rt = Wt.state, pr = nE(G, oe, it.items, "Pass either item or index to getItemProps!"), gr = pr[0], Dt = pr[1], ln = it.isItemDisabled(gr, Dt), jr = "onClick", mr = wt, qt = function() {
      Dt !== rt.highlightedIndex && (O.current = !1, d({
        type: Wg,
        index: Dt,
        disabled: ln
      }));
    }, cn = function() {
      d({
        type: ec,
        index: Dt
      });
    }, Xt = function(vs) {
      return vs.preventDefault();
    };
    return me((N = {}, N[U] = Mr(be, function(_t) {
      _t && (v.current[x.getItemId(Dt)] = _t);
    }), N["aria-disabled"] = ln, N["aria-selected"] = "" + (Dt === rt.highlightedIndex), N.id = x.getItemId(Dt), N.role = "option", N), !ln && (W = {}, W[jr] = nt(mr, cn), W), {
      onMouseMove: nt(De, qt),
      onMouseDown: nt(Re, Xt)
    }, St);
  }, [d, E, O, x]), Y = pe(function(B) {
    var N, W = B === void 0 ? {} : B, V = W.onClick;
    W.onPress;
    var G = W.refKey, oe = G === void 0 ? "ref" : G, X = W.ref, U = tn(W, vE), be = E.current.state, De = function() {
      d({
        type: Vg
      });
    };
    return me((N = {}, N[oe] = Mr(X, function(Re) {
      y.current = Re;
    }), N["aria-controls"] = x.menuId, N["aria-expanded"] = be.isOpen, N.id = x.toggleButtonId, N.tabIndex = -1, N), !U.disabled && me({}, {
      onClick: nt(V, De)
    }), U);
  }, [d, E, x]), H = pe(function(B, N) {
    var W, V = B === void 0 ? {} : B, G = V.onKeyDown, oe = V.onChange, X = V.onInput, U = V.onBlur;
    V.onChangeText;
    var be = V.onClick, De = V.refKey, Re = De === void 0 ? "ref" : De, wt = V.ref, ct = tn(V, bE), St = N === void 0 ? {} : N, Wt = St.suppressRefError, it = Wt === void 0 ? !1 : Wt;
    D("getInputProps", it, Re, b);
    var rt = E.current.state, pr = function(Xt) {
      var _t = Na(Xt);
      _t && $[_t] && $[_t](Xt);
    }, gr = function(Xt) {
      d({
        type: Ql,
        inputValue: Xt.target.value
      });
    }, Dt = function(Xt) {
      if (rt.isOpen && !R.current.isMouseDown) {
        var _t = Xt.relatedTarget === null && o.document.activeElement !== o.document.body;
        d({
          type: Gi,
          selectItem: !_t
        });
      }
    }, ln = function() {
      d({
        type: Jl
      });
    }, jr = "onChange", mr = {};
    if (!ct.disabled) {
      var qt;
      mr = (qt = {}, qt[jr] = nt(oe, X, gr), qt.onKeyDown = nt(G, pr), qt.onBlur = nt(U, Dt), qt.onClick = nt(be, ln), qt);
    }
    return me((W = {}, W[Re] = Mr(wt, function(cn) {
      b.current = cn;
    }), W["aria-activedescendant"] = rt.isOpen && rt.highlightedIndex > -1 ? x.getItemId(rt.highlightedIndex) : "", W["aria-autocomplete"] = "list", W["aria-controls"] = x.menuId, W["aria-expanded"] = rt.isOpen, W["aria-labelledby"] = ct && ct["aria-label"] ? void 0 : x.labelId, W.autoComplete = "off", W.id = x.inputId, W.role = "combobox", W.value = rt.inputValue, W), mr, ct);
  }, [D, E, x, $, d, R, o]), z = pe(function() {
    d({
      type: Bg
    });
  }, [d]), ee = pe(function() {
    d({
      type: zg
    });
  }, [d]), I = pe(function() {
    d({
      type: jg
    });
  }, [d]), F = pe(function(B) {
    d({
      type: Yg,
      highlightedIndex: B
    });
  }, [d]), te = pe(function(B) {
    d({
      type: tc,
      selectedItem: B
    });
  }, [d]), J = pe(function(B) {
    d({
      type: Ug,
      inputValue: B
    });
  }, [d]), re = pe(function() {
    d({
      type: Gg
    });
  }, [d]);
  return {
    // prop getters.
    getItemProps: L,
    getLabelProps: T,
    getMenuProps: j,
    getInputProps: H,
    getToggleButtonProps: Y,
    // actions.
    toggleMenu: z,
    openMenu: I,
    closeMenu: ee,
    setHighlightedIndex: F,
    setInputValue: J,
    selectItem: te,
    reset: re,
    // state.
    highlightedIndex: h,
    isOpen: f,
    selectedItem: p,
    inputValue: g
  };
}
function yE(t) {
  var e = t.removedSelectedItem, n = t.itemToString;
  return n(e) + " has been removed.";
}
me({}, Lg, {
  selectedItems: K.array,
  initialSelectedItems: K.array,
  defaultSelectedItems: K.array,
  getA11yRemovalMessage: K.func,
  activeIndex: K.number,
  initialActiveIndex: K.number,
  defaultActiveIndex: K.number,
  onActiveIndexChange: K.func,
  onSelectedItemsChange: K.func,
  keyNavigationNext: K.string,
  keyNavigationPrevious: K.string
});
fo.itemToString, fo.stateReducer, fo.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function Xg({
  items: t,
  inputValue: e,
  onInputValueChange: n
}) {
  const {
    selected: r,
    onSelect: o,
    displayedValueKey: i,
    multiple: s,
    withConfirmation: a,
    setIsOpen: l,
    resettable: c = !0
  } = _n(), [u, d] = S.useState(r), f = a ? u : r;
  return {
    ...st({
      isOpen: !0,
      inputValue: e,
      onInputValueChange: ({ inputValue: p }) => n(p ?? ""),
      onIsOpenChange: ({ isOpen: p, type: g }) => {
        g !== st.stateChangeTypes.InputBlur && l(!!p);
      },
      items: t,
      itemToString: (p) => p != null && p[1] ? i ? p[1][i] : p[1] : "",
      selectedItem: f,
      onSelectedItemChange: ({ selectedItem: p }) => {
        if (!s) {
          a ? d(p) : o(p);
          return;
        }
        const g = f.findIndex(
          ([v]) => v === (p == null ? void 0 : p[0])
        ), m = a ? d : o;
        g > 0 ? m([
          ...f.slice(0, g),
          ...f.slice(g + 1)
        ]) : m(g === 0 ? [...f.slice(1)] : [...f, p]);
      },
      stateReducer: S.useMemo(
        () => s || a ? wE : xE({ resettable: c }),
        [s, a, c]
      ),
      scrollIntoView: _E
    }),
    selectedItem: f,
    resetSelectionBuffer: () => d([])
  };
}
const xE = ({ resettable: t }) => (e, n) => {
  var i;
  const { changes: r, type: o } = n;
  switch (o) {
    case st.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return {
        ...r,
        inputValue: ""
        // reset input value on popover opening
      };
    case st.stateChangeTypes.InputKeyDownEnter:
    case st.stateChangeTypes.ItemClick:
      return t ? {
        ...r,
        selectedItem: ((i = e.selectedItem) == null ? void 0 : i[0]) === r.selectedItem[0] ? [] : r.selectedItem
      } : r;
    case st.stateChangeTypes.InputBlur:
      return {
        ...r,
        selectedItem: e.selectedItem,
        // don't select on blur
        highlightedIndex: e.highlightedIndex,
        inputValue: e.inputValue
      };
    case st.stateChangeTypes.InputClick:
      return {
        ...r,
        isOpen: !0
      };
    default:
      return r;
  }
}, wE = (t, e) => {
  const { changes: n, type: r } = e;
  switch (r) {
    case st.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return {
        ...n,
        inputValue: t.inputValue || ""
      };
    case st.stateChangeTypes.InputKeyDownEnter:
    case st.stateChangeTypes.ItemClick:
      return {
        ...n,
        isOpen: !0,
        // keep dropdown open after selection
        highlightedIndex: t.highlightedIndex,
        // keep highlighted index position
        inputValue: t.inputValue
        // keep search query
      };
    case st.stateChangeTypes.InputBlur:
      return {
        ...n,
        selectedItem: t.selectedItem,
        // don't select on blur
        highlightedIndex: t.highlightedIndex,
        inputValue: t.inputValue
      };
    case st.stateChangeTypes.InputClick:
      return {
        ...n,
        isOpen: !0
      };
    default:
      return n;
  }
}, _E = (t) => {
  requestAnimationFrame ? requestAnimationFrame(() => {
    t.scrollIntoView({
      block: "nearest",
      inline: "nearest"
    });
  }) : setTimeout(() => {
    t.scrollIntoView({
      block: "nearest",
      inline: "nearest"
    });
  }, 0);
}, N8 = (t) => {
  var r;
  const [e, n] = S.useState(!1);
  return /* @__PURE__ */ _(
    cg.Provider,
    {
      value: {
        ...t,
        withConfirmation: t.withConfirmation,
        setIsOpen: n
      },
      children: /* @__PURE__ */ Z(m4, { open: e, onOpenChange: n, children: [
        /* @__PURE__ */ _(CE, { ref: t.triggerRef }),
        /* @__PURE__ */ Z(
          y4,
          {
            sideOffset: 6,
            collisionPadding: 10,
            ...t.contentProps,
            className: ye(
              `line
            z-10
          flex
          max-h-[min(var(--radix-popover-content-available-height),26rem)]
          w-[var(--radix-popover-content-available-width)] max-w-[max(var(--radix-popover-trigger-width),_16rem)] flex-col rounded-md
          bg-foundations-default
          py-1 shadow-2`,
              (r = t.contentProps) == null ? void 0 : r.className
            ),
            children: [
              t.options && /* @__PURE__ */ _(OE, {}),
              t.getOptions && /* @__PURE__ */ _(PE, {})
            ]
          }
        )
      ] })
    }
  );
}, CE = S.forwardRef(
  (t, e) => {
    const {
      selected: n,
      prefixText: r,
      prefixIcon: o,
      disabled: i,
      className: s,
      multiple: a,
      error: l,
      onBlur: c
    } = _n();
    return /* @__PURE__ */ Z(
      v4,
      {
        ref: e,
        type: "button",
        role: "combobox",
        "aria-haspopup": "listbox",
        className: ye(
          "flex w-full select-none items-center rounded-md border border-foundations-bold bg-foundations-default py-2 pl-3 pr-2 text-left text-sm text-foundations-subtle focus:border-info-bold focus:text-info focus:shadow-3 focus:outline-none focus:ring-1 focus:ring-info-bold disabled:cursor-not-allowed aria-expanded:border-info-bold aria-expanded:text-info aria-expanded:shadow-3 aria-expanded:ring-1 aria-expanded:ring-info-bold",
          !i && "group/drop-down hover:shadow-3",
          l && "border-danger-bold focus:border-danger-bold focus:ring-danger-bold [&:focus>svg]:!text-danger [&>svg]:text-danger",
          s
        ),
        disabled: i,
        onBlur: c,
        children: [
          r && /* @__PURE__ */ _("span", { className: "-my-2 mr-3 flex-shrink-0 border-r border-r-foundations-subtle py-2 pr-3 text-sm text-foundations-subtle", children: r }),
          o && /* @__PURE__ */ _(o, { className: "-ml-1 mr-3 h-5 w-5" }),
          /* @__PURE__ */ _(
            "span",
            {
              className: ye(
                "value block flex-1 truncate text-sm text-foundations-subtle",
                {
                  "text-foundations-bolder": a ? n.length : n == null ? void 0 : n[1]
                }
              ),
              children: a ? /* @__PURE__ */ _(EE, {}) : /* @__PURE__ */ _(kE, {})
            }
          ),
          /* @__PURE__ */ _(ip, { className: "ml-2 h-5 w-5 shrink-0 transition-transform group-aria-expanded/drop-down:rotate-180" })
        ]
      }
    );
  }
), EE = () => {
  const { label: t, selected: e, displayedValueKey: n } = _n();
  return e != null && e.length ? /* @__PURE__ */ _(dt, { children: e.map(
    ([r, o]) => n ? o[n] : o
  ).join(", ") }) : /* @__PURE__ */ _(dt, { children: t });
}, kE = () => {
  const { label: t, selected: e, displayedValueKey: n } = _n();
  return e != null && e[1] ? /* @__PURE__ */ _(dt, { children: n ? e[1][n] : e[1] }) : /* @__PURE__ */ _(dt, { children: t });
}, Zg = ({ errorMsg: t }) => /* @__PURE__ */ Z("div", { className: "my-4 flex flex-col items-center space-y-4", children: [
  /* @__PURE__ */ _(lp, {}),
  /* @__PURE__ */ _("p", { className: "text-center text-sm text-foundations-subtle", children: t || "No matching data available" })
] }), ME = () => /* @__PURE__ */ _("div", { className: "my-4 flex flex-col items-center", children: /* @__PURE__ */ _(QC, {}) }), OE = () => {
  const {
    options: t = [],
    filterBy: e,
    displayedValueKey: n,
    onSelect: r,
    setIsOpen: o,
    ExtraBodyContent: i,
    searchTerm: s,
    onSearch: a
  } = _n(), [l, c] = S.useState(""), u = t.filter(([b, y]) => {
    var w;
    return e ? e(l, y) : n ? (w = y[n]) == null ? void 0 : w.toLowerCase().includes(l == null ? void 0 : l.toLowerCase()) : y == null ? void 0 : y.toLowerCase().includes(l == null ? void 0 : l.toLowerCase());
  }), {
    getLabelProps: d,
    getMenuProps: f,
    getInputProps: h,
    getItemProps: p,
    highlightedIndex: g,
    selectedItem: m,
    resetSelectionBuffer: v
  } = Xg({
    items: u,
    inputValue: s ?? l,
    onInputValueChange: a ?? c
  });
  return /* @__PURE__ */ Z(dt, { children: [
    /* @__PURE__ */ _(Qg, { getLabelProps: d, getInputProps: h }),
    i,
    /* @__PURE__ */ _(
      "ul",
      {
        className: "my-1 flex-1 space-y-1 overflow-y-auto px-2",
        ...f(),
        children: u.length ? u.map((b, y) => /* @__PURE__ */ _(
          Jg,
          {
            "data-highlighted": g === y,
            option: b,
            getItemProps: p,
            index: y,
            selectedItem: m
          },
          b[0]
        )) : /* @__PURE__ */ _(Zg, {})
      }
    ),
    /* @__PURE__ */ _(
      em,
      {
        onReset: v,
        onApply: () => {
          r(m), o(!1);
        }
      }
    )
  ] });
}, PE = () => {
  const {
    getOptions: t,
    dependencies: e = [],
    onSelect: n,
    setIsOpen: r,
    ExtraBodyContent: o,
    parseGetOptionsError: i
  } = _n(), [s, a] = S.useState(""), [l, c] = S.useState(!0), [u, d] = S.useState(null), [f, h] = S.useState([]), {
    getLabelProps: p,
    getMenuProps: g,
    getInputProps: m,
    getItemProps: v,
    highlightedIndex: b,
    selectedItem: y,
    resetSelectionBuffer: w
  } = Xg({
    items: f,
    inputValue: s,
    onInputValueChange: a
  });
  return w4(
    () => {
      c(!0), t(s).then(h).catch((x) => {
        const M = i != null && i(x) || typeof x == "string" ? x : null;
        d(M || null);
      }).finally(() => c(!1));
    },
    500,
    [s, ...e]
  ), /* @__PURE__ */ Z(dt, { children: [
    /* @__PURE__ */ _(Qg, { getLabelProps: p, getInputProps: m }),
    o,
    /* @__PURE__ */ _(
      "ul",
      {
        className: "my-1 flex-1 space-y-1 overflow-y-auto px-2",
        ...g(),
        children: l ? /* @__PURE__ */ _(ME, {}) : f.length ? f.map((x, M) => /* @__PURE__ */ _(
          Jg,
          {
            "data-highlighted": b === M,
            option: x,
            getItemProps: v,
            index: M,
            selectedItem: y
          },
          x[0]
        )) : /* @__PURE__ */ _(Zg, { errorMsg: u })
      }
    ),
    /* @__PURE__ */ _(
      em,
      {
        onReset: w,
        onApply: () => {
          n(y), r(!1);
        }
      }
    )
  ] });
}, Qg = ({
  getLabelProps: t,
  getInputProps: e
}) => {
  const { label: n, name: r, placeholder: o = "Search" } = _n();
  return /* @__PURE__ */ Z("div", { className: "px-4 pb-1 pt-3", children: [
    /* @__PURE__ */ Z("div", { className: "flex items-center justify-between space-x-2", children: [
      /* @__PURE__ */ _(
        "label",
        {
          title: n,
          className: "select-none truncate font-medium text-foundations-bolder",
          ...t(),
          children: n
        }
      ),
      /* @__PURE__ */ _(b4, { className: "shrink-0 text-foundations-subtler hover:text-info focus:text-info focus:outline-none ", children: /* @__PURE__ */ _(YC, { className: "h-5 w-5" }) })
    ] }),
    /* @__PURE__ */ Z("div", { className: "relative mt-3", children: [
      /* @__PURE__ */ _(
        "input",
        {
          className: "w-full rounded-md border border-foundations-bold bg-foundations-default py-1.5 pl-10 pr-2 text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:ring-1 focus:ring-info-bold",
          placeholder: o,
          ...e({ name: r })
        }
      ),
      /* @__PURE__ */ _("div", { className: "pointer-events-none absolute inset-y-0 left-0 inline-flex items-center pl-2", children: /* @__PURE__ */ _(zC, { className: "h-5 w-5 text-foundations-subtler " }) })
    ] })
  ] });
}, SE = Kt(
  "group flex justify-between items-center text-sm text-foundations-bolder p-2 rounded",
  {
    variants: {
      multiple: {
        true: "data-[highlighted=true]:bg-foundations-subtlest",
        false: "data-[highlighted=true]:bg-info-bold data-[highlighted=true]:text-foundations-inverse data-[selected=true]:bg-info-bold data-[selected=true]:text-foundations-inverse data-[highlighted=true]:data-[selected=true]:bg-info-bolder"
      }
    },
    defaultVariants: {
      multiple: !1
    }
  }
), Jg = S.forwardRef(({ selectedItem: t, option: e, getItemProps: n, index: r, ...o }, i) => {
  const { multiple: s, renderOption: a } = _n(), [l, c] = e, u = s ? t == null ? void 0 : t.some(([d]) => d === l) : l === (t == null ? void 0 : t[0]);
  return /* @__PURE__ */ Z(
    "li",
    {
      ref: i,
      "data-selected": u,
      className: SE({ multiple: s }),
      ...n({ item: e, index: r }),
      ...o,
      children: [
        /* @__PURE__ */ _("div", { className: "flex flex-1 items-center justify-between overflow-hidden", children: a ? a(c) : /* @__PURE__ */ Z(dt, { children: [
          /* @__PURE__ */ _("span", { children: c }),
          !s && /* @__PURE__ */ _(cs, { className: "invisible h-5 w-5 flex-shrink-0 group-data-[selected=true]:visible" })
        ] }) }),
        s && /* @__PURE__ */ _(
          up,
          {
            tabIndex: -1,
            checked: u,
            readOnly: !0,
            disabled: !0,
            className: "pointer-events-none flex-shrink-0 select-none"
          }
        )
      ]
    }
  );
}), em = ({
  onReset: t,
  onApply: e
}) => {
  const { withConfirmation: n, ExtraFooterAction: r } = _n();
  return n ? /* @__PURE__ */ Z("div", { className: "border-t border-t-neutral-200 px-6 py-4", children: [
    r,
    /* @__PURE__ */ Z("div", { className: "flex space-x-4", children: [
      /* @__PURE__ */ _(sa, { variant: "secondary", onClick: t, className: "flex-1", children: "Reset" }),
      /* @__PURE__ */ _(sa, { onClick: e, className: "flex-1", children: "Apply" })
    ] })
  ] }) : null;
}, tm = S.createContext(null), nm = () => {
  const t = S.useContext(tm);
  if (!t)
    throw new Error("useSelectContext must be used within <Select />");
  return t;
}, DE = (t) => {
  const [e, n] = S.useState(!1), [r, o] = S.useState(""), {
    selected: i,
    onSelect: s,
    options: a,
    placement: l = "bottom",
    className: c,
    contentClassName: u,
    displayedValueKey: d,
    filterBy: f
  } = t, h = S.useRef(!1), p = S.useMemo(() => h.current ? a.filter(([E, C]) => {
    if (typeof C == "string")
      return C.toLowerCase().includes(r == null ? void 0 : r.toLowerCase());
    if (f)
      return f(r, C);
    if (d)
      return C[d].toLowerCase().includes(r == null ? void 0 : r.toLowerCase());
  }) : a, [e, a, r, d]), g = S.useCallback(
    (E, C) => {
      var D;
      const { changes: O, type: R } = C;
      switch (R) {
        case st.stateChangeTypes.InputKeyDownEscape:
        case st.stateChangeTypes.InputBlur:
          return {
            ...O,
            selectedItem: E.selectedItem,
            inputValue: (D = E.selectedItem) != null && D[1] ? d ? E.selectedItem[1][d] : E.selectedItem[1] : ""
          };
        default:
          return O;
      }
    },
    [d]
  ), {
    getInputProps: m,
    getMenuProps: v,
    getItemProps: b,
    highlightedIndex: y,
    getToggleButtonProps: w
  } = st({
    isOpen: e,
    onIsOpenChange: ({ isOpen: E, ...C }) => {
      h.current = !1, n(!!E);
    },
    onInputValueChange: ({ inputValue: E }) => {
      h.current = !0, o(E ?? "");
    },
    items: p,
    itemToString: (E) => E != null && E[1] ? d ? E[1][d] : E[1] : "",
    selectedItem: i,
    onSelectedItemChange: ({ selectedItem: E }) => {
      s(E);
    },
    stateReducer: g
  }), { refs: x, floatingStyles: M } = nl({
    open: e,
    placement: l,
    middleware: [
      qa(6),
      Ka(),
      Xa(),
      Za({
        apply: ({ elements: E, rects: C, availableWidth: O, availableHeight: R }) => {
          const { width: D, height: $ } = C.reference, T = E.floating.style;
          T.setProperty("--available-width", `${O}px`), T.setProperty(
            "--available-height",
            `${R}px`
          ), T.setProperty("--trigger-width", `${D}px`), T.setProperty("--trigger-height", `${$}px`);
        },
        padding: 10
      })
    ],
    whileElementsMounted: tl
  });
  return /* @__PURE__ */ _(tm.Provider, { value: t, children: /* @__PURE__ */ Z("div", { ref: x.setReference, className: c, children: [
    /* @__PURE__ */ _(
      rm,
      {
        getInputProps: m,
        getToggleButtonProps: w
      }
    ),
    /* @__PURE__ */ _(x4, { children: /* @__PURE__ */ _(
      "ul",
      {
        className: ye(
          "z-50 max-h-[min(var(--available-height),_12.5rem)] w-[var(--available-width)] max-w-[max(var(--trigger-width),_18rem)] overflow-y-auto rounded-md bg-foundations-default p-2 py-1 shadow-2",
          !e && "hidden",
          u
        ),
        ...v({ ref: x.setFloating, style: M }),
        children: t.options && /* @__PURE__ */ _(
          im,
          {
            getItemProps: b,
            highlightedIndex: y,
            filteredOptions: p
          }
        )
      }
    ) })
  ] }) });
};
DE.displayName = "Select";
const rm = ({
  getInputProps: t,
  getToggleButtonProps: e
}) => {
  const {
    selected: n,
    id: r,
    name: o,
    disabled: i,
    prefixText: s,
    prefixIcon: a,
    placeholder: l,
    inputClassName: c,
    onBlur: u,
    error: d,
    inputRef: f
  } = nm();
  return /* @__PURE__ */ Z("div", { className: "relative", children: [
    /* @__PURE__ */ _(
      "input",
      {
        className: ye(
          "peer w-full overflow-ellipsis rounded-md border border-foundations-bold bg-foundations-default p-2 pr-8 text-left text-sm text-foundations-subtle focus:border-info-bold focus:text-foundations-boldest focus:shadow-3 focus:outline-none focus:ring-1 focus:ring-info-bold disabled:cursor-not-allowed  aria-expanded:border-info-bold aria-expanded:shadow-3 aria-expanded:ring-1 aria-expanded:ring-info-bold",
          {
            "hover:shadow-3": !i,
            "text-foundations-boldest": n == null ? void 0 : n[1],
            "pl-9": a,
            "pl-16": s,
            "border-danger-bold focus:border-danger-bold focus:ring-danger-bold": d
          },
          c
        ),
        ...t({
          onBlur: u,
          disabled: i,
          placeholder: l,
          name: o,
          id: r,
          ref: f
        })
      }
    ),
    s && /* @__PURE__ */ _("span", { className: "pointer-events-none absolute inset-y-0 left-0 top-0 flex flex-shrink-0 items-center justify-center border-r border-r-foundations-bold px-3 text-sm text-foundations-subtle", children: s }),
    a && /* @__PURE__ */ _(a, { className: "pointer-events-none absolute left-2 top-1/2 h-5 w-5 -translate-y-1/2 text-foundations-subtler peer-focus:text-info peer-aria-expanded:text-info" }),
    /* @__PURE__ */ _(
      "button",
      {
        ...e({ disabled: i, type: "button" }),
        className: "absolute inset-y-0 right-2 flex flex-shrink-0 items-center justify-center text-foundations-subtler transition-transform disabled:cursor-not-allowed peer-focus:text-info peer-aria-expanded:rotate-180 peer-aria-expanded:text-info",
        children: /* @__PURE__ */ _(ip, { className: " h-5 w-5 " })
      }
    )
  ] });
};
rm.displayName = "SelectInput";
const om = () => /* @__PURE__ */ Z("div", { className: "my-4 flex flex-col items-center space-y-4 text-center", children: [
  /* @__PURE__ */ _(lp, {}),
  /* @__PURE__ */ _("p", { className: "text-sm text-foundations-subtle", children: "No matching data available" })
] });
om.displayName = "EmptyOptions";
const im = ({
  highlightedIndex: t,
  getItemProps: e,
  filteredOptions: n
}) => /* @__PURE__ */ _(dt, { children: n.length ? n.map((r, o) => /* @__PURE__ */ _(
  sm,
  {
    "data-highlighted": t === o,
    option: r,
    getItemProps: e,
    index: o
  },
  r[0]
)) : /* @__PURE__ */ _(om, {}) });
im.displayName = "SelectOptions";
const TE = Kt(
  "group flex justify-between items-center text-sm text-foundations-subtle p-2 rounded my-0.5",
  {
    variants: {
      multiple: {
        true: "data-[highlighted=true]:bg-foundations-subtlest",
        false: "data-[highlighted=true]:bg-info-bold data-[highlighted=true]:text-foundations-inverse data-[selected=true]:bg-info-bold data-[selected=true]:text-foundations-inverse data-[highlighted=true]:data-[selected=true]:bg-info-bolder"
      }
    },
    defaultVariants: {
      multiple: !1
    }
  }
), sm = S.forwardRef(({ option: t, getItemProps: e, index: n, ...r }, o) => {
  const { renderOption: i, selected: s } = nm(), [a, l] = t, c = a === (s == null ? void 0 : s[0]);
  return /* @__PURE__ */ _(
    "li",
    {
      ref: o,
      "data-selected": c,
      className: TE(),
      ...e({ item: t, index: n }),
      ...r,
      children: /* @__PURE__ */ _("div", { className: "flex flex-1 items-center justify-between", children: i ? i(l) : /* @__PURE__ */ Z(dt, { children: [
        /* @__PURE__ */ _("span", { children: l }),
        /* @__PURE__ */ _(cs, { className: "invisible h-5 w-5 group-data-[selected=true]:visible" })
      ] }) })
    }
  );
});
sm.displayName = "Option";
const IE = S.forwardRef(
  ({
    multiple: t = !1,
    accept: e,
    label: n = "",
    hint: r = "",
    uploadingProgress: o = 0,
    uploadedFiles: i = [],
    onFilesChange: s
  }, a) => {
    const l = o > 0 && o < 100, c = S.useMemo(
      () => `UploadFiles${n.split(" ").join("")}`,
      [n]
    ), [u, d] = S.useState(!1), f = S.useRef(null), h = S.useCallback(
      (m) => {
        var v;
        if (d(!1), (v = m.target.files) != null && v.length) {
          if (l)
            return;
          s([...m.target.files]);
        }
      },
      [s]
    ), p = S.useCallback(
      (m) => {
        m.preventDefault(), d(!0);
      },
      []
    ), g = S.useCallback(
      (m) => {
        m.preventDefault(), d(!1);
      },
      []
    );
    return /* @__PURE__ */ Z(dt, { children: [
      n && /* @__PURE__ */ Z(
        "label",
        {
          htmlFor: c,
          className: "mb-2 inline-flex items-center gap-2",
          children: [
            /* @__PURE__ */ _("span", { className: "block text-sm font-medium text-foundations-bold", children: n }),
            r && /* @__PURE__ */ _(K0, { delayDuration: 0, children: /* @__PURE__ */ _(
              ts,
              {
                variant: "dark",
                content: r,
                side: "top",
                size: "sm",
                collisionPadding: 4,
                children: /* @__PURE__ */ _("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-neutral-100", children: /* @__PURE__ */ _(
                  jC,
                  {
                    width: 16,
                    height: 16,
                    className: " text-foundations-subtler"
                  }
                ) })
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ Z(
        "div",
        {
          ref: a,
          className: ye(
            "relative flex w-full items-center justify-center gap-2 overflow-hidden rounded border border-dashed border-neutral-300 p-4 text-foundations-subtle transition-all duration-200",
            {
              "border-blue-500 bg-neutral-50 text-blue-500": u,
              "pointer-events-none border-solid border-blue-200": l,
              "pointer-events-none border-solid border-green-200": i.length > 0
            }
          ),
          children: [
            l ? /* @__PURE__ */ Z(dt, { children: [
              /* @__PURE__ */ _(
                op,
                {
                  variant: "primary",
                  value: o,
                  size: 26,
                  strokeWidth: 4,
                  strokeClassName: "stroke-neutral-800",
                  strokeLinecap: "square"
                }
              ),
              /* @__PURE__ */ Z("p", { className: "p-1 text-xs font-medium", children: [
                "Uploading (",
                o,
                "%)"
              ] }),
              /* @__PURE__ */ _(
                "div",
                {
                  className: "absolute bottom-0 left-0 h-[5px] bg-blue-500",
                  style: { width: `${o}%` }
                }
              )
            ] }) : /* @__PURE__ */ _(dt, { children: i.length > 0 ? /* @__PURE__ */ Z(dt, { children: [
              /* @__PURE__ */ _("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-green-100", children: /* @__PURE__ */ _(
                cs,
                {
                  width: 16,
                  height: 16,
                  className: "text-green-500"
                }
              ) }),
              /* @__PURE__ */ _("p", { className: "p-1 text-xs font-medium", children: i[0].name })
            ] }) : /* @__PURE__ */ Z(dt, { children: [
              /* @__PURE__ */ _(
                ld,
                {
                  width: 20,
                  height: 20,
                  className: "pointer-events-none"
                }
              ),
              /* @__PURE__ */ _("p", { className: "pointer-events-none p-1 text-xs font-medium", children: "Drop file or click here to upload" })
            ] }) }),
            /* @__PURE__ */ _(
              "input",
              {
                id: c,
                className: "absolute inset-0 cursor-pointer opacity-0",
                ref: f,
                type: "file",
                accept: e,
                multiple: t,
                onChange: h,
                onDragEnter: p,
                onDragLeave: g
              }
            )
          ]
        }
      ),
      e && /* @__PURE__ */ Z("p", { className: "mt-[6px] text-xs text-foundations-subtle", children: [
        "Supported file types: ",
        e.split(",").join(" ")
      ] }),
      i.length > 0 && /* @__PURE__ */ Z(
        "button",
        {
          className: "flex items-center justify-center gap-2 px-4 py-[6px] text-foundations-subtle",
          onClick: () => {
            var m;
            return (m = f.current) == null ? void 0 : m.click();
          },
          children: [
            /* @__PURE__ */ _(ld, { width: 20, height: 20 }),
            /* @__PURE__ */ _("span", { className: "text-xs font-medium", children: "Re-upload file" })
          ]
        }
      )
    ] });
  }
);
IE.displayName = "UploadArea";
const Aa = "dismissableLayer.update", $E = "dismissableLayer.pointerDownOutside", NE = "dismissableLayer.focusOutside";
let Zd;
const RE = /* @__PURE__ */ At({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), AE = /* @__PURE__ */ de((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: s, onInteractOutside: a, onDismiss: l, ...c } = t, u = Gt(RE), [d, f] = ke(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = ke({}), g = et(
    e,
    (C) => f(C)
  ), m = Array.from(u.layers), [v] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), b = m.indexOf(v), y = d ? m.indexOf(d) : -1, w = u.layersWithOutsidePointerEventsDisabled.size > 0, x = y >= b, M = LE((C) => {
    const O = C.target, R = [
      ...u.branches
    ].some(
      (D) => D.contains(O)
    );
    !x || R || (i == null || i(C), a == null || a(C), C.defaultPrevented || l == null || l());
  }, h), E = FE((C) => {
    const O = C.target;
    [
      ...u.branches
    ].some(
      (D) => D.contains(O)
    ) || (s == null || s(C), a == null || a(C), C.defaultPrevented || l == null || l());
  }, h);
  return vf((C) => {
    y === u.layers.size - 1 && (o == null || o(C), !C.defaultPrevented && l && (C.preventDefault(), l()));
  }, h), ue(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Zd = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), Qd(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Zd);
      };
  }, [
    d,
    h,
    r,
    u
  ]), ue(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), Qd());
  }, [
    d,
    u
  ]), ue(() => {
    const C = () => p({});
    return document.addEventListener(Aa, C), () => document.removeEventListener(Aa, C);
  }, []), /* @__PURE__ */ A(je.div, ne({}, c, {
    ref: g,
    style: {
      pointerEvents: w ? x ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: ve(t.onFocusCapture, E.onFocusCapture),
    onBlurCapture: ve(t.onBlurCapture, E.onBlurCapture),
    onPointerDownCapture: ve(t.onPointerDownCapture, M.onPointerDownCapture)
  }));
});
function LE(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = ht(t), r = le(!1), o = le(() => {
  });
  return ue(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          am($E, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (e.removeEventListener("click", o.current), o.current = c, e.addEventListener("click", o.current, {
          once: !0
        })) : c();
      } else
        e.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      e.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), e.removeEventListener("pointerdown", i), e.removeEventListener("click", o.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function FE(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = ht(t), r = le(!1);
  return ue(() => {
    const o = (i) => {
      i.target && !r.current && am(NE, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", o), () => e.removeEventListener("focusin", o);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Qd() {
  const t = new CustomEvent(Aa);
  document.dispatchEvent(t);
}
function am(t, e, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && o.addEventListener(t, e, {
    once: !0
  }), r ? za(o, i) : o.dispatchEvent(i);
}
const ea = "focusScope.autoFocusOnMount", ta = "focusScope.autoFocusOnUnmount", Jd = {
  bubbles: !1,
  cancelable: !0
}, HE = /* @__PURE__ */ de((t, e) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...s } = t, [a, l] = ke(null), c = ht(o), u = ht(i), d = le(null), f = et(
    e,
    (g) => l(g)
  ), h = le({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ue(() => {
    if (r) {
      let g = function(y) {
        if (h.paused || !a)
          return;
        const w = y.target;
        a.contains(w) ? d.current = w : On(d.current, {
          select: !0
        });
      }, m = function(y) {
        if (h.paused || !a)
          return;
        const w = y.relatedTarget;
        w !== null && (a.contains(w) || On(d.current, {
          select: !0
        }));
      }, v = function(y) {
        if (document.activeElement === document.body)
          for (const x of y)
            x.removedNodes.length > 0 && On(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const b = new MutationObserver(v);
      return a && b.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), b.disconnect();
      };
    }
  }, [
    r,
    a,
    h.paused
  ]), ue(() => {
    if (a) {
      tf.add(h);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const v = new CustomEvent(ea, Jd);
        a.addEventListener(ea, c), a.dispatchEvent(v), v.defaultPrevented || (WE(YE(lm(a)), {
          select: !0
        }), document.activeElement === g && On(a));
      }
      return () => {
        a.removeEventListener(ea, c), setTimeout(() => {
          const v = new CustomEvent(ta, Jd);
          a.addEventListener(ta, u), a.dispatchEvent(v), v.defaultPrevented || On(g ?? document.body, {
            select: !0
          }), a.removeEventListener(ta, u), tf.remove(h);
        }, 0);
      };
    }
  }, [
    a,
    c,
    u,
    h
  ]);
  const p = pe((g) => {
    if (!n && !r || h.paused)
      return;
    const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, v = document.activeElement;
    if (m && v) {
      const b = g.currentTarget, [y, w] = VE(b);
      y && w ? !g.shiftKey && v === w ? (g.preventDefault(), n && On(y, {
        select: !0
      })) : g.shiftKey && v === y && (g.preventDefault(), n && On(w, {
        select: !0
      })) : v === b && g.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ A(je.div, ne({
    tabIndex: -1
  }, s, {
    ref: f,
    onKeyDown: p
  }));
});
function WE(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (On(r, {
      select: e
    }), document.activeElement !== n)
      return;
}
function VE(t) {
  const e = lm(t), n = ef(e, t), r = ef(e.reverse(), t);
  return [
    n,
    r
  ];
}
function lm(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function ef(t, e) {
  for (const n of t)
    if (!BE(n, {
      upTo: e
    }))
      return n;
}
function BE(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function jE(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function On(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({
      preventScroll: !0
    }), t !== n && jE(t) && e && t.select();
  }
}
const tf = zE();
function zE() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = nf(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = nf(t, e), (n = t[0]) === null || n === void 0 || n.resume();
    }
  };
}
function nf(t, e) {
  const n = [
    ...t
  ], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function YE(t) {
  return t.filter(
    (e) => e.tagName !== "A"
  );
}
const cm = "Popper", [um, dm] = sn(cm), [UE, fm] = um(cm), GE = (t) => {
  const { __scopePopper: e, children: n } = t, [r, o] = ke(null);
  return /* @__PURE__ */ A(UE, {
    scope: e,
    anchor: r,
    onAnchorChange: o
  }, n);
}, KE = "PopperAnchor", qE = /* @__PURE__ */ de((t, e) => {
  const { __scopePopper: n, virtualRef: r, ...o } = t, i = fm(KE, n), s = le(null), a = et(e, s);
  return ue(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
  }), r ? null : /* @__PURE__ */ A(je.div, ne({}, o, {
    ref: a
  }));
}), hm = "PopperContent", [XE, R8] = um(hm), ZE = /* @__PURE__ */ de((t, e) => {
  var n, r, o, i, s, a, l, c;
  const { __scopePopper: u, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: g = 0, avoidCollisions: m = !0, collisionBoundary: v = [], collisionPadding: b = 0, sticky: y = "partial", hideWhenDetached: w = !1, updatePositionStrategy: x = "optimized", onPlaced: M, ...E } = t, C = fm(hm, u), [O, R] = ke(null), D = et(
    e,
    (Re) => R(Re)
  ), [$, T] = ke(null), j = rl($), L = (n = j == null ? void 0 : j.width) !== null && n !== void 0 ? n : 0, Y = (r = j == null ? void 0 : j.height) !== null && r !== void 0 ? r : 0, H = d + (h !== "center" ? "-" + h : ""), z = typeof b == "number" ? b : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...b
  }, ee = Array.isArray(v) ? v : [
    v
  ], I = ee.length > 0, F = {
    padding: z,
    boundary: ee.filter(QE),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: I
  }, { refs: te, floatingStyles: J, placement: re, isPositioned: B, middlewareData: N } = nl({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: H,
    whileElementsMounted: (...Re) => tl(...Re, {
      animationFrame: x === "always"
    }),
    elements: {
      reference: C.anchor
    },
    middleware: [
      qa({
        mainAxis: f + Y,
        alignmentAxis: p
      }),
      m && Xa({
        mainAxis: !0,
        crossAxis: !1,
        limiter: y === "partial" ? _f() : void 0,
        ...F
      }),
      m && Ka({
        ...F
      }),
      Za({
        ...F,
        apply: ({ elements: Re, rects: wt, availableWidth: ct, availableHeight: St }) => {
          const { width: Wt, height: it } = wt.reference, rt = Re.floating.style;
          rt.setProperty("--radix-popper-available-width", `${ct}px`), rt.setProperty("--radix-popper-available-height", `${St}px`), rt.setProperty("--radix-popper-anchor-width", `${Wt}px`), rt.setProperty("--radix-popper-anchor-height", `${it}px`);
        }
      }),
      $ && Df({
        element: $,
        padding: g
      }),
      JE({
        arrowWidth: L,
        arrowHeight: Y
      }),
      w && wf({
        strategy: "referenceHidden",
        ...F
      })
    ]
  }), [W, V] = pm(re), G = ht(M);
  Rn(() => {
    B && (G == null || G());
  }, [
    B,
    G
  ]);
  const oe = (o = N.arrow) === null || o === void 0 ? void 0 : o.x, X = (i = N.arrow) === null || i === void 0 ? void 0 : i.y, U = ((s = N.arrow) === null || s === void 0 ? void 0 : s.centerOffset) !== 0, [be, De] = ke();
  return Rn(() => {
    O && De(window.getComputedStyle(O).zIndex);
  }, [
    O
  ]), /* @__PURE__ */ A("div", {
    ref: te.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...J,
      transform: B ? J.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: be,
      "--radix-popper-transform-origin": [
        (a = N.transformOrigin) === null || a === void 0 ? void 0 : a.x,
        (l = N.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: t.dir
  }, /* @__PURE__ */ A(XE, {
    scope: u,
    placedSide: W,
    onArrowChange: T,
    arrowX: oe,
    arrowY: X,
    shouldHideArrow: U
  }, /* @__PURE__ */ A(je.div, ne({
    "data-side": W,
    "data-align": V
  }, E, {
    ref: D,
    style: {
      ...E.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: B ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = N.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
});
function QE(t) {
  return t !== null;
}
const JE = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, o, i, s;
    const { placement: a, rects: l, middlewareData: c } = e, d = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : t.arrowWidth, h = d ? 0 : t.arrowHeight, [p, g] = pm(a), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], v = ((r = (o = c.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2, b = ((i = (s = c.arrow) === null || s === void 0 ? void 0 : s.y) !== null && i !== void 0 ? i : 0) + h / 2;
    let y = "", w = "";
    return p === "bottom" ? (y = d ? m : `${v}px`, w = `${-h}px`) : p === "top" ? (y = d ? m : `${v}px`, w = `${l.floating.height + h}px`) : p === "right" ? (y = `${-h}px`, w = d ? m : `${b}px`) : p === "left" && (y = `${l.floating.width + h}px`, w = d ? m : `${b}px`), {
      data: {
        x: y,
        y: w
      }
    };
  }
});
function pm(t) {
  const [e, n = "center"] = t.split("-");
  return [
    e,
    n
  ];
}
const e7 = GE, t7 = qE, n7 = ZE, r7 = /* @__PURE__ */ de((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = t;
  return r ? /* @__PURE__ */ af.createPortal(/* @__PURE__ */ A(je.div, ne({}, o, {
    ref: e
  })), r) : null;
}), o7 = [
  "Enter",
  " "
], i7 = [
  "ArrowDown",
  "PageUp",
  "Home"
], gm = [
  "ArrowUp",
  "PageDown",
  "End"
], s7 = [
  ...i7,
  ...gm
], ms = "Menu", [La, a7, l7] = hp(ms), [hr, mm] = sn(ms, [
  l7,
  dm,
  us
]), rc = dm(), vm = us(), [c7, Ao] = hr(ms), [u7, oc] = hr(ms), d7 = (t) => {
  const { __scopeMenu: e, open: n = !1, children: r, dir: o, onOpenChange: i, modal: s = !0 } = t, a = rc(e), [l, c] = ke(null), u = le(!1), d = ht(i), f = Tl(o);
  return ue(() => {
    const h = () => {
      u.current = !0, document.addEventListener("pointerdown", p, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", p, {
        capture: !0,
        once: !0
      });
    }, p = () => u.current = !1;
    return document.addEventListener("keydown", h, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", h, {
        capture: !0
      }), document.removeEventListener("pointerdown", p, {
        capture: !0
      }), document.removeEventListener("pointermove", p, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ A(e7, a, /* @__PURE__ */ A(c7, {
    scope: e,
    open: n,
    onOpenChange: d,
    content: l,
    onContentChange: c
  }, /* @__PURE__ */ A(u7, {
    scope: e,
    onClose: pe(
      () => d(!1),
      [
        d
      ]
    ),
    isUsingKeyboardRef: u,
    dir: f,
    modal: s
  }, r)));
}, f7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, ...r } = t, o = rc(n);
  return /* @__PURE__ */ A(t7, ne({}, o, r, {
    ref: e
  }));
}), bm = "MenuPortal", [h7, p7] = hr(bm, {
  forceMount: void 0
}), g7 = (t) => {
  const { __scopeMenu: e, forceMount: n, children: r, container: o } = t, i = Ao(bm, e);
  return /* @__PURE__ */ A(h7, {
    scope: e,
    forceMount: n
  }, /* @__PURE__ */ A(ur, {
    present: n || i.open
  }, /* @__PURE__ */ A(r7, {
    asChild: !0,
    container: o
  }, r)));
}, Nn = "MenuContent", [m7, ym] = hr(Nn), v7 = /* @__PURE__ */ de((t, e) => {
  const n = p7(Nn, t.__scopeMenu), { forceMount: r = n.forceMount, ...o } = t, i = Ao(Nn, t.__scopeMenu), s = oc(Nn, t.__scopeMenu);
  return /* @__PURE__ */ A(La.Provider, {
    scope: t.__scopeMenu
  }, /* @__PURE__ */ A(ur, {
    present: r || i.open
  }, /* @__PURE__ */ A(La.Slot, {
    scope: t.__scopeMenu
  }, s.modal ? /* @__PURE__ */ A(b7, ne({}, o, {
    ref: e
  })) : /* @__PURE__ */ A(y7, ne({}, o, {
    ref: e
  })))));
}), b7 = /* @__PURE__ */ de((t, e) => {
  const n = Ao(Nn, t.__scopeMenu), r = le(null), o = et(e, r);
  return ue(() => {
    const i = r.current;
    if (i)
      return zp(i);
  }, []), /* @__PURE__ */ A(xm, ne({}, t, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: ve(
      t.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), y7 = /* @__PURE__ */ de((t, e) => {
  const n = Ao(Nn, t.__scopeMenu);
  return /* @__PURE__ */ A(xm, ne({}, t, {
    ref: e,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), xm = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: o, onOpenAutoFocus: i, onCloseAutoFocus: s, disableOutsidePointerEvents: a, onEntryFocus: l, onEscapeKeyDown: c, onPointerDownOutside: u, onFocusOutside: d, onInteractOutside: f, onDismiss: h, disableOutsideScroll: p, ...g } = t, m = Ao(Nn, n), v = oc(Nn, n), b = rc(n), y = vm(n), w = a7(n), [x, M] = ke(null), E = le(null), C = et(e, E, m.onContentChange), O = le(0), R = le(""), D = le(0), $ = le(null), T = le("right"), j = le(0), L = p ? Jp : of, Y = p ? {
    as: zt,
    allowPinchZoom: !0
  } : void 0, H = (ee) => {
    var I, F;
    const te = R.current + ee, J = w().filter(
      (G) => !G.disabled
    ), re = document.activeElement, B = (I = J.find(
      (G) => G.ref.current === re
    )) === null || I === void 0 ? void 0 : I.textValue, N = J.map(
      (G) => G.textValue
    ), W = T7(N, te, B), V = (F = J.find(
      (G) => G.textValue === W
    )) === null || F === void 0 ? void 0 : F.ref.current;
    (function G(oe) {
      R.current = oe, window.clearTimeout(O.current), oe !== "" && (O.current = window.setTimeout(
        () => G(""),
        1e3
      ));
    })(te), V && setTimeout(
      () => V.focus()
    );
  };
  ue(() => () => window.clearTimeout(O.current), []), Vp();
  const z = pe((ee) => {
    var I, F;
    return T.current === ((I = $.current) === null || I === void 0 ? void 0 : I.side) && $7(ee, (F = $.current) === null || F === void 0 ? void 0 : F.area);
  }, []);
  return /* @__PURE__ */ A(m7, {
    scope: n,
    searchRef: R,
    onItemEnter: pe((ee) => {
      z(ee) && ee.preventDefault();
    }, [
      z
    ]),
    onItemLeave: pe((ee) => {
      var I;
      z(ee) || ((I = E.current) === null || I === void 0 || I.focus(), M(null));
    }, [
      z
    ]),
    onTriggerLeave: pe((ee) => {
      z(ee) && ee.preventDefault();
    }, [
      z
    ]),
    pointerGraceTimerRef: D,
    onPointerGraceIntentChange: pe((ee) => {
      $.current = ee;
    }, [])
  }, /* @__PURE__ */ A(L, Y, /* @__PURE__ */ A(HE, {
    asChild: !0,
    trapped: o,
    onMountAutoFocus: ve(i, (ee) => {
      var I;
      ee.preventDefault(), (I = E.current) === null || I === void 0 || I.focus();
    }),
    onUnmountAutoFocus: s
  }, /* @__PURE__ */ A(AE, {
    asChild: !0,
    disableOutsidePointerEvents: a,
    onEscapeKeyDown: c,
    onPointerDownOutside: u,
    onFocusOutside: d,
    onInteractOutside: f,
    onDismiss: h
  }, /* @__PURE__ */ A(mp, ne({
    asChild: !0
  }, y, {
    dir: v.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: x,
    onCurrentTabStopIdChange: M,
    onEntryFocus: ve(l, (ee) => {
      v.isUsingKeyboardRef.current || ee.preventDefault();
    })
  }), /* @__PURE__ */ A(n7, ne({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": P7(m.open),
    "data-radix-menu-content": "",
    dir: v.dir
  }, b, g, {
    ref: C,
    style: {
      outline: "none",
      ...g.style
    },
    onKeyDown: ve(g.onKeyDown, (ee) => {
      const F = ee.target.closest("[data-radix-menu-content]") === ee.currentTarget, te = ee.ctrlKey || ee.altKey || ee.metaKey, J = ee.key.length === 1;
      F && (ee.key === "Tab" && ee.preventDefault(), !te && J && H(ee.key));
      const re = E.current;
      if (ee.target !== re || !s7.includes(ee.key))
        return;
      ee.preventDefault();
      const N = w().filter(
        (W) => !W.disabled
      ).map(
        (W) => W.ref.current
      );
      gm.includes(ee.key) && N.reverse(), S7(N);
    }),
    onBlur: ve(t.onBlur, (ee) => {
      ee.currentTarget.contains(ee.target) || (window.clearTimeout(O.current), R.current = "");
    }),
    onPointerMove: ve(t.onPointerMove, Ha((ee) => {
      const I = ee.target, F = j.current !== ee.clientX;
      if (ee.currentTarget.contains(I) && F) {
        const te = ee.clientX > j.current ? "right" : "left";
        T.current = te, j.current = ee.clientX;
      }
    }))
  })))))));
}), x7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, ...r } = t;
  return /* @__PURE__ */ A(je.div, ne({
    role: "group"
  }, r, {
    ref: e
  }));
}), w7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, ...r } = t;
  return /* @__PURE__ */ A(je.div, ne({}, r, {
    ref: e
  }));
}), Fa = "MenuItem", rf = "menu.itemSelect", _7 = /* @__PURE__ */ de((t, e) => {
  const { disabled: n = !1, onSelect: r, ...o } = t, i = le(null), s = oc(Fa, t.__scopeMenu), a = ym(Fa, t.__scopeMenu), l = et(e, i), c = le(!1), u = () => {
    const d = i.current;
    if (!n && d) {
      const f = new CustomEvent(rf, {
        bubbles: !0,
        cancelable: !0
      });
      d.addEventListener(
        rf,
        (h) => r == null ? void 0 : r(h),
        {
          once: !0
        }
      ), za(d, f), f.defaultPrevented ? c.current = !1 : s.onClose();
    }
  };
  return /* @__PURE__ */ A(C7, ne({}, o, {
    ref: l,
    disabled: n,
    onClick: ve(t.onClick, u),
    onPointerDown: (d) => {
      var f;
      (f = t.onPointerDown) === null || f === void 0 || f.call(t, d), c.current = !0;
    },
    onPointerUp: ve(t.onPointerUp, (d) => {
      var f;
      c.current || (f = d.currentTarget) === null || f === void 0 || f.click();
    }),
    onKeyDown: ve(t.onKeyDown, (d) => {
      const f = a.searchRef.current !== "";
      n || f && d.key === " " || o7.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
    })
  }));
}), C7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = t, s = ym(Fa, n), a = vm(n), l = le(null), c = et(e, l), [u, d] = ke(!1), [f, h] = ke("");
  return ue(() => {
    const p = l.current;
    if (p) {
      var g;
      h(((g = p.textContent) !== null && g !== void 0 ? g : "").trim());
    }
  }, [
    i.children
  ]), /* @__PURE__ */ A(La.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: o ?? f
  }, /* @__PURE__ */ A(vp, ne({
    asChild: !0
  }, a, {
    focusable: !r
  }), /* @__PURE__ */ A(je.div, ne({
    role: "menuitem",
    "data-highlighted": u ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, i, {
    ref: c,
    onPointerMove: ve(t.onPointerMove, Ha((p) => {
      r ? s.onItemLeave(p) : (s.onItemEnter(p), p.defaultPrevented || p.currentTarget.focus());
    })),
    onPointerLeave: ve(t.onPointerLeave, Ha(
      (p) => s.onItemLeave(p)
    )),
    onFocus: ve(
      t.onFocus,
      () => d(!0)
    ),
    onBlur: ve(
      t.onBlur,
      () => d(!1)
    )
  }))));
}), E7 = "MenuRadioGroup";
hr(E7, {
  value: void 0,
  onValueChange: () => {
  }
});
const k7 = "MenuItemIndicator";
hr(k7, {
  checked: !1
});
const M7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, ...r } = t;
  return /* @__PURE__ */ A(je.div, ne({
    role: "separator",
    "aria-orientation": "horizontal"
  }, r, {
    ref: e
  }));
}), O7 = "MenuSub";
hr(O7);
function P7(t) {
  return t ? "open" : "closed";
}
function S7(t) {
  const e = document.activeElement;
  for (const n of t)
    if (n === e || (n.focus(), document.activeElement !== e))
      return;
}
function D7(t, e) {
  return t.map(
    (n, r) => t[(e + r) % t.length]
  );
}
function T7(t, e, n) {
  const o = e.length > 1 && Array.from(e).every(
    (c) => c === e[0]
  ) ? e[0] : e, i = n ? t.indexOf(n) : -1;
  let s = D7(t, Math.max(i, 0));
  o.length === 1 && (s = s.filter(
    (c) => c !== n
  ));
  const l = s.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function I7(t, e) {
  const { x: n, y: r } = t;
  let o = !1;
  for (let i = 0, s = e.length - 1; i < e.length; s = i++) {
    const a = e[i].x, l = e[i].y, c = e[s].x, u = e[s].y;
    l > r != u > r && n < (c - a) * (r - l) / (u - l) + a && (o = !o);
  }
  return o;
}
function $7(t, e) {
  if (!e)
    return !1;
  const n = {
    x: t.clientX,
    y: t.clientY
  };
  return I7(n, e);
}
function Ha(t) {
  return (e) => e.pointerType === "mouse" ? t(e) : void 0;
}
const N7 = d7, R7 = f7, A7 = g7, L7 = v7, F7 = x7, H7 = w7, W7 = _7, V7 = M7, wm = "DropdownMenu", [B7, A8] = sn(wm, [
  mm
]), jn = mm(), [j7, _m] = B7(wm), z7 = (t) => {
  const { __scopeDropdownMenu: e, children: n, dir: r, open: o, defaultOpen: i, onOpenChange: s, modal: a = !0 } = t, l = jn(e), c = le(null), [u = !1, d] = Wn({
    prop: o,
    defaultProp: i,
    onChange: s
  });
  return /* @__PURE__ */ A(j7, {
    scope: e,
    triggerId: po(),
    triggerRef: c,
    contentId: po(),
    open: u,
    onOpenChange: d,
    onOpenToggle: pe(
      () => d(
        (f) => !f
      ),
      [
        d
      ]
    ),
    modal: a
  }, /* @__PURE__ */ A(N7, ne({}, l, {
    open: u,
    onOpenChange: d,
    dir: r,
    modal: a
  }), n));
}, Y7 = "DropdownMenuTrigger", U7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = t, i = _m(Y7, n), s = jn(n);
  return /* @__PURE__ */ A(R7, ne({
    asChild: !0
  }, s), /* @__PURE__ */ A(je.button, ne({
    type: "button",
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": i.open,
    "aria-controls": i.open ? i.contentId : void 0,
    "data-state": i.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, o, {
    ref: Ba(e, i.triggerRef),
    onPointerDown: ve(t.onPointerDown, (a) => {
      !r && a.button === 0 && a.ctrlKey === !1 && (i.onOpenToggle(), i.open || a.preventDefault());
    }),
    onKeyDown: ve(t.onKeyDown, (a) => {
      r || ([
        "Enter",
        " "
      ].includes(a.key) && i.onOpenToggle(), a.key === "ArrowDown" && i.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(a.key) && a.preventDefault());
    })
  })));
}), G7 = (t) => {
  const { __scopeDropdownMenu: e, ...n } = t, r = jn(e);
  return /* @__PURE__ */ A(A7, ne({}, r, n));
}, K7 = "DropdownMenuContent", q7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = _m(K7, n), i = jn(n), s = le(!1);
  return /* @__PURE__ */ A(L7, ne({
    id: o.contentId,
    "aria-labelledby": o.triggerId
  }, i, r, {
    ref: e,
    onCloseAutoFocus: ve(t.onCloseAutoFocus, (a) => {
      var l;
      s.current || (l = o.triggerRef.current) === null || l === void 0 || l.focus(), s.current = !1, a.preventDefault();
    }),
    onInteractOutside: ve(t.onInteractOutside, (a) => {
      const l = a.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
      (!o.modal || u) && (s.current = !0);
    }),
    style: {
      ...t.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), X7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = jn(n);
  return /* @__PURE__ */ A(F7, ne({}, o, r, {
    ref: e
  }));
}), Z7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = jn(n);
  return /* @__PURE__ */ A(H7, ne({}, o, r, {
    ref: e
  }));
}), Q7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = jn(n);
  return /* @__PURE__ */ A(W7, ne({}, o, r, {
    ref: e
  }));
}), J7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = jn(n);
  return /* @__PURE__ */ A(V7, ne({}, o, r, {
    ref: e
  }));
}), e8 = z7, t8 = U7, n8 = G7, r8 = q7, o8 = X7, i8 = Z7, s8 = Q7, a8 = J7, l8 = e8;
l8.displayName = "Menu";
const c8 = t8;
c8.displayName = "MenuTrigger";
const u8 = o8;
u8.displayName = "MenuGroup";
const d8 = S.forwardRef(
  ({
    className: t,
    align: e = "end",
    sideOffset: n = 4,
    collisionPadding: r = 32,
    loop: o = !0,
    disablePortal: i = !1,
    ...s
  }, a) => {
    const l = i ? S.Fragment : n8;
    return /* @__PURE__ */ _(l, { children: /* @__PURE__ */ _(
      r8,
      {
        ref: a,
        sideOffset: n,
        align: e,
        className: ye(
          "z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] w-56 overflow-hidden overflow-y-auto rounded-md border border-foundations-subtle bg-foundations-default p-2 text-foundations-bolder shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
          t
        ),
        loop: o,
        collisionPadding: r,
        ...s
      }
    ) });
  }
);
d8.displayName = "MenuContent";
const f8 = Kt(
  "relative flex cursor-pointer select-none scroll-m-1 items-center rounded px-4 py-2 text-sm outline-none transition-colors data-[highlighted]:bg-foundations-subtlest data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
  {
    variants: {
      variant: {
        destructive: "text-danger"
      }
    }
  }
), h8 = S.forwardRef(({ className: t, variant: e, ...n }, r) => /* @__PURE__ */ _(
  s8,
  {
    ref: r,
    className: ye(f8({ variant: e }), t),
    ...n
  }
));
h8.displayName = "MenuItem";
const p8 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ _(
  i8,
  {
    ref: n,
    className: ye(
      "px-4 py-2 text-xs font-medium uppercase text-foundations-subtle",
      t
    ),
    ...e
  }
));
p8.displayName = "MenuHeading";
const g8 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ _(
  a8,
  {
    ref: n,
    className: ye("-mx-2 my-1.5 border-t border-foundations-subtle", t),
    ...e
  }
));
g8.displayName = "MenuSeparator";
const L8 = S.forwardRef(({ Icon: t, className: e, ...n }, r) => /* @__PURE__ */ _(t, { className: ye("mr-2 h-5 w-5", e), ref: r, ...n }));
function F8({
  currency: t,
  amount: e,
  compact: n = !1
}) {
  const r = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: t,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: n ? "compact" : "standard"
  });
  return n ? r.format(e) : r.format(e).replace(/^(\D+)\s*(.+)$/, "$2$1").trim();
}
function H8({
  value: t,
  compact: e = !1
}) {
  return new Intl.NumberFormat(void 0, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: e ? "compact" : "standard"
  }).format(t);
}
export {
  P8 as AccessDeniedIllustration,
  GC as Alert,
  LC as Badge,
  sa as Button,
  gv as ButtonGroup,
  $p as Calendar,
  qC as Card,
  SC as Chart,
  Cl as ChartJS,
  up as Checkbox,
  $C as CircleChart,
  g4 as DateInput,
  f4 as DatePicker,
  C8 as DiffPercentageBadge,
  N8 as DropdownSearch,
  E8 as EmptyStateIllustration,
  k8 as EmptyStateIllustration2,
  M8 as EmptyStateIllustration3,
  O8 as EmptyStateIllustration4,
  RC as HorizontalBarsChart,
  aa as IconButton,
  cp as Input,
  f5 as Link,
  XC as LinkBox,
  ZC as LinkOverlay,
  l8 as Menu,
  d8 as MenuContent,
  u8 as MenuGroup,
  p8 as MenuHeading,
  L8 as MenuIcon,
  h8 as MenuItem,
  g8 as MenuSeparator,
  c8 as MenuTrigger,
  lp as NoMatchingResultIllustration,
  L5 as Option,
  A5 as OptionsGroup,
  q0 as OverflowText,
  m4 as Popover,
  $8 as PopoverArrow,
  b4 as PopoverClose,
  y4 as PopoverContent,
  v4 as PopoverTrigger,
  x4 as Portal,
  op as ProgressRadial,
  u5 as Radio,
  QC as SearchIllustration,
  DE as Select,
  X0 as Skeleton,
  D8 as Switch,
  ts as Tooltip,
  K0 as TooltipProvider,
  IE as UploadArea,
  UC as alertVariants,
  AC as badgeVariants,
  Ei as buttonVariants,
  ye as cn,
  _8 as createScale,
  Kt as cva,
  F8 as formatCurrency,
  H8 as formatNumber,
  Bt as getColorFromCssVariable,
  xc as iconButtonVariants,
  d5 as linkVariants,
  It as useDateInput
};
